// This file is auto-generated by @hey-api/openapi-ts

export type ObjectWithIntegerId = {
  id: number;
};

export type ObjectWithIntegerIdArray = Array<ObjectWithIntegerId>;

export type Bookmark = {
  bookmarkeeType?: string;
  bookmarkeeId?: number;
  createdAt?: string;
  id?: number;
  bookmarkee?: {
    abstract?: string;
    duration?: string;
    endScreenType?: string;
    number?: number;
    slug?: string;
    title?: string;
    isExampleLesson?: boolean;
    videoThumbUrlAltText?: string;
    updatedAt?: string;
    indexIdentifier?: string;
    videoThumbUrl?: string;
    durationSecs?: number;
    offlineEnabled?: boolean;
    brightcoveVideoId?: string;
    id?: number;
    course?: ObjectWithIntegerId;
    subchapters?: ObjectWithIntegerIdArray;
    season?: string;
    chaptersInstructors?: ObjectWithIntegerIdArray;
    instructors?: ObjectWithIntegerIdArray;
  };
};

export type Bookmarks = Array<Bookmark>;

export type CreateBookmarkAttributes = {
  bookmarkeeType: string;
  bookmarkeeId: string;
};

export type MediaItem = {
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This will be deprecated in the future.
   *
   */
  brightcoveVideoId?: string;
  /**
   * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
   *
   */
  mediaUuid?: string;
};

export type CourseDeepInstructor = {
  bio?: string;
  courses: ObjectWithIntegerIdArray;
  headshotUrl?: string;
  headshotUrlAltText?: string | null;
  id: number;
  name: string;
};

export type CourseSubchapter = {
  chapterId: number;
  duration: number;
  endTime: number;
  id: number;
  imageUrl?: string;
  startTime: number;
  title: string;
};

export type ChapterType = "chapter" | "episode";

export const ChapterType = {
  CHAPTER: "chapter",
  EPISODE: "episode",
} as const;

export type CourseChapter = {
  abstract: string;
  availableAt?: string | null;
  brightcoveVideoId?: string;
  mediaUuid: string;
  chaptersInstructors?: ObjectWithIntegerIdArray;
  course: ObjectWithIntegerId;
  duration: string;
  durationSecs?: number;
  endScreenType?: string | null;
  id: number;
  indexIdentifier?: string;
  instructors: Array<CourseDeepInstructor>;
  isExampleLesson?: boolean;
  number: number;
  offlineEnabled?: boolean;
  season?: ObjectWithIntegerId | null;
  slug: string;
  subchapters: Array<CourseSubchapter>;
  title: string;
  type: ChapterType;
  updatedAt?: string;
  videoThumbUrl: string;
  videoThumbUrlAltText?: string | null;
  /**
   * This field is replaced by the teaser field. It will be deprecated in the near future.
   *
   */
  teaserBrightcoveVideoId?: string | null;
  teaser?: MediaItem | null;
};

export type Season = {
  id: number;
  title: string;
  teaser: string;
  isAvailable: boolean;
  chapters: ObjectWithIntegerIdArray;
};

export type Seasons = Array<Season>;

export type CourseType = "course" | "series";

export const CourseType = {
  COURSE: "course",
  SERIES: "series",
} as const;

export type CourseDeep = {
  id: number;
  uuid: string;
  aapExclusive: boolean;
  allPdfs?: Array<{
    id?: number;
    previewImage1?: string | null;
    previewImage1AltText?: string | null;
    title?: string;
    url?: string;
  }>;
  audioFriendly: string;
  availableAt: string | null;
  /**
   * This field is deprecated and will be removed in the future. Please use the `autoPlay` field instead.
   *
   * @deprecated
   */
  autoPlayBrightcoveVideoId?: number | null;
  autoPlay?: MediaItem | null;
  brightcoveVideoId?: string;
  mediaUuid?: string;
  categories: Array<{
    camps?: ObjectWithIntegerIdArray;
    courses?: ObjectWithIntegerIdArray;
    coverImage?: string | null;
    coverImageAltText?: string | null;
    id: number;
    name: string;
    position: number;
    slug: string;
  }>;
  chapters: Array<CourseChapter>;
  chatEnabled?: boolean;
  cinematic12x5?: string;
  cinematic16x9?: string;
  cinematic12x5AltText?: string;
  cinematic16x9AltText?: string;
  classHeroIosAltText?: string;
  classSkillsAltText?: string;
  classTileImage?: string;
  classTileImageAltText?: string;
  coursesInstructors: Array<{
    course: ObjectWithIntegerId;
    courseId: number;
    id: number;
    instructor: ObjectWithIntegerId;
    instructorId: number;
    position: number;
  }>;
  engagementRank: number;
  hasRelatedInstructors?: boolean;
  headline?: string;
  headshotAltText?: string | null;
  hpFeaturedTileAltText?: string | null;
  hpTileAltText?: string | null;
  image16x9?: string;
  image16x9AltText?: string | null;
  image256x135?: string;
  image256x135AltText?: string | null;
  image2x3?: string;
  image2x3AltText?: string | null;
  image4x3?: string;
  image4x3AltText?: string | null;
  indexIdentifier?: string;
  instructorBio?: string;
  instructorAccolades?: Array<string>;
  instructorName?: string;
  instructorTagline?: string | null;
  instructors: Array<CourseDeepInstructor>;
  isSingleCut?: boolean;
  isMultiInstructor: boolean;
  leftAlignedNameplate?: string;
  marketingCmColumn?: string;
  marketingOverview?: string;
  matureContent: boolean;
  merchandisingImages?: ObjectWithIntegerIdArray;
  multiInstructorName?: string | null;
  nameplate?: string;
  nameplateAltText?: string | null;
  nameplateSvgAltText?: string | null;
  numChapters: number;
  overview?: string;
  pdfs?: Array<{
    id: number;
    previewImage1?: string | null;
    previewImage1AltText?: string | null;
    title: string;
    url: string;
  }>;
  primary16x9?: string;
  primary16x9AltText?: string | null;
  primary1x1?: string;
  primary1x1AltText?: string | null;
  primary2x3?: string;
  primary2x3AltText?: string | null;
  primaryCategory?: ObjectWithIntegerId;
  productId?: number;
  releaseDescription?: string | null;
  /**
   * This field is deprecated and will be removed in the future. Please use the `sample` field instead.
   *
   * @deprecated
   */
  sampleVideoId?: string;
  sample?: MediaItem;
  seasonNote?: string | null;
  seasons: Seasons;
  secondary16x9AltText?: string | null;
  shortOverview?: string;
  skill?: string;
  slug: string;
  status: string;
  subchapters?: Array<CourseSubchapter>;
  tag: string | null;
  title: string;
  totalSeconds: number;
  type: CourseType;
  upcomingChapter?: CourseChapter | null;
  upcomingChapters?: Array<CourseChapter>;
  updatedAt?: string;
  vanityName?: string;
  welcomeStatement?: string;
  welcomeSurvey?: {
    course: ObjectWithIntegerId;
    id: number;
  };
  workbookCoverImages?: Array<string>;
  workbookCoverImagesAltTexts?: Array<string>;
  workbookDescription?: string;
};

export type Course = {
  id: number;
  uuid: string;
  aapExclusive: boolean;
  allPdfs?: ObjectWithIntegerIdArray;
  audioFriendly: string;
  availableAt: string;
  /**
   * This field is deprecated and will be removed in the future. Please use the `autoPlay` field instead.
   *
   * @deprecated
   */
  autoPlayBrightcoveVideoId?: string;
  autoPlay?: MediaItem;
  brightcoveVideoId?: string;
  mediaUuid?: string;
  categories?: ObjectWithIntegerIdArray;
  categoryIds?: Array<string>;
  chapters?: ObjectWithIntegerIdArray;
  chatEnabled?: boolean;
  cinematic12x5?: string;
  cinematic16x9?: string;
  cinematic12x5AltText?: string;
  cinematic16x9AltText?: string;
  classHeroIosAltText?: string;
  classSkillsAltText?: string;
  classTileImage?: string;
  classTileImageAltText?: string;
  coursesInstructors?: ObjectWithIntegerIdArray;
  engagementRank?: number;
  hasRelatedInstructors?: boolean;
  headline?: string;
  headshotAltText?: string;
  hpFeaturedTileAltText?: string;
  hpTileAltText?: string;
  image16x9?: string;
  image16x9AltText?: string;
  image256x135?: string;
  image256x135AltText?: string;
  image2x3?: string;
  image2x3AltText?: string;
  image4x3?: string;
  image4x3AltText?: string;
  indexIdentifier?: string;
  instructorBio?: string;
  instructorName?: string;
  instructorTagline?: string;
  instructors?: ObjectWithIntegerIdArray;
  isSingleCut?: boolean;
  isMultiInstructor?: boolean;
  marketingCmColumn?: string;
  marketingOverview?: string;
  matureContent?: boolean;
  merchandisingImages?: ObjectWithIntegerIdArray;
  multiInstructorName?: string | null;
  nameplate?: string;
  nameplateAltText?: string;
  nameplateSvgAltText?: string;
  numChapters?: number;
  overview?: string;
  pdfs?: ObjectWithIntegerIdArray;
  primary16x9?: string;
  primary16x9AltText?: string;
  primary1x1?: string;
  primary1x1AltText?: string;
  primary2x3?: string;
  primary2x3AltText?: string;
  primaryCategory?: ObjectWithIntegerId;
  productId?: number;
  releaseDescription?: string | null;
  /**
   * This field is deprecated and will be removed in the future. Please use the `sample` field instead.
   *
   */
  sampleVideoId?: string;
  sample?: MediaItem;
  seasonNote?: string;
  seasons?: ObjectWithIntegerIdArray;
  secondary16x9AltText?: string;
  shortOverview?: string;
  showChapterNumbers?: boolean;
  skill?: string;
  slug: string;
  status: string;
  subchapters?: ObjectWithIntegerIdArray;
  tag: string | null;
  title: string;
  type: CourseType;
  totalSeconds?: number;
  updatedAt?: string;
  vanityName?: string;
  welcomeStatement?: string;
  welcomeSurvey?: ObjectWithIntegerId;
  workbookCoverImages?: Array<string>;
  workbookCoverImagesAltTexts?: Array<string>;
  workbookDescription?: string;
};

export type CoursesResult = Array<CourseDeep> | Array<Course>;

export type Instructor = {
  bio?: string;
  courses?: CoursesResult | ObjectWithIntegerIdArray;
  headshotUrl?: string;
  headshotUrlAltText?: string;
  id: number;
  name: string;
};

export type SessionFeaturedProjects = {
  id: number;
  description?: string;
  imageUrl?: string;
  imageUrlAltText?: string;
  position: number;
  mediaType?: string;
  video?: string;
};

export type Session = {
  id: number;
  fullDescription: string;
  isLive: boolean;
  isFixedEnrollment: boolean;
  launchDate: string;
  slug: string;
  title: string;
  primary2x3?: string;
  primary16x9?: string;
  secondary16x9?: string;
  outcomesTitle: string;
  color: string;
  nameplateImage: string;
  nameplateSvg: string;
  instructors: Array<Instructor>;
  campFeaturedProjects: Array<SessionFeaturedProjects>;
  trailer?: {
    brightcoveVideoId?: string;
    mediaUuid: string;
  };
};

export type SessionsResult = Array<Session>;

export type SingleSessionResult = {
  state: string;
  totalProjects: number;
  color?: string;
  equipmentDescription?: string;
  fullDescription: string;
  isLive: boolean;
  launchDate?: string;
  lastEnrollmentWindowClosedAt?: string;
  nameplateTitle: string;
  outcomesTitle?: string;
  projectsOutputDescription: string;
  slug: string;
  title: string;
  vanityName?: string;
  indexIdentifier?: string;
  headline?: string;
  supportingHeadline?: string;
  preLiveEnrollmentCount?: number;
  totalCohorts?: number;
  remainingCohortSpots?: number;
  cinematic12x5?: string;
  cinematic16x9?: string;
  nameplateImage?: string;
  nameplateSvg: string;
  primary1x1: string;
  primary2x3: string;
  primary16x9: string;
  secondary16x9?: string;
  totalDurationDays?: number;
  isFixedEnrollment: boolean;
  id: number;
  uuid: string;
  classOverviewTrailer?: {
    brightcoveVideoId?: string;
    mediaUuid: string;
    duration?: number;
    thumbUrl?: string;
    thumbUrlAltText?: string;
    id: number;
    videoSegments?: Array<string>;
  };
  trailer: {
    brightcoveVideoId?: string;
    mediaUuid: string;
    duration?: number;
    thumbUrl?: string;
    thumbUrlAltText?: string;
    id: number;
    videoSegments?: Array<string>;
  };
  primaryCategory?: {
    name: string;
    slug: string;
    id: number;
    camps?: Array<{
      id: number;
    }>;
    courses?: Array<{
      id: number;
    }>;
  };
  categories?: Array<{
    name: string;
    slug: string;
    id: number;
    camps?: Array<{
      id: number;
    }>;
    courses?: Array<{
      id: number;
    }>;
  }>;
  campModules?: Array<{
    campId: number;
    title: string;
    slug: string;
    description?: string;
    position: number;
    dueFromCampStartDays?: number;
    marketing3x2: string;
    totalVideos?: number;
    totalProjects?: number;
    id: number;
    campTasks?: Array<{
      campModuleId: number;
      taskType: string;
      title: string;
      description: string;
      dueFromCampStartDays?: number;
      position: number;
      slug: string;
      submissionMediaSupported?: Array<string>;
      durationSecs?: number;
      thumbUrl?: string;
      id: number;
    }>;
  }>;
  campProfileQuestions?: Array<{
    campId: number;
    question: string;
    questionType: string;
    position: number;
    id: number;
  }>;
  competencies?: Array<{
    campId: number;
    name: string;
    items: Array<string>;
    id: number;
  }>;
  instructors?: Array<{
    name: string;
    headshotUrl?: string;
    id: number;
  }>;
  campFeaturedProjects?: Array<SessionFeaturedProjects>;
  currentEnrollmentWindow?: {
    isOpen?: boolean;
    closesAt?: string;
  };
  instructorBio?: {
    description?: string;
    id: number;
    bio1x1?: string;
    bio16x9?: string;
    instructorPortfolioItems?: Array<{
      id: number;
      mediaType?: string;
      position: number;
      altText?: string;
      imageUrl?: string;
      instructorBio?: {
        id: number;
      };
      video?: string;
    }>;
  };
};

export type Category = {
  id: number;
  name: string;
  slug: string;
  camps: ObjectWithIntegerIdArray;
  courses: ObjectWithIntegerIdArray;
};

export type CategoriesResult = Array<Category>;

export type Chapter = {
  id: number;
  abstract: string;
  availableAt?: string;
  course: ObjectWithIntegerId | Course;
  duration: string;
  durationSecs: number;
  instructors: Array<ObjectWithIntegerId | Instructor>;
  number: number;
  slug: string;
  title: string;
  type: ChapterType;
  videoThumbUrl: string;
  videoThumbUrlAltText: string;
  /**
   * The unique identifier for the brightcove video content. In order to follow conventions,
   * this field will be deprecated in the future. Use the `teaser` nested object instead.
   *
   */
  teaserBrightcoveVideoId?: string | null;
  teaser?: {
    /**
     * The unique identifier for the brightcove video content.
     * Use this brightcove video ID to fetch metdata from Brightcove.
     * This will be deprecated in the future.
     *
     */
    brightcoveVideoId?: string;
    /**
     * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
     *
     */
    mediaUuid?: string;
  };
  /**
   * The title of the chapter, with the chapter number prepended if the course has chapter numbering enabled.
   *
   */
  displayTitle?: string;
};

export type ChapterResult = Array<Chapter>;

export type MobileContentGems = {
  courseId: number;
  id: number;
  position: number;
  imageUrl: string;
  imageUrlAltText: string;
  title: string;
};

export type ContentRowEntityType =
  | "course"
  | "course_progress"
  | "custom"
  | "lesson"
  | "playlist"
  | "session"
  | "session_progress";

export const ContentRowEntityType = {
  COURSE: "course",
  COURSE_PROGRESS: "course_progress",
  CUSTOM: "custom",
  LESSON: "lesson",
  PLAYLIST: "playlist",
  SESSION: "session",
  SESSION_PROGRESS: "session_progress",
} as const;

export type Pill = {
  text?: string;
  /**
   * See `PillKind` for a list of currently supported values.
   */
  kind?: string;
};

export type ContentRowEntityOverwrite = {
  tileImage?: {
    url?: string;
    altText?: string;
  };
  tileVideo?: {
    videoId: string;
  };
  title?: string;
  subtitle?: string;
  caption?: string;
  redirectUrl?: string;
  primaryPill?: Pill;
  secondaryPill?: Pill;
};

export type ContinueCourseEntity = {
  id: number;
  chapter: {
    id: number;
    duration: number;
    number: number;
    slug: string;
  };
  images: {
    cinematic12x5: string;
    cinematic12x5AltText: string;
    image16x9: string;
    image16x9AltText: string;
  };
  resumeProgress: {
    cursor: number;
    duration: number;
    progress: number;
  };
  slug: string;
  subtitle: string;
  tileType: string;
  title: string;
  type: CourseType;
  caption: string;
  /**
   * The unique identifier for the brightcove video content.
   * This field will be deprecated soon, as part of the CMS video migration project. Do not use this field. Use the `preview` field instead.
   *
   */
  videoPreview: string;
  preview?: {
    /**
     * The unique identifier for the brightcove video content.
     * Use this brightcove video ID to fetch metdata from Brightcove.
     * This will be deprecated in the future.
     *
     */
    brightcoveVideoId?: string;
    /**
     * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
     *
     */
    mediaUuid?: string;
  };
};

export type ContinueSessionEntity = {
  id: number;
  images: {
    image1x1?: string;
    image2x3?: string;
    image16x9?: string;
  };
  slug: string;
  subtitle: string;
  task: {
    id: number;
    duration?: number | null;
    slug: string;
    videoTask: boolean;
  };
  title: string;
};

export type ContentRowEntity =
  | (ContentRowEntityOverwrite & ContinueCourseEntity)
  | ContinueSessionEntity
  | ObjectWithIntegerId;

export type ContentRowItem = {
  analytics?: {
    [key: string]: string | null | number;
  };
  entityType: ContentRowEntityType;
  entity: ContentRowEntity;
};

export type ContentRowTileAttributes = {
  /**
   * See the `ContentRowUIConfigTileRatio` enum for list of values.
   */
  tileRatio?: string;
  /**
   * See the `ContentRowUIConfigTileImageMode` enum for list of values.
   */
  tileImageMode?: string;
  /**
   * See the `ContentRowUIConfigTileVideoMode` enum for list of values.
   */
  tileVideoMode?: string;
  showTileCaption?: boolean;
  showTileLogo?: boolean;
  /**
   * See the `ContentRowUIConfigShowTileVideoOn` enum for list of values.
   */
  showTileVideoOn?: string;
  showTileVideoCaptions?: boolean;
  /**
   * Hexadecimal color representation (#RRGGBB)
   */
  tileBackgroundColor?: string;
  /**
   * See the `ContentRowUiConfigTileTextPlacement` enum for list of values.
   */
  tileTextPlacement?: string;
  /**
   * See the `ContentRowUiConfigTileClickTarget` enum for list of values.
   */
  tileClickTarget?: string;
};

export type ContentRowTitleAttributes = {
  htmlId?: string;
  cta?: Array<{
    label: string;
    url: string;
  }>;
  title?: string;
  description?: string;
  titleImage?: {
    url: string;
    altText?: string;
  };
};

export type ContentRowCarouselAttributes = {
  lazyLoad?: boolean;
  visibleTileCount?: number;
  visibleTileCountResponsive?: {
    [key: string]: number;
  };
  scrollTileCount?: number;
  autoScroll?: boolean;
  autoScrollPeriodInSec?: number;
  scrollLoop?: boolean;
  mutedTitle?: boolean;
  forceFillHeight?: boolean;
};

export type ContentRowGridAttributes = {
  rowTileCount?: number;
  rowTileCountResponsive?: {
    [key: string]: number;
  };
};

export type ContentRowUiConfigAttributes = ContentRowTileAttributes &
  ContentRowTitleAttributes & {
    carousel?: ContentRowCarouselAttributes;
    grid?: ContentRowGridAttributes;
  };

export type ContentRowUiConfig = {
  /**
   * See the `ContentRowUIConfigType` enum for list of values.
   */
  type: string;
  attributes?: ContentRowUiConfigAttributes;
};

export type ContentRow = {
  id: number;
  apiType: string;
  slug: string;
  content?: Array<ContentRowItem>;
  analytics: {
    [key: string]: unknown;
  };
  refreshNeeded: boolean;
  uiConfig: ContentRowUiConfig;
  dynamicContent: boolean;
  conditions?: {
    experiments?: {
      [key: string]: unknown;
    };
  };
  items?: Array<ContentRowItem>;
};

export type ContentRows = Array<ContentRow>;

export type ConversationMessageKnowledge = {
  id: number;
  messageId: number;
  distance: number;
  ragJson?: {
    contentId?: number;
    classFormat?: string;
    classId?: number;
    distance?: number;
    startSecs?: number;
    endSecs?: number;
    category?: string;
    instructors?: string;
    courseTitle?: string;
    chapterTitle?: string;
    thumbUrl?: string;
    courseUrl?: string;
    chapterUrl?: string;
    text?: string;
  };
};

export type ConversationMessage = {
  id: number;
  conversationId: number;
  chapterId?: number;
  replyId?: number;
  source?: "user" | "assistant";
  content: string;
  rating?: "thumbsup" | "thumbsdown" | null;
  toxic?: boolean;
  createdAt?: string;
  knowledge?: Array<ConversationMessageKnowledge>;
};

export type Conversation = {
  id: number;
  courseId?: number;
  visitSessionId?: string;
  messages?: Array<ConversationMessage>;
  color?: string;
};

export type Conversations = Array<Conversation>;

export type ConversationMessageAttributes = {
  content: string;
  source?: "user" | "assistant";
  chapterId?: number;
  visitSessionId?: string;
};

export type ConversationAttributes = {
  courseId?: number;
  visitSessionId: string;
  messagesAttributes?: Array<ConversationMessageAttributes>;
  color?: string;
};

export type ConversationIntroduction = {
  introduction?: string;
  suggestions?: Array<string>;
};

export type ConversationMessages = Array<ConversationMessage>;

export type ConversationMessageUpdateAttributes = {
  rating?: string | null;
};

export type EmailConfirmationAction =
  | "cc_renew"
  | "delink"
  | "email_update"
  | "password_update"
  | "verify_email"
  | "email_correction";

export const EmailConfirmationAction = {
  CC_RENEW: "cc_renew",
  DELINK: "delink",
  EMAIL_UPDATE: "email_update",
  PASSWORD_UPDATE: "password_update",
  VERIFY_EMAIL: "verify_email",
  EMAIL_CORRECTION: "email_correction",
} as const;

export type EmailConfirmationAttributes = {
  type: EmailConfirmationAction;
};

export type EmailConfirmationStatus =
  | "confirmed"
  | "new_confirmation_required"
  | "pending_confirmation";

export const EmailConfirmationStatus = {
  CONFIRMED: "confirmed",
  NEW_CONFIRMATION_REQUIRED: "new_confirmation_required",
  PENDING_CONFIRMATION: "pending_confirmation",
} as const;

export type EmailConfirmation = {
  action: EmailConfirmationAction;
  status: EmailConfirmationStatus;
  /**
   * The email address to confirm.
   */
  unconfirmedEmail?: string;
};

export type EnterpriseSubscription = {
  id: number;
  organizationId: number;
  quantity: number;
  expiresAt: string;
  status: string;
  originatorType: string;
  originatorId: number;
  createdAt: string;
  updatedAt: string;
  requireConsent: boolean;
  terminatedAt?: string;
  cancellationScheduledAt?: string;
  canceledAt?: string;
  analyticsEnabled: boolean;
  enterpriseExperience: boolean;
  bulkSeatInviteSentAt?: string;
  marketingEmailsEnabled?: boolean;
  customInviteBody?: string;
  teamId: number;
  contractEffectiveDate?: string;
  teamName: string;
  infoSeats?: {
    total: number;
    available: number;
    active: number;
    pending: number;
  };
};

export type EnterpriseSubscriptions = Array<EnterpriseSubscription>;

export type EnterpriseNotification = {
  id: number;
  category: string;
  content: string;
  createdAt: string;
  licenseId: number;
  organizationId: number;
  status: string;
  teamId: number;
  title: string;
  userId: number;
};

export type EnterpriseNotifications = Array<EnterpriseNotification>;

export type TeamScheduledInvitation = {
  id: number;
  sendNow: boolean;
  sendInviteAt: string;
  status: string;
  membersInvited: number;
};

export type TeamCreateAttributes = {
  name: string;
  organizationId: number;
  parentTeamId: number;
};

export type TeamAdmin = {
  id: number;
  userId: number;
  teamId: number;
  role: string;
  firstName: string;
  lastName: string;
  email: string;
  noEmailUser: boolean;
  username?: string;
};

export type TeamChild = {
  id: number;
  name: string;
  createdAt: string;
  depth: number;
  ownsLicense?: boolean;
  requireConsent?: boolean;
  parentTeamId: number;
  analyticsEnabled: boolean;
  lastUpdatedAt: string;
  licenseId?: number;
  membersCount: number;
  seatsCount?: number;
  seatsPending?: number;
  seatsRemaining?: number;
  children?: Array<TeamChild>;
  userRoles: Array<string>;
};

export type TeamMember = {
  id: number;
  userId: number;
  role: string;
  firstName: string;
  lastName: string;
  licenseTeam?: string;
  email: string;
  status: string;
  emailSentAt: string;
  createdAt: string;
  noEmailUser: boolean;
  username?: string;
};

export type TeamLicense = {
  id: number;
  organizationId: number;
  quantity: number;
  expiresAt: string;
  status: string;
  bulkSeatInviteSentAt: string;
  infoSeats: {
    total: number;
    available: number;
    active: number;
    pending: number;
  };
  selfServeEligible?: boolean;
  seatPrice?: number;
};

export type Team = {
  id: number;
  parentTeamId: number;
  organizationId: number;
  name: string;
  analyticsEnabled: boolean;
  lastUpdatedAt: string;
  membersCount: number;
  admins?: Array<TeamAdmin>;
  children?: Array<TeamChild>;
  members?: Array<TeamMember>;
  redeemed?: Array<TeamMember>;
  unassigned?: Array<TeamMember>;
  unredeemed?: Array<TeamMember>;
  licenses?: Array<TeamLicense>;
  teamHierarchy?: Array<TeamChild>;
  userRoles: Array<string>;
  pagination?: {
    /**
     * specify limit of how many items to return per request
     */
    limit?: number;
    /**
     * specify current pointer of how many items to return per request
     */
    offset?: number;
    /**
     * specify total count of items for the filter
     */
    count?: number;
  };
  pendingSeatsCount: number;
  redeemedSeatsCount: number;
};

export type TeamScheduledInvitations = Array<TeamScheduledInvitation>;

export type TeamNotification = {
  id?: number;
  title?: string | null;
  message: string;
  startsAt: string;
  endsAt: string;
  teamId: number;
};

export type Organization = {
  id: number;
  name: string;
  businessName: string;
  messaging?: TeamNotification | null;
  logoUrl: string | null;
  createdAt: string;
  primaryTeamId: number | null;
  primaryTeamName?: string;
  teamHierarchy?: Array<TeamChild>;
  requireConsent?: boolean;
  contentAssignments: boolean;
};

export type MemberNotification = {
  id: number;
  title?: string | null;
  message: string;
};

export type Video = {
  id: number;
  duration: number;
  brightcoveVideoId?: string;
  mediaUuid: string;
  thumbUrl?: string;
  thumbUrlAltText?: string;
};

export type Episode = {
  id: number;
  slug: string;
  title: string;
  description: string;
  number: number;
  duration?: string;
  video?: Video;
};

export type Episodes = Array<Episode>;

export type Experiment = {
  name?: string;
  value?: string;
  id?: string;
};

export type Experiments = Array<Experiment>;

export type FeatureInteraction = {
  id: number;
  interactionCount: number;
  name: string;
  user: ObjectWithIntegerId;
};

export type FeatureInteractionsResult = Array<FeatureInteraction>;

export type FeatureInteractionAttributes = {
  interactionCount: number;
  name: string;
};

export type FreeTrial = {
  eligible: boolean;
  advocate: {
    id: string;
    name?: string;
    email: string;
    profileImg?: string;
  } | null;
  durationDays?: number;
  termsLink: string;
  partnership?: string;
  isPartnershipTrial?: boolean;
  isGuestPass?: boolean;
  freeTrialType?: string;
  partnerInfo?: {
    displayName?: string;
  };
  source?: {
    name?: string;
    sharedContent?: {
      contentType?: string;
      contentId?: number;
    };
    promoCode?: string;
  };
  ineligibilityReason?:
    | "invalid_token"
    | "already_redeemed"
    | "campaign_ended"
    | "partnership_disabled"
    | "advocate_limit_reached"
    | "not_eligible"
    | null;
  id: string;
};

export type GuestPassShareAttributes = {
  data: {
    attributes?: {
      emails?: Array<string>;
    };
  };
};

export type ImmersiveHero = {
  id: number;
  slug: string;
  name: string;
  courseId: number;
  chapterId?: number | null;
  course: {
    id: number;
    slug: string;
    type: "series" | "course";
    title: string;
    welcomeStatement: string;
    instructorName: string;
    cinematic12X5: string;
    marketingCmColumn?: string;
    nameplate: string;
    nameplateAltText?: string;
    headline: string;
    releaseDescription?: string;
    chapters: ObjectWithIntegerIdArray;
  };
  chapter: {
    id: number;
    slug: string;
    type: "chapter" | "episode";
    title: string;
    availableAt?: string;
    number: number;
  };
  resumeChapter?: {
    slug: string;
  };
  title: string;
  video: {
    id: number;
    brightcoveVideoId: number;
  };
  membersOnly: boolean;
};

export type ImmersiveHeros = Array<ImmersiveHero>;

export type MarketingSectionSlug =
  | "featured-instructor"
  | "trending"
  | "coming-soon";

export const MarketingSectionSlug = {
  FEATURED_INSTRUCTOR: "featured-instructor",
  TRENDING: "trending",
  COMING_SOON: "coming-soon",
} as const;

export type MarketingSectionItem = {
  id: string | number;
  slug: string;
  videoId?: string | null | number;
  title: string;
  subtitle?: string | null;
  instructorName?: string | null;
  tag?: string | null;
  link: string;
  duration?: number | null;
  nameplateImage?: string | null;
  primary16x9?: string | null;
  primary2x3?: string | null;
  primary16x9AltText?: string | null;
  primary2x3AltText?: string | null;
  primary1x1?: string | null;
  backgroundImage?: string | null;
  backgroundImageAltText?: string | null;
  type?: string | null;
  verticalBackgroundImage?: string | null;
  verticalBackgroundImageAltText?: string | null;
  releaseDescription?: string | null;
  metaDescription?: string | null;
  brightcoveVideoId?: string | null;
  mediaUuid?: string | null;
};

export type MarketingSectionAction = {
  slug: string;
  title: string;
  subtitle: string;
  link: string;
  cta: string;
};

export type MarketingSection = {
  id: string | number;
  slug: MarketingSectionSlug;
  marketingSectionItems: Array<MarketingSectionItem>;
  marketingSectionAction?: MarketingSectionAction;
};

export type MarketingSectionsResult = Array<MarketingSection>;

export type Note = {
  chapter: ObjectWithIntegerId;
  course: ObjectWithIntegerId;
  content: string;
  id: number;
};

export type NoteDeep = {
  chapter: {
    id: number;
    slug: string;
    course: ObjectWithIntegerId;
    instructors: ObjectWithIntegerIdArray;
    subchapters: ObjectWithIntegerIdArray;
    type: ChapterType;
    title: string;
    number: number;
  };
  course: ObjectWithIntegerId;
  content: string;
  id: number;
};

export type Notes = Array<Note> | Array<NoteDeep>;

export type CreateNoteAttributes = {
  chapterId: number;
  content: string;
};

export type PlaylistTrack = {
  id: number;
  slug: string;
  name: string;
  uuid?: string;
  position?: number;
};

export type Playlist = {
  id: number;
  slug: string;
  uuid: string;
  name: string;
  description: string;
  status: string;
  duration: number;
  updatedAt: string;
  playlistTwoByThreeAltText?: string;
  playlistPosterImageAltText?: string;
  indexIdentifier?: string;
  playlistTwoByThree: string;
  playlistPosterImage?: string;
  themes: Array<ObjectWithIntegerId>;
  instructors: Array<ObjectWithIntegerId | Instructor>;
  tracks: Array<ObjectWithIntegerId | PlaylistTrack>;
};

export type Playlists = Array<Playlist>;

export type Category2 =
  | "coupon_code"
  | "gift_code"
  | "referral_code"
  | "value_coupon"
  | "promo_code"
  | "gifting_activation"
  | "corporate_discount_code"
  | "bulk_order_coupon"
  | "renewal_coupon"
  | "internal";

export const Category2 = {
  COUPON_CODE: "coupon_code",
  GIFT_CODE: "gift_code",
  REFERRAL_CODE: "referral_code",
  VALUE_COUPON: "value_coupon",
  PROMO_CODE: "promo_code",
  GIFTING_ACTIVATION: "gifting_activation",
  CORPORATE_DISCOUNT_CODE: "corporate_discount_code",
  BULK_ORDER_COUPON: "bulk_order_coupon",
  RENEWAL_COUPON: "renewal_coupon",
  INTERNAL: "internal",
} as const;

export type DiscountType = "amount_off" | "percentage_off";

export const DiscountType = {
  AMOUNT_OFF: "amount_off",
  PERCENTAGE_OFF: "percentage_off",
} as const;

export type Coupon = {
  id: number;
  code: string;
  category: Category2;
  currency?: string;
  discountType: DiscountType;
  maxRedemptions?: number;
  percentage?: number;
  redemptions?: number;
  requiredLogin?: boolean;
};

export type Product = {
  id: number;
  currency?: string;
  price?: string;
  assetSlug: string;
  pricing: {
    applyTax?: boolean;
    basePrice?: number;
    countryCode?: string;
    currency?: string;
    currencySymbol?: string;
    price?: number;
    taxAmount?: number;
    taxInclusive?: boolean;
  };
  basePrice?: number;
  taxAmount?: number;
  taxInclusive?: boolean;
  applyTax?: boolean;
  currencySymbol?: string;
  pricingMarketingText?: string | null;
  pricingMarketingText2?: string | null;
  vanityPrice?: number | null;
  productLtv?: {
    gift?: number;
    regular?: number;
  } | null;
  productLtvInUsd?: number;
  monetizedFlatRate?: string;
  monetizedFlatRateTotal?: string | null;
  unmonetizedFlatRateTotal?: number;
  monetizedYearPricePerMonth: string;
  monetizedYearPricePerMonthDiscounted?: string | null;
  monetizedYearPricePerDay?: string | null;
  monetizedYearPricePerDayDiscounted?: string | null;
  monetizedYearPricePerWeek?: string | null;
  monetizedYearPricePerWeekDiscounted?: string | null;
  monetizedYearPricePerWeekRounded?: string | null;
  flatRate: number;
  grantsCertificatePass?: boolean;
  grantsCertificateCredit?: boolean;
  coupon?: Coupon;
};

export type Products = Array<Product>;

export type Feature = {
  name: string;
  value: boolean | number | unknown;
  displayName?: string | null;
};

export type Entitlement = {
  id: number;
  name: string;
  benefits: Array<Feature>;
  mobileDisplayName?: string | null;
  appleProductId?: string | null;
  googleProductId?: string | null;
  hierarchy?: number | null;
  alternateGoogleProductIds?: Array<string>;
};

export type MemberOrganization = {
  id: number;
  name?: string;
  businessName?: string;
  primaryTeamId: number;
  logoUrl?: string;
};

export type User = {
  activeAnnualPass?: boolean;
  availableAuthTypes: Array<{
    lastLoginAt?: string;
    type: string;
  }>;
  bogoEligible: boolean;
  bogoGiftExpiration?: string | null;
  bogoGiftExpirationRaw?: string | null;
  bogoGiftToken?: string | null;
  canUpgrade: boolean;
  currentAuthType?: string;
  email: string;
  emailToken: string;
  entitlement?: Entitlement | ObjectWithIntegerId;
  enrolledCourses: Array<string>;
  enterpriseSeatToken?: {
    id: number;
  };
  firstName?: string | null;
  gdprOptIn: boolean;
  id: number;
  lastName?: string | null;
  locale?: string | null;
  matureContentEnabled: boolean | null;
  profileId: number;
  profilePhotoUrl?: string | null;
  slug: string;
  subtitleEnabled: boolean;
  subtitleLocale?: string | null;
  organizationsAdministered?: Array<number>;
  organizationsMembered?: Array<MemberOrganization>;
  username?: string | null;
  noEmailUser: boolean;
  needsSetup?: boolean;
  hasHadSubscriptions?: boolean;
  hasCreditCard?: boolean;
  braintreePaypalEmailOfLatestSub?: string;
  hasBraintreeCcSub?: boolean;
  sponsoredSubscriptionInfo?: {
    [key: string]: unknown;
  };
  hasActiveAfterpaySubscription?: boolean;
  hasOnCallAccess?: boolean;
};

export type Profile = {
  city?: string;
  country?: string;
  displayName: string;
  id: number;
  location?: string;
  matureContentEnabled?: boolean;
  onboardedAt?: string;
  personalUrl?: string;
  personalUrlType?: string;
  profession?: string;
  profileImage?: string;
  skills: Array<ObjectWithIntegerId>;
  slug: string;
  tagline?: string;
  user: ObjectWithIntegerId | User;
  uuid: string;
  defaultProfile: boolean;
  careerGoal?: string;
};

export type Profiles = Array<Profile>;

export type ProfileCreateAttributes = {
  avatarColor: string;
  city?: string;
  country?: string;
  displayName: string;
  firstName?: string;
  lastName?: string;
  location?: string;
  matureContentEnabled?: boolean;
  personalUrl?: string;
  personalUrlType?: string;
  profession?: string;
  profileImage?: string;
  profilePhotoUrl?: string;
  skills?: Array<ObjectWithIntegerId>;
  tagline?: string;
};

export type ProfileUpdateAttributes = {
  avatarColor?: string;
  city?: string;
  country?: string;
  displayName?: string;
  firstName?: string;
  lastName?: string;
  location?: string;
  matureContentEnabled?: boolean;
  onboarded?: string;
  personalUrl?: string;
  personalUrlType?: string;
  profession?: string;
  profileImage?: string;
  profilePhotoUrl?: string;
  skills?: Array<ObjectWithIntegerId>;
  tagline?: string;
};

export type OnboardingContentType = "Course" | "Camp";

export const OnboardingContentType = {
  COURSE: "Course",
  CAMP: "Camp",
} as const;

export type OnboardingCategory = {
  id?: number;
  name: string;
  isPrimary?: boolean;
};

export type OnboardingContent = {
  contentId: number;
  contentType: OnboardingContentType;
  contentSlug: string;
  headline: string;
  supportingHeadline: string;
  image: string;
  position: number;
  instructor: Instructor;
  categories: Array<OnboardingCategory>;
};

export type OnboardingContentRecommendation = Array<OnboardingContent>;

export type PurchasePlan = {
  id: number;
  billingCyclePeriod: number;
  slug: string;
  mobileDisplayName: string;
  isAnnualPass: boolean;
  isMonthlyPass: boolean;
  isInstallments: boolean;
  productTierName?: string;
  product?: ObjectWithIntegerId | Product;
};

export type ReferralAudioProgram = {
  id: number;
  name: string;
};

export type ReferralAudioProgramsResult = Array<ReferralAudioProgram>;

export type ReferralTokenAttributes = {
  courseId?: string;
  recipeId?: string;
  source:
    | "guest_pass_advocate"
    | "class"
    | "recipes"
    | "pre_onboarding"
    | "articles"
    | "catalog"
    | "class_guest"
    | "class_guest_next"
    | "class_locked"
    | "lesson"
    | "lesson_tile"
    | "lesson_video"
    | "lesson_page_logged_out"
    | "single_class_gift"
    | "homepage_class_samples"
    | "homepage_featured_instructor"
    | "homepage_featured_instructor_next"
    | "immersive_hero";
};

export type ShareLinks = {
  id: string;
  token?: string;
  invitationLinks: Array<{
    content:
      | "Facebook"
      | "Linkedin"
      | "Twitter"
      | "Copy"
      | "Messenger"
      | "Email"
      | "More"
      | "Message";
    url: string;
    id: number;
  }>;
};

export type Showcase = {
  id: number;
  backgroundImageUrl: string;
  caption?: string | null;
  course?: Course | ObjectWithIntegerId;
  session?: Session | ObjectWithIntegerId;
  ctaText?: string;
  gradient?: boolean;
  pillText?: string;
  pillType?: string;
  position: number;
  redirectUrl: string;
  subtitle?: string;
  tileType: string;
  title: string;
  updatedAt: string;
};

export type ShowcasesResult = Array<Showcase>;

export type Skill = {
  id: number;
  parentId: number | null;
  slug: string;
  name: string;
  uuid: string;
};

export type SkillsResult = Array<Skill>;

export type Subscription = {
  expiresAt?: string;
  cancelAtPeriodEnd?: boolean;
  id: number;
  providerType?: string;
  status?: string;
  startsAt?: string;
  renewalPurchasePlanId?: number;
  changeType?: string;
  "sponsored?": boolean;
  remainingDays: string;
  active: boolean;
  purchasePlan: PurchasePlan | ObjectWithIntegerId;
  renewalPurchasePlan?: PurchasePlan | ObjectWithIntegerId;
  entitlement?: Entitlement | ObjectWithIntegerId;
  sponsorName?: string;
};

export type ThemesResults = Array<{
  id: number;
  name: string;
  status: string;
  updatedAt: string;
  description?: string;
  playlists: Array<Playlist>;
}>;

export type TierHierarchy = 0 | 1 | 2 | 3;

export const TierHierarchy = {
  INDIVIDUAL: 0,
  DUO: 1,
  FAMILY: 2,
  FAMILY_PLUS: 3,
} as const;

export type PricingPlan = {
  id: number;
  name: string;
  paymentGatewayType: string;
  paymentGatewaySkuId: string;
};

export type TierBenefit = {
  name:
    | "concurrent_devices"
    | "offline_download"
    | "unlimit_mastercamp_access"
    | "multiple_profiles"
    | "optional_mature_content_exclusions"
    | "persona_in_tiers"
    | "certificate_program_pass"
    | "annual_certificate_credit";
  value: number | boolean | string | null;
  displayName: string | null;
};

export type TierEntitlement = {
  id: number;
  name: string;
  mobileDisplayName?: string;
  benefits: Array<TierBenefit>;
};

/**
 * Monthly price of a tier's membership bought together with the certificate credit add-on, as the combined checkout charges it. The promo discounts the membership only; the add-on is always charged in full. Rounded up to the currency's whole unit.
 */
export type CertCreditBundlePricing = {
  /**
   * Membership plus add-on, per month, before any promo.
   */
  monetizedYearPricePerMonth: string;
  /**
   * Membership with the percentage-off promo applied, plus the add-on, per month. Null without an applicable percentage-off promo.
   */
  monetizedYearPricePerMonthDiscounted: string | null;
};

export type Tier = {
  id: number;
  displayName: string;
  hierarchy: TierHierarchy;
  isUserCurrentTier: boolean;
  bestValue?: boolean;
  mostPopular?: boolean;
  internalName?: string;
  currencySymbol?: string;
  displayMonthlyPrice?: string;
  displayMonthlyPriceWithDiscount?: string;
  product: Product;
  pricingPlan?: PricingPlan;
  entitlement?: TierEntitlement;
  /**
   * prcng-4V1 experiment attribute
   */
  basicPlanIdentifier?: string;
  /**
   * prcng-52V1 experiment attribute
   */
  premiumPlusPlanIdentifier?: string;
  /**
   * prcng-52V1 experiment attribute
   */
  monetizedPremiumFamilyPriceDifference?: string;
  /**
   * Certificates catalog value in the tier's currency, rounded down to two significant figures (e.g. "$2k"), without a trailing "+". Null unless the tier grants certificates.
   */
  monetizedCertificatesCatalogValue?: string | null;
  /**
   * Null when the tier cannot be bundled with the add-on, the add-on is switched off, or the two are priced in different currencies.
   */
  certCreditBundle?: CertCreditBundlePricing | null;
};

export type TierCollection = {
  id: number;
  metadata?: string | null;
  pricingTiers: Array<Tier>;
};

export type PartnershipData = {
  partnerName: string;
  partnerImage?: string;
  partnerUrl?: string;
  partnerDisplayName: string;
  partnerPaymentGateway: string;
  sku: string;
  resellerSkuDisplayName: string;
  skuSlug: string;
};

export type CartData = {
  email?: string;
  enterpriseAdmin?: boolean;
  enterpriseBusinessUser?: boolean;
  updatedFromSap?: boolean;
  userState?: string;
  connectedToFacebook?: boolean;
  needConfirmResidence?: boolean;
  projectPlusOneOfferEligible?: boolean;
  trialDay?: number | null;
  trialDaysLeft?: number | null;
  id?: number;
  subscription?: {
    status?: string;
    providerType?: string;
    canceledAt?: string | null;
    createdAt?: string;
    remainingSubscriptionDays?: number;
    cancelAtPeriodEnd?: boolean;
    paymentGatewayUserProduct?: {
      [key: string]: unknown;
    } | null;
    expirationDate?: string;
    originatorType?: string;
    canceledOnPaypalDashboard?: boolean | null;
    purchaseCountry?: string;
    accessType?: string;
    currentSubscriptionCycle?: number;
    canUpgradeToConsumer?: boolean;
    trialStartsAt?: string | null;
    trialEndsAt?: string | null;
    id?: number;
    isMonthlyPass?: boolean;
  };
  addOnSubscriptions?: Array<{
    id?: number;
    status?: string;
    productId?: number;
    pricingPlanId?: number;
    pricingPlanProductId?: number;
    subscriptionId?: number;
    canceledAt?: string | null;
    createdAt?: string;
    cancelAtPeriodEnd?: boolean;
    accessType?: string;
    currentSubscriptionCycle?: number;
  }>;
  partnershipsData?: PartnershipData;
};

export type GuestPass = {
  available?: boolean;
  remaining?: number;
  guestPassTotalDays?: number;
  expirationDate?: string;
  id?: string;
};

export type StreamAttributes = {
  uuid: string;
  assetType: string;
  videoId: string | number;
};

export type Stream = {
  uuid: string;
  timestamp: string;
  videoId: string;
};

export type StreamsResult = {
  active: number;
  authorized: boolean;
  interval: number;
  limit: number;
  streams?: Array<Stream>;
};

export type UserSession = {
  id: number;
  campId: number;
};

export type UserSessionsResult = Array<UserSession>;

export type UserCourse = {
  completedAt?: string;
  course?: ObjectWithIntegerId;
  courseId: number;
  courseImpactChapter?: number;
  hasNotes?: boolean;
  id: number;
  npsChapter?: number;
  npsDismissed?: string;
  originatorType: string;
  profile?: ObjectWithIntegerId;
  profileId?: number;
  profileUuid?: string;
  progressEntries?: ObjectWithIntegerId;
  resumeChapter?: ObjectWithIntegerId;
  resumeChapterId: number;
  resumeChapterProgress?: {
    chapterId?: number;
    createdAt?: string;
    cursor?: number;
    deletedAt?: string;
    duration?: number;
    id?: number;
    progress?: number;
    updatedAt?: string;
    userCourseId?: number;
  };
  updatedAt: string;
  user?: ObjectWithIntegerId;
  userId: number;
};

export type UserCourseDeep = {
  completedAt?: string;
  course?: {
    aapExclusive?: boolean;
    allPdfs?: ObjectWithIntegerIdArray;
    audioFriendly?: string;
    availableAt?: string;
    brightcoveVideoId?: string;
    categories?: ObjectWithIntegerIdArray;
    chapters?: ObjectWithIntegerIdArray;
    cinematic12x5?: string;
    cinematic12x5AltText?: string;
    cinematic16x9AltText?: string;
    classHeroIosAltText?: string;
    classSkillsAltText?: string;
    classTileImage?: string;
    classTileImageAltText?: string;
    coursesInstructors?: ObjectWithIntegerIdArray;
    engagementRank?: number;
    hasRelatedInstructors?: boolean;
    headline?: string;
    headshotAltText?: string;
    hpFeaturedTileAltText?: string;
    hpTileAltText?: string;
    id: number;
    image16x9?: string;
    image16x9AltText?: string;
    image256x135?: string;
    image256x135AltText?: string;
    image2x3?: string;
    image2x3AltText?: string;
    image4x3?: string;
    image4x3AltText?: string;
    indexIdentifier?: string;
    instructorBio?: string;
    instructorName?: string;
    instructors?: Array<{
      bio?: string;
      courses?: ObjectWithIntegerIdArray;
      headshotUrl?: string;
      headshotUrlAltText?: string;
      id?: number;
      name?: string;
    }>;
    isMultiInstructor?: boolean;
    marketingCmColumn?: string;
    marketingOverview?: string;
    matureContent?: boolean;
    merchandisingImages?: ObjectWithIntegerIdArray;
    multiInstructorName?: string | null;
    nameplate?: string;
    nameplateAltText?: string;
    nameplateSvgAltText?: string;
    numChapters?: number;
    overview?: string;
    pdfs?: ObjectWithIntegerIdArray;
    primary16x9?: string;
    primary16x9AltText?: string;
    primary1x1?: string;
    primary1x1AltText?: string;
    primary2x3?: string;
    primary2x3AltText?: string;
    primaryCategory?: ObjectWithIntegerId;
    productId?: number;
    /**
     * This field is deprecated and will be removed in the future. Please use the `sample` field instead.
     *
     */
    sampleVideoId?: string;
    sample?: MediaItem;
    seasonNote?: string;
    seasons?: ObjectWithIntegerIdArray;
    secondary16x9AltText?: string;
    shortOverview?: string;
    skill?: string;
    slug?: string;
    status?: string;
    title?: string;
    totalSeconds?: number;
    type: CourseType;
    updatedAt?: string;
    uuid: string;
    vanityName?: string;
    welcomeStatement?: string;
    welcomeSurvey?: ObjectWithIntegerId;
    workbookCoverImages?: Array<string>;
    workbookCoverImagesAltTexts?: Array<string>;
    workbookDescription?: string;
  };
  courseId: number;
  courseImpactChapter?: number;
  hasNotes?: boolean;
  id: number;
  npsChapter?: number;
  npsDismissed?: string;
  originatorType: string;
  profile?: ObjectWithIntegerId;
  profileId?: number;
  profileUuid?: string;
  progressEntries?: Array<{
    chapter?: ObjectWithIntegerId;
    chapterId?: number;
    completed?: boolean;
    cursor?: number;
    duration?: number;
    durationSecs?: number;
    id?: number;
    progress?: number;
    updatedAt?: string;
    userCourse?: ObjectWithIntegerId;
    userCourseId?: number;
  }>;
  resumeChapter?: {
    abstract?: string;
    brightcoveVideoId?: string;
    chaptersInstructors?: ObjectWithIntegerIdArray;
    course?: ObjectWithIntegerId;
    duration?: string;
    durationSecs?: number;
    endScreenType?: string;
    id: number;
    indexIdentifier?: string;
    instructors?: ObjectWithIntegerIdArray;
    isExampleLesson?: boolean;
    number: number;
    offlineEnabled?: boolean;
    season?: string;
    slug: string;
    subchapters?: ObjectWithIntegerIdArray;
    title: string;
    type: "episode" | "chapter";
    updatedAt?: string;
    uuid?: string;
    videoThumbUrl?: string;
    videoThumbUrlAltText?: string;
  };
  resumeChapterId: number;
  resumeChapterProgress?: {
    chapterId?: number;
    createdAt?: string;
    cursor?: number;
    deletedAt?: string;
    duration?: number;
    id?: number;
    progress?: number;
    updatedAt?: string;
    userCourseId?: number;
  };
  updatedAt: string;
  user?: ObjectWithIntegerId;
  userId: number;
};

export type UserCoursesResult = Array<UserCourse | UserCourseDeep>;

export type CreateUserCourseAttributes = {
  courseId: number;
};

export type UserProgress = {
  indexIdentifier: string;
  contentType: string;
  contentId: number;
  contentUuid: string;
  cursorPercentage: number;
  isRecentlyPlayed: boolean;
  isCompleted: boolean;
  redirectPath: string;
};

export type UserProgressResults = Array<UserProgress>;

export type UserPlaylistResults = Array<{
  percentCompleted: number;
  completed: boolean;
  updatedAt: string;
  playlist?: Playlist;
}>;

export type UserAttributesForUpdate = {
  email?: string;
  oldPassword?: string;
  password?: string;
  passwordConfirmation?: string;
  matureContentEnabled?: boolean;
  locale?: "en-US" | "en-GB";
  subtitleEnabled?: boolean;
  subtitleLocale?: "en-US" | "en-GB";
};

export type VideoProgressEntry = {
  id: number;
  completed: boolean;
  cursor: number;
  duration: number;
  progress: number;
  updatedAt: string;
  videoId: number;
  video: ObjectWithIntegerId;
};

export type VideoProgressEntriesResult = Array<VideoProgressEntry>;

export type VideoProgressEntryAttributesForCreate = {
  videoId: number;
  duration: number;
  cursor?: number;
  progress?: number;
};

export type VideoProgressEntryAttributesForUpdate = {
  videoId?: number;
  duration?: number;
  cursor?: number;
  progress?: number;
};

export type WatchListListableType = "Course" | "Camp";

export const WatchListListableType = {
  COURSE: "Course",
  CAMP: "Camp",
} as const;

export type WatchListItemCourse = {
  uuid: string;
  id: number;
  indexIdentifier?: string;
  title?: string;
  slug?: string;
  brightcoveVideoId?: string;
  mediaUuid?: string;
  audioFriendly: string;
  headline?: string;
  classTileImage?: string;
  primary1x1?: string;
  primary2x3?: string;
  cinematic12x5?: string;
  nameplate?: string;
  instructorName?: string;
  welcomeStatement?: string;
  skill?: string;
  image2x3?: string;
  image16x9?: string;
  image256x135?: string;
  status: string;
  vanityName?: string;
  aapExclusive: boolean;
  availableAt?: string;
  instructorBio?: string;
  matureContent: boolean;
  engagementRank: number;
  overview?: string;
  shortOverview?: string;
  merchandisingImages?: Array<string>;
  workbookCoverImages?: unknown[];
  workbookDescription?: string;
};

export type WatchListItemChapter = {
  uuid: string;
  id: number;
  indexIdentifier?: string;
  abstract?: string;
  brightcoveVideoId?: string;
  mediaUuid?: string;
  duration?: string;
  endScreenType?: string;
  number?: number;
  slug?: string;
  title?: string;
  isExampleLesson: boolean;
  videoThumbUrl?: string;
  durationSecs?: number;
  offlineEnabled: boolean;
};

export type WatchListItem = {
  id: number;
  listableType: WatchListListableType;
  listableId: number;
  user?: ObjectWithIntegerId;
  listable?: WatchListItemCourse | WatchListItemChapter;
};

export type WatchListResults = Array<WatchListItem>;

export type WatchListItemAttributes = {
  listableId: number;
  listableType: WatchListListableType;
};

export type LandingPrice = {
  id: string;
  billingCycle: string;
  monetizedPrice: string;
  currencySymbol: string;
  amount: number;
};

export type LandingPrices = {
  bestCo: LandingPrice;
};

export type PersonaBundle = Product & {
  discount?: number;
  personaMonthlyPrice?: string;
};

export type SearchConfigParams = {
  maxFacetHits: number;
  maxValuesPerFacet: number;
  facetingAfterDistinct: boolean;
};

export type SearchConfig = {
  index: string;
  baseFilters: string;
  params: SearchConfigParams;
  searchAppId: string;
  searchApiKey: string;
};

export type EmailAccount = {
  email: string;
  isFacebookLogin: boolean;
  needsSetup: boolean;
};

export type UnregisteredEmail = {
  /**
   * True when the email belongs to a Fast Track Referral nominee.
   */
  isReferred: boolean;
};

export type UserRegistration = {
  name: string;
  password: string;
  passwordConfirmation: string;
  gdprOptIn: boolean;
};

export type CreditCard = {
  id: number;
  userId: number;
  stripeCustomerId: string;
  stripeCardId: string;
  fingerprint: string;
  lastFourDigits: number;
  expMonth: number;
  expYear: number;
  brand: string;
  isDefault: boolean;
  postalCode: string | null;
  billingCountry: string | null;
  bankCountry: string;
  createdAt: string;
  updatedAt: string;
  setupIntentId?: string | null;
  setupIntentStatus?: string | null;
  requiresAction?: boolean | null;
  authenticationRedirectUrl?: string | null;
  error?: {
    message?: string;
  } | null;
};

export type CreditCards = Array<CreditCard>;

export type CreateCreditCardAttributes = {
  creditCard: {
    token?: string;
    paymentMethodId?: string;
    fromGift?: boolean;
  };
};

export type SetupIntentStatus = {
  status?: string | null;
  error?: string | null;
};

export type LocaleText = {
  [key: string]: string;
};

export type DiscountCoupon = {
  amountOff: number;
  description: string;
  discountHeadline: string;
  discountType: string;
  discountValue: string;
  percentageOff: number;
  promoStatus: string;
  slug: string;
  intro?: string;
  type: string;
  upsellText: string;
  termsLink: string;
  modalTitle?: LocaleText;
  modalText?: LocaleText;
  modalCtaText?: LocaleText;
  error?: string;
  showPromotionAppliedOnError?: boolean;
  gift?: boolean;
  requireLogin?: boolean;
};

export type ElectronicGiftOrder = {
  sendAtType: "delayed" | "immediately";
  sendDate?: string;
  delayedTimestamp?: string;
};

export type GiftCardOrder = {
  messageLine2?: string;
  careOf: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
};

export type GiftOrder =
  | ({
      giftType: "electronic_gift" | "gift_card";
      gifteeName: string;
      email: string;
      gifterName: string;
      gifterEmail: string;
      message?: string;
      sponsored?: boolean;
    } & ElectronicGiftOrder)
  | GiftCardOrder;

export type StripeOrderAttributes = {
  token?: string;
  saveCard?: boolean | null;
  creditCardId?: number | null;
  discountSlug?: string | null;
  paymentMethodId?: string | null;
  wallet?: boolean | null;
  gift?: GiftOrder;
};

export type BraintreeOrderAttributes = {
  paymentMethodNonce?: string;
  paypalBillingAddress?: {
    city?: string;
    countryCode?: string;
    line1?: string;
    postalCode?: string;
    state?: string;
  };
};

export type PaymentType = "stripe" | "braintree_credit_card" | "braintree";

export const PaymentType = {
  STRIPE: "stripe",
  BRAINTREE_CREDIT_CARD: "braintree_credit_card",
  BRAINTREE: "braintree",
} as const;

export type RegionInfo = {
  regionCode?: string;
  postalCode?: string;
};

export type CreateOrderAttributes = StripeOrderAttributes &
  BraintreeOrderAttributes & {
    email?: string;
    paymentType: PaymentType;
    products: Array<number>;
    regionInfo?: RegionInfo;
    gclid?: string | null;
    fbclid?: string | null;
    turnstileToken?: string;
    /**
     * Plan Z experiment bucket (prcng-955V1), passed from frontend to prevent FE/BE bucket mismatch at 50/50 split
     */
    planZB?: "control" | "variant_1";
    purchaseSource:
      | "cert-subscription-page"
      | "certificate-cohort"
      | "certificate-expiration-extension"
      | "certificate-expiration-upsell"
      | "gift-modal"
      | "logged-in-gift-page"
      | "post-paywall-certificate-page"
      | "post-purchase-add-on"
      | "post-purchase-certificate-annual-pass-add-on"
      | "post-purchase-second-certificate"
      | "pre-paywall"
      | "storefront";
  };

export type ProductType =
  | "subscription"
  | "gift"
  | "course"
  | "voucher"
  | "add_on_subscription";

export const ProductType = {
  SUBSCRIPTION: "subscription",
  GIFT: "gift",
  COURSE: "course",
  VOUCHER: "voucher",
  ADD_ON_SUBSCRIPTION: "add_on_subscription",
} as const;

export type GiftAddOn = {
  monetizedPrice?: string;
  monetizedOriginalPrice?: string;
  discount?: number;
  discountId?: number;
  discountCode?: string;
  currency?: string;
  monetizedDiscount?: string;
  productId?: number;
  productTierName?: string | null;
};

export type MultiGiftsSummary = {
  monetizedPrice?: string;
  monetizedOriginalPrice?: string;
  discount?: number;
  discountId?: number;
  discountCode?: string;
  currency?: string;
  monetizedDiscount?: string;
  productId?: number;
  flatRate?: number;
  unmonetizedFlatRateTotal?: number;
};

export type CartProduct = {
  annualPassGiftHeadline?: string;
  afterpayInstallmentMonetizedFlatRate?: string;
  cartExclusive?: boolean;
  chaptersCount?: number | null;
  countryCode?: string;
  courseId?: number;
  courseSlug?: string;
  courseStatus?: string | null;
  courseTitle?: string;
  courseTagline?: string;
  currency: string;
  currencySymbol: string;
  discountCode?: string | null;
  braintreeRedeemable?: boolean;
  flatRate: number;
  geoPrice: string;
  giftCardDisclaimer?: string;
  hasPromo: boolean;
  headline?: string;
  hierarchy?: TierHierarchy;
  id: number;
  imageUrl?: string | null;
  instructorName?: string;
  isAnnualPass?: boolean;
  isCertCreditAddOn?: boolean;
  grantsCertificatePass?: boolean;
  grantsCertificateCredit?: boolean;
  isGeneric?: boolean | null;
  isMonthlyPass?: boolean;
  isSubscription: boolean;
  monetizedFlatRate: string;
  monetizedFlatRateTotal: string;
  monetizedYearPricePerMonth: string;
  monetizedYearPricePerMonthDiscounted: string | null;
  unmonetizedFlatRateTotal: number;
  multipleYearPass?: boolean;
  paypalSubAvailable?: boolean;
  price: number;
  pricingMarketingText?: string | null;
  pricingMarketingText2?: string | null;
  pricingPlanId?: number;
  productLtv: {
    gift?: number;
    regular?: number;
  };
  productTierName: string;
  receiptHeadline: string;
  /**
   * Only present for non-course assets such as certificate programs, which have no courseId.
   */
  slug?: string;
  stripePricingPlan?: string | null;
  type?: "PurchasePlan" | "Course" | "CertificateProgram";
  upsell?: boolean;
  vanityPrice?: number | null;
  displayPrice?: string;
  amountOff?: number;
  discountPercentage?: number;
  discountHeadline?: string;
  productType?: ProductType;
  giftAddOn?: GiftAddOn | null;
  monetizedDiscount?: string | null;
  quantity?: number;
  multiGiftsSummary?: MultiGiftsSummary | null;
  /**
   * The name of the product. It is only present for certificate programs.
   */
  displayName?: string | null;
};

export type SegmentEvent = {
  name?: string;
  properties?: {
    firstName?: string | null;
    lastName?: string | null;
    email?: string;
    contentIds?: Array<number>;
    postalCode?: string | null;
    contentType?: string;
    discount?: number;
    anonymousId?: string | null;
    freeTrialConversion?: boolean;
    isGift?: boolean;
    mcSlug?: string;
    orderId?: string;
    paymentId?: number;
    pricingPlanId?: number;
    productId?: number;
    productVanityName?: string | null;
    productSku?: string;
    revenue?: number;
    purchaseCurrency?: string;
    purchaseAmount?: number;
    total?: number;
    countryCode?: string;
    subscriptionWas?: string | null;
    firstTimeOrder?: boolean;
    currency?: string;
    cardLast4?: number;
    cardBrand?: string;
    fbp?: string | null;
    fbc?: string | null;
    freeTrialOrigin?: {
      name?: string;
      trialLength?: number;
      advocateId?: number;
      advocateEmail?: string;
      promoCode?: string;
      sharedContent?: string | null;
    } | null;
    ttclid?: string | null;
    trialLength?: number | null;
    trialExpiresAt?: string | null;
    isSponsored?: boolean;
    sponsorEmail?: string | null;
    sponsoreName?: string | null;
    sponsoreeEmail?: string;
    sponsoreeName?: string | null;
    paymentProvider?: string;
    purchaseSource?: string | null;
    sponsorCardLast4?: string | null;
    products?: ObjectWithIntegerIdArray;
  };
  integrations?: {
    integrations?: {
      [key: string]: unknown;
    };
  };
};

export type Order = {
  products: Array<CartProduct>;
  redirectPath: string;
  email?: string;
  needsSetup: boolean;
  newUserId?: number;
  orderId: number;
  subtotal: number;
  subtotalFormatted: number;
  promoResult: {
    error?: string;
  };
  isFreeTrial: boolean;
  freeTrialType?: "free_trial" | "guest_pass";
  segmentEvents: Array<SegmentEvent>;
  showReferralSurvey: boolean;
  referralSources: Array<string>;
  guestPass: {
    show?: boolean;
  };
  requiresAction?: boolean;
  afterpayRedirectUrl?: string;
  authenticationRedirectUrl?: string;
  orderSasNumber?: string;
  /**
   * specify user's BOGO gift token available to send
   */
  bogoGiftToken?: string;
  /**
   * specify when user's BOGO gift expires (iso 8601 format)
   */
  bogoGiftExpirationRaw?: string;
  /**
   * specify when the user's subscription expires (used for guest-pass iso 8601 format)
   */
  subscriptionEndsAt?: string;
  /**
   * prcng-4V1 experiment - specify if users purchased the new tier and it was auto upgraded
   */
  isExpanded?: boolean;
  /**
   * Link using PaymentElement
   */
  clientSecret?: string;
  /**
   * specifies if the payment method is stripe link
   */
  isStripeLink?: boolean;
};

export type OrderConfirmation = {
  id: number;
  status: string;
  products?: Array<CartProduct>;
  redirectPath?: string;
  needsSetup?: boolean;
  isFreeTrial?: boolean;
  segmentEvents?: Array<{
    name?: string;
    properties?: {
      firstName?: string | null;
      lastName?: string | null;
      email?: string;
      contentIds?: Array<number>;
      postalCode?: string | null;
      contentType?: string;
      discount?: number;
      anonymousId?: string | null;
      freeTrialConversion?: boolean;
      isGift?: boolean;
      mcSlug?: string;
      orderId?: string;
      paymentId?: number;
      pricingPlanId?: number;
      productId?: number;
      productVanityName?: string | null;
      productSku?: string;
      revenue?: number;
      purchaseCurrency?: string;
      purchaseAmount?: number;
      total?: number;
      countryCode?: string;
      subscriptionWas?: string | null;
      firstTimeOrder?: boolean;
      currency?: string;
      cardLast4?: number;
      cardBrand?: string;
      fbp?: string | null;
      fbc?: string | null;
      ttclid?: string | null;
      isSponsored?: boolean;
      sponsorEmail?: string | null;
      sponsoreName?: string | null;
      sponsoreeEmail?: string;
      sponsoreeName?: string | null;
      paymentProvider?: string;
      sponsorCardLast4?: string | null;
      products?: ObjectWithIntegerIdArray;
    };
    integrations?: {
      integrations?: {
        [key: string]: unknown;
      };
    };
  }>;
  showReferralSurvey?: boolean;
  referralSources?: Array<string>;
};

export type UpdateProductAttributes = {
  productId: number;
  discountSlug?: string;
};

export type AddProductAttributes = {
  productId: number;
  gift?: boolean;
  discountSlug?: string;
  productType?: string;
  quantity?: number;
  /**
   * Client-decided experiment bucket for the promo-period multi-gift volume discount experiment. Only honored while a promo is active. An absent or unrecognised value keeps the existing promo volume tiers.
   *
   */
  multiGiftPromoBucket?: "control" | "variant_1";
};

export type RemoveProductAttributes = {
  productId: number;
  productType: string;
};

export type CartProducts = {
  products: Array<CartProduct>;
  orderSummary?: {
    total?: string;
    discountedTotal?: string;
    discountAmount?: string;
  };
  /**
   * Checkout routing hint based on the user's existing subscription. 'stripe' routes to the credit card payment screen (Stripe); 'paypal' routes to the PayPal payment screen (Braintree). Null for logged-out users or users without an active subscription.
   *
   */
  existingPaymentMethod?: "stripe" | "paypal" | null;
};

export type RedeemBogoGift = {
  email: string;
  gifteeName: string;
  gifterEmail: string;
  gifterName: string;
  message: string;
  sendAtType: "delayed" | "immediately";
  sendDate?: string;
  sponsored?: boolean;
};

export type PersonaAddOn = {
  monetizedPrice?: string;
  monetizedOriginalPrice?: string;
  billingCycle?: string;
  currency?: string;
  productId?: number;
  productType?: string;
};

export type LearningToolkitAddOn = {
  monetizedPrice?: string;
  billingCycle?: string;
  currency?: string;
  productId?: number;
  productType?: string;
  monetizedOriginalPrice?: string;
  discount?: number;
  discountId?: number;
  discountCode?: string;
  monetizedDiscount?: string;
  status?: "purchasable" | "purchased" | "granted";
};

export type CertificateProgramAddOnPricing = {
  /**
   * Raw price value in cents
   */
  price: number;
  /**
   * Formatted price with currency symbol
   */
  monetizedPrice: string;
  /**
   * Currency code
   */
  currency: string;
  /**
   * Discount percentage
   */
  discount: number;
  /**
   * ID of the coupon applied for the discount
   */
  discountId?: number | null;
  /**
   * Code of the coupon applied for the discount
   */
  discountCode?: string | null;
  /**
   * Price in cents after discount applied
   */
  discountedPrice: number;
  /**
   * Formatted discounted price
   */
  discountedMonetizedPrice: string;
};

export type Image = {
  altText?: string;
  url: string;
};

export type CertificateProgramAddOnImages = {
  /**
   * The main program thumbnail image (16x9 aspect ratio)
   */
  mainImage: Image;
  /**
   * The partner logo lockup condensed light image
   */
  logo: Image;
};

export type CertificateProgramAddOnPartner = {
  /**
   * The name of the partner organization (e.g., "NAVY SEAL FOUNDATION")
   */
  name: string;
};

export type CertificateProgramAddOn = {
  /**
   * The unique identifier of the certificate program
   */
  id: string;
  /**
   * The slug of the certificate program
   */
  slug: string;
  /**
   * The title of the certificate program
   */
  title: string;
  /**
   * ID of the associated product
   */
  productId: number;
  /**
   * Always "certificate_program"
   */
  productType: "certificate_program";
  /**
   * UUID of the media resource for video playback
   */
  mediaUuid: string;
  pricing: CertificateProgramAddOnPricing;
  images: CertificateProgramAddOnImages;
  partner: CertificateProgramAddOnPartner;
};

export type CertificateCreditAddOn = {
  monetizedPrice?: string;
  monetizedSavings?: string;
  monetizedMonthlyPrice?: string;
  monetizedMonthlyOriginalPrice?: string;
  discount?: number;
  billingCycle?: string;
  currency?: string;
  productId?: number;
  productType?: string;
};

export type AnnualPassAddOn = {
  monetizedPrice?: string;
  monetizedOriginalPrice?: string;
  discount?: number;
  discountCode?: string;
  billingCycle?: string;
  currency?: string;
  productId?: number;
  productType?: string;
};

export type ProrationPreview = {
  /**
   * ID of the product
   */
  productId?: number;
  /**
   * Formatted current price with currency symbol
   */
  monetizedCurrentPrice?: string;
  /**
   * Formatted renewal price with currency symbol
   */
  monetizedRenewalPrice?: string;
  /**
   * Date when the subscription will renew (YYYY-MM-DD)
   */
  renewalDate?: string;
  /**
   * Formatted original price with currency symbol
   */
  monetizedOriginalPrice?: string;
  /**
   * Billing cycle of the product (e.g., monthly, yearly)
   */
  billingCycle?: string;
  /**
   * Currency code (e.g., USD, EUR)
   */
  currency?: string;
  /**
   * Type of the product (e.g., add-on, subscription)
   */
  productType?: string;
  discount?: number;
  discountId?: number;
  discountCode?: string;
};

export type EmailConfirmationLegacyAttributes = {
  action: EmailConfirmationAction;
  /**
   * The email address to confirm.
   */
  email?: string;
};

export type ContentRowUiConfigShowTileVideoOn =
  | "hover"
  | "first_visible"
  | "last_visible";

export const ContentRowUiConfigShowTileVideoOn = {
  HOVER: "hover",
  FIRST_VISIBLE: "first_visible",
  LAST_VISIBLE: "last_visible",
} as const;

export type ContentRowUiConfigTileImageMode =
  | "primary"
  | "cinematic"
  | "outcome"
  | "current_progress";

export const ContentRowUiConfigTileImageMode = {
  PRIMARY: "primary",
  CINEMATIC: "cinematic",
  OUTCOME: "outcome",
  CURRENT_PROGRESS: "current_progress",
} as const;

export type ContentRowUiConfigTileRatio = "16x9" | "2x3" | "1x1";

export const ContentRowUiConfigTileRatio = {
  _16X9: "16x9",
  _2X3: "2x3",
  _1X1: "1x1",
} as const;

export type ContentRowUiConfigTileVideoMode = "current_progress" | "trailer";

export const ContentRowUiConfigTileVideoMode = {
  CURRENT_PROGRESS: "current_progress",
  TRAILER: "trailer",
} as const;

export type ContentRowUiConfigType =
  | "carousel"
  | "hidden"
  | "grid"
  | "list"
  | "library_banner"
  | "enterprise_banner"
  | "assignment_carousel"
  | "looking_for_more_banner"
  | "daily_moments";

export const ContentRowUiConfigType = {
  CAROUSEL: "carousel",
  HIDDEN: "hidden",
  GRID: "grid",
  LIST: "list",
  LIBRARY_BANNER: "library_banner",
  ENTERPRISE_BANNER: "enterprise_banner",
  ASSIGNMENT_CAROUSEL: "assignment_carousel",
  LOOKING_FOR_MORE_BANNER: "looking_for_more_banner",
  DAILY_MOMENTS: "daily_moments",
} as const;

export type PartnershipEntitlement = {
  id: string;
  status: string;
  resellerName: string;
  resellerDisplayName: string;
  sku: string;
  partner: string;
  redirectAfterActivation: boolean;
  redemptionStatus: string;
  resellerSkuDisplayName: string;
  skuSlug: string;
  resellerAsset?: string | null;
  resellerUrl?: string | null;
  redirectUrl?: string | null;
  resellerAssetAltText?: string | null;
  faqUrl?: string | null;
};

export type PillKind =
  | "default"
  | "dim"
  | "transparent"
  | "primary"
  | "utility";

export const PillKind = {
  DEFAULT: "default",
  DIM: "dim",
  TRANSPARENT: "transparent",
  PRIMARY: "primary",
  UTILITY: "utility",
} as const;

export type ResumeChapter = {
  id: number;
  abstract: string;
  brightcoveVideoId?: string;
  mediaUuid: string;
  duration: string;
  endScreenType: string;
  number: number;
  slug: string;
  title: string;
  type: ChapterType;
  isExampleLesson: boolean;
  videoThumbUrl: string;
  uuid: string;
};

export type SessionsGalleryItem = {
  createdAt: string;
  id: number;
  moduleTitle: string;
  mediaSequence?: Array<{
    id: number;
    url: string;
    mediaType: string;
    status?: string;
    uuid?: string;
    position?: number;
  }>;
  postGroupId: number;
  postGroupType: string;
  text?: string;
};

export type SessionsGalleryFeed = {
  results: Array<SessionsGalleryItem>;
  cursor: number;
};

export type ThirdPartyOrderAttributes = {
  zipCode?: string;
};

export type CouponCategories = Category2;

export type CouponDiscountType = DiscountType;

export type PurchasePlans = PurchasePlan;

export type V3Bookmark = {
  /**
   * The unique identifier of a resource to bookmark.
   */
  uuid: string;
  /**
   * The time the resource was bookmarked.
   */
  bookmarkedAt: string;
};

export type Playhead = {
  progress: number;
  cursor: number;
  /**
   * The percentage of the thumbnail bar to display.
   */
  barPercentage: number;
  isComplete: boolean;
  updatedAt: string;
};

export type EnterpriseAdminInteractions = {
  assignment?: {
    canAssign: boolean;
    cta?: EnterpriseAdminInteractionsCta;
  };
};

export type DisplayPagesType = "CWP" | "CDP" | "SDP" | "SAP";

export const DisplayPagesType = {
  CWP: "CWP",
  CDP: "CDP",
  SDP: "SDP",
  SAP: "SAP",
} as const;

export type EnterpriseAdminInteractionsCta = {
  title: string;
  content?: EnterpriseAdminInteractionsCtaContent;
  /**
   * Applicable pages for this cta, "CDP - Content Details Page", "CWP" - Content Watch Page", "SDP" - Session Details Page, "SAP" - Session Activity Page
   */
  displayPages?: Array<string>;
};

export type EnterpriseAdminInteractionsCtaContent = {
  title: string;
  subtitle?: string;
  image?: {
    "1x1"?: Image;
  };
};

export type Assignment = {
  /**
   * The message shared by the admin.
   */
  message?: string;
  /**
   * Name of the assigner (admin)
   */
  assignedBy?: string;
  /**
   * Name of the assignee or assignees (user)
   */
  assignedTo?: string;
  assignedAt?: string;
  /**
   * Applicable pages for this assignment, "CDP - Content Details Page", "CWP" - Content Watch Page", "SDP" - Session Details Page, "SAP" - Session Activity Page
   */
  displayPages?: Array<string>;
};

export type NpsSurveyType =
  | "FreeformTextNpsSurveyStep"
  | "ScoreNpsSurveyStep"
  | "MultiSelectNpsSurveyStep"
  | "NumericalRatingNpsSurveyStep"
  | "ImprovementNpsSurveyStep"
  | "PriorProficiencyNpsSurveyStep"
  | "FamiliarityNpsSurveyStep"
  | "InspirationNpsSurveyStep"
  | "HowItHelpsNpsSurveyStep"
  | "RatingReasonNpsSurveyStep"
  | "PromoterHighlightsStep"
  | "DetractorConcernsStep";

export const NpsSurveyType = {
  FREEFORM_TEXT_NPS_SURVEY_STEP: "FreeformTextNpsSurveyStep",
  SCORE_NPS_SURVEY_STEP: "ScoreNpsSurveyStep",
  MULTI_SELECT_NPS_SURVEY_STEP: "MultiSelectNpsSurveyStep",
  NUMERICAL_RATING_NPS_SURVEY_STEP: "NumericalRatingNpsSurveyStep",
  IMPROVEMENT_NPS_SURVEY_STEP: "ImprovementNpsSurveyStep",
  PRIOR_PROFICIENCY_NPS_SURVEY_STEP: "PriorProficiencyNpsSurveyStep",
  FAMILIARITY_NPS_SURVEY_STEP: "FamiliarityNpsSurveyStep",
  INSPIRATION_NPS_SURVEY_STEP: "InspirationNpsSurveyStep",
  HOW_IT_HELPS_NPS_SURVEY_STEP: "HowItHelpsNpsSurveyStep",
  RATING_REASON_NPS_SURVEY_STEP: "RatingReasonNpsSurveyStep",
  PROMOTER_HIGHLIGHTS_STEP: "PromoterHighlightsStep",
  DETRACTOR_CONCERNS_STEP: "DetractorConcernsStep",
} as const;

export type NpsSurvey = {
  /**
   * Indicates if the survey should be taken.
   */
  shouldTakeSurvey: boolean;
  /**
   * The unique identifier of the content to display the survey after.
   */
  contentUuid: string;
  /**
   * When specified, application triggers a survey when the user reaches the end of the moment.
   */
  momentUuid?: string;
  steps: Array<NpsSurveyStep>;
};

export type NpsSurveyStep = {
  /**
   * The type of survey step. Check `NpsSurveyType` for the list of enums
   */
  stepType: string;
  /**
   * The slug for the question, used to identify the question in the survey.
   */
  questionSlug?: string;
  /**
   * The question to be asked in the survey step.
   */
  question?: string;
  /**
   * Indicates if the step is optional.
   */
  optional?: boolean;
  freeformText?: {
    /**
     * Placeholder text for the freeform text input.
     */
    placeholder?: string;
  };
  score?: {
    /**
     * Indicates if the step is an NPS score step.
     */
    isNps?: boolean;
    /**
     * Minimum score value.
     */
    minimumScore: number;
    /**
     * Maximum score value.
     */
    maximumScore: number;
    /**
     * Label for the minimum score value.
     */
    minimumLabel: string;
    /**
     * Label for the maximum score value.
     */
    maximumLabel: string;
    freeformText?: {
      /**
       * Title for the freeform text input.
       */
      title?: string;
      /**
       * Indicates if the freeform text input is optional.
       */
      optional?: boolean;
      /**
       * Placeholder text for the freeform text input.
       */
      placeholder?: string;
    };
  };
  multiSelect?: {
    selectOptions: Array<{
      /**
       * Slug for the select option, used to identify the option in the survey.
       */
      slug?: string;
      /**
       * Text to display for the select option.
       */
      text?: string;
      freeformText?: {
        /**
         * Placeholder text for the freeform text input.
         */
        placeholder?: string;
      };
    }>;
  };
  numericalRating?: {
    title: string;
    question: string;
  };
  improvement?: {
    title: string;
    question: string;
  };
  priorProficiency?: {
    question: string;
  };
  familiarity?: {
    question: string;
  };
  inspiration?: {
    question: string;
    selectOptions: Array<SurveyStepSelectOption>;
  };
  howItHelps?: {
    question: string;
    selectOptions: Array<SurveyStepSelectOption>;
  };
  ratingReason?: {
    title?: string;
    question: string;
    subheading?: string;
  };
  promoterHighlights?: {
    title?: string;
    question: string;
    subheading?: string;
    selectOptions: Array<SurveyStepSelectOption>;
  };
  detractorConcerns?: {
    title?: string;
    question: string;
    subheading?: string;
    selectOptions: Array<SurveyStepSelectOption>;
  };
};

export type SurveyStepSelectOption = {
  /**
   * Enum key for the step.
   * For the list of enums check `HowItHelpsStepValue` for howItHelps,
   * `InspirationStepValue` for inspiration, and `FeedbackAspectStepValue` for `promoterHighlights` and `detractorConcerns`.
   *
   */
  name: string;
  /**
   * text presented for the step
   */
  text: string;
};

export type Communities = Array<CommunityItem>;

export type CommunityItem = {
  /**
   * The name of the community.
   */
  name: string;
  isSelected: boolean;
  isNew: boolean;
  id: string;
};

export type RecommendedSource = {
  /**
   * Text label for the recommendation source.
   */
  label?: string;
  /**
   * URL of the logo image.
   */
  logoUrl: string;
  /**
   * Text to display when logo image is unavailable.
   */
  fallbackText: string;
  /**
   * Alternative text for the logo image, used for accessibility.
   */
  logoAltText: string;
};

/**
 * This object provides the information that is necessary to display a landing page
 * for a bundle of video content, such as the CDP (Content Details Page).
 *
 */
export type WatchBundle = {
  /**
   * The unique identifier for the WatchBundle.
   */
  watchBundleUuid: string;
  /**
   * The total duration of released video content, in seconds.
   */
  totalRuntime: number;
  /**
   * The count of video content in the bundle once all content has been released.
   */
  finalContentCount: number;
  /**
   * Indicates if the bundle is suitable for consuming audio content without video.
   */
  isAudioFriendly: boolean;
  /**
   * Indicates if the bundle is mature subject matter.
   */
  isMature: boolean;
  /**
   * An ordered list of starring instructors.
   */
  highlightedStars?: Array<WatchBundleStar>;
  /**
   * Indicates to the client whether to display the contents in a list on the watch page
   * or hide the list of content. Typically used for single cut content.
   *
   */
  shouldShowWatchList?: boolean;
  /**
   * An ordered list of video content contained in the WatchBundle.
   */
  contents: Array<WatchBundleContent>;
  /**
   * An ordered list of seasons that can be used to group the video content. Not all watch bundles have seasons.
   *
   */
  seasons: Array<WatchBundleSeason>;
  terminology: WatchBundleTerminology;
  text: WatchBundleText;
  image: WatchBundleImage;
  video: WatchBundleVideo;
  links: WatchBundleLinks;
  tracking: WatchBundleTracking;
};

export type WatchBundleLinks = {
  /**
   * A path to the content details page.
   */
  detailsPage?: string;
};

export type WatchBundleVideo = {
  trailer?: unknown & PublicMedia;
  autoPlay?: AutoPlayVideo;
};

export type WatchBundleImage = {
  titleOverlay?: unknown & Image;
  /**
   * Images that can be set as dark backgrounds.
   */
  background?: {
    "16x9"?: Image;
    "12x5"?: Image;
    "256x135"?: Image;
    "2x3"?: Image;
  };
  /**
   * Images that represent thumbnails of the bundle.
   */
  thumbnail?: {
    "1x1"?: Image;
    "16x9"?: Image;
  };
};

export type WatchBundleText = {
  /**
   * The title of the bundle, typically displayed above the `subtitle` or `continuedTitle` text.
   */
  title: string;
  /**
   * A continuation of the title, typically preceded by the title. Often, this text resembles the subtitle
   * but with leading text that gramatically joins the title and subtitle.
   *
   */
  continuedTitle: string;
  /**
   * A brief line of text that provides context to the bundle.
   */
  subtitle: string;
  /**
   * A more detailed description of the bundle.
   */
  description: string;
  /**
   * Auxilliary watch information to display to the user, such as total runtime and/or content count.
   *
   */
  watchDetails?: string;
  /**
   * The text that should appear label for a tab that contains the list of content for the watch bundle.
   * This will be formatted in "Title Case". Clients should change the case as they see fit so the text appears in the UX appropriately.
   *
   */
  contentListTab?: string;
  /**
   * The text used on a button or link when starting the watch bundle.
   */
  startWatchingCta?: string;
  /**
   * Provides additional context about the seasons, such as when the next season is coming.
   */
  seasonNote?: string;
  /**
   * Indicates the release schedule of the content, such as when new episodes are released. Currently used for series only.
   */
  releaseNote?: string;
};

/**
 * Information that describes the format of the watch bundle.
 */
export type WatchBundleTerminology = {
  text: {
    watchBundle: string;
    season: string;
    content: string;
  };
  image: {
    /**
     * An image that represents the term for the watch bundle and can be overlayed over a dark background.
     */
    watchBundleOverlay?: Image;
  };
};

export type WatchBundleStar = {
  text: {
    name: string;
    /**
     * A paragraph describing noteworthy achievements by the instructor.
     */
    description: string;
  };
  image: {
    thumbnail: {
      "1x1": Image;
    };
  };
};

export type WatchBundleSeason = {
  /**
   * The unique identifier for the season.
   */
  seasonUuid: string;
  /**
   * A number indicating the relative order of the season within the bundle.
   * A season should chronologically precede other seasons with higher sequence numbers.
   *
   */
  sequenceNumber: number;
  text: {
    title: string;
    /**
     * A descriptive text with details about the season.
     */
    teaser?: string;
  };
};

export type WatchBundleContent = {
  /**
   * The unique identifier for the video content.
   */
  contentUuid: string;
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This will be deprecated in the future.
   *
   */
  brightcoveVideoId?: string;
  /**
   * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
   *
   */
  mediaUuid?: string;
  /**
   * Experimental. The position in the video to begin playback.
   */
  startPosition?: number;
  /**
   * Experimental. The position in the video to end playback.
   */
  endPosition?: number;
  /**
   * The duration of the video, in seconds.
   */
  runtime: number;
  downloadDetails: {
    /**
     * Indicates if the video is downloadable on mobile devices.
     */
    isDownloadable: boolean;
  };
  cta?: {
    /**
     * A path to an existing page.
     */
    path: string;
    /**
     * Text for the cta element
     */
    text: string;
  };
  sharingDetails: {
    /**
     * Indicates if the content can be shared
     */
    isShareable: boolean;
    image: {
      "12x5"?: Image;
    };
    /**
     * Text for the share button
     */
    ctaText?: string;
  };
  /**
   * The unique identifier for the season this content belongs to.
   */
  seasonUuid?: string;
  /**
   * A number indicating the relative order of the content within the bundle.
   * A piece of content should chronologically precede other contents with higher sequence numbers.
   *
   */
  sequenceNumber: number;
  releaseDetails: {
    /**
     * Indicates if the content has been released for consumption.
     */
    isReleased: boolean;
    /**
     * Formatted in date-only ISO8601, the date the content has been released. If the content is yet to be released,
     * expect the date to be in the future.
     *
     */
    releasedOn?: string;
  };
  text: {
    /**
     * The headline of the content.
     */
    title: string;
    /**
     * Additional title for the content.
     */
    continuedTitle?: string;
    /**
     * The supporting headline of the content.
     */
    subtitle?: string;
    /**
     * The paragraph that provides and introduction and context to the content.
     */
    description?: string;
    /**
     * A short label that indicates the position of the content within the bundle.
     */
    sequenceLabel?: string;
  };
  image: {
    thumbnail: {
      "16x9": Image;
    };
  };
  moments: Array<Moment>;
  links: WatchBundleContentLinks;
  tracking: WatchBundleContentTracking;
  conversation?: WatchBundleContentConversation;
  chatEnabled?: boolean;
};

export type WatchBundleContentLinks = {
  /**
   * A path to the content watch page.
   */
  watchPage: string;
  /**
   * A path to the content details page. This attribute is deprecated and will be removed in the future. It is superseded by the `cta` attribute.
   * @deprecated
   */
  detailsPage?: string;
};

export type PublicMedia = {
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This will be deprecated in the future.
   *
   */
  brightcoveVideoId: string;
  /**
   * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
   *
   */
  mediaUuid: string;
  text: {
    /**
     * The headline of the trailer.
     */
    title: string;
  };
  image: {
    thumbnail: {
      "16x9": Image;
    };
  };
};

/**
 * The video that should be played automatically when the watch bundle is opened.
 */
export type AutoPlayVideo = {
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This will be deprecated in the future.
   *
   */
  brightcoveVideoId: string;
  /**
   * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
   *
   */
  mediaUuid: string;
};

export type Moment = {
  /**
   * The unique identifier for the Moment.
   */
  momentUuid: string;
  /**
   * The point in video the moment takes place, in seconds.
   */
  position: number;
  text: {
    /**
     * The title of the moment.
     */
    title: string;
  };
  tracking: MomentTracking;
};

export type WatchBundleTrackingType =
  | "PlaylistTracking"
  | "CourseTracking"
  | "SearchPlaylistTracking";

export const WatchBundleTrackingType = {
  PLAYLIST_TRACKING: "PlaylistTracking",
  COURSE_TRACKING: "CourseTracking",
  SEARCH_PLAYLIST_TRACKING: "SearchPlaylistTracking",
} as const;

export type WatchBundleTracking = {
  /**
   * The type of tracking object.
   */
  trackingType: string;
  courseSlug?: string;
  courseId?: string;
  courseVanityName?: string;
  playlist?: string;
  playlistId?: string;
  search?: string;
  watchBundleUuid?: string;
};

export type WatchBundleContentTracking = {
  contentType: string;
  contentId: string;
  chapterSlug?: string;
  courseSlug?: string;
  courseId?: string;
  contentTitle: string;
  resourceType: string;
  resourceId: string;
  videoId?: string;
  contentUuid?: string;
};

export type WatchBundleContentConversation = {
  courseId: number;
  chapterId: number;
};

export type MomentTracking = {
  resourceType: string;
  resourceId: string;
};

/**
 * A dedicated CDP representation for a WatchBundle, aggregating the bundle
 * and related domain data into a single response.
 *
 */
export type WatchBundleDetails = {
  bundle: WatchBundle;
  /**
   * Mobile content gems for the bundle. Only present for courses.
   *
   */
  gems?: Array<WatchBundleContentGem>;
  /**
   * Featured reviews for the bundle. Only present for courses.
   *
   */
  reviews?: Array<WatchBundleReview>;
};

/**
 * A mobile content gem associated with a course, displayed on the CDP.
 *
 */
export type WatchBundleContentGem = {
  title: string;
  position: number;
  image: Image;
};

/**
 * A featured course review, displayed on the CDP.
 *
 */
export type WatchBundleReview = {
  name: string;
  location: string;
  review: string;
  position: number;
  image?: Image;
};

export type WatchBundleExtras = {
  /**
   * The unique identifier for the WatchBundle.
   */
  watchBundleUuid: string;
  documents?: {
    guide?: Document;
    additionalMaterial?: Array<Document>;
  };
  externalResources?: Array<Document>;
  recipes?: Array<WatchBundleRecipe>;
  featuredRow?: {
    /**
     * Indicates that the client should show a featured row on the watch page.
     * This row typically takes the form of top rated lessons.
     *
     */
    shouldShowFeaturedRow?: boolean;
  };
  takeaways?: Array<Takeaway>;
};

export type Document = {
  url: string;
  /**
   * See `DocumentIntent` for a list of currently supported values.
   */
  intent?: string;
  text: {
    title: string;
    description?: string;
  };
  image?: {
    cover: Image;
  };
  tracking: DocumentTracking;
  cta?: {
    title: string;
  };
};

export type DocumentIntent = "download" | "redirect";

export const DocumentIntent = {
  DOWNLOAD: "download",
  REDIRECT: "redirect",
} as const;

export type WatchBundleRecipe = {
  recipeUuid: string;
  contentUuid: string;
  /**
   * Indicates if this recipe can be shared publicly
   */
  isShareable: boolean;
  text: {
    title: string;
    serves: string;
  };
  image?: {
    background?: {
      "4x3"?: Image;
    };
  };
  html: {
    ingredients: string;
    instructions: string;
  };
  document?: Document;
  tracking: RecipeTracking;
};

export type RecipeTracking = {
  resourceType: string;
  resourceId: string;
};

export type DocumentTracking = {
  resourceTitle: string;
  resourceType: string;
  resourceId: string;
};

export type Takeaway = {
  takeawayUuid: string;
  contentUuid: string;
  summary?: string;
  popup?: {
    showPosition: number;
    hidePosition: number;
  };
  list?: {
    startPosition: number;
    endPosition: number;
  };
};

export type WatchBundleInteractions = {
  continue?: WatchBundleContinueWatching;
  bookmarks?: WatchBundleBookmarks;
  notes?: WatchBundleNotes;
  surveys?: WatchBundleSurveys;
  assignment?: Assignment;
  enterpriseAdmin?: EnterpriseAdminInteractions;
  recommendedSource?: RecommendedSource;
};

export type WatchBundleSurveys = {
  netPromoterScore?: NpsSurvey;
  segment?: SegmentSurvey;
};

export type SegmentSurvey = {
  contentUuid: string;
  title: string;
  question: string;
  cta: SegmentSurveyCta;
};

export type SegmentSurveyCta = {
  /**
   * A path to an existing page.
   */
  path: string;
  /**
   * Text for the cta element
   */
  text: string;
};

export type WatchBundleContinueWatching = {
  resume?: ContentResume;
  contents?: Array<ContentPlayhead>;
};

export type ContentResume = {
  contentUuid: string;
  /**
   * The text to apply to a button or link when resuming the watch bundle content.
   */
  resumeText?: string;
};

export type ContentPlayhead = {
  contentUuid: string;
} & Playhead;

export type ContentBookmark = {
  contentUuid: string;
  /**
   * The time the resource was bookmarked.
   */
  bookmarkedAt: string;
};

export type MomentBookmark = {
  momentUuid: string;
  /**
   * The time the resource was bookmarked.
   */
  bookmarkedAt: string;
};

export type RecipeBookmark = {
  recipeUuid: string;
  /**
   * The time the resource was bookmarked.
   */
  bookmarkedAt: string;
};

export type WatchBundleBookmarks = {
  /**
   * Indicates if bookmarking is supported.
   */
  isSupported: boolean;
  bookmarks?: Array<V3Bookmark>;
  /**
   * @deprecated
   */
  contents?: Array<ContentBookmark>;
  /**
   * @deprecated
   */
  moments?: Array<MomentBookmark>;
  /**
   * @deprecated
   */
  recipes?: Array<RecipeBookmark>;
};

export type WatchBundleNotes = {
  /**
   * Indicates if notes are supported.
   */
  isSupported: boolean;
  contents?: Array<ContentNote>;
};

export type ContentNote = {
  contentUuid: string;
  entry: string;
  tracking?: NoteTracking;
};

export type NoteTracking = {
  resourceType: string;
  resourceUuid: string;
  resourceId?: string;
};

export type WatchBundleContentInteractions = {
  netPromoterScore?: NpsSurvey;
};

export type PlaybackTokenResponse = {
  token: string;
};

export type V3Note = {
  entry: string;
};

export type UpdateSurvey = {
  /**
   * The slug of the question being answered. This is used to identify the specific survey step.
   * It should match the slug defined in the survey step.
   *
   */
  questionSlug?: string;
  /**
   * Freeform text for the survey step `FreeformTextNpsSurveyStep`
   */
  freeformText?: {
    /**
     * A text entry for the given survey step
     */
    text: string;
  };
  /**
   * Survey feedback for the survey step `ScoreNpsSurveyStep`
   */
  score?: {
    /**
     * A score for the given survey step
     */
    value: number;
    /**
     * A freeform text entry for the given survey step
     */
    freeformText?: string;
  };
  /**
   * Survey feedback for the survey step `MultiSelectNpsSurveyStep`
   */
  multiSelect?: {
    selections: Array<{
      /**
       * The slug of the select option
       */
      slug: string;
      /**
       * A freeform text entry for the given survey step
       */
      freeformText?: string;
    }>;
  };
  /**
   * Survey feedback for the netPromoterScore survey step `NumericalRatingNpsSurveyStep``
   */
  numericalRating?: {
    score: number;
  };
  /**
   * Survey feedback for the netPromoterScore survey step `ImprovementNpsSurveyStep``
   */
  improvement?: {
    /**
     * A text entry for the given survey step
     */
    feedback: string;
  };
  /**
   * Survey feedback for the netPromoterScore survey step `PriorProficiencyNpsSurveyStep``
   */
  priorProficiency?: {
    /**
     * A text entry for the given survey step
     */
    feedback: string;
  };
  /**
   * Survey feedback for the netPromoterScore survey step `FamiliarityNpsSurveyStep``
   */
  familiarity?: {
    /**
     * A text entry for the given survey step
     */
    feedback: string;
  };
  /**
   * Survey feedback for the survey step `InspirationNpsSurveyStep``
   */
  inspiration?: {
    /**
     * comma-separated list of options for this survey step. Check `InspirationStepValue` for the list of enums
     */
    feedback?: string;
    freeFormFeedback?: string;
  };
  /**
   * Survey feedback for the survey step `HowItHelpsNpsSurveyStep``
   */
  howItHelps?: {
    /**
     * comma-separated list of options for this survey step. Check `HowItHelpsStepValue` for the list of enums
     */
    feedback?: string;
    freeFormFeedback?: string;
  };
};

export type InspirationStepValue =
  | "Topic"
  | "Instructor"
  | "Recommendation"
  | "Asked"
  | "Other";

export const InspirationStepValue = {
  TOPIC: "Topic",
  INSTRUCTOR: "Instructor",
  RECOMMENDATION: "Recommendation",
  ASKED: "Asked",
  OTHER: "Other",
} as const;

export type HowItHelpsStepValue =
  | "Work"
  | "Personal"
  | "Motivation"
  | "NoImpact"
  | "Other";

export const HowItHelpsStepValue = {
  WORK: "Work",
  PERSONAL: "Personal",
  MOTIVATION: "Motivation",
  NO_IMPACT: "NoImpact",
  OTHER: "Other",
} as const;

/**
 * The enum values for the `PromoterHighlightsStep` and `DetractorConcernsStep` survey steps.
 *
 */
export type FeedbackAspectStepValue =
  | "InstructorAndTeachingStyle"
  | "Relevance"
  | "Structure"
  | "Activities"
  | "Pacing"
  | "UsabilityAndSupport"
  | "Other"
  | "None";

export const FeedbackAspectStepValue =
  /**
   * The enum values for the `PromoterHighlightsStep` and `DetractorConcernsStep` survey steps.
   *
   */
  {
    INSTRUCTOR_AND_TEACHING_STYLE: "InstructorAndTeachingStyle",
    RELEVANCE: "Relevance",
    STRUCTURE: "Structure",
    ACTIVITIES: "Activities",
    PACING: "Pacing",
    USABILITY_AND_SUPPORT: "UsabilityAndSupport",
    OTHER: "Other",
    NONE: "None",
  } as const;

export type Sharing = {
  links: {
    facebook: SharingLink;
    linkedin: SharingLink;
    twitter: SharingLink;
    copy: SharingLink;
    messenger: SharingLink;
    email: EmailSharingLink;
    more: SharingLink;
    message: SharingLink;
  };
  tracking: {
    /**
     * The identifier of the user requesting shareable links.
     */
    advocateId: string;
    /**
     * The email of the user requesting shareable links.
     */
    advocateEmail: string;
  };
};

export type SharingLink = {
  url: string;
  /**
   * Indicates if this link offers a redeemable guest pass.
   */
  includesGuestPass: boolean;
};

export type EmailSharingLink = SharingLink & {
  /**
   * The subject of the email to prepare.
   */
  subject: string;
  /**
   * The body of the email to prepare.
   */
  body: string;
};

export type SessionActivityInteractions = {
  communities?: Communities;
  community?: Community;
  surveys?: {
    netPromoterScore?: NpsSurvey;
  };
};

/**
 * This field is deprecated and will be replaced by `communities`.
 * @deprecated
 */
export type Community = {
  name: string;
};

export type SessionsInteractions = {
  assignment?: Assignment;
  enterpriseAdmin?: EnterpriseAdminInteractions;
  communities?: Communities;
};

export type CreateAssignments = {
  assignees: Array<AssigneeIdentifier>;
  message?: string;
  contentUuid: string;
};

export type Assignees = Array<Assignee>;

export type Assignee = {
  /**
   * Type of Assignee. Check `AssigneeTypeValue` for the list of enums
   */
  type: string;
  team?: V3Team;
  member?: Member;
};

export type AssigneeTypeValue = "Member" | "Team";

export const AssigneeTypeValue = {
  MEMBER: "Member",
  TEAM: "Team",
} as const;

export type Member = {
  id: string;
  name: string;
  email: string;
  noEmailUser: boolean;
  username?: string;
};

export type V3Team = {
  id: string;
  name: string;
};

export type AssigneeIdentifier = {
  id: string;
  /**
   * Assignee.  See 'AssigneeType' for the list of enums
   */
  type: string;
};

export type UserIdentifier = {
  userId: string;
};

export type ContentProgress = {
  /**
   * The unique identifier of an assignable resource
   */
  uuid: string;
  /**
   * A list of supported columns that should be shown in the Member Progress table (based on user's permissions)
   */
  detailedProgressFields: Array<string>;
  /**
   * The total number of members this class was shared with
   */
  totalMembersShared: number;
  /**
   * The total number of members this class was shared by the current user
   */
  totalMembersSharedByMe: number;
  /**
   * The total number of members with filters applied
   */
  totalMembers: number;
  /**
   * The total number of members that watched the course
   */
  totalMembersStarted: number;
  /**
   * Whether the data is incomplete
   */
  dataIncomplete: boolean;
  details: AssignedContentDetails;
  detailedProgress?: Array<DetailedProgress>;
  effectiveness?: {
    /**
     * The effectiveness rating given by viewers, on a scale of 0-10
     */
    rating: number;
    /**
     * The number of viewers who have rated the content
     */
    responseCount: number;
    /**
     * The list of individual users' NPS ratings (anonymized)
     */
    scores: Array<number>;
  };
  engagementMetrics?: {
    /**
     * The total number of members that started this class
     */
    started: number;
    /**
     * The total number of minutes watched
     */
    totalMinutesWatched: number;
    /**
     * The average of minutes watched
     */
    avgMinutesWatched: number;
    /**
     * The percentage of completion
     */
    pctCompletion: number;
    /**
     * The total number of members with filters applied
     */
    totalMembers: number;
    /**
     * The percentage of members that started this class
     */
    pctStarted: number;
    /**
     * The percentage of activities completed
     */
    pctActivitiesCompleted?: number;
  };
  impactSurvey?: {
    /**
     * The total number of viewers who responded to an impact survey for this content
     */
    totalResponseCount: number;
    prompts: Array<ImpactScorePrompt>;
  };
  programDetails?: {
    /**
     * The total number of sessions for this program
     */
    totalSessions: number;
    programSessions?: Array<ProgramSession>;
  };
};

export type ProgramSession = {
  /**
   * The unique identifier of the session
   */
  uuid: string;
  /**
   * The title of the session
   */
  title: string;
  image?: Image;
};

export type AssignedContents = Array<AssignedContent>;

export type AssignedContent = {
  /**
   * The unique identifier of a resource that has been assigned.
   */
  uuid: string;
  /**
   * The slug of the shared content.
   */
  slug: string;
  /**
   * Whether the current user can view progress for this assignment
   */
  canViewProgress: boolean;
  details: AssignedContentDetails;
  assignments: Array<Assignment>;
};

export type AssignedContentDetails = {
  /**
   * The title of the content
   */
  title: string;
  /**
   * The subtitle of the content, typically displayed below the main title
   */
  subtitle: string;
  image: Image;
};

export type AssignableContentResult = {
  contentItems: Array<AssignableContentListItem>;
};

export type AssignableContentListItem = {
  /**
   * The unique identifier of the content
   */
  uuid: string;
  /**
   * The title of the content
   */
  title: string;
};

export type DetailedProgress = {
  /**
   * User id
   */
  userId: number;
  /**
   * User Email Address
   */
  userEmail: string;
  /**
   * User Name
   */
  userName: string;
  /**
   * First share message from admin
   */
  firstShareMessage?: string;
  /**
   * Date and time when this content was first shared with the user
   */
  firstSharedOn?: string;
  /**
   * Name of the admin who shared this content first
   */
  firstSharedBy?: string;
  /**
   * Progress percentage of the user for the current content
   */
  contentProgress?: number;
  /**
   * Progress in minutes of the user for the current content
   */
  contentProgressMinutes?: number;
  /**
   * Date and time when the user started taking the content
   */
  contentStartedAt?: string;
  /**
   * Date and time when the user completed the content
   */
  contentCompletedAt?: string;
  /**
   * Date and time when the user last accessed this content
   */
  contentLastAccessedAt?: string;
  /**
   * The title of the content
   */
  contentTitle?: string;
  /**
   * Content duration in minutes
   */
  contentDurationMinutes?: number;
  /**
   * The content primary skill
   */
  contentSkill?: string;
  userNoEmailUser?: boolean;
  userUsername?: string;
  /**
   * Average completion percentage of the user for the current content
   */
  pctActivitiesCompleted?: number;
};

export type ImpactScorePrompt = {
  /**
   * The text of the prompt
   */
  promptText: string;
  /**
   * The number of respondents who agreed with the prompt
   */
  responseCount: number;
  /**
   * The percentage of respondents who agreed with the prompt
   */
  responsePct: number;
  textResponses: Array<TextResponse>;
};

export type TextResponse = {
  /**
   * A viewer's free-form text response to the prompt
   */
  text: string;
};

export type NavigationContents = Array<NavigationContent>;

export type NavigationContent = {
  /**
   * Path Action or TeamID.  See 'NavigationPathItems' for available paths
   */
  path: string;
  /**
   * Display text to show in sidebar
   */
  label: string;
  /**
   * (optional) Access to current option, unless set this value in 'false' only user for team hierarchy
   */
  enabled?: boolean;
  children?: Array<NavigationContent>;
};

export type V3Organization = {
  name: string;
  /**
   * A list of roles supported of current user
   */
  roles: Array<string>;
  /**
   * Whether current user has analytics access
   */
  analytics: boolean;
  /**
   * Whether current user has content assignments access
   */
  contentAssignments: boolean;
  teamsHierarchy: Array<TeamsHierarchy>;
};

export type TeamsHierarchy = {
  /**
   * The unique identifier of a team
   */
  id: string;
  /**
   * Display the team name
   */
  name: string;
  /**
   * A list of roles supported of current user for this team
   */
  roles: Array<string>;
  /**
   * License release date if the team is belongs to one.
   */
  launchDate: string;
  /**
   * Id of the parent team if exits
   */
  parentTeamId?: number;
  /**
   * Whether the team owns a license
   */
  ownsLicense?: boolean;
  /**
   * The team can serve as a data filter
   */
  filterable: boolean;
  /**
   * Whether the team supports filtering by revoked users
   */
  revokedUsersAvailable: boolean;
  tracking: {
    /**
     * Admin type for this team
     */
    adminType: string;
    /**
     * User permission for this team
     */
    adminPermission: string;
  };
  children: Array<TeamsHierarchy>;
};

export type EnterpriseLicenses = Array<EnterpriseLicense>;

export type EnterpriseLicense = {
  /**
   * Internal ID of the license
   */
  licenseId: number;
  /**
   * License Type.  See 'EnterpriseLicenseTypes' for available types
   */
  licenseType: string;
  /**
   * Number of seats available
   */
  quantity: number;
  /**
   * The date the license expires
   */
  expiresAt: string;
  /**
   * Cost per seat for the license, note that this is not available for all licenses
   */
  seatPrice?: number;
};

export type EnterpriseLicenseTypes = "trial" | "license" | "grant" | "demo";

export const EnterpriseLicenseTypes = {
  TRIAL: "trial",
  LICENSE: "license",
  GRANT: "grant",
  DEMO: "demo",
} as const;

export type V3Playlists = Array<V3Playlist>;

export type V3Playlist = {
  uuid: string;
  slug?: string;
  /**
   * The playlist title.
   */
  title: string;
  /**
   * Number of lessons included in the playlist.
   */
  totalLessons: number;
  creator?: {
    name?: string;
    email: string;
  };
  /**
   * The playlist description.
   */
  description?: string;
  /**
   * See 'PlaylistStatus' for available statuses
   */
  status: string;
  /**
   * The date the resource was created.
   */
  createdAt: string;
  /**
   * The date the resource was last updated.
   */
  updatedAt: string;
  primarySkill?: EnterprisePlaylistSkill;
  secondarySkill?: EnterprisePlaylistSkill;
  skills?: Array<EnterprisePlaylistSkill>;
  duration: number;
  assets?: {
    tall: PlaylistFile;
    wide: PlaylistFile;
    discussionGuide?: PlaylistFile;
  };
  visibleTo?: Array<{
    organization?: string;
    teams?: Array<string>;
  }>;
  isDeletionAllowed?: boolean;
};

export type EnterprisePlaylistSkill = {
  /**
   * uuid of the requested resource
   */
  uuid: string;
  /**
   * The name of the skill
   */
  name: string;
  slug?: string;
  /**
   * When skill has a parent, specified the uuid from it.
   */
  parentUuid?: string;
};

export type EnterprisePlaylistLesson = {
  /**
   * uuid of the requested resource
   */
  uuid: string;
  /**
   * The position in which the lesson is shown
   */
  position: number;
  image: Image;
  /**
   * The lesson name.
   */
  name: string;
  /**
   * The lesson description.
   */
  description?: string;
  /**
   * The instructor names involved in this lesson
   */
  instructors: string;
  /**
   * Lesson duration in seconds
   */
  duration: number;
  /**
   * See 'PlaylistStatus' for available statuses
   */
  status: string;
  isDeletionAllowed: boolean;
  /**
   * The date when the lesson was added to the playlist.
   */
  createdAt: string;
  /**
   * The content type of the lesson
   */
  contentType: string;
};

export type CreatePlaylist = {
  /**
   * The playlist title.
   */
  title: string;
  /**
   * The organization id to which the playlist belongs.
   */
  organizationId: string;
};

export type ReorderLessons = {
  lessons: Array<EnterprisePlaylistLessonOrder>;
};

export type CreatedPlaylist = {
  /**
   * The unique identifier of the playlist
   */
  uuid: string;
};

export type UpdatePlaylist = {
  /**
   * The playlist title.
   */
  title?: string;
  /**
   * The playlist description.
   */
  description?: string;
  playlistDiscussionGuide?: Blob | File;
  playlistTwoByThree?: Blob | File;
  playlistTwoByThreeAltText?: string;
  playlistPosterImage?: Blob | File;
  playlistPosterImageAltText?: string;
  /**
   * uuid of the primary skill
   */
  primarySkill?: string;
  /**
   * comma-separated list of skills uuids
   */
  secondarySkills?: string;
  removeDiscussionGuide?: boolean;
};

export type EnterprisePlaylistLessonOrder = {
  /**
   * The unique identifier of the lesson
   */
  uuid: string;
  /**
   * The position in which the lesson is shown
   */
  position: number;
};

export type PlaylistFile = {
  altText?: string;
  url: string;
  filename?: string;
};

export type EnterprisePlaylistAddLessons = {
  lessons: Array<EnterprisePlaylistNewLesson>;
};

export type EnterprisePlaylistNewLesson = {
  /**
   * The unique identifier of the lesson
   */
  uuid: string;
};

export type UpdateLesson = {
  /**
   * The lesson name.
   */
  name?: string;
  /**
   * The lesson description.
   */
  description?: string;
  /**
   * See 'PlaylistStatus' for available statuses
   */
  status?: string;
};

export type Program = {
  /**
   * The unique identifier of the program
   */
  uuid: string;
  /**
   * The program slug.
   */
  slug: string;
  details: {
    /**
     * The program title.
     */
    title: string;
    /**
     * The program subtitle.
     */
    subtitle: string;
    /**
     * The program about.
     */
    about: string;
    /**
     * The program duration.
     */
    duration: string;
    audience: string;
    bestFor: string;
  };
  userDetails: {
    /**
     * Determines whether the user has permission to share the program.
     */
    canAssign: boolean;
    /**
     * Indicates whether or not the user is enrolled in the program.
     */
    isEnrolled?: boolean;
    progress: ProgramUserDetailsProgress;
  };
  programBanner21x9?: Image;
  image1x1?: Image;
  programTile16x9?: Image;
  programBanner16x9?: Image;
  instructors?: Array<ProgramInstructor>;
  modules?: Array<ProgramModule>;
  adminResources?: Array<ProgramAdminResource>;
};

export type ProgramInstructor = {
  /**
   * The instructor name.
   */
  name: string;
  image: Image;
  /**
   * The instructor bio.
   */
  bio: string;
};

export type ProgramModule = {
  /**
   * The unique identifier of the session
   */
  uuid: string;
  /**
   * The position in which the module is shown
   */
  position?: number;
  /**
   * Number of activities included in the module.
   */
  totalActivities?: number;
  /**
   * The module duration.
   */
  duration?: string;
  /**
   * The module title.
   */
  title: string;
  /**
   * The module description.
   */
  description: string;
  competencies?: Array<{
    name: string;
    items: Array<string>;
  }>;
  /**
   * The slug of the session
   */
  slug: string;
  image?: Image;
  skills?: Array<string>;
  progress?: ProgramModuleProgress;
  resource?: ProgramModuleResource;
};

export type ProgramModuleProgress = {
  /**
   * See 'ProgramModuleStatus' for available statuses.
   */
  status: string;
  /**
   * The percentage in progress of the module
   */
  completedPercentage: number;
  buttonText?: string;
  /**
   * The task slug to resume or start the session.
   */
  moduleResumeTaskSlug?: string;
  /**
   * The task uuid to resume or start the session.
   */
  moduleResumeTaskUuid?: string;
};

export type ProgramUserDetailsProgress = {
  buttonText: string;
  /**
   * The session slug to resume or start the program.
   */
  programResumeCampSlug: string;
  /**
   * The task slug to resume or start the program.
   */
  programResumeTaskSlug: string;
};

export type ProgramAdminResource = {
  /**
   * The stage to which the resource belongs. See 'ProgramResourceStage' for possible values.
   */
  stage: string;
  /**
   * URL to download a zip file including all admin resources of the program stage.
   */
  url: string;
  buttonText: string;
  /**
   * A comma-separated string of document identifiers belonging to the resource.
   */
  documentIds?: string;
};

export type ProgramModuleResource = {
  /**
   * URL to download the resources of the module.
   */
  url: string;
  buttonText: string;
  /**
   * A comma-separated string of document identifiers belonging to the resource.
   */
  documentIds?: string;
};

/**
 * Describes the available navigation path items
 */
export type NavigationPathItems =
  | "overview"
  | "teams"
  | "shared-content"
  | "analytics"
  | "active-users"
  | "engagement"
  | "top-skills"
  | "top-courses"
  | "course-progress"
  | "member-leaderboard"
  | "playlists"
  | "customizations"
  | "logo"
  | "messaging"
  | "certificates";

export const NavigationPathItems =
  /**
   * Describes the available navigation path items
   */
  {
    OVERVIEW: "overview",
    TEAMS: "teams",
    SHARED_CONTENT: "shared-content",
    ANALYTICS: "analytics",
    ACTIVE_USERS: "active-users",
    ENGAGEMENT: "engagement",
    TOP_SKILLS: "top-skills",
    TOP_COURSES: "top-courses",
    COURSE_PROGRESS: "course-progress",
    MEMBER_LEADERBOARD: "member-leaderboard",
    PLAYLISTS: "playlists",
    CUSTOMIZATIONS: "customizations",
    LOGO: "logo",
    MESSAGING: "messaging",
    CERTIFICATES: "certificates",
  } as const;

/**
 * Describes the available assignee types
 */
export type AssigneeType = "Team" | "Member";

export const AssigneeType =
  /**
   * Describes the available assignee types
   */
  {
    TEAM: "Team",
    MEMBER: "Member",
  } as const;

/**
 * Describes the available detailed progress fields
 */
export type DetailedProgressFields =
  | "content_last_accessed_at"
  | "pct_completion"
  | "first_shared_by"
  | "first_shared_on"
  | "unshare"
  | "pct_activities_completed";

export const DetailedProgressFields =
  /**
   * Describes the available detailed progress fields
   */
  {
    CONTENT_LAST_ACCESSED_AT: "content_last_accessed_at",
    PCT_COMPLETION: "pct_completion",
    FIRST_SHARED_BY: "first_shared_by",
    FIRST_SHARED_ON: "first_shared_on",
    UNSHARE: "unshare",
    PCT_ACTIVITIES_COMPLETED: "pct_activities_completed",
  } as const;

/**
 * Describes the available admin roles
 */
export type AdminRoles = "management_admin" | "performance_admin";

export const AdminRoles =
  /**
   * Describes the available admin roles
   */
  {
    MANAGEMENT_ADMIN: "management_admin",
    PERFORMANCE_ADMIN: "performance_admin",
  } as const;

/**
 * Describes the available playlist statuses
 */
export type PlaylistStatus = "unavailable" | "available";

export const PlaylistStatus =
  /**
   * Describes the available playlist statuses
   */
  {
    UNAVAILABLE: "unavailable",
    AVAILABLE: "available",
  } as const;

/**
 * Describes the available program resource stages
 */
export type ProgramResourceStage = "before" | "along" | "after";

export const ProgramResourceStage =
  /**
   * Describes the available program resource stages
   */
  {
    BEFORE: "before",
    ALONG: "along",
    AFTER: "after",
  } as const;

/**
 * Describes the available program module statuses
 */
export type ProgramModuleStatus = "Not Started" | "In Progress" | "Done";

export const ProgramModuleStatus =
  /**
   * Describes the available program module statuses
   */
  {
    NOT_STARTED: "Not Started",
    IN_PROGRESS: "In Progress",
    DONE: "Done",
  } as const;

/**
 * Quote Request, requires either email and address OR discountCode
 */
export type EnterpriseQuoteRequest = {
  /**
   * First Name
   */
  firstName?: string;
  /**
   * Last Name
   */
  lastName?: string;
  /**
   * Email address of the prospective Customer
   */
  email?: string;
  address?: EnterpriseAddress;
  /**
   * Quanitity for the order
   */
  quantity: number;
  product: EnterpriseProduct;
  /**
   * Discount Code associated with the quote request
   */
  discountCode?: string;
  /**
   * VAT Identification number (required for EU customers)
   */
  vatId?: string;
};

/**
 * Addon Quote Request, requires licenseId and quantity
 */
export type EnterpriseAddonQuoteRequest = {
  /**
   * License ID of the license to be quoted
   */
  licenseId: number;
  /**
   * Quanitity for the order
   */
  quantity: number;
};

/**
 * Certificate purchase-interest lead submitted from the enterprise admin
 * (painted door). No payment is processed.
 *
 */
export type CreateCertificateInterest = {
  /**
   * ID of the organization the admin is purchasing on behalf of
   */
  organizationId: number;
  /**
   * UUID of the certificate program of interest
   */
  certificateProgramUuid: string;
  /**
   * Title of the certificate program of interest
   */
  certificateTitle: string;
  /**
   * Slug of the certificate program of interest
   */
  certificateSlug?: string;
  /**
   * Number of certificates the admin is interested in
   */
  quantity: number;
  /**
   * Unit price shown to the admin in minor currency units, if known
   * (absent for coming-soon certs with no purchasable product)
   *
   */
  unitPrice?: number;
  /**
   * Formatted unit price shown to the admin, if known
   */
  displayPrice?: string;
  /**
   * ISO currency code of the price shown, if known
   */
  currency?: string;
};

/**
 * Result of capturing a certificate purchase-interest lead
 */
export type CertificateInterestResult = {
  /**
   * Human-readable confirmation message
   */
  message: string;
};

/**
 * Products available for purchase through self service
 */
export type EnterpriseProduct = "enterprise_license" | "bulk_code";

export const EnterpriseProduct =
  /**
   * Products available for purchase through self service
   */
  {
    ENTERPRISE_LICENSE: "enterprise_license",
    BULK_CODE: "bulk_code",
  } as const;

/**
 * Street Address
 */
export type EnterpriseAddress = {
  /**
   * first line of address
   */
  line1: string;
  /**
   * second line of address if required
   */
  line2?: string;
  /**
   * City
   */
  city: string;
  /**
   * State or Province
   */
  state: string;
  /**
   * Country
   */
  country: string;
  /**
   * Zip/Postal Code
   */
  postalCode: string;
};

/**
 * The quote generated for the customer
 */
export type EnterpriseQuote = {
  lineItems: Array<EnterpriseQuoteLineItem>;
  /**
   * Total cost before taxes
   */
  subtotal: number;
  discount?: EnterpriseQuoteComponent;
  tax: EnterpriseQuoteComponent;
  /**
   * Total cost
   */
  total: number;
};

/**
 * Line item for an enterprise quote
 */
export type EnterpriseQuoteLineItem = {
  /**
   * Item being purchased
   */
  product: string;
  /**
   * Number of items
   */
  quantity: number;
  /**
   * Cost of the item
   */
  unitPrice: number;
};

/**
 * Discount or Taxes associated with a quote
 */
export type EnterpriseQuoteComponent = {
  /**
   * Percentage of the discount or taxes
   */
  percent: number;
  /**
   * $ value of the discount or taxes
   */
  value: number;
};

/**
 * Addon Order Request, requires licenseId and quantity
 */
export type EnterpriseProcessAddonOrderRequest = {
  /**
   * License ID of the license to be quoted
   */
  licenseId: number;
  /**
   * Quanitity for the order
   */
  quantity: number;
  /**
   * Authentication token for the transaction
   */
  token: string;
  /**
   * country for payment processing
   */
  country: string;
  /**
   * postalCode for payment processing
   */
  postalCode: string;
};

/**
 * Order Request, requires email + address, or discountCode, along with payment tokens.
 */
export type EnterpriseProcessOrderRequest = {
  /**
   * First Name
   */
  firstName?: string;
  /**
   * Last Name
   */
  lastName?: string;
  /**
   * Email address of the prospective Customer
   */
  email?: string;
  address?: EnterpriseAddress;
  /**
   * Quantity for the order
   */
  quantity: number;
  product: EnterpriseProduct;
  /**
   * Discount Code associated with the order request
   */
  discountCode?: string;
  /**
   * Name of the organization
   */
  organizationName?: string;
  /**
   * payment type, credit card/wire
   */
  paymentType: "credit_card" | "wire";
  /**
   * Authentication token for the transaction
   */
  token?: string;
  /**
   * Card token for payment processing
   */
  cardToken?: string;
  /**
   * User agreed to consent to terms and conditions
   */
  userConsent: boolean;
  /**
   * Flag indicating this was an assisted order
   */
  assistedSelfServe?: boolean;
  /**
   * Payment method id for payment processing
   */
  paymentMethodId?: string;
  /**
   * Payment intent id for Stripe
   */
  paymentIntentId?: string;
  /**
   * Unique identifier for the zuora self order audit
   */
  selfServeOrderReferenceId?: string;
  /**
   * VAT Identification number (required for EU customers)
   */
  vatId?: string;
};

/**
 * The processed order details for the customer
 */
export type EnterpriseAddonOrder = {
  orderId: number;
  lineItems: Array<EnterpriseQuoteLineItem>;
  /**
   * Total cost before taxes
   */
  subtotal: number;
  discount?: EnterpriseQuoteComponent;
  tax: EnterpriseQuoteComponent;
  /**
   * Total cost
   */
  total: number;
};

/**
 * The processed order details for the customer
 */
export type EnterpriseOrder = {
  userId?: number;
  /**
   * Customer's email address
   */
  email?: string;
  lineItems?: Array<EnterpriseOrderLineItem>;
  /**
   * Total cost before taxes
   */
  orderSubtotal?: number;
  orderDiscount?: EnterpriseOrderComponent;
  orderTax?: EnterpriseOrderComponent;
  /**
   * Total cost
   */
  orderTotal?: number;
  /**
   * URL path for product activation
   */
  activationPath?: string;
  /**
   * Unique identifier for the order
   */
  orderId?: string;
  /**
   * Unique identifier for the zuora self order audit
   */
  selfServeOrderReferenceId?: string;
  /**
   * Flag indicating if the order requires action
   */
  requiresAction?: boolean;
  /**
   * URL for authentication redirect
   */
  authenticationRedirectUrl?: string;
  /**
   * Payment intent id for Stripe
   */
  paymentIntentId?: string;
  /**
   * Order status for 3Ds confimation
   */
  status3ds?: string;
};

export type EnterpriseOrderError = {
  errors?: Array<{
    status?: string;
    code?: string;
    title?: string;
  }>;
};

/**
 * Line item for an enterprise order
 */
export type EnterpriseOrderLineItem = {
  /**
   * Item being purchased
   */
  product: string;
  /**
   * Number of items
   */
  quantity: number;
  /**
   * Cost of the item
   */
  unitPrice: number;
};

/**
 * Discount or Taxes associated with an order
 */
export type EnterpriseOrderComponent = {
  /**
   * Percentage of the discount or taxes
   */
  percent: number;
  /**
   * $ value of the discount or taxes
   */
  value: number;
};

/**
 * The invoice details
 */
export type EnterpriseInvoice = {
  url: string;
};

export type TeamCsvImportTask = {
  id: number;
  status: "pending" | "in_progress" | "completed" | "failed";
  startedAt?: string | null;
  completedAt?: string | null;
  /**
   * Summary and per-row details once the task has completed.
   * Empty `{}` until the task transitions out of pending/inProgress.
   *
   */
  reportData?: {
    [key: string]: unknown;
  };
};

export type CreateTeamCsvImport = {
  /**
   * CSV file with `email,team` header.
   */
  file: Blob | File;
};

/**
 * The current value of a filter; value type should match bounds type
 */
export type EnterpriseAnalyticsMetricFilterValue = {
  value: string;
  /**
   * (optional) The display value of the filter
   */
  label?: string;
};

/**
 * type of the EnterpriseAnalyticsMetricBounds
 */
export type EnterpriseAnalyticsMetricBoundsType =
  | "date_range"
  | "range"
  | "enum";

export const EnterpriseAnalyticsMetricBoundsType =
  /**
   * type of the EnterpriseAnalyticsMetricBounds
   */
  {
    DATE_RANGE: "date_range",
    RANGE: "range",
    ENUM: "enum",
  } as const;

/**
 * The maximum range of possible values for a filter
 */
export type EnterpriseAnalyticsMetricBounds = {
  /**
   * see EnterpriseAnalyticsMetricBoundsType for more information
   */
  type?: string;
  range?: EnterpriseAnalyticsMetricDateRangeBounds;
  enumBounds?: EnterpriseAnalyticsMetricEnumBounds;
};

/**
 * A bounds used to specify end points for a sortable range of data
 */
export type EnterpriseAnalyticsMetricDateRangeBounds = {
  options: [string, string];
};

/**
 * A bounds used to specify a list of discrete options
 */
export type EnterpriseAnalyticsMetricEnumBounds = {
  options: Array<{
    label: string;
    value: string;
  }>;
};

/**
 * the type of the EnterpriseAnalyticsRelationship
 */
export type EnterpriseAnalyticsRelationshipType = "content" | "skill" | "user";

export const EnterpriseAnalyticsRelationshipType =
  /**
   * the type of the EnterpriseAnalyticsRelationship
   */
  {
    CONTENT: "content",
    SKILL: "skill",
    USER: "user",
  } as const;

/**
 * additional data for enterprise analytics relationships
 */
export type EnterpriseAnalyticsRelationship = {
  /**
   * see EnterpriseAnalyticsRelationshipType
   */
  type?: string;
  content?: EnterpriseAnalyticsContent;
  skill?: EnterpriseAnalyticsSkill;
  user?: EnterpriseAnalyticsUser;
};

/**
 * additional data for content objects
 */
export type EnterpriseAnalyticsContent = {
  uuid: string;
  /**
   * type of content
   */
  contentType: string;
  title: string;
  subtitle: string;
  imageUrl?: string;
  primarySkill?: string;
};

/**
 * additional data for skill objects
 */
export type EnterpriseAnalyticsSkill = {
  uuid: string;
  slug: string;
  name: string;
};

/**
 * additional data for user objects
 */
export type EnterpriseAnalyticsUser = {
  uuid: string;
  email: string;
  displayName?: string;
  displayName1Line: string;
  username?: string;
  noEmailUser?: boolean;
};

export type EnterpriseAnalyticsFilterKey =
  | "from_date"
  | "to_date"
  | "interval"
  | "skill_uuid"
  | "include_revoked_members";

export const EnterpriseAnalyticsFilterKey = {
  FROM_DATE: "from_date",
  TO_DATE: "to_date",
  INTERVAL: "interval",
  SKILL_UUID: "skill_uuid",
  INCLUDE_REVOKED_MEMBERS: "include_revoked_members",
} as const;

export type EnterpriseAnalyticsFilterInterval =
  | "day"
  | "week"
  | "month"
  | "quarter";

export const EnterpriseAnalyticsFilterInterval = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
  QUARTER: "quarter",
} as const;

export type EnterpriseAnalyticsCsvSlug =
  | "activity_overview_csv"
  | "user_activity_time_series_csv"
  | "course_progress_csv"
  | "top_courses_csv"
  | "top_skills_csv"
  | "user_course_progress_csv"
  | "top_users_csv";

export const EnterpriseAnalyticsCsvSlug = {
  ACTIVITY_OVERVIEW_CSV: "activity_overview_csv",
  USER_ACTIVITY_TIME_SERIES_CSV: "user_activity_time_series_csv",
  COURSE_PROGRESS_CSV: "course_progress_csv",
  TOP_COURSES_CSV: "top_courses_csv",
  TOP_SKILLS_CSV: "top_skills_csv",
  USER_COURSE_PROGRESS_CSV: "user_course_progress_csv",
  TOP_USERS_CSV: "top_users_csv",
} as const;

export type EnterpriseAnalyticsMetricSlug =
  | "activity_overview"
  | "avg_num_minutes_watched_time_series"
  | "num_minutes_watched_time_series"
  | "num_unique_active_users_time_series"
  | "top_courses"
  | "top_skills"
  | "top_users";

export const EnterpriseAnalyticsMetricSlug = {
  ACTIVITY_OVERVIEW: "activity_overview",
  AVG_NUM_MINUTES_WATCHED_TIME_SERIES: "avg_num_minutes_watched_time_series",
  NUM_MINUTES_WATCHED_TIME_SERIES: "num_minutes_watched_time_series",
  NUM_UNIQUE_ACTIVE_USERS_TIME_SERIES: "num_unique_active_users_time_series",
  TOP_COURSES: "top_courses",
  TOP_SKILLS: "top_skills",
  TOP_USERS: "top_users",
} as const;

export type EnterpriseAnalyticsMetric = {
  errors?: EnterpriseAnalyticsMetricErrors;
  meta: EnterpriseAnalyticsMetricMeta;
  data?: {
    rows: Array<Array<string>>;
    columns: EnterpriseAnalyticsMetricColumns;
  };
  relationships?: EnterpriseAnalyticsMetricRelationships;
};

export type EnterpriseAnalyticsMetricColumns = Array<{
  name: string;
}>;

/**
 * Only returned if data is not returned
 */
export type EnterpriseAnalyticsMetricErrors = Array<{
  /**
   * Machine-readable key that indicates the type of error. May be used to conditionally show client-side error states.
   */
  name: string;
  /**
   * Human-readable error message
   */
  message: string;
}>;

export type EnterpriseAnalyticsMetricMeta = {
  slug: string;
  filters: Array<{
    name: string;
    value?: EnterpriseAnalyticsMetricFilterValue;
    bounds: EnterpriseAnalyticsMetricBounds;
  }>;
  /**
   * See EnterpriseAnalyticsMetricEmptyValueDescription
   */
  emptyValueDescription?: string;
};

/**
 * additional data for enterprise analytics metrics object identifiers
 */
export type EnterpriseAnalyticsMetricRelationships =
  Array<EnterpriseAnalyticsRelationship>;

/**
 * Explain the empty values in metrics data
 */
export type EnterpriseAnalyticsMetricEmptyValueDescription =
  | "no-data"
  | "no-data-in-range"
  | "privacy-protection";

export const EnterpriseAnalyticsMetricEmptyValueDescription =
  /**
   * Explain the empty values in metrics data
   */
  {
    NO_DATA: "no-data",
    NO_DATA_IN_RANGE: "no-data-in-range",
    PRIVACY_PROTECTION: "privacy-protection",
  } as const;

export type EnterpriseAnalyticsGenerateCsvReportJobMetric = {
  /**
   * See EnterpriseAnalyticsCsvSlug for values
   */
  slug: string;
  /**
   * key-value pairs of filters. See EnterpriseAnalyticsFilterKey for more information.
   */
  filters?: {
    [key: string]: unknown;
  };
};

export type EnterpriseAnalyticsGenerateCsvReportJobRequest = {
  /**
   * team id
   */
  teamId: string;
  metric: EnterpriseAnalyticsGenerateCsvReportJobMetric;
};

export type EnterpriseAnalyticsGenerateCsvReportJobResponse = {
  /**
   * Job identifier
   */
  uuid?: string;
  /**
   * see EnterpriseAnalyticsGenerateCsvReportJobStatus
   */
  status?: string;
  /**
   * pre-signed S3 link to the generated report
   */
  link?: string;
  /**
   * team id
   */
  teamId?: string;
  metric?: EnterpriseAnalyticsGenerateCsvReportJobMetric;
};

/**
 * EnterpriseAnalyticsGenerateCsvReportJob status
 */
export type EnterpriseAnalyticsGenerateCsvReportJobStatus =
  | "pending"
  | "successful"
  | "failed";

export const EnterpriseAnalyticsGenerateCsvReportJobStatus =
  /**
   * EnterpriseAnalyticsGenerateCsvReportJob status
   */
  {
    PENDING: "pending",
    SUCCESSFUL: "successful",
    FAILED: "failed",
  } as const;

export type V3ContentRow = {
  id: number;
  slug: string;
  uuid?: string;
  apiType: string;
  analytics: {
    [key: string]: string;
  };
  refreshNeeded: boolean;
  uiConfig: V3ContentRowUiConfig;
  experiments?: {
    [key: string]: string;
  };
  items: Array<V3ContentRowItem>;
};

export type V3ContentRows = Array<V3ContentRow>;

export type V3ContentRowItem = {
  itemUuid: string;
  /**
   * See `ContentRowTileType` for available types.
   */
  tileType: string;
  default?: ContentRowCarouselTile;
  assignment?: AssignmentCarouselTile;
  dailySkillTrack?: DailySkillTrackCarouselTile;
  continueWatching?: ContentRowCarouselTile;
  insight?: CollectionTile;
  quizCollection?: CollectionTile;
  takeawayCollection?: CollectionTile;
  audioCollection?: CollectionTile;
  shortVideoCollection?: CollectionTile;
  thumbnail?: ContentRowCarouselTile;
  imageBanner?: ImageBannerTile;
  interactiveHero?: InteractiveHeroTile;
  androidEngage?: AndroidEngageTile;
  info?: InfoTile;
};

export type ContentRowTileType =
  | "DefaultTile"
  | "DailySkillTrackTile"
  | "AssignmentTile"
  | "ContinueWatchingTile"
  | "CollectionTile"
  | "ThumbnailTile"
  | "TakeawayCollectionTile"
  | "QuizCollectionTile"
  | "AudioCollectionTile"
  | "ShortVideoCollectionTile"
  | "ImageBannerTile"
  | "InteractiveHeroTile"
  | "AndroidEngageTile"
  | "InfoTile";

export const ContentRowTileType = {
  DEFAULT_TILE: "DefaultTile",
  DAILY_SKILL_TRACK_TILE: "DailySkillTrackTile",
  ASSIGNMENT_TILE: "AssignmentTile",
  CONTINUE_WATCHING_TILE: "ContinueWatchingTile",
  COLLECTION_TILE: "CollectionTile",
  THUMBNAIL_TILE: "ThumbnailTile",
  TAKEAWAY_COLLECTION_TILE: "TakeawayCollectionTile",
  QUIZ_COLLECTION_TILE: "QuizCollectionTile",
  AUDIO_COLLECTION_TILE: "AudioCollectionTile",
  SHORT_VIDEO_COLLECTION_TILE: "ShortVideoCollectionTile",
  IMAGE_BANNER_TILE: "ImageBannerTile",
  INTERACTIVE_HERO_TILE: "InteractiveHeroTile",
  ANDROID_ENGAGE_TILE: "AndroidEngageTile",
  INFO_TILE: "InfoTile",
} as const;

export type ContentRowEntitySubtype = "episode" | "series";

export const ContentRowEntitySubtype = {
  EPISODE: "episode",
  SERIES: "series",
} as const;

export type V3ContentRowEntityType =
  | "camp"
  | "camp_task"
  | "chapter"
  | "course"
  | "custom"
  | "playlist"
  | "track"
  | "collection_part"
  | "audio_part"
  | "quiz_part"
  | "short_video_part"
  | "takeaway_part"
  | "program"
  | "certificate_program";

export const V3ContentRowEntityType = {
  CAMP: "camp",
  CAMP_TASK: "camp_task",
  CHAPTER: "chapter",
  COURSE: "course",
  CUSTOM: "custom",
  PLAYLIST: "playlist",
  TRACK: "track",
  COLLECTION_PART: "collection_part",
  AUDIO_PART: "audio_part",
  QUIZ_PART: "quiz_part",
  SHORT_VIDEO_PART: "short_video_part",
  TAKEAWAY_PART: "takeaway_part",
  PROGRAM: "program",
  CERTIFICATE_PROGRAM: "certificate_program",
} as const;

export type V3ContentRowUiConfig = {
  /**
   * See the `ContentRowUiConfigType` enum for list of values.
   */
  type: string;
  attributes?: V3ContentRowUiConfigAttributes;
};

export type V3ContentRowUiConfigAttributes = ContentRowTileAttributes &
  ContentRowTitleAttributes & {
    carousel?: ContentRowCarouselAttributes;
    grid?: ContentRowGridAttributes;
  };

export type ContentRowUiConfigTileTextPlacement =
  | "bottom"
  | "top"
  | "right"
  | "left";

export const ContentRowUiConfigTileTextPlacement = {
  BOTTOM: "bottom",
  TOP: "top",
  RIGHT: "right",
  LEFT: "left",
} as const;

export type ContentRowUiConfigTileClickTarget =
  | "same_tab"
  | "new_tab"
  | "new_window"
  | "modal";

export const ContentRowUiConfigTileClickTarget = {
  SAME_TAB: "same_tab",
  NEW_TAB: "new_tab",
  NEW_WINDOW: "new_window",
  MODAL: "modal",
} as const;

export type V3ContentRowUiConfigType =
  | "assignment_carousel"
  | "banner"
  | "carousel"
  | "enterprise_banner"
  | "grid"
  | "hidden"
  | "library_banner"
  | "list"
  | "looking_for_more_banner"
  | "daily_moments"
  | "collections";

export const V3ContentRowUiConfigType = {
  ASSIGNMENT_CAROUSEL: "assignment_carousel",
  BANNER: "banner",
  CAROUSEL: "carousel",
  ENTERPRISE_BANNER: "enterprise_banner",
  GRID: "grid",
  HIDDEN: "hidden",
  LIBRARY_BANNER: "library_banner",
  LIST: "list",
  LOOKING_FOR_MORE_BANNER: "looking_for_more_banner",
  DAILY_MOMENTS: "daily_moments",
  COLLECTIONS: "collections",
} as const;

export type ContentRowCarouselTile = {
  analytics?: {
    [key: string]: string;
  };
  title?: string;
  subtitle?: string;
  caption?: string;
  logo?: {
    url?: string;
    altText?: string;
    widthRatio?: number;
    heightRatio?: number;
  };
  progress?: number;
  progressInSeconds?: number;
  topRightPill?: Pill;
  bottomRightPill?: Pill;
  topLeftPill?: Pill;
  bottomLeftPill?: Pill;
  tags?: Array<Tag>;
  images?: {
    primary16x9?: string;
    primary2x3?: string;
    primary1x1?: string;
    cinematic16x9?: string;
    outcome16x9?: string;
    currentProgress16x9?: string;
    nameplate?: string;
    manual?: string;
  };
  /**
   * This field is replaced by the `media` field.
   * This field will be deprecated soon, as part of the CMS video migration project.
   *
   */
  videos?: {
    trailer16x9?: string;
    currentProgress16x9?: string;
    manual?: string;
  };
  /**
   * This field is the new field to replace the `videos` field. The attribute names are the same as `videos`, but the
   * value is an object with `brightcoveVideoId` and `mediaUuid` attributes, to align with the conventional implementation.
   *
   */
  media?: {
    trailer16x9?: {
      /**
       * The unique identifier for the brightcove video content.
       * Use this brightcove video ID to fetch metdata from Brightcove.
       * This will be deprecated in the future.
       *
       */
      brightcoveVideoId?: string;
      /**
       * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
       *
       */
      mediaUuid?: string;
    };
    currentProgress16x9?: {
      /**
       * The unique identifier for the brightcove video content.
       * Use this brightcove video ID to fetch metdata from Brightcove.
       * This will be deprecated in the future.
       *
       */
      brightcoveVideoId?: string;
      /**
       * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
       *
       */
      mediaUuid?: string;
    };
    manual?: {
      /**
       * The unique identifier for the brightcove video content.
       * Use this brightcove video ID to fetch metdata from Brightcove.
       * This will be deprecated in the future.
       *
       */
      brightcoveVideoId?: string;
      /**
       * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
       *
       */
      mediaUuid?: string;
    };
  };
  tileClickRedirect?: string;
  watchNowRedirect?: string;
  resource?: {
    entityId?: number;
    entitySlug?: string;
    entityUuid?: string;
    /**
     * See `ContentRowEntitySubtype` for a list of currently supported values.
     */
    entitySubtype?: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
    entityChapterId?: number;
  };
  overlay?: {
    text?: string;
    setReminder?: boolean;
  };
  overflowMenu?: TileOverflowMenu;
  recommendedSource?: RecommendedSource;
  logoNonOverlay?: {
    url?: string;
    altText?: string;
    widthRatio?: number;
    heightRatio?: number;
  };
};

export type AssignmentCarouselTile = {
  entityUuid?: string;
  title?: string;
  subtitle?: string;
  caption?: string;
  logo?: {
    url?: string;
    altText?: string;
    widthRatio?: number;
    heightRatio?: number;
  };
  progressDetails?: {
    isComplete?: boolean;
    barPercentage?: number;
    progressText?: string;
    /**
     * The time the content was completed.
     */
    completedAt?: string;
  };
  images?: {
    primary1x1?: string;
    primary2x3?: string;
    primary16x9?: string;
  };
  tileClickRedirect?: string;
  assignerDisplayName?: string;
  /**
   * The time the content was assigned.
   */
  assignedAt?: string;
  assignedOn?: string;
  message?: string;
  resource?: {
    entityId?: number;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
  };
  analytics?: {
    [key: string]: string;
  };
};

export type DefaultTile = ContentRowCarouselTile;

export type DailySkillTrackCarouselTile = {
  tileType?: string;
  analytics?: {
    [key: string]: string;
  };
  title?: string;
  subtitle?: string;
  caption?: string;
  duration?: string;
  progress?: number;
  images?: {
    primary16x9?: string;
    primary2x3?: string;
    manual?: string;
  };
  tileClickRedirect?: string;
  resource?: {
    entityId?: number;
    entitySlug?: string;
    /**
     * See `ContentRowEntitySubtype` for a list of currently supported values.
     */
    entitySubtype?: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
    playlistId?: string;
  };
};

export type V3PillKind =
  | "default"
  | "dim"
  | "transparent"
  | "primary"
  | "utility"
  | "announce";

export const V3PillKind = {
  DEFAULT: "default",
  DIM: "dim",
  TRANSPARENT: "transparent",
  PRIMARY: "primary",
  UTILITY: "utility",
  ANNOUNCE: "announce",
} as const;

export type TagSlugValue = "activities" | "community";

export const TagSlugValue = {
  ACTIVITIES: "activities",
  COMMUNITY: "community",
} as const;

export type Tag = {
  slug: string;
  /**
   * Name of the tag
   */
  name: string;
};

export type CollectionTile = {
  /**
   * The type of the tile.
   */
  type?: string;
  collectionUuid: string;
  collectionSlug?: string;
  partUuid?: string;
  partSlug?: string;
  /**
   * Hexadecimal color representation (#RRGGBB)
   */
  loadingColor?: string;
  /**
   * For accessibility.
   */
  altText?: string;
  tileClickRedirect?: string;
  analytics?: {
    [key: string]: string;
  };
  /**
   * Freeform text representing status like New or Featured
   */
  pillText?: string;
  resource?: {
    entityId?: number;
    entitySlug?: string;
    entityUuid?: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
  };
  /**
   * Object to show the data under the image
   */
  footer?: {
    image?: CollectionImage;
    /**
     * HTML representaton of the styled text.
     */
    text?: string;
    /**
     * Redirects to CDP.
     */
    clickRedirect?: string;
  };
  progress?: {
    resumePartUuid?: string;
    isComplete?: boolean;
    barPercentage?: number;
    resumeCardUuid?: string;
  };
  background?: CollectionImage;
  /**
   * See `FrontCoverTemplateTypes` for values
   */
  templateType?: string;
  collection?: CollectionTileContent;
  quiz?: QuizCollectionTileContent;
  takeaway?: TakeawayCollectionTileContent;
  audio?: AudioCollectionTileContent;
  short?: ShortVideoCollectionTileContent;
};

export type CollectionTileContent = {
  images?: {
    nameplate?: CollectionImage;
  };
};

export type QuizCollectionTileContent = {
  images?: {
    instructor?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML representaton of the styled text.
     */
    quizCta?: string;
  };
};

export type TakeawayCollectionTileContent = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML representaton of the styled text.
     */
    subtitle?: string;
  };
};

export type AudioCollectionTileContent = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML representaton of the styled text.
     */
    duration?: string;
  };
};

export type ShortVideoCollectionTileContent = {
  video?: MediaItem;
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML representaton of the styled text.
     */
    duration?: string;
  };
};

export type CollectionImage = {
  /**
   * URL of the image
   */
  url?: string;
  height?: number;
  width?: number;
};

export type FrontCoverTemplateTypes =
  | "CollectionTileContent"
  | "QuizCollectionTileContent"
  | "TakeawayCollectionTileContent"
  | "AudioCollectionTileContent"
  | "ShortVideoCollectionTileContent";

export const FrontCoverTemplateTypes = {
  COLLECTION_TILE_CONTENT: "CollectionTileContent",
  QUIZ_COLLECTION_TILE_CONTENT: "QuizCollectionTileContent",
  TAKEAWAY_COLLECTION_TILE_CONTENT: "TakeawayCollectionTileContent",
  AUDIO_COLLECTION_TILE_CONTENT: "AudioCollectionTileContent",
  SHORT_VIDEO_COLLECTION_TILE_CONTENT: "ShortVideoCollectionTileContent",
} as const;

export type ImageBannerTile = {
  tileType?: string;
  entityUuid?: string;
  images?: {
    primary16x9?: string;
  };
  description?: string;
  logo?: {
    url?: string;
    altText?: string;
    widthRatio?: number;
    heightRatio?: number;
  };
  attributesMap?: Array<{
    key?: string;
    value?: string;
  }>;
  tagsContent?: {
    label?: string;
    tags?: Array<Tag>;
  };
  mainBadge?: string;
  tileClickRedirect?: string;
  ctaText?: string;
  ctaAltText?: string;
  analytics?: {
    [key: string]: string;
  };
  resource?: {
    entityId?: number;
    entitySlug?: string;
    entityUuid?: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
  };
};

export type InteractiveHeroTile = {
  tileType?: string;
  analytics?: {
    [key: string]: string;
  };
  texts: {
    /**
     * Text that has to be displayed instead of a nameplate image.
     */
    title?: string;
    caption?: string;
    altText?: string;
  };
  images: {
    tile2x3?: string;
    tile16x9?: string;
    nameplate?: string;
  };
  ctas?: {
    tileCtaUrl?: string;
    playCta?: {
      text?: string;
      url?: string;
      analytics?: {
        [key: string]: string;
      };
    };
    updateInListCta?: {
      text?: string;
      isAdded?: boolean;
      analytics?: {
        [key: string]: string;
      };
    };
  };
  pills?: {
    topRightPill?: Pill;
  };
  resource?: {
    entityUuid: string;
    entityId: number;
    entitySlug: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType: string;
    /**
     * See `ContentRowEntitySubtype` for a list of currently supported values.
     */
    entitySubtype?: string;
  };
};

export type AndroidEngageTile = {
  tileType?: string;
  title?: string;
  subtitle?: string;
  images?: {
    primary16x9?: string;
    primary2x3?: string;
    primary1x1?: string;
    currentProgress16x9?: string;
  };
  playbackRedirect?: string;
  detailsRedirect?: string;
  /**
   * Unix timestamp in milliseconds indicating when the content became available.
   */
  availableAt?: number;
  /**
   * Duration of the content in seconds.
   */
  duration?: number;
  genre?: string;
  /**
   * Progress of the content as a percentage.
   */
  progress?: number;
  /**
   * Progress of the content in seconds.
   */
  progressInSeconds?: number;
  /**
   * Unix timestamp in milliseconds indicating the last time the user engaged with the content.
   */
  lastEngagementTime?: number;
  analytics?: {
    [key: string]: string;
  };
  resource?: {
    entityId?: number;
    entitySlug?: string;
    entityUuid?: string;
    /**
     * See `ContentRowEntityType` for a list of currently supported values.
     */
    entityType?: string;
    /**
     * See `ContentRowEntitySubtype` for a list of currently supported values.
     */
    entitySubtype?: string;
  };
};

export type InfoTileCtaStyle = "primary" | "secondary" | "consent";

export const InfoTileCtaStyle = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  CONSENT: "consent",
} as const;

export type InfoTileCtaIntent = "redirect" | "share" | "track_event";

export const InfoTileCtaIntent = {
  REDIRECT: "redirect",
  SHARE: "share",
  TRACK_EVENT: "track_event",
} as const;

export type InfoTileStyle = "default" | "card";

export const InfoTileStyle = {
  DEFAULT: "default",
  CARD: "card",
} as const;

export type InfoTileImageAspectRatio = "16x9" | "1x1" | "2x3";

export const InfoTileImageAspectRatio = {
  _16X9: "16x9",
  _1X1: "1x1",
  _2X3: "2x3",
} as const;

export type InfoTileTitleSize = "header_l" | "header_m" | "header_s";

export const InfoTileTitleSize = {
  HEADER_L: "header_l",
  HEADER_M: "header_m",
  HEADER_S: "header_s",
} as const;

export type InfoTileBodySize = "body_l" | "body_m" | "body_s";

export const InfoTileBodySize = {
  BODY_L: "body_l",
  BODY_M: "body_m",
  BODY_S: "body_s",
} as const;

export type InfoTileCtaLayout = "vertical" | "horizontal";

export const InfoTileCtaLayout = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
} as const;

export type InfoTile = {
  tileType?: string;
  title?: string;
  body?: Array<string>;
  caption?: string;
  images?: {
    primary?: string;
  };
  ctas?: Array<{
    text: string;
    link?: string;
    /**
     * See `InfoTileCtaStyle` for a list of currently supported values.
     */
    style: string;
    /**
     * See `InfoTileCtaIntent` for a list of currently supported values.
     */
    intent: string;
    /**
     * Present only if style is consent
     */
    consent?: {
      /**
       * Whether consent is required to proceed with the action.
       */
      isRequired?: boolean;
      /**
       * Text to display for the consent checkbox.
       */
      text?: string;
    };
    analytics?: {
      [key: string]: string;
    };
  }>;
  uiConfig?: {
    /**
     * See `InfoTileStyle` for a list of currently supported values.
     */
    tileStyle?: string;
    /**
     * See `InfoTileImageAspectRatio` for a list of currently supported values.
     */
    primaryImageAspectRatio?: string;
    /**
     * See `InfoTileTitleSize` for a list of currently supported values.
     */
    titleSize?: string;
    /**
     * See `InfoTileBodySize` for a list of currently supported values.
     */
    bodySize?: string;
    /**
     * See `InfoTileCtaLayout` for a list of currently supported values.
     */
    ctaLayout?: string;
  };
  analytics?: {
    [key: string]: string;
  };
};

/**
 * Known semantic action types for tile overflow menus.
 *
 */
export type TileActionType =
  | "add_to_list"
  | "remove_from_list"
  | "remove_from_continue"
  | "add_to_bookmark"
  | "remove_from_bookmark"
  | "share"
  | "deeplink";

export const TileActionType =
  /**
   * Known semantic action types for tile overflow menus.
   *
   */
  {
    ADD_TO_LIST: "add_to_list",
    REMOVE_FROM_LIST: "remove_from_list",
    REMOVE_FROM_CONTINUE: "remove_from_continue",
    ADD_TO_BOOKMARK: "add_to_bookmark",
    REMOVE_FROM_BOOKMARK: "remove_from_bookmark",
    SHARE: "share",
    DEEPLINK: "deeplink",
  } as const;

export type TileAction = {
  /**
   * Semantic action type. See TileActionType for known values.
   *
   */
  type: string;
  /**
   * Required when type is "share" or "deeplink". For share: the URL to include in the native share sheet. For deeplink: the internal URL/deeplink to navigate to. Ignored for all other action types.
   *
   */
  url?: string;
};

export type TileOverflowMenuItem = {
  /**
   * Display label for this menu item.
   */
  text: string;
  analytics?: {
    [key: string]: string;
  };
  action: TileAction;
};

export type TileOverflowMenu = {
  analytics?: {
    [key: string]: string;
  };
  items: Array<TileOverflowMenuItem>;
};

export type UniqueIdentifiersResponse = {
  /**
   * uuid of the requested resource.
   */
  uuid: string;
};

export type MyListItem = {
  uuid: string;
};

export type HomepageLayout = {
  navigation: Navigation;
};

export type Navigation = {
  items: Array<NavigationItem>;
};

export type NavigationItem = {
  position: number;
  /**
   * References to a content row bundle location
   */
  bundle: string;
  display: NavigationItemDisplay;
  analytics: {
    [key: string]: string;
  };
};

export type NavigationItemDisplay = {
  name: string;
};

export type SemanticSearchClassFormat = "Course" | "SeriesCourse" | "Camp";

export const SemanticSearchClassFormat = {
  COURSE: "Course",
  SERIES_COURSE: "SeriesCourse",
  CAMP: "Camp",
} as const;

export type SemanticSearchResponse = {
  search?: string;
  watchBundleUuid?: string;
  results?: Array<SemanticSearchResult>;
};

export type SemanticSearchResult = {
  chunkUuid?: string;
  /**
   * The semantic relevance of the answer. The lower the number, the more relevant the answer is likely to be.
   */
  distance?: number;
  /**
   * Refer to `SemanticSearchClassFormat` for the set of values.
   */
  classFormat?: string;
  /**
   * The id of the `Course` that the answer is found in.
   */
  classId?: number;
  courseTitle?: string;
  chapterTitle?: string;
  /**
   * The id of the `Chapter` that the answer is found in.
   */
  contentId?: number;
  courseUrl?: string;
  chapterUrl?: string;
  thumbUrl?: string;
  instructors?: string;
  /**
   * The point in the video the answer starts.
   */
  startSecs?: number;
  /**
   * The point in the video the answer ends.
   */
  endSecs?: number;
  /**
   * Description of the content
   */
  text?: string;
};

export type UpdateType = "Valid" | "Forced" | "Unsupported";

export const UpdateType = {
  VALID: "Valid",
  FORCED: "Forced",
  UNSUPPORTED: "Unsupported",
} as const;

export type AppData = {
  update: Update;
};

export type Update = {
  /**
   * Check "UpdateType" for enum values
   */
  status: string;
  message?: string;
};

export type CareerGoalValue =
  | "team_member"
  | "team_leader"
  | "senior_leadership"
  | "unsure";

export const CareerGoalValue = {
  TEAM_MEMBER: "team_member",
  TEAM_LEADER: "team_leader",
  SENIOR_LEADERSHIP: "senior_leadership",
  UNSURE: "unsure",
} as const;

export type LearningPreferences = {
  /**
   * enum key for the goal. For the list of enums, check CareerGoalValue
   */
  careerGoal?: string;
  skills?: Array<string>;
  subskills?: Array<string>;
};

export type CareerGoal = {
  slug: string;
  title: string;
  text?: string;
  description?: string;
  isSelected?: boolean;
};

export type CareerGoalPage = {
  title: string;
  subtitle: string;
  careerGoals: Array<CareerGoal>;
};

export type Subskill = {
  uuid: string;
  text: string;
  subskill: string;
  isSelected: boolean;
};

export type V3Skill = {
  uuid: string;
  iconSlug: string;
  title?: string;
  text?: string;
  fadedText?: string;
  isSelected?: boolean;
  subskills?: Array<Subskill>;
};

export type SkillsPage = {
  title: string;
  subtitle: string;
  skills: Array<V3Skill>;
};

export type SubskillsPage = {
  title: string;
  subtitle: string;
  skills: Array<V3Skill>;
};

export type TabContent = {
  navigation?: TabContentNavigation;
  title?: Text;
  /**
   * Used to drive the career skill text
   */
  isCareerSkill?: boolean;
  goal?: Text;
  subNavigation?: SubNavigation;
  skillProgresses?: SkillProgresses;
  subSkillProgresses?: SubSkillProgresses;
  analytics?: {
    [key: string]: string;
  };
};

export type TabContentNavigation = {
  /**
   * default text to present if the navigation is a collapsable
   */
  defaultText?: string;
  items: Array<TabContentNavigationItem>;
};

export type SubNavigation = {
  items: Array<SubNavigationItem>;
};

export type SkillProgresses = {
  items: Array<SkillProgressesItem>;
};

/**
 * Sorted list of subskill progress
 */
export type SubSkillProgresses = {
  items: Array<SubSkillProgressesItem>;
};

export type Text = {
  text?: string;
};

/**
 * Parameters used to call content rows API
 */
export type ContentRowParams = {
  /**
   * References to a content row bundle location
   */
  bundle?: string;
  /**
   * Row reference id
   */
  referenceUuid?: string;
};

/**
 * Parameters used to call tab-content API
 */
export type TabContentParams = {
  /**
   * References to a navigation item
   */
  navigation?: string;
};

export type TabContentNavigationItem = {
  cta?: NavigationCta;
  display: Text;
  analytics: {
    [key: string]: string;
  };
};

export type SubNavigationItem = {
  cta?: ContentRowCta;
  display: Text;
  analytics: {
    [key: string]: string;
  };
};

export type SkillProgressesItem = {
  text: string;
  value: string;
  cta?: NavigationCta;
  analytics?: {
    [key: string]: string;
  };
};

export type SubSkillProgressesItem = {
  text: string;
  value: string;
  isHighlighted: boolean;
  isSelected?: boolean;
};

export type NavigationCta = {
  contentRowParams?: ContentRowParams;
  tabContentParams?: TabContentParams;
};

export type ContentRowCta = {
  contentRowParams?: ContentRowParams;
};

export type Collection = {
  /**
   * The universally unique identifier.
   */
  uuid: string;
  /**
   * The slug used for friendly page links.
   */
  slug: string;
  /**
   * Hexadecimal color representation (#RRGGBB)
   */
  loadingColor?: string;
  /**
   * This field is deprecated and replaced by the backgroundAudio MediaItem.
   *
   * @deprecated
   */
  backgroundMediaAudioUuid?: string;
  /**
   * This field is deprecated and replaced by the backgroundAudio MediaItem.
   *
   * @deprecated
   */
  backgroundBrightcoveAudioId?: string;
  backgroundAudio?: MediaItem;
  /**
   * Max volume for background audio.
   */
  maxVolume?: number;
  /**
   * Background audio volume on video cards.
   */
  ambientVolumeInVideoCard?: number;
  /**
   * See `CollectionTypes` enum for values.
   */
  collectionType?: string;
  parts: Array<CollectionPart>;
};

export type CollectionTypes =
  | "Collection"
  | "Collection::Takeaway"
  | "Collection::Audio"
  | "Collection::ShortVideo"
  | "Collection::Quiz"
  | "Collection::Onboarding";

export const CollectionTypes = {
  COLLECTION: "Collection",
  COLLECTION__TAKEAWAY: "Collection::Takeaway",
  COLLECTION__AUDIO: "Collection::Audio",
  COLLECTION__SHORT_VIDEO: "Collection::ShortVideo",
  COLLECTION__QUIZ: "Collection::Quiz",
  COLLECTION__ONBOARDING: "Collection::Onboarding",
} as const;

export type CollectionPart = {
  /**
   * The universally unique identifier.
   */
  uuid: string;
  /**
   * The slug used for friendly page links.
   */
  slug: string;
  /**
   * CollectionPart position within the Collection.
   */
  position?: number;
  analytics?: {
    [key: string]: string;
  };
  cards?: Array<
    CollectionPartCard & {
      partCover?: CollectionTemplatePartCover;
      textOnly?: CollectionTemplateTextOnly;
      imageTop?: CollectionTemplateImageTop;
      imageBottom?: CollectionTemplateImageBottom;
      fullScreenImage?: CollectionTemplateFullScreenImage;
      quote?: CollectionTemplateQuote;
      framing?: CollectionTemplateFraming;
      quiz?: CollectionTemplateQuiz;
      videoSetup?: CollectionTemplateVideoSetup;
      list?: CollectionTemplateList;
      partEnd?: CollectionTemplatePartEnd;
      shortVideo?: CollectionTemplateShortVideo;
      audio?: CollectionTemplateAudio;
      partendWithLinks?: CollectionTemplatePartEndWithLinks;
      takeaway?: CollectionTemplateTakeawayText;
      quizCoverCard?: CollectionTemplateQuizCover;
      onboardingSelection?: CollectionTemplateOnboardingSelection;
      quizArticle?: CollectionTemplateQuizArticle;
      compactPartCover?: CollectionTemplateCompactPartCover;
    }
  >;
};

export type CollectionPartCard = {
  /**
   * The universally unique identifier.
   */
  uuid: string;
  /**
   * The slug used for friendly page links.
   */
  slug: string;
  /**
   * For values see `CollectionPartCardType`.
   */
  type: string;
  /**
   * Hex value of the color
   */
  backgroundColor?: string;
  /**
   * CollectionPartCard position within the CollectionPart.
   */
  position?: number;
  backgroundImage?: CollectionImage;
  analytics?: {
    [key: string]: string;
  };
};

export type CollectionPartCardType =
  | "PartCover"
  | "TextOnly"
  | "ImageTop"
  | "ImageBottom"
  | "FullScreenImage"
  | "Quote"
  | "Framing"
  | "Quiz"
  | "VideoSetup"
  | "List"
  | "PartEnd"
  | "ShortVideo"
  | "Audio"
  | "PartEndWithLinks"
  | "Takeaway"
  | "QuizCover"
  | "OnboardingSelection"
  | "QuizArticle"
  | "CompactPartCover";

export const CollectionPartCardType = {
  PART_COVER: "PartCover",
  TEXT_ONLY: "TextOnly",
  IMAGE_TOP: "ImageTop",
  IMAGE_BOTTOM: "ImageBottom",
  FULL_SCREEN_IMAGE: "FullScreenImage",
  QUOTE: "Quote",
  FRAMING: "Framing",
  QUIZ: "Quiz",
  VIDEO_SETUP: "VideoSetup",
  LIST: "List",
  PART_END: "PartEnd",
  SHORT_VIDEO: "ShortVideo",
  AUDIO: "Audio",
  PART_END_WITH_LINKS: "PartEndWithLinks",
  TAKEAWAY: "Takeaway",
  QUIZ_COVER: "QuizCover",
  ONBOARDING_SELECTION: "OnboardingSelection",
  QUIZ_ARTICLE: "QuizArticle",
  COMPACT_PART_COVER: "CompactPartCover",
} as const;

export type CollectionQuizCardType =
  | "PartCover"
  | "TextOnly"
  | "ImageTop"
  | "ImageBottom"
  | "FullScreenImage"
  | "Quote"
  | "Framing"
  | "InlineAnswer"
  | "VideoSetup"
  | "List"
  | "PartEnd";

export const CollectionQuizCardType = {
  PART_COVER: "PartCover",
  TEXT_ONLY: "TextOnly",
  IMAGE_TOP: "ImageTop",
  IMAGE_BOTTOM: "ImageBottom",
  FULL_SCREEN_IMAGE: "FullScreenImage",
  QUOTE: "Quote",
  FRAMING: "Framing",
  INLINE_ANSWER: "InlineAnswer",
  VIDEO_SETUP: "VideoSetup",
  LIST: "List",
  PART_END: "PartEnd",
} as const;

export type CollectionTemplatePartCover = {
  images?: {
    separatorIcon?: CollectionImage;
    instructors?: CollectionImage;
    nameplate?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    instructorsLabel?: string;
    /**
     * HTML representaton of the styled text.
     */
    description?: string;
  };
};

export type CollectionTemplateCompactPartCover = {
  images?: {
    instructors?: CollectionImage;
    nameplate?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    instructorsLabel?: string;
  };
};

export type CollectionTemplateTextOnly = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    header1?: string;
    /**
     * HTML representaton of the styled text.
     */
    header2?: string;
  };
  images?: {
    separatorIcon?: CollectionImage;
  };
};

export type CollectionTemplateImageTop = {
  images?: {
    assetImage?: CollectionImage;
    separatorIcon?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    header?: string;
    /**
     * HTML representaton of the styled text.
     */
    body?: string;
  };
};

export type CollectionTemplateImageBottom = {
  images?: {
    assetImage?: CollectionImage;
    separatorIcon?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    header?: string;
    /**
     * HTML representaton of the styled text.
     */
    body?: string;
  };
};

export type CollectionTemplateFullScreenImage = {
  images?: {
    separatorIcon?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    captionText?: string;
  };
};

export type CollectionTemplateQuote = {
  images?: {
    quote?: CollectionImage;
    separatorIcon?: CollectionImage;
    instructorProfile?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
    /**
     * HTML representaton of the styled text.
     */
    instructorName?: string;
    /**
     * HTML representaton of the styled text.
     */
    instructorBio?: string;
  };
};

export type CollectionTemplateFraming = {
  images?: {
    assetImage?: CollectionImage;
    eyebrowBackgroundImage?: CollectionImage;
    separatorIcon?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
    /**
     * HTML representaton of the styled text.
     */
    description?: string;
  };
};

export type CollectionTemplateQuiz = {
  question?: CollectionTemplateQuizQuestion;
  results?: Array<CollectionQuizResult>;
};

export type CollectionTemplateQuizQuestion = {
  images?: {
    assetImage?: CollectionImage;
    eyebrowBackgroundImage?: CollectionImage;
    pillImage?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
    /**
     * HTML representaton of the styled text.
     */
    pillText?: string;
  };
  options?: Array<CollectionTemplateQuizQuestionOption>;
};

export type CollectionTemplateQuizQuestionOption = {
  answerReference?: string;
  isCorrect?: boolean;
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    optionText?: string;
  };
};

export type CollectionQuizResult = {
  answerReference?: string;
  /**
   * For values see `CollectionQuizCardType`.
   */
  type?: string;
  backgroundImage?: CollectionImage;
  partCover?: CollectionTemplatePartCover;
  textOnly?: CollectionTemplateTextOnly;
  imageTop?: CollectionTemplateImageTop;
  imageBottom?: CollectionTemplateImageBottom;
  fullScreenImage?: CollectionTemplateFullScreenImage;
  quote?: CollectionTemplateQuote;
  framing?: CollectionTemplateFraming;
  videoSetup?: CollectionTemplateVideoSetup;
  list?: CollectionTemplateList;
  partEnd?: CollectionTemplatePartEnd;
  inlineAnswer?: CollectionTemplateInlineAnswer;
  shortVideo?: CollectionTemplateShortVideo;
  audio?: CollectionTemplateAudio;
  partendWithLinks?: CollectionTemplatePartEndWithLinks;
  takeaway?: CollectionTemplateTakeawayText;
  quizCoverCard?: CollectionTemplateQuizCover;
  onboardingSelection?: CollectionTemplateOnboardingSelection;
  quizArticle?: CollectionTemplateQuizArticle;
  compactPartCover?: CollectionTemplateCompactPartCover;
};

export type CollectionTemplateVideoSetup = {
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This will be deprecated in the future.
   *
   */
  brightcoveVideoId?: string;
  /**
   * The unique identifier for the video content. Use this media UUID to fetch metdata from the edge API.
   *
   */
  mediaUuid?: string;
  images?: {
    quote?: CollectionImage;
    separatorIcon?: CollectionImage;
    instructorProfile?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
    /**
     * HTML representaton of the styled text.
     */
    headerText2?: string;
    /**
     * HTML representaton of the styled text.
     */
    instructorName?: string;
    /**
     * HTML representaton of the styled text.
     */
    instructorBio?: string;
  };
};

export type CollectionTemplateList = {
  images?: {
    assetImage?: CollectionImage;
    separatorIcon?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
  };
  bullets?: Array<{
    bulletImage?: CollectionImage;
    /**
     * HTML representaton of the styled text.
     */
    bulletTitleHtml?: string;
    /**
     * HTML representaton of the styled text.
     */
    bulletDescriptionHtml?: string;
  }>;
};

export type CollectionTemplatePartEnd = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
  };
  images?: {
    nameplate?: CollectionImage;
  };
  /**
   * Hexadecimal color representation (#RRGGBB)
   */
  circleGroupColor?: string;
};

export type CollectionTemplateInlineAnswer = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    headerText?: string;
    /**
     * HTML representaton of the styled text.
     */
    headerText2?: string;
    /**
     * HTML representaton of the styled text.
     */
    description?: string;
  };
};

export type CollectionRows = {
  rows?: Array<CollectionRow>;
};

export type CollectionRow = {
  /**
   * A UUID that identifies the row.
   */
  rowUuid: string;
  /**
   * The title of the row in the UX
   */
  title?: string;
  tiles?: Array<CollectionRowTile>;
  analytics?: {
    [key: string]: string;
  };
};

export type CollectionRowTile = {
  /**
   * The unique identifier for the tile.
   */
  tileUuid: string;
  collectionUuid?: string;
  collectionSlug?: string;
  partUuid?: string;
  partSlug?: string;
  backgroundImageUrl?: string;
  /**
   * Hexadecimal color representation (#RRGGBB)
   */
  loadingColor?: string;
  /**
   * For accessibility.
   */
  altText?: string;
  tileClickRedirect?: string;
  analytics?: {
    [key: string]: string;
  };
  releaseDetails?: {
    isReleased?: boolean;
  };
  progress?: {
    isComplete?: boolean;
    barPercentage?: number;
    resumeCardUuid?: string;
  };
};

export type CollectionTemplateShortVideo = {
  /**
   * The unique identifier for the brightcove video content.
   * Use this brightcove video ID to fetch metdata from Brightcove.
   * This field is deprecated and replaced by the video MediaItem.
   *
   * @deprecated
   */
  brightcoveVideoId?: string;
  /**
   * This field is deprecated and replaced by the video MediaItem.
   *
   * @deprecated
   */
  mediaUuid?: string;
  video?: MediaItem;
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
  };
};

export type CollectionTemplateAudio = {
  audio?: MediaItem;
  /**
   * Time in seconds
   */
  startPosition?: number;
  /**
   * Time in seconds
   */
  endPosition?: number;
  /**
   * The url of the mp3 of the text that is uttered at the start of the content. mp3 is the output of the MC TTS Service.
   */
  audioNoteUrl?: string;
  images?: {
    asset?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
  };
};

export type CollectionTemplatePartEndWithLinks = {
  images?: {
    finishedIcon?: CollectionImage;
    asset?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML representaton of the styled text.
     */
    subtitle?: string;
    /**
     * HTML representaton of the styled text.
     */
    relatedContentTitle?: string;
    /**
     * HTML representaton of the styled text.
     */
    instructorName?: string;
  };
  /**
   * URL similar to content row item tileClickRedirect
   */
  tileClickRedirect?: string;
};

export type CollectionTemplateTakeawayText = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    takeaway?: string;
    /**
     * HTML representaton of the styled text.
     */
    ctaTitle?: string;
    /**
     * HTML representaton of the styled text.
     */
    ctaSubtitle?: string;
  };
  images?: {
    ctaImage?: CollectionImage;
    pillImage?: CollectionImage;
  };
  /**
   * URL similar to content row item tileClickRedirect
   */
  tileClickRedirect?: string;
};

export type CollectionTemplateQuizCover = {
  images?: {
    instructorAsset?: CollectionImage;
  };
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
  };
};

export type CollectionTemplateQuizArticle = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
    /**
     * HTML string
     */
    subtitle?: string;
  };
};

export type CollectionTemplateOnboardingSelection = {
  htmlText?: {
    /**
     * HTML representaton of the styled text.
     */
    title?: string;
  };
};

export type CollectionInteractions = {
  progress?: {
    resumePartUuid?: string;
    /**
     * The slug of the part that the user is resuming.
     */
    resumePartSlug?: string;
    resumeCardUuid?: string;
    /**
     * The slug of the card in the part that the user is resuming.
     */
    resumeCardSlug?: string;
    /**
     * Returns whether the user has completed the collection.
     */
    isComplete?: boolean;
    /**
     * The percentage of the progress that the user has made in the collection.
     */
    barPercentage?: number;
  };
  /**
   * Any additional analytics information that needs to be sent.
   */
  analytics?: {
    [key: string]: string;
  };
};

export type OnboardingAnalytics = {
  slug: string;
};

export type OnboardingStep = {
  slug: string;
};

export type Onboarding = {
  id: number;
  steps: Array<OnboardingStep>;
  analytics: OnboardingAnalytics;
};

export type UpdateSessionPreferences = {
  communityId: string;
};

export type IterableToken = {
  /**
   * The Json Web Token (JWT)
   */
  accessToken: string;
  expiresIn: number;
};

export type RevolutEligibleGift = {
  /**
   * The identifier is eligible to redeem a Revolut tier
   */
  eligible: boolean;
  /**
   * See `RevolutEligibleGiftStatuses` enum for values.
   */
  status: string;
  /**
   * See `RevolutEligibleGiftTiers` enum for values.
   */
  tier: string;
  /**
   * Defines whether the same type of tier is being activated.
   */
  isStack: boolean;
  /**
   * Returns the Revolut tier sku.
   */
  sku: string;
};

export type RevolutEligibleGiftStatuses =
  | "available"
  | "upgrade"
  | "downgrade"
  | "undefined"
  | "enterprise_user"
  | "expired_gift"
  | "redeemed_gift"
  | "active_subscription";

export const RevolutEligibleGiftStatuses = {
  AVAILABLE: "available",
  UPGRADE: "upgrade",
  DOWNGRADE: "downgrade",
  UNDEFINED: "undefined",
  ENTERPRISE_USER: "enterprise_user",
  EXPIRED_GIFT: "expired_gift",
  REDEEMED_GIFT: "redeemed_gift",
  ACTIVE_SUBSCRIPTION: "active_subscription",
} as const;

export type RevolutEligibleGiftTiers = "high" | "low";

export const RevolutEligibleGiftTiers = {
  HIGH: "high",
  LOW: "low",
} as const;

export type CertificateProgram = {
  /**
   * The unique identifier of the certificate program.
   */
  uuid: string;
  /**
   * The slug of the certificate program.
   */
  slug: string;
  /**
   * The title of the certificate program.
   */
  title: string;
  /**
   * The subtitle of the certificate program, displayed below the title on the marketing page hero.
   */
  subtitle?: string;
  /**
   * Optional marketing hero overrides. title/subtitle fall back to the program title/subtitle on the client when absent; eyebrow is only shown when present.
   *
   */
  heroSection?: {
    /**
     * Small eyebrow above the headline, typically the program name.
     */
    eyebrow?: string;
    /**
     * Marketing headline. Client falls back to program.title if blank.
     */
    headline?: string;
    /**
     * Marketing subheadline. Client falls back to program.subtitle if blank.
     */
    subheadline?: string;
  };
  /**
   * The images associated with the certificate program.
   */
  images?: {
    hero1x1?: Image;
    hero16x9?: Image;
    logoLockup?: Image;
    logoLockupLight?: Image;
    thumbnail16x9?: Image;
    showcase4x5?: Image;
  };
  /**
   * The videos associated with the certificate program.
   */
  videos?: {
    /**
     * Media UUID of course trailer.
     */
    trailerMediaUuid?: string;
  };
  defaultEngagement?: CertificateProgramEngagement;
  /**
   * The syllabus of the certificate program.
   */
  syllabus?: {
    /**
     * The URL to the syllabus PDF.
     */
    pdfUrl?: string;
    preview10x13?: Image;
  };
  /**
   * The key benefits of the certificate program.
   */
  keyBenefits?: Array<{
    /**
     * The title of the key benefit.
     */
    title?: string;
    /**
     * A short description of the key benefit.
     */
    description?: string;
  }>;
  /**
   * The outcome section of the certificate program.
   */
  outcomes?: {
    /**
     * The eyebrow text for the outcomes section.
     */
    eyebrow?: string;
    /**
     * The headline of the outcomes section.
     */
    headline?: string;
    /**
     * List of outcome statements for the certificate program.
     */
    outcomeStatements?: Array<CurriculumStatement>;
    /**
     * List of skills taught by this certificate program.
     */
    skills?: Array<CurriculumStatement>;
    /**
     * Grouped outcomes, such as the week cards on a cohort landing page.
     */
    groups?: Array<CertificateProgramOutcomeGroup>;
    images?: {
      outcomes9x16?: Image;
      outcomes1x1?: Image;
    };
  };
  partner?: CertificateProgramPartner;
  /**
   * Every partner of a cohort program, in position order. Only returned for cohort programs; self-paced programs return `partner` instead.
   */
  partners?: Array<CertificateProgramPartner>;
  /**
   * List of instructors for the certificate program.
   */
  instructors?: Array<CurriculumInstructor>;
  /**
   * Header copy for the instructors section.
   */
  instructorsSection?: {
    /**
     * Small eyebrow above the instructors section headline.
     */
    eyebrow?: string;
    /**
     * The instructors section headline.
     */
    headline?: string;
  };
  curriculum?: Curriculum;
  /**
   * A descriptive label for when the certificate program will be available (e.g., "available Fall 2024").
   */
  releaseLabel?: string;
  /**
   * Whether signup for this certificate program is enabled.
   */
  signupEnabled?: boolean;
  /**
   * Whether this certificate program is currently in pre-enrollment.
   */
  isPreenroll?: boolean;
  /**
   * List of testimonials for the certificate program, sourced from external platforms (e.g. LinkedIn).
   */
  testimonials?: Array<{
    /**
     * The highlighted testimonial quote.
     */
    quote?: string;
    customer?: {
      /**
       * The name of the customer.
       */
      name?: string;
      /**
       * The title of the customer.
       */
      title?: string;
    };
    /**
     * The platform the testimonial originates from. Drives source-specific rendering (e.g. the LinkedIn icon and post link).
     * See `CertificateProgramTestimonialSource` for a list of possible values.
     *
     */
    source?: string;
    /**
     * URL of the author's avatar image.
     */
    avatarUrl?: string;
    /**
     * Permalink to the original post or review on the source platform.
     */
    sourceUrl?: string;
    /**
     * The full testimonial body text.
     */
    body?: string;
  }>;
  /**
   * The certificate showcase section configuration and content.
   */
  certificateShowcase?: {
    /**
     * The images for the certificate showcase section.
     */
    images?: {
      showcase4x5?: Image;
    };
    /**
     * The subtext for the certificate showcase section.
     */
    subtext?: string;
  };
  /**
   * The pedagogy section of the certificate program.
   */
  pedagogy?: Array<{
    /**
     * The eyebrow text for the pedagogy section.
     */
    eyebrow?: string;
    /**
     * The title of the pedagogy section.
     */
    title?: string;
    /**
     * The description of the pedagogy section.
     */
    description?: string;
    image?: Image;
  }>;
  /**
   * Product bundles that include this certificate program.
   */
  includedInBundles?: Array<CertificateProgramBundleReference>;
  /**
   * How the certificate program is delivered, as set in admin: `cohort` for a program that sells
   * seats in cohorts, otherwise `selfPaced`. A cohort program with no cohort currently accepting
   * purchases keeps `format` `cohort` and sends no `cohort` object.
   *
   */
  format?: string;
  cohort?: CertificateProgramCohort;
};

export type CertificateProgramFormat = "self_paced" | "cohort";

export const CertificateProgramFormat = {
  SELF_PACED: "self_paced",
  COHORT: "cohort",
} as const;

/**
 * The cohort currently accepting purchases for a cohort program. Present only when `format` is
 * `cohort` and a cohort is accepting; absent for self-paced programs and for a cohort program
 * between cohorts.
 * Dates are calendar dates interpreted as midnight Pacific time (America/LosAngeles). `onSale`
 * decides whether the cohort can be bought; `enrollmentWindows` is for display, and today can be
 * on sale without falling inside any listed window. The price comes from the certificate program
 * product endpoint, not from this object.
 *
 */
export type CertificateProgramCohort = {
  /**
   * The date the cohort starts.
   */
  startDate: string;
  /**
   * How many weeks the cohort runs, from its start date to its end date. Absent until the cohort
   * has an end date.
   *
   */
  durationWeeks?: number;
  /**
   * The maximum number of seats in the cohort. Absent when the cohort has no seat cap.
   */
  seatCap?: number;
  /**
   * True exactly when `seatsAvailable` is zero. One input to `onSale`, not an override of it.
   *
   */
  soldOut: boolean;
  /**
   * The cohort's name, as set in admin.
   */
  name?: string;
  /**
   * Seats left: `seatCap` minus active and pending enrollments, never below zero. Absent when
   * the cohort has no seat cap. The cap is soft: two buyers who both see a seat can both get one,
   * so this is an estimate, not a reservation.
   *
   */
  seatsAvailable?: number;
  /**
   * The one field that gates purchase. True when the cohort is active, enrollment is not paused,
   * today is inside an enrollment window, and the cohort is not sold out. Checkout re-checks the
   * same rule and returns `cohortNotOnSale` or `cohortSoldOut` when it no longer holds.
   *
   */
  onSale?: boolean;
  /**
   * The cohort's priority, early and final windows in date order, contiguous: each window's
   * `endsOn` is the next one's `starts_on`. Any other window on the cohort is left out.
   *
   */
  enrollmentWindows: Array<CertificateProgramCohortEnrollmentWindow>;
};

export type CertificateProgramCohortEnrollmentWindow = {
  /**
   * See `CertificateProgramCohortWindowType` for possible values.
   */
  windowType: string;
  /**
   * The first day of the window.
   */
  startsOn: string;
  /**
   * Exclusive. The window closes at the start of this day.
   */
  endsOn: string;
};

export type CertificateProgramCohortWindowType = "priority" | "early" | "final";

export const CertificateProgramCohortWindowType = {
  PRIORITY: "priority",
  EARLY: "early",
  FINAL: "final",
} as const;

export type CertificateProgramOutcomeGroup = {
  /**
   * The short label shown above the title of the outcome group.
   */
  label?: string;
  /**
   * The title of the outcome group.
   */
  title?: string;
  /**
   * The description of the outcome group.
   */
  description?: string;
  /**
   * The heading shown above the outcomes in this group.
   */
  statementsHeading?: string;
  /**
   * The outcomes in this group.
   */
  statements?: Array<CurriculumStatement>;
};

/**
 * A partner of a certificate program. Self-paced programs return their partner as `partner`; cohort programs return theirs as `partners`.
 */
export type CertificateProgramPartner = {
  /**
   * The eyebrow text for the partner.
   */
  eyebrow?: string;
  /**
   * The headline of the partner section.
   */
  headline?: string;
  /**
   * The name of the partner.
   */
  name?: string;
  /**
   * The subheading for the partner about section.
   */
  subheading?: string;
  /**
   * A brief bio of the partner.
   */
  bio?: string;
  images?: {
    logo?: Image;
    brand1x1?: Image;
  };
};

export type CertificateProgramBundleReference = {
  /**
   * The unique identifier of the product bundle.
   */
  uuid: string;
  /**
   * The slug of the product bundle, used for URL construction.
   */
  slug: string;
  /**
   * The display name of the product bundle (certificate path title).
   */
  name: string;
};

/**
 * A general object containing a text property.
 */
export type CurriculumStatement = {
  text: string;
};

export type Curriculum = {
  /**
   * The details of the curriculum.
   */
  details: {
    /**
     * The title of the curriculum.
     */
    title?: string;
    /**
     * The description of the curriculum.
     */
    description?: string;
    images?: {
      hero1x1?: Image;
      rewardPreview?: Image;
      logoLockup?: Image;
      logoLockupCondensedDark?: Image;
    };
    videos?: {
      /**
       * Media UUID of course trailer.
       */
      trailerMediaUuid?: string;
    };
    /**
     * The total estimated time to complete the curriculum, in seconds.
     */
    estimatedDuration?: number;
    /**
     * The total number of lessons in the curriculum.
     */
    totalLessons?: number;
    /**
     * The difficulty of the curriculum.
     */
    difficulty?: string;
    /**
     * See `CurriculumStatus` for possible values.
     */
    status?: string;
    /**
     * The applied skills section of the curriculum.
     */
    appliedSkills?: {
      /**
       * The heading for the applied skills section.
       */
      heading?: string;
      /**
       * List of applied skills for the curriculum.
       */
      statements?: Array<CurriculumStatement>;
    };
    /**
     * The partner information for the certificate program.
     */
    partner?: {
      /**
       * The name of the partner.
       */
      name?: string;
      images?: {
        logo?: Image;
        logo1x1?: Image;
      };
    };
  };
  units: Array<CurriculumUnit>;
  analytics?: {
    [key: string]: string;
  };
  /**
   * Glossary terms for the curriculum.
   */
  glossary?: Array<CurriculumGlossaryTerm>;
  /**
   * Whether this certificate's curriculum has any authored tool templates (Digital Workbook content). Drives Toolkit nav visibility and /toolkit access.
   */
  hasTools?: boolean;
};

/**
 * Experiment assignment for the current user. Null if the user is not enrolled in an active experiment.
 */
export type CurriculumExperimentMetadata = {
  /**
   * The GrowthBook experiment flag name (e.g. mccerts-123V1).
   */
  experimentName: string;
  /**
   * The variant the user is assigned to (e.g. control, variant1). Null if the user has not yet been assigned a variant.
   */
  variantName?: string | null;
};

/**
 * Per-user curriculum migration notification. Null if the user has no UserCurriculum on the resolved curriculum.
 */
export type CurriculumMigrationNotification = {
  /**
   * True iff the user has been migrated to the winning variant and has not yet dismissed the banner.
   */
  hasPendingNotification: boolean;
  /**
   * When the user was migrated to the winning variant. Null if the user has not been migrated.
   */
  migratedAt?: string | null;
};

export type CurriculumStatus = "available" | "coming_soon";

export const CurriculumStatus = {
  AVAILABLE: "available",
  COMING_SOON: "coming_soon",
} as const;

export type CurriculumUnit = {
  /**
   * The unique identifier of a unit.
   */
  uuid: string;
  /**
   * The title of the unit.
   */
  title: string;
  /**
   * The position of the unit.
   */
  position?: number;
  /**
   * The description of the unit.
   */
  description?: string;
  /**
   * The total estimated time to complete the unit, in seconds.
   */
  estimatedDuration?: number;
  /**
   * List of skills taught by this curriculum.
   */
  skills?: Array<CurriculumStatement>;
  /**
   * The total number of lessons in the unit.
   */
  totalLessons?: number;
  analytics?: {
    [key: string]: string;
  };
  lessons: Array<CurriculumLesson>;
};

export type CurriculumLesson = {
  /**
   * The unique identifier of a lesson.
   */
  uuid: string;
  /**
   * The slug of the lesson.
   */
  slug: string;
  /**
   * The title of the lesson.
   */
  title: string;
  /**
   * The title of the lesson.
   */
  subtitle?: string;
  /**
   * The description of the lesson.
   */
  description?: string;
  /**
   * The position of the lesson.
   */
  position: number;
  /**
   * The duration of the lesson, in seconds.
   */
  estimatedDuration?: number;
  /**
   * See `CurriculumLessonType` for possible values.
   */
  lessonType?: string;
  /**
   * Whether the lesson is required or not.
   */
  required?: boolean;
  analytics?: {
    [key: string]: string;
  };
  activities?: Array<CurriculumActivity>;
  navigation?: {
    /**
     * Slug of the next lesson
     */
    nextLessonSlug?: string;
    /**
     * Slug of the previous lesson
     */
    previousLessonSlug?: string;
  };
  download?: {
    /**
     * The header text of the download section.
     */
    headerText?: string;
    /**
     * The description of the download section.
     */
    description?: string;
    /**
     * The call to action text.
     */
    ctaText?: string;
    downloadImage?: Image;
    analytics?: {
      [key: string]: string;
    };
  };
};

export type CurriculumLessonType =
  | "video"
  | "quiz"
  | "reading"
  | "discussion"
  | "project"
  | "questionnaire"
  | "applied_learning"
  | "roleplay";

export const CurriculumLessonType = {
  VIDEO: "video",
  QUIZ: "quiz",
  READING: "reading",
  DISCUSSION: "discussion",
  PROJECT: "project",
  QUESTIONNAIRE: "questionnaire",
  APPLIED_LEARNING: "applied_learning",
  ROLEPLAY: "roleplay",
} as const;

/**
 * Error body returned when the user may reach the certificate program but not this lesson. Clients branch on `code` and never parse `error`.
 */
export type CurriculumLessonAccessErrorResponse = {
  /**
   * Human-readable summary. Do not branch on it.
   */
  error: string;
  /**
   * See `CurriculumLessonAccessErrorCode` for possible values.
   */
  code: string;
};

/**
 * Machine-readable reasons a lesson is forbidden. `dataSharingConsentRequired` means the enrollment still needs data sharing consent; `lessonNotAccessible` means the user has access to the certificate but not to this lesson.
 */
export type CurriculumLessonAccessErrorCode =
  | "data_sharing_consent_required"
  | "lesson_not_accessible";

export const CurriculumLessonAccessErrorCode =
  /**
   * Machine-readable reasons a lesson is forbidden. `dataSharingConsentRequired` means the enrollment still needs data sharing consent; `lessonNotAccessible` means the user has access to the certificate but not to this lesson.
   */
  {
    DATA_SHARING_CONSENT_REQUIRED: "data_sharing_consent_required",
    LESSON_NOT_ACCESSIBLE: "lesson_not_accessible",
  } as const;

export type CurriculumActivity = {
  /**
   * The unique identifier of an activity.
   */
  uuid: string;
  /**
   * The title of the activity.
   */
  title?: string;
  /**
   * The description of the activity.
   */
  description?: string;
  /**
   * The position of the activity.
   */
  position: number;
  /**
   * Whether the activity is required or not.
   */
  required?: boolean;
  /**
   * The estimated duration of the activity in seconds.
   */
  estimatedDuration?: number;
  analytics?: {
    [key: string]: string;
  };
  resource?: {
    /**
     * The call to action text.
     */
    ctaText?: string;
    /**
     * The URL to download the resource.
     */
    downloadUrl?: string;
  };
  /**
   * See `CurriculumActivityType` for possible values.
   */
  activityType?: string;
  video?: CurriculumVideoActivity;
  quiz?: CurriculumQuizActivity;
  article?: CurriculumArticleActivity;
  discussion?: CurriculumDiscussionActivity;
  instructors?: CurriculumInstructorsActivity;
  capstoneSummary?: CurriculumCapstoneSummaryActivity;
  questionnaire?: CurriculumQuestionnaireActivity;
  appliedLearning?: CurriculumAppliedLearningActivity;
  roleplay?: CurriculumRoleplayActivity;
  aiProject?: CurriculumAIProjectActivity;
};

export type CurriculumActivityType =
  | "video"
  | "article"
  | "quiz"
  | "discussion"
  | "instructors"
  | "capstone_summary"
  | "questionnaire"
  | "applied_learning"
  | "roleplay"
  | "ai_project";

export const CurriculumActivityType = {
  VIDEO: "video",
  ARTICLE: "article",
  QUIZ: "quiz",
  DISCUSSION: "discussion",
  INSTRUCTORS: "instructors",
  CAPSTONE_SUMMARY: "capstone_summary",
  QUESTIONNAIRE: "questionnaire",
  APPLIED_LEARNING: "applied_learning",
  ROLEPLAY: "roleplay",
  AI_PROJECT: "ai_project",
} as const;

export type CurriculumVideoActivity = {
  /**
   * The unique identifier of the video.
   */
  mediaUuid: string;
  /**
   * The footer text of the video.
   */
  footerText?: string;
};

export type CurriculumArticleActivity = {
  /**
   * The text of the article.
   */
  text: string;
  glossary?: Array<CurriculumGlossaryTerm>;
  /**
   * URL of an optional narration of the article, read aloud.
   */
  audioUrl?: string | null;
};

export type CurriculumGlossaryTerm = {
  /**
   * Human-readable identifier for the glossary term
   */
  slug: string;
  /**
   * Display title for the glossary term
   */
  title: string;
  /**
   * The content of the glossary term.
   */
  content: string;
};

export type CurriculumQuizActivity = {
  questions: Array<CurriculumQuizQuestion>;
};

export type CurriculumQuizQuestion = {
  /**
   * The slug of the question.
   */
  slug: string;
  /**
   * The text of the question.
   */
  text: string;
  /**
   * The description of the question to provide more context.
   */
  description?: string;
  choices: Array<CurriculumQuizChoice>;
};

export type CurriculumQuizChoice = {
  /**
   * The slug of the option.
   */
  slug: string;
  /**
   * The text of the option.
   */
  text: string;
};

export type CurriculumDiscussionActivity = {
  discussionQuestions: Array<CurriculumDiscussionQuestion>;
  rubric?: CurriculumDiscussionRubric;
};

/**
 * If the discussion submission is to be evaluated, this object will be returned to provide the user with
 * the rubric for the discussion.
 *
 */
export type CurriculumDiscussionRubric = {
  /**
   * The unique identifier of the rubric.
   */
  rubricUuid?: string;
  /**
   * See `CurriculumDiscussionRubricEvaluationType` for possible values.
   */
  evaluationType?: string;
  /**
   * The maximum mark a user can achieve.
   */
  maxMark?: number;
  /**
   * The passing mark for the discussion.
   */
  passingMark?: number;
  /**
   * The questions in the rubric, where the key is the question slug.
   */
  questions?: {
    [key: string]: CurriculumDiscussionRubricQuestion;
  };
};

export type CurriculumDiscussionRubricEvaluationType =
  | "full_evaluation"
  | "only_feedback";

export const CurriculumDiscussionRubricEvaluationType = {
  FULL_EVALUATION: "full_evaluation",
  ONLY_FEEDBACK: "only_feedback",
} as const;

export type CurriculumDiscussionRubricQuestion = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The maximum mark a user can achieve for this question. This value is an aggregate of all the maximum criteria marks.
   */
  maxMark?: number;
  criteria?: Array<CurriculumDiscussionRubricQuestionCriterion>;
};

export type CurriculumDiscussionRubricQuestionCriterion = {
  /**
   * The slug of the criteria.
   */
  criterionSlug: string;
  /**
   * The position of the criteria.
   */
  position: number;
  /**
   * The maximum mark a user can achieve for this criterion.
   */
  maxMark?: number;
  /**
   * The text of the criteria.
   */
  text: string;
  /**
   * The description of the criteria to provide more context.
   */
  description?: string;
};

export type CurriculumDiscussionQuestion = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The primary text of the question.
   */
  text: string;
  /**
   * The description of the question to provide more context.
   */
  description?: string;
  /**
   * The minimum length of the answer.
   */
  minLength?: number;
  /**
   * The maximum length of the answer.
   */
  maxLength?: number;
};

export type CurriculumInstructorsActivity = Array<CurriculumInstructor>;

/**
 * The capstone summary activity for a lesson.
 */
export type CurriculumCapstoneSummaryActivity = {
  projectPreview4x3?: Image;
  /**
   * The maximum mark that can be achieved for the entire capstone project.
   */
  maxMark?: number;
  /**
   * The total number of discussion questions in the capstone project.
   */
  totalDiscussionQuestions?: number;
  /**
   * The capstone project deliverables.
   */
  deliverables?: Array<CapstoneProjectDeliverable>;
};

/**
 * A deliverable item for a capstone project.
 */
export type CapstoneProjectDeliverable = {
  discussion?: {
    /**
     * The unique identifier of the lesson associated with this deliverable.
     */
    lessonUuid: string;
    /**
     * The slug of the lesson associated with this deliverable.
     */
    lessonSlug: string;
    /**
     * The unique identifier of the activity associated with this deliverable.
     */
    activityUuid: string;
    /**
     * The title of the deliverable.
     */
    title: string;
    questions: Array<{
      /**
       * The question title.
       */
      title: string;
      /**
       * The maximum mark that can be achieved for this deliverable.
       */
      maxMark?: number;
      /**
       * The slug of the question.
       */
      questionSlug: string;
    }>;
  };
};

export type CurriculumInstructor = {
  /**
   * The name of the instructor.
   */
  name: string;
  /**
   * The role of the instructor.
   */
  role?: string;
  image?: Image;
  card?: CurriculumInstructorCard;
};

/**
 * The instructor card for this certificate program. Only on the certificate program endpoint.
 */
export type CurriculumInstructorCard = {
  title?: string;
  summary?: string;
  /**
   * The instructor's full bio, shown when the card is expanded.
   */
  fullBio?: string;
  highlight?: CurriculumInstructorHighlight;
};

/**
 * The highlight on the instructor card for this certificate program.
 */
export type CurriculumInstructorHighlight = {
  title?: string;
  subtitle?: string;
};

export type CurriculumQuestionnaireActivity = {
  /**
   * The type of questionnaire. See CurriculumQuestionnaireType enum for possible values.
   */
  questionnaireType: string;
  /**
   * The total number of questions in the questionnaire.
   */
  totalQuestions?: number;
  questions: Array<CurriculumQuestionnaireQuestion>;
};

export type CurriculumQuestionnaireQuestion = {
  /**
   * The slug of the question.
   */
  slug: string;
  /**
   * The text of the question.
   */
  text: string;
  choices: Array<CurriculumQuestionnaireChoice>;
};

export type CurriculumQuestionnaireChoice = {
  /**
   * The slug of the choice.
   */
  slug: string;
  /**
   * The text of the choice.
   */
  text: string;
  /**
   * The feedback of the choice.
   */
  feedback: string;
};

export type CurriculumQuestionnaireType = "self_assessment";

export const CurriculumQuestionnaireType = {
  SELF_ASSESSMENT: "self_assessment",
} as const;

export type CurriculumAppliedLearningActivity = {
  steps: Array<CurriculumAppliedLearningStep>;
  /**
   * The total number of steps in the applied learning activity.
   */
  totalSteps?: number;
  /**
   * Custom heading for the artifact cards (preview and result). When null, the client falls back to its default copy.
   */
  artifactTitle?: string | null;
  /**
   * Custom subtitle for the artifact cards (preview and result). When null, the client falls back to its default copy.
   */
  artifactSubtitle?: string | null;
};

export type CurriculumAppliedLearningStep = {
  /**
   * The unique slug identifier of the step.
   */
  slug: string;
  /**
   * The position of the step in the sequence.
   */
  position: number;
  /**
   * The title of the step.
   */
  title: string;
  /**
   * The instructions for the step.
   */
  instructions?: string;
};

export type CertificateProgramCatalog = {
  /**
   * Self-paced programs. Cohort programs are returned in `cohortTiles`.
   */
  tiles?: Array<CertificateTile>;
  /**
   * Cohort programs.
   */
  cohortTiles?: Array<CertificateTile>;
  bundleSpotlight?: ProductBundleSpotlight;
};

export type AppliedLearningUserConversation = {
  /**
   * The unique identifier of the conversation.
   */
  conversationUuid?: string;
  /**
   * JWT token for authenticating conversation interactions.
   */
  token?: string;
  /**
   * Token expiration time as Unix timestamp (seconds since epoch).
   */
  tokenExpiration?: number;
  messages?: Array<AppliedLearningUserConversationMessage>;
};

export type AppliedLearningUserConversationMessage = {
  /**
   * The unique identifier of the message.
   */
  messageUuid: string;
  /**
   * The role of the sender.
   */
  role: string;
  /**
   * The thoughts of the sender.
   */
  thoughts: string;
  /**
   * The turn number of the message.
   */
  turn: number;
  /**
   * Structured object parsed from thoughts when the assistant has an outputSchema configured.
   */
  parsedThoughts?: {
    [key: string]: unknown;
  } | null;
};

export type CertificateHubTiles = {
  continueWatchingTiles?: Array<CertificateTile>;
  moreCertificatesTiles?: Array<CertificateTile>;
  /**
   * Cohort programs, enrolled or not. `continueWatchingTiles` and `moreCertificatesTiles`
   * hold self-paced programs only.
   *
   */
  cohortTiles?: Array<CertificateTile>;
};

export type ProductBundleSpotlight = {
  /**
   * The slug of the product bundle.
   */
  slug: string;
  /**
   * The unique identifier of the product bundle.
   */
  uuid: string;
  /**
   * The condensed bundle title (titleCondensed).
   */
  name: string;
  /**
   * The certificate path title of the product bundle.
   */
  title: string;
  /**
   * The certificate path description of the product bundle.
   */
  description?: string;
  diplomaImage?: Image;
  diplomaHeader?: string;
  diplomaSubheader?: string;
  /**
   * Total certificate programs included in the bundle.
   */
  numberOfCourses: number;
  /**
   * Total estimated hours across the included certificate programs.
   */
  durationInHours?: number;
  /**
   * The formatted bundle savings amount (e.g. "$300") compared to purchasing courses individually.
   */
  displayDiscountAmount?: string;
  /**
   * URL for terms and conditions.
   */
  termsUrl?: string;
  curriculumPrograms: Array<ProductBundleItemRow>;
};

export type ProductBundleItemRow = {
  /**
   * The condensed title of the certificate program.
   */
  title: string;
  /**
   * The unique identifier of the certificate program.
   */
  uuid: string;
  logoMark?: Image;
};

export type ProductBundle = {
  /**
   * The slug of the product bundle.
   */
  slug: string;
  /**
   * The name of the product bundle.
   */
  name: string;
  /**
   * The unique identifier of the product bundle.
   */
  uuid: string;
  hero?: ProductBundleHero;
  certificatePath?: ProductBundleCertificatePath;
  marketingContent?: ProductBundleMarketingContent;
  whatsIncluded?: ProductBundleWhatsIncluded;
};

/**
 * Certificate path section content for a product bundle.
 */
export type ProductBundleCertificatePath = {
  title?: string;
  description?: string;
  diplomaImage?: Image;
  diplomaHeader?: string;
  diplomaSubheader?: string;
  /**
   * Total certificate programs included in the bundle.
   */
  totalOfCourses?: number;
  /**
   * Total estimated hours across the included certificate programs.
   */
  totalOfHours?: number;
};

/**
 * Hero content for a product bundle.
 */
export type ProductBundleHero = {
  title?: string;
  description?: string;
  /**
   * Hero header copy (localized for request locale).
   */
  header?: string;
  /**
   * Hero headline copy.
   */
  heroHeadline?: string;
  /**
   * Hero subheadline copy.
   */
  heroSubheadline?: string;
  image?: ProductBundleMarketingContentImages;
  video?: ProductBundleHeroVideos;
  curriculumLogos?: Array<ProductBundleHeroCurriculumLogo>;
  /**
   * Disclaimer text (localized for request locale) displayed before the terms and conditions link.
   */
  disclaimer?: string;
  /**
   * URL for terms and conditions.
   */
  termsUrl?: string;
};

/**
 * Videos associated with the product bundle hero.
 */
export type ProductBundleHeroVideos = {
  trailerMediaUuid?: string;
};

/**
 * Curriculum logo item for a product bundle hero.
 */
export type ProductBundleHeroCurriculumLogo = {
  title?: string;
  logoMark?: Image;
};

export type ProductBundleMarketingContent = {
  /**
   * List of testimonials for the product bundle, aggregated from the certificate programs the bundle is composed of (localized for the request locale).
   */
  testimonials?: Array<{
    /**
     * The highlighted testimonial quote.
     */
    quote?: string;
    customer?: {
      /**
       * The name of the customer.
       */
      name?: string;
      /**
       * The title of the customer.
       */
      title?: string;
    };
    /**
     * The platform the testimonial originates from. Drives source-specific rendering (e.g. the LinkedIn icon and post link).
     * See `CertificateProgramTestimonialSource` for a list of possible values.
     *
     */
    source?: string;
    /**
     * URL of the author's avatar image.
     */
    avatarUrl?: string;
    /**
     * Permalink to the original post or review on the source platform.
     */
    sourceUrl?: string;
    /**
     * The full testimonial body text.
     */
    body?: string;
  }>;
};

/**
 * Images associated with the product bundle.
 */
export type ProductBundleMarketingContentImages = {
  hero1x1?: Image;
  hero16x9?: Image;
};

/**
 * What's included section content for a product bundle.
 */
export type ProductBundleWhatsIncluded = {
  /**
   * Section title (localized for request locale).
   */
  title?: string;
  /**
   * Section subheading (localized for request locale).
   */
  subheading?: string;
  /**
   * Products included in the bundle (certificate programs).
   */
  products?: Array<ProductBundleWhatsIncludedProduct>;
};

export type ProductBundleWhatsIncludedProduct = {
  /**
   * The unique identifier of the certificate program.
   */
  uuid?: string;
  /**
   * The slug of the certificate program.
   */
  slug?: string;
  /**
   * Display title of the certificate program.
   */
  title?: string;
  /**
   * Total lessons in the certificate program curriculum.
   */
  lessons?: number;
  /**
   * Total modules (curriculum units) in the certificate program curriculum.
   */
  modules?: number;
  /**
   * Estimated hours to complete the certificate program curriculum.
   */
  hours?: number;
  /**
   * Availability label for the certificate program (e.g. available or release label for coming soon).
   */
  availability?: string;
  /**
   * Subheading for the certificate program.
   */
  subheading?: string;
  /**
   * URL to download the syllabus PDF.
   */
  syllabusUrl?: string;
  images?: ProductBundleWhatsIncludedProductImages;
};

export type ProductBundleWhatsIncludedProductImages = {
  thumbnail16x9?: Image;
  logoLockup?: Image;
  logoLockupLight?: Image;
};

export type CertificateTile = {
  /**
   * The unique identifier of the certificate program.
   */
  uuid: string;
  /**
   * The slug of the certificate program.
   */
  slug?: string;
  /**
   * The title of the certificate program.
   */
  title: string;
  /**
   * A brief overview of the certificate program.
   */
  description: string;
  /**
   * How the program is delivered. See `CertificateProgramFormat` for possible values.
   */
  format?: string;
  /**
   * The total estimated time to complete the curriculum, in seconds. Absent for cohort programs.
   */
  estimatedDuration?: number;
  /**
   * Length of the cohort currently accepting purchases, in weeks. Present only for cohort
   * programs with an accepting cohort that has a start and end date.
   *
   */
  durationWeeks?: number;
  thumbnail16x9: Image;
  logoLockup?: Image;
  logoLockupLight?: Image;
  badge?: {
    /**
     * Text to display on the badge.
     */
    text?: string;
    /**
     * See `CertificateTileBadgeStatus` for possible values.
     */
    status?: string;
  };
  /**
   * True when the viewer's enrollment for this program has expired and
   * they hold no active or pending one. Absent for logged-out viewers
   * and programs the viewer never enrolled in.
   *
   */
  accessExpired?: boolean;
  /**
   * The subheading of the certificate program.
   */
  subheading?: string;
  partnerLogo?: Image;
  /**
   * URL to the certificate program's downloadable syllabus PDF, when available.
   */
  syllabusPdfUrl?: string;
  cta?: {
    /**
     * The text of the call to action.
     */
    text: string;
    /**
     * The slug of the last visited lesson.
     */
    lessonSlug?: string;
    /**
     * The unique identifier of the last visited lesson.
     */
    lessonUuid?: string;
  };
};

/**
 * `earlyEnrollment`, `priorityEnrollment` and `finalEnrollment` are the enrollment window
 * open today on a cohort program's accepting cohort.
 *
 */
export type CertificateTileBadgeStatus =
  | "coming_soon"
  | "pre_enroll"
  | "completed"
  | "expired"
  | "early_enrollment"
  | "priority_enrollment"
  | "final_enrollment";

export const CertificateTileBadgeStatus =
  /**
   * `earlyEnrollment`, `priorityEnrollment` and `finalEnrollment` are the enrollment window
   * open today on a cohort program's accepting cohort.
   *
   */
  {
    COMING_SOON: "coming_soon",
    PRE_ENROLL: "pre_enroll",
    COMPLETED: "completed",
    EXPIRED: "expired",
    EARLY_ENROLLMENT: "early_enrollment",
    PRIORITY_ENROLLMENT: "priority_enrollment",
    FINAL_ENROLLMENT: "final_enrollment",
  } as const;

export type CertificateProgramInteractions = {
  enrollment?: CertificateProgramEnrollment;
  curriculumInteractions?: CurriculumInteractions;
  engagement?: CertificateProgramEngagement;
};

/**
 * The engagement section for certificate programs. This section is used to entice the user
 * to engage in the certificate program, and to provide the user with actions they can take related to the
 * certificate program.
 *
 */
export type CertificateProgramEngagement = {
  /**
   * The email capture section for engagement. This section is used to provide the user with
   * an email capture form to sign up for updates related to the certificate program.
   *
   */
  emailCapture?: {
    /**
     * The headline of the email capture section.
     */
    headline?: string;
  };
  /**
   * The notice section for engagement. This section is used to provide the user with a
   * notice for the engagement section. This is typically used to provide the user with a
   * call to action related to the certificate program.
   *
   */
  notice?: {
    /**
     * The headline of the notice section.
     */
    headline?: string;
    /**
     * The description of the notice section.
     */
    description?: string;
  };
  actionBlock?: CertificateProgramEngagementActionBlock;
  navigation?: CertificateProgramEngagementNavigation;
};

export type CertificateProgramEngagementNavigation = {
  /**
   * The actions available to the user in the navigation bar.
   *
   */
  actions?: Array<CertificateProgramEngagementCta>;
};

export type CertificateProgramEngagementActionBlock = {
  /**
   * The header section for engagement. This section is used to provide the user with
   * a header for the engagement section.
   *
   */
  header?: {
    /**
     * The eyebrow of the header section.
     */
    eyebrow?: string;
    /**
     * The headline of the header section.
     */
    headline?: string;
  };
  /**
   * The actions section for engagement. This section is used to provide the user with
   * actions they can take related to the certificate program.
   *
   */
  actions: Array<CertificateProgramEngagementCta>;
  /**
   * The details section for engagement. This section is used to provide information to the user
   * related to the certificate program, or to provide context to the user about the
   * engagement actions.
   *
   */
  details?: {
    /**
     * The text of the info section. This is used to provide information to the user
     * related to the certificate program, or to provide context to the user about the
     * engagement actions.
     *
     */
    text: string;
    /**
     * The link object is used to provide a link to the user. This can be used to
     * provide an alternative engagement action to the user, or to provide
     * additional information to the user.
     *
     */
    link?: {
      /**
       * The text of the link.
       */
      text: string;
      /**
       * The action to perform when the link is clicked.
       * See `CertificateProgramEngagementActionType` for a list of possible values.
       *
       */
      actionType: string;
    };
  };
};

/**
 * The actions available to the user related to the certificate program. This section is used to
 * provide the user with actions they can take related to the certificate program. For a user who is
 * not enrolled in the certificate program, this section could be used to provide the user with
 * actions they can take to enroll in the certificate program. For a user who is already enrolled in the
 * certificate program, this section could be used to direct the user to the curriculum.
 *
 */
export type CertificateProgramEngagementCta = {
  /**
   * The text of the action.
   */
  text: string;
  /**
   * The action to perform when the action is clicked.
   * See `CertificateProgramEngagementActionType` for a list of possible values.
   *
   */
  actionType: string;
  /**
   * The state of the action. This is used to indicate whether the action is enabled or disabled.
   * See `CertificateProgramCtaState` for a list of possible values.
   *
   */
  state?: string;
  /**
   * The style of the action. This is used to indicate the style of the action.
   * See `CertificateProgramCtaStyle` for a list of possible values.
   *
   */
  style?: string;
  /**
   * The context of the action. This is used to provide additional information to the user about the action.
   * The context is typically only provided if only a single action is available to the user.
   * For example, this could be used to provide the user with information about their current progress in
   * the certificate program.
   *
   */
  context?: {
    /**
     * The eyebrow of the context.
     */
    eyebrow?: string;
    /**
     * The headline of the context.
     */
    headline?: string;
  };
};

export type CertificateProgramCtaState = "enabled" | "disabled";

export const CertificateProgramCtaState = {
  ENABLED: "enabled",
  DISABLED: "disabled",
} as const;

export type CertificateProgramCtaStyle = "primary" | "secondary" | "tertiary";

export const CertificateProgramCtaStyle = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
} as const;

export type CertificateProgramEngagementActionType =
  | "start_trial"
  | "purchase_aap"
  | "purchase_certificate"
  | "download_syllabus"
  | "go_to_curriculum";

export const CertificateProgramEngagementActionType = {
  START_TRIAL: "start_trial",
  PURCHASE_AAP: "purchase_aap",
  PURCHASE_CERTIFICATE: "purchase_certificate",
  DOWNLOAD_SYLLABUS: "download_syllabus",
  GO_TO_CURRICULUM: "go_to_curriculum",
} as const;

export type CertificateProgramTestimonialSource = "linkedin";

export const CertificateProgramTestimonialSource = {
  LINKEDIN: "linkedin",
} as const;

export type CurriculumInteractions = {
  /**
   * The unique identifier of the certificate program.
   */
  certificateProgramUuid?: string;
  /**
   * The percentage of the CurriculumLesson completed.
   */
  completionPercentage?: number;
  /**
   * The estimated time remaining to complete the curriculum, in seconds.
   */
  estimatedTimeRemaining?: number;
  /**
   * Whether the curriculum is completed or not.
   */
  curriculumCompleted?: boolean;
  /**
   * The date and time when the unit was completed.
   */
  completedAt?: string;
  /**
   * Whether the reward is unlocked or not.
   */
  rewardUnlocked?: boolean;
  lastVisitedLesson?: {
    /**
     * The unique identifier of the last visited lesson.
     */
    uuid?: string;
    /**
     * The title of the last visited lesson.
     */
    lessonTitle?: string;
    /**
     * The slug of the last visited lesson.
     */
    lessonSlug?: string;
    ctaText?: string;
  };
  unitsInteractions: {
    [key: string]: CurriculumUnitInteractions;
  };
  /**
   * The survey for the curriculum. This survey should be presented to the user upon successful issuance of the certificate.
   *
   */
  survey?: {
    /**
     * Indicates if the survey should be taken by this user. `false` if the user has already been presented the survey.
     */
    shouldTakeSurvey?: boolean;
    /**
     * The unique identifier to use for the survey.
     */
    contentUuid?: string;
    steps?: Array<NpsSurveyStep>;
  };
  experimentMetadata?: CurriculumExperimentMetadata | null;
  migrationNotification?: CurriculumMigrationNotification | null;
};

export type CurriculumUnitInteractions = {
  /**
   * The unique identifier of a unit.
   */
  uuid: string;
  /**
   * The number of completed lessons in the unit.
   */
  completedLessons?: number;
  /**
   * The percentage of the unit completed.
   */
  completionPercentage?: number;
  /**
   * See `CurriculumProgressStatus` for possible values.
   */
  status?: string;
  /**
   * Whether the unit is locked or not.
   */
  locked?: boolean;
  lessonsInteractions: {
    [key: string]: CurriculumLessonInteractions;
  };
};

export type CurriculumProgressStatus =
  | "not_started"
  | "in_progress"
  | "completed";

export const CurriculumProgressStatus = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
} as const;

export type CurriculumLessonInteractions = {
  /**
   * The unique identifier of a lesson.
   */
  uuid: string;
  /**
   * See `CurriculumProgressStatus` for possible values.
   */
  status?: string;
  /**
   * The percentage of the lesson completed.
   */
  completionPercentage?: number;
  /**
   * Whether the lesson is locked or not.
   */
  locked?: boolean;
  todoList?: {
    /**
     * The title of the todo list.
     */
    title?: string;
    items?: Array<{
      /**
       * The text of the todo item.
       */
      text?: string;
      /**
       * Whether the todo item is completed or not.
       */
      completed?: boolean;
      /**
       * The unique identifier of the activity.
       */
      activityUuid?: string;
      /**
       * Whether the todo item is required or not.
       */
      required?: boolean;
      /**
       * The estimated time to complete the todo item, in seconds.
       */
      estimatedDuration?: number;
    }>;
  };
  activitiesInteractions?: {
    [key: string]: CurriculumActivityInteractions;
  };
  /**
   * The survey for the lesson. This survey should be presented to the user upon successful completion of the lesson.
   * If there is no survey for the lesson, this object will not be present.
   *
   */
  survey?: {
    /**
     * Indicates if the survey should be taken upon completion of the lesson. `false` if the user has already been presented the survey.
     */
    shouldTakeSurvey?: boolean;
    /**
     * The unique identifier to use for the survey.
     */
    contentUuid?: string;
    steps?: Array<NpsSurveyStep>;
  };
};

export type CurriculumActivityInteractions = {
  /**
   * The unique identifier of an activity.
   */
  uuid: string;
  /**
   * See `CurriculumActivityType` for possible values.
   */
  activityType?: string;
  /**
   * Current state of user tools tied to this activity.
   */
  tools?: Array<UserTool>;
  video?: CurriculumVideoActivityInteractions;
  quiz?: CurriculumQuizActivityInteractions;
  discussion?: CurriculumDiscussionActivityInteractions;
  capstoneSummary?: CurriculumCapstoneSummaryActivityInteractions;
  questionnaire?: CurriculumQuestionnaireActivityInteractions;
  appliedLearning?: CurriculumAppliedLearningActivityInteractions;
  roleplay?: CurriculumRoleplayActivityInteractions;
  aiProject?: CurriculumAIProjectActivityInteractions;
};

/**
 * Cosmetic classification of a UserTool. Drives the displayed icon,
 * framing copy, and specific user-facing label. Flat enum — orthogonal
 * to `personalized`.
 *
 */
export type UserToolSubtype =
  | "framework"
  | "template"
  | "ai_prompt"
  | "checklist"
  | "applied_learning_artifact"
  | "assessment_results_artifact"
  | "guide"
  | "cheat_sheet";

export const UserToolSubtype =
  /**
   * Cosmetic classification of a UserTool. Drives the displayed icon,
   * framing copy, and specific user-facing label. Flat enum — orthogonal
   * to `personalized`.
   *
   */
  {
    FRAMEWORK: "framework",
    TEMPLATE: "template",
    AI_PROMPT: "ai_prompt",
    CHECKLIST: "checklist",
    APPLIED_LEARNING_ARTIFACT: "applied_learning_artifact",
    ASSESSMENT_RESULTS_ARTIFACT: "assessment_results_artifact",
    GUIDE: "guide",
    CHEAT_SHEET: "cheat_sheet",
  } as const;

export type UserTool = {
  /**
   * Stable identity.
   */
  uuid: string;
  /**
   * See `UserToolSubtype` for possible values.
   */
  subtype: string;
  /**
   * True iff `content` (when available) is per-user-generated from the
   * parent teachable. False for static-content entries.
   *
   */
  personalized: boolean;
  /**
   * Display name.
   */
  title: string;
  /**
   * Secondary line. Optional.
   */
  subtitle?: string | null;
  /**
   * The parent activity that unlocks this tool.
   */
  activityUuid: string;
  /**
   * The lesson hosting the parent activity.
   */
  lessonUuid: string;
  /**
   * True once the user has completed the parent activity.
   */
  available: boolean;
  /**
   * Server-rendered markdown.
   */
  content?: string | null;
  image4x5?: Image;
  /**
   * True if unlocking this tool fires the large celebration moment.
   *
   */
  largeCelebration: boolean;
  /**
   * Headline shown in the large celebration. Present only when
   * `largeCelebration` is true.
   *
   */
  celebrationHeadline?: string | null;
};

export type Toolkit = {
  summary: ToolkitSummary;
  /**
   * Curriculum units hosting at least one tool, ordered by unit
   * position. Units with no tools are omitted.
   *
   */
  units: Array<ToolkitUnit>;
};

export type ToolkitSummary = {
  /**
   * Total number of tools, locked and unlocked.
   */
  total: number;
  /**
   * Number of tools the user has unlocked.
   */
  available: number;
};

export type ToolkitUnit = {
  uuid: string;
  /**
   * Display name of the curriculum unit (module).
   */
  title: string;
  /**
   * 1-based position of the unit within the curriculum.
   */
  position: number;
  /**
   * Tools hosted by this unit, ordered by lesson position, then
   * activity position, then tool position.
   *
   */
  tools: Array<UserTool>;
};

/**
 * The user's Projects (capstone) page for a certificate program: the
 * capstone project's deliverables as render-ready Projects, plus
 * page-level score. Deliverables the user has not yet submitted are
 * returned with `available: false` and null marks/answers.
 *
 */
export type Projects = {
  /**
   * The user's total mark across all deliverables.
   */
  totalMark: number;
  /**
   * The maximum mark achievable across all deliverables.
   */
  maxMark: number;
  /**
   * Per-certificate markdown intro copy for the Projects page, authored on
   * the curriculum's capstone project. Null when the certificate has no
   * custom copy.
   *
   */
  description?: string | null;
  /**
   * The uuid of the capstone-summary activity used to build the PDF
   * export URL. Null when the curriculum has no capstone-summary activity.
   *
   */
  downloadActivityUuid?: string | null;
  /**
   * The capstone project deliverables, in display order.
   */
  projects: Array<Project>;
};

/**
 * A single capstone deliverable with merged per-user state — one card on
 * the Projects page. `available` is true once the user has submitted the
 * deliverable's discussion.
 *
 */
export type Project = {
  /**
   * The unique identifier of the deliverable's activity (stable identity).
   */
  uuid: string;
  /**
   * The title of the deliverable.
   */
  title: string;
  /**
   * The unique identifier of the lesson hosting the deliverable.
   */
  lessonUuid: string;
  /**
   * The slug of the lesson hosting the deliverable.
   */
  lessonSlug: string;
  /**
   * 1-based position of the module (curriculum unit) hosting the deliverable.
   */
  modulePosition: number;
  /**
   * Display name of the module (curriculum unit) hosting the deliverable.
   */
  moduleTitle: string;
  /**
   * True once the user has submitted this deliverable's discussion.
   */
  available: boolean;
  /**
   * The user's mark for this deliverable. Null until submitted.
   */
  mark?: number | null;
  /**
   * The maximum mark achievable for this deliverable.
   */
  maxMark: number;
  /**
   * Whether the user passed this deliverable. Null until submitted.
   */
  passed?: boolean | null;
  /**
   * When the user submitted this deliverable. Null until submitted.
   */
  submittedAt?: string | null;
  /**
   * The deliverable's discussion questions, each with the user's answer.
   */
  questions: Array<ProjectQuestion>;
  image4x5?: Image;
};

/**
 * A discussion question within a project deliverable, with the user's answer.
 */
export type ProjectQuestion = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The question title.
   */
  title: string;
  /**
   * The maximum mark achievable for this question.
   */
  maxMark?: number | null;
  /**
   * The user's answer to the question. Null until answered.
   */
  userAnswer?: string | null;
};

/**
 * The tools and project deliverables to display in the user's
 * recent-activity section for a certificate program.
 *
 */
export type RecentActivity = {
  /**
   * The tools to display, in the order they should appear.
   */
  tools: Array<UserTool>;
  /**
   * The project deliverables to display, in the order they should
   * appear.
   *
   */
  projects: Array<Project>;
};

export type CurriculumVideoActivityInteractions = {
  /**
   * Whether the video activity is completed or not.
   */
  completed?: boolean;
  /**
   * The progress of the video activity in seconds
   */
  progress?: number;
};

export type CurriculumQuizActivityInteractions = {
  answers?: Array<CurriculumQuizAnswer>;
  /**
   * Whether the user can submit the quiz or not.
   */
  canSubmit?: boolean;
  /**
   * The number of correct answers to the questions on the quiz.
   */
  correctAnswers?: number;
  /**
   * The total number of questions on the quiz.
   */
  totalQuestions?: number;
  /**
   * The minimum number of correct answers required to pass the quiz.
   */
  threshold?: number;
  /**
   * Whether the user has passed the quiz or not.
   */
  passed?: boolean;
};

export type CurriculumQuizAnswer = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The slug of the choice.
   */
  choiceSlug: string;
  /**
   * Whether the answer is correct or not.
   */
  isCorrect?: boolean;
  /**
   * The title of the feedback.
   */
  feedbackTitle?: string;
  answerMaterial?: {
    /**
     * The text of the answer.
     */
    text?: string;
    /**
     * The URL of the answer video.
     */
    videoUrl?: string;
  };
};

export type CurriculumQuestionnaireActivityInteractions = {
  answers?: Array<CurriculumQuestionnaireAnswer>;
  /**
   * Whether the questionnaire activity is completed or not.
   */
  completed?: boolean;
  /**
   * The feedback of the questionnaire.
   */
  feedback?: string;
};

export type CurriculumQuestionnaireAnswer = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The slug of the choice.
   */
  choiceSlug: string;
};

export type CurriculumDiscussionActivityInteractions = {
  answers?: Array<CurriculumDiscussionAnswer>;
  /**
   * The total number of questions on the discussion.
   */
  totalQuestions?: number;
  /**
   * Whether the discussion activity is completed or not.
   */
  completed?: boolean;
  evaluation?: CurriculumDiscussionEvaluation;
  analytics?: {
    [key: string]: string;
  };
  /**
   * The unique identifier of the discussion submission.
   */
  submissionId?: string;
};

/**
 * If the discussion submission is to be evaluated, this object will be returned to provide the user with the evaluation of the discussion. The rubric in the evaluation might be different from the rubric in the discussion activity, particularly if the rubric has been updated since the user submitted the discussion.
 */
export type CurriculumDiscussionEvaluation = {
  rubric?: CurriculumDiscussionRubric;
  /**
   * The outcome of the evaluation, once the evaluation is complete. If the outcome is `pass`, the user has passed the evaluation. If the outcome is `fail`, the user has failed the evaluation.
   * See `CurriculumDiscussionEvaluationOutcome` for possible values.
   *
   */
  outcome?: string;
  /**
   * The status of the evaluation. If the status is `pending`, the evaluation is still in progress. If the status is `complete`, the evaluation is complete. If the status is `error`, there was an error in the evaluation process.
   * See `CurriculumDiscussionEvaluationStatus` for possible values.
   *
   */
  status: string;
  /**
   * The mark of the discussion.
   */
  mark?: number;
  /**
   * Overall feedback on the submission.
   */
  feedback?: string;
  /**
   * The answers in the evaluation, where the key is the question slug.
   */
  assessments?: {
    [key: string]: CurriculumDiscussionEvaluationAssessment;
  };
};

export type CurriculumDiscussionEvaluationOutcome = "pass" | "fail";

export const CurriculumDiscussionEvaluationOutcome = {
  PASS: "pass",
  FAIL: "fail",
} as const;

export type CurriculumDiscussionEvaluationStatus =
  | "pending"
  | "complete"
  | "error"
  | "flagged";

export const CurriculumDiscussionEvaluationStatus = {
  PENDING: "pending",
  COMPLETE: "complete",
  ERROR: "error",
  FLAGGED: "flagged",
} as const;

export type CurriculumDiscussionEvaluationAssessment = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The mark of the question.
   */
  mark?: number;
  /**
   * Feedback on the submission for the question.
   */
  feedback?: string;
  /**
   * The criteria in the assessment, where the key is the criterion slug.
   */
  criteria: {
    [key: string]: CurriculumDiscussionEvaluationAssessmentCriterion;
  };
};

export type CurriculumDiscussionEvaluationAssessmentCriterion = {
  /**
   * The slug of the criterion.
   */
  criterionSlug: string;
  /**
   * The mark of the criterion.
   */
  mark?: number;
  /**
   * Feedback on the submission for the question, as it pertains to the criterion.
   */
  feedback?: string;
};

export type CurriculumDiscussionAnswer = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The answer of the user.
   */
  userAnswer: string;
  /**
   * see `CurriculumDiscussionAnswerStatus` for possible values.
   */
  status?: string;
};

export type CurriculumDiscussionAnswerStatus = "draft" | "submitted";

export const CurriculumDiscussionAnswerStatus = {
  DRAFT: "draft",
  SUBMITTED: "submitted",
} as const;

export type CurriculumCapstoneSummaryActivityInteractions = {
  /**
   * The number of questions passed.
   */
  questionsPassed?: number;
  /**
   * The total mark.
   */
  totalMark?: number;
  deliverables?: {
    [key: string]: CapstoneProjectDeliverableInteractions;
  };
};

export type CurriculumAppliedLearningActivityInteractions = {
  /**
   * The status of the applied learning activity. See AppliedLearningConversationStatus for possible values.
   */
  status?: string;
  progress?: AppliedLearningConversationProgress;
  /**
   * The unique identifier of the conversation.
   */
  conversationUuid?: string;
};

export type AppliedLearningConversationProgress = {
  /**
   * Slugs of completed steps.
   */
  completedSteps?: Array<string>;
  /**
   * The final result generated at the end of the conversation.
   */
  result?: string;
};

export type AppliedLearningConversationStatus =
  | "not_started"
  | "in_progress"
  | "moderating"
  | "ready_to_unlock"
  | "completed"
  | "flagged"
  | "error";

export const AppliedLearningConversationStatus = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  MODERATING: "moderating",
  READY_TO_UNLOCK: "ready_to_unlock",
  COMPLETED: "completed",
  FLAGGED: "flagged",
  ERROR: "error",
} as const;

/**
 * Configuration for an AI Project activity.
 */
export type CurriculumAIProjectActivity = {
  /**
   * The project's steps, in the order the learner walks through them.
   */
  steps?: Array<CurriculumAIProjectStep>;
};

/**
 * A single step of the walkthrough. Only `slug` and `type` are typed; the content the step renders varies by `type` and is forwarded as authored.
 */
export type CurriculumAIProjectStep = {
  /**
   * The unique slug identifier of the step. Learner progress is keyed by it.
   */
  slug: string;
  /**
   * The step's type, which selects the renderer the client uses. See `CurriculumAIProjectStepType` for possible values.
   */
  type: string;
  [key: string]: unknown | string;
};

export type CurriculumAIProjectStepType = "audit" | "triage" | "prompt_refine";

export const CurriculumAIProjectStepType = {
  AUDIT: "audit",
  TRIAGE: "triage",
  PROMPT_REFINE: "prompt_refine",
} as const;

export type CurriculumAIProjectActivityInteractions = {
  /**
   * The status of the AI Project activity. See `CurriculumAIProjectStatus` for possible values.
   */
  status?: string;
  /**
   * Per-step learner state keyed by step slug, holding the selections needed to restore an in-progress project. Untyped for the same reason as a step's body.
   */
  progress?: {
    [key: string]: unknown;
  };
  /**
   * The learner's optional free-text reflection, captured after the walkthrough.
   */
  reflectionText?: string | null;
  analytics?: {
    [key: string]: string;
  };
};

export type CurriculumAIProjectStatus =
  | "not_started"
  | "in_progress"
  | "completed";

export const CurriculumAIProjectStatus = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
} as const;

/**
 * Request body for submitting AI Project progress. Every property is optional so the walkthrough and the closing reflection can submit independently; a request carrying neither `stepSlug` nor `reflectionText` is accepted as a no-op.
 */
export type CurriculumAIProjectSubmitRequest = {
  /**
   * Slug of the step being saved. A slug the activity's configuration does not contain is ignored, leaving stored progress untouched. Omit it to submit a reflection on its own.
   */
  stepSlug?: string;
  /**
   * The learner's selections for the submitted step, replacing any previously saved for it. The item shape varies by step type and is stored as sent: audit and prompt_refine steps address lines, triage steps address items. Defaults to empty when a `step_slug` is sent without it, and ignored without one.
   */
  selections?: Array<{
    [key: string]: unknown;
  }>;
  /**
   * The learner's optional free-text reflection. Only written when present, so submitting a step without it leaves an existing reflection intact.
   */
  reflectionText?: string | null;
};

/**
 * Configuration for a roleplay activity scenario.
 */
export type CurriculumRoleplayActivity = {
  /**
   * The title of the roleplay scenario, shown as a subtitle in the roleplay panel header.
   */
  scenarioTitle?: string;
  /**
   * Available AI role options.
   */
  aiRoles?: Array<RoleplayConfigOption>;
  /**
   * Available voice style options.
   */
  voiceStyles?: Array<RoleplayConfigOption>;
  /**
   * Available AI personality options.
   */
  aiPersonalities?: Array<RoleplayConfigOption>;
  additionalContextConfig?: RoleplayAdditionalContextConfig;
  /**
   * The tips for the roleplay.
   */
  tips?: Array<string>;
  rubric?: CurriculumRoleplayRubric;
};

/**
 * The rubric for evaluating a roleplay conversation. Returned to provide the user with
 * the evaluation criteria for the roleplay.
 *
 */
export type CurriculumRoleplayRubric = {
  /**
   * The unique identifier of the rubric.
   */
  rubricUuid?: string;
  /**
   * The maximum mark a user can achieve.
   */
  maxMark?: number;
  /**
   * The passing mark for the roleplay.
   */
  passingMark?: number;
  /**
   * The questions in the rubric, where the key is the question slug. Roleplay uses a single implicit question representing the entire evaluation.
   */
  questions?: {
    [key: string]: CurriculumRoleplayRubricQuestion;
  };
};

export type CurriculumRoleplayRubricQuestion = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The maximum mark a user can achieve for this question. This value is an aggregate of all the maximum criteria marks.
   */
  maxMark?: number;
  criteria?: Array<CurriculumRoleplayRubricQuestionCriterion>;
};

export type CurriculumRoleplayRubricQuestionCriterion = {
  /**
   * The slug of the criterion.
   */
  criterionSlug: string;
  /**
   * The position of the criterion.
   */
  position: number;
  /**
   * The maximum mark a user can achieve for this criterion.
   */
  maxMark?: number;
  /**
   * The text of the criterion.
   */
  text: string;
  /**
   * The description of the criterion to provide more context.
   */
  description?: string;
};

/**
 * A selectable option for roleplay configuration dropdowns.
 */
export type RoleplayConfigOption = {
  /**
   * Internal identifier for this option.
   */
  slug: string;
  /**
   * Display text shown to the user.
   */
  text: string;
  /**
   * Optional description shown below the option.
   */
  description?: string;
};

/**
 * Configuration for the additional context text field.
 */
export type RoleplayAdditionalContextConfig = {
  /**
   * Custom label for the additional context field.
   */
  label?: string;
  /**
   * Custom placeholder for the additional context text field.
   */
  placeholder?: string;
};

/**
 * Request body for creating or restarting a roleplay conversation.
 */
export type CreateRoleplayConversationRequest = {
  /**
   * Slug of the selected AI role.
   */
  aiRole?: string;
  /**
   * Slug of the selected voice style.
   */
  voiceStyle?: string;
  /**
   * Slug of the selected AI personality.
   */
  aiPersonality?: string;
  /**
   * Optional additional context provided by the user.
   */
  additionalContext?: string;
};

/**
 * The user's interaction state for a roleplay activity.
 */
export type CurriculumRoleplayActivityInteractions = {
  /**
   * Whether the roleplay activity is completed or not.
   */
  completed?: boolean;
  /**
   * The unique identifier of the current roleplay conversation.
   */
  conversationUuid?: string;
  evaluation?: CurriculumRoleplayEvaluation;
  /**
   * Speech performance metrics for the roleplay conversation.
   */
  speechMetrics?: Array<RoleplaySpeechMetricItem>;
};

/**
 * A single speech performance metric.
 */
export type RoleplaySpeechMetricItem = {
  /**
   * Display title for the metric (e.g., "Words per minute").
   */
  title: string;
  /**
   * The metric value as a display string (e.g., "142.5", "45/55", "2.3%").
   */
  data: string;
  /**
   * Rating category for the metric. See `RoleplaySpeechMetricRating` for possible values.
   */
  rating: string;
  /**
   * Contextual guidance text for the metric.
   */
  subtitle: string;
};

export type RoleplaySpeechMetricRating =
  | "good"
  | "average"
  | "needs_improvement";

export const RoleplaySpeechMetricRating = {
  GOOD: "good",
  AVERAGE: "average",
  NEEDS_IMPROVEMENT: "needs_improvement",
} as const;

/**
 * A user's roleplay conversation including messages and progress.
 */
export type RoleplayUserConversation = {
  /**
   * The unique identifier of the conversation.
   */
  conversationUuid?: string;
  /**
   * The UUID of the underlying Parley conversation.
   */
  parleyConversationUuid?: string;
  /**
   * JWT token for authenticating conversation interactions.
   */
  token?: string;
  /**
   * Token expiration time as Unix timestamp (seconds since epoch).
   */
  tokenExpiration?: number;
  /**
   * The status of the conversation. See RoleplayConversationStatus for possible values.
   */
  status?: string;
};

/**
 * The evaluation of a roleplay conversation. Returned after the user submits a conversation for evaluation.
 * The rubric in the evaluation might be different from the rubric in the roleplay activity,
 * particularly if the rubric has been updated since the user started the conversation.
 *
 */
export type CurriculumRoleplayEvaluation = {
  rubric?: CurriculumRoleplayRubric;
  /**
   * The outcome of the evaluation, once the evaluation is complete. If the outcome is `pass`, the user has passed the evaluation. If the outcome is `fail`, the user has failed the evaluation.
   * See `CurriculumRoleplayEvaluationOutcome` for possible values.
   *
   */
  outcome?: string;
  /**
   * The status of the evaluation. If the status is `pending`, the evaluation is still in progress. If the status is `complete`, the evaluation is complete. If the status is `error`, there was an error in the evaluation process.
   * See `CurriculumRoleplayEvaluationStatus` for possible values.
   *
   */
  status: string;
  /**
   * The mark of the roleplay.
   */
  mark?: number;
  /**
   * Overall feedback on the conversation.
   */
  feedback?: string;
  /**
   * The assessments in the evaluation, where the key is the question slug.
   */
  assessments?: {
    [key: string]: CurriculumRoleplayEvaluationAssessment;
  };
};

export type CurriculumRoleplayEvaluationOutcome = "pass" | "fail";

export const CurriculumRoleplayEvaluationOutcome = {
  PASS: "pass",
  FAIL: "fail",
} as const;

export type CurriculumRoleplayEvaluationStatus =
  | "pending"
  | "complete"
  | "error"
  | "flagged";

export const CurriculumRoleplayEvaluationStatus = {
  PENDING: "pending",
  COMPLETE: "complete",
  ERROR: "error",
  FLAGGED: "flagged",
} as const;

export type CurriculumRoleplayEvaluationAssessment = {
  /**
   * The slug of the question.
   */
  questionSlug: string;
  /**
   * The mark of the question.
   */
  mark?: number;
  /**
   * Feedback on the conversation for the question.
   */
  feedback?: string;
  /**
   * The criteria in the assessment, where the key is the criterion slug.
   */
  criteria: {
    [key: string]: CurriculumRoleplayEvaluationAssessmentCriterion;
  };
};

export type CurriculumRoleplayEvaluationAssessmentCriterion = {
  /**
   * The slug of the criterion.
   */
  criterionSlug: string;
  /**
   * The mark of the criterion.
   */
  mark?: number;
  /**
   * Feedback on the conversation as it pertains to the criterion.
   */
  feedback?: string;
};

/**
 * The status of a roleplay conversation.
 */
export type RoleplayConversationStatus =
  | "in_progress"
  | "moderating"
  | "completed"
  | "flagged"
  | "error";

export const RoleplayConversationStatus =
  /**
   * The status of a roleplay conversation.
   */
  {
    IN_PROGRESS: "in_progress",
    MODERATING: "moderating",
    COMPLETED: "completed",
    FLAGGED: "flagged",
    ERROR: "error",
  } as const;

export type CapstoneProjectDeliverableInteractions = {
  discussion?: {
    /**
     * The mark of the deliverable.
     */
    mark?: number;
    /**
     * The date and time when the deliverable was submitted.
     */
    submittedAt?: string;
    /**
     * Whether the deliverable was passed or not.
     */
    passed?: boolean;
    /**
     * Key is the question slug, value is the user's answer to the question.
     */
    userAnswers?: {
      [key: string]: {
        /**
         * The slug of the question.
         */
        questionSlug?: string;
        /**
         * The user's answer to the question.
         */
        userAnswer?: string;
      };
    };
  };
};

export type CertificateProgramProduct = {
  /**
   * The id of the Certificate Program.
   */
  id: number;
  /**
   * The display name of the Certificate Program.
   */
  name: string;
  /**
   * The description of the Certificate Program.
   */
  description: string;
  /**
   * The unique identifier of the Certificate Program.
   */
  uuid?: string;
  /**
   * The slug of the Certificate Program.
   */
  slug: string;
  /**
   * The currency of the Certificate Program.
   */
  currency: string;
  /**
   * Price in minor currency units (cents / pence / etc.), before any discounts are applied.
   */
  price: number;
  /**
   * Total discount applied to the list price.
   */
  discountAmount?: number;
  /**
   * The price after rebates and discounts but before non-inclusive taxes.
   */
  netPrice?: number;
  /**
   * Temporary price prop for Product Viewed: Same value as analytics price before a discount (MCCERTS-2547)
   */
  nonDiscountedPrice?: number;
  /**
   * Text to display indicating the applied discount.
   */
  discountSubheading?: string;
  /**
   * If tax needs to be applied for the Certificate Program.
   */
  applyTax: boolean;
  /**
   * The display price of the Certificate Program.
   */
  displayPrice: string;
  /**
   * The display price rounded up to the whole currency unit, for pre-paywall display. The payment step must keep rendering the exact `displayPrice`; the checkout Value Primer shows this rounded value (PM-approved, MCCERTS-2806).
   */
  displayPriceRounded?: string;
  /**
   * The display discounted amount of the Certificate Program
   */
  displayDiscountAmount?: string;
  /**
   * The display net price of the Certificate Program after discounts and rebates are applied.
   */
  displayNetPrice?: string;
  /**
   * The display net price rounded up to the whole currency unit, for pre-paywall display (mirrors core's marketing-price convention). The payment step must keep rendering the exact `display_net_price`; the checkout Value Primer shows this rounded value (PM-approved, MCCERTS-2806). Absent when no discount applies.
   */
  displayNetPriceRounded?: string;
  /**
   * The net price (the list price when no discount applies) rounded up to the whole currency unit, as a bare number in major units rather than subunits: 239.20 USD is 240, 31,900.50 HUF is 31901. Same rounding as `displayNetPriceRounded`, for consumers that need a number rather than a formatted string, such as a URL parameter.
   */
  netPriceRoundedMajorUnits?: number;
  /**
   * The code of the coupon that was selected and applied (the highest-value eligible candidate). Absent when no coupon applied. Lets the frontend key promo copy off the winning candidate.
   */
  winningDiscountSlug?: string;
  /**
   * See `ProductTier` for available types.
   */
  productTier?: string;
  /**
   * Tier hierarchy level (1 = lowest tier)
   */
  productTierLevel?: number;
  /**
   * Whether PayPal subscription is available for this certificate product.
   */
  paypalSubAvailable?: boolean;
  /**
   * Whether this certificate product is currently in pre-enrollment.
   */
  isPreenroll?: boolean;
  /**
   * Names of included certificate programs (present only for bundle products).
   */
  bundleItems?: Array<string>;
  /**
   * Integer percentage saved vs buying certificates individually (present only for bundle products).
   */
  bundleSavingsPercentage?: number;
  /**
   * Integer percentage the applied coupon discounts off this product's price (present only when a coupon is applied). Additive to bundle_savings_percentage — legal requires the coupon be shown as an additional discount, never as the combined stacked total.
   */
  couponDiscountPercentage?: number;
  /**
   * Savings amount vs buying certificates individually (present only for bundle products).
   */
  bundleDiscountAmount?: number;
  /**
   * Formatted bundle savings amount (present only for bundle products).
   */
  displayBundleDiscountAmount?: string;
  /**
   * The bundle's own price after the path/bundle saving but BEFORE any promo discount, in minor currency units. Equals `price - bundle_discount_amount`, and equals `net_price` when no promo is applied (present only for bundle products).
   */
  bundleNetPrice?: number;
  /**
   * Formatted bundleNetPrice, e.g. "$797.60" (present only for bundle products).
   */
  displayBundleNetPrice?: string;
  valuePrimerImage?: Image;
  analytics?: {
    [key: string]: unknown;
  };
};

/**
 * The product tier identifier
 */
export type ProductTier = "tier1" | "tier2";

export const ProductTier =
  /**
   * The product tier identifier
   */
  {
    TIER1: "tier1",
    TIER2: "tier2",
  } as const;

/**
 * List of SKU products for the certificate program.
 */
export type CertificateProgramProducts = Array<CertificateProgramProduct>;

export type UserCertificateProgramReward = {
  /**
   * The unique identifier of a certificate program.
   */
  certificateProgramUuid: string;
  /**
   * The title of the certificate.
   */
  certificateTitle?: string;
  /**
   * The duration of the certificate.
   */
  certificateDuration?: number;
  curriculumImage?: Image;
  /**
   * The name of the user.
   */
  userName?: string;
  /**
   * The email of the user.
   */
  email?: string;
  /**
   * The date and time when the certificate was completed.
   */
  completedAt?: string;
  /**
   * The URL of the certificate.
   */
  certificateUrl?: string;
  /**
   * The URL to share the certificate on LinkedIn.
   */
  shareUrl?: string;
  /**
   * The URL to download the certificate.
   */
  downloadUrl?: string;
  /**
   * see `CertificateRewardIssueStatus` for possible values.
   */
  issueStatus?: string;
  rewardPreviewImage?: Image;
  rewardImage?: Image;
  /**
   * The media UUID of the completion video.
   */
  completionVideoMediaUuid?: string;
  analytics?: {
    [key: string]: string;
  };
};

export type CertificateRewardIssueStatus = "pending" | "issued";

export const CertificateRewardIssueStatus = {
  PENDING: "pending",
  ISSUED: "issued",
} as const;

/**
 * This object contains the enrollment data for the certificate program.
 *
 */
export type CertificateProgramEnrollment = {
  /**
   * Indicates whether the user is enrolled in the certificate program. This is true for both active and pending enrollments.
   */
  isEnrolled?: boolean;
  /**
   * The type of the originator of the enrollment. See `CertificateProgramEnrollmentSource` for possible values.
   */
  source?: string;
  /**
   * The current status of the enrollment. See `CertificateProgramEnrollmentStatus` for possible values.
   */
  status?: string;
  /**
   * The certificate program information.
   */
  certificateProgram?: {
    /**
     * The unique identifier of the certificate program.
     */
    uuid?: string;
    /**
     * The slug of the certificate program.
     */
    slug?: string;
    /**
     * The title of the certificate program.
     */
    title?: string;
    /**
     * The learning platform that delivers the program. See `CertificateProgramTeachingPlatform` for possible values.
     */
    teachingPlatform?: string;
  };
  /**
   * The date and time when the user was enrolled in the certificate program. If the user pre-enrolled, this will be the date and time when the user was pre-enrolled in the certificate program. See the activatedAt field for the date and time the enrollment was activated.
   */
  enrolledAt?: string;
  /**
   * The date and time when the user activated the certificate program.
   */
  activatedAt?: string;
  /**
   * The date and time when access to the certificate program expires.
   */
  expiresAt?: string;
  /**
   * The calendar date the enrollment's cohort starts, midnight Pacific time. Present only when the
   * enrollment belongs to a cohort. A cohort purchase made before this date is pending until the
   * cohort starts.
   *
   */
  cohortStartDate?: string;
  /**
   * The number of days since access to the certificate program expired. Only present for expired enrollments; null otherwise.
   */
  daysSinceExpiry?: number | null;
  /**
   * Whether the user can request a self-serve access extension for this enrollment. True only for expired enrollments that have not used their one-time extension.
   */
  extensionAvailable?: boolean;
  /**
   * Whether to show the pre-expiry warning banner. True for active enrollments whose access expires within the warning window and whose learner has not completed the curriculum. Dismissal is a client-side, per-session concern.
   */
  showPreExpiryBanner?: boolean;
  /**
   * The tier level of the certificate program enrollment. See `ProductTier` for possible values.
   */
  productTier?: string;
  /**
   * The curriculum experiment variant name for this enrollment, if one is active. Used as a cache key to differentiate curriculum responses per variant.
   */
  curriculumVariant?: string | null;
  dataSharingConsent?: CertificateDataSharingConsent;
};

/**
 * A certificate challenge created for an enrollment.
 */
export type CertificateChallenge = {
  /**
   * The number of days for the challenge period. One of 15, 30, or 45.
   */
  durationDays?: number;
  /**
   * The discount percentage awarded upon completing the challenge.
   */
  discountPercent?: number;
  /**
   * The current status of the challenge. One of active, rewarded, expired.
   */
  status?: string;
  /**
   * The date and time when the challenge started.
   */
  startedAt?: string;
  /**
   * The date and time by which the challenge must be completed.
   */
  deadlineAt?: string;
  /**
   * The date and time when the challenge was completed.
   */
  completedAt?: string | null;
  /**
   * The number of days remaining until the challenge deadline.
   */
  daysRemaining?: number;
  /**
   * Whether the challenge was automatically enrolled rather than user opt-in.
   */
  autoEnrolled?: boolean;
};

export type CertificateProgramCoupon = {
  code: string;
  /**
   * see `CertificateProgramCouponEligibility` for possible values.
   */
  couponEligibility: string;
  /**
   * see `CertificateProgramCouponDiscountType` for possible values.
   */
  discountType?: string;
  /**
   * The discount value of the coupon.
   */
  discountValue?: number;
  /**
   * The unique identifier of the product.
   */
  productUuid?: string;
  modal?: {
    title?: string;
    text?: string;
    cta?: string;
  };
};

export type CertificateProgramCouponDiscountType =
  | "amount_off"
  | "percentage_off";

export const CertificateProgramCouponDiscountType = {
  AMOUNT_OFF: "amount_off",
  PERCENTAGE_OFF: "percentage_off",
} as const;

export type CertificateProgramCouponEligibility = "eligible" | "ineligible";

export const CertificateProgramCouponEligibility = {
  ELIGIBLE: "eligible",
  INELIGIBLE: "ineligible",
} as const;

export type PostPurchaseCertAddOns = {
  /**
   * Ordered list of certificate add-on slots, up to two. May be empty.
   */
  slots: Array<PostPurchaseCertAddOnSlot>;
};

export type PostPurchaseCertAddOnSlot = {
  /**
   * The unique identifier of the certificate program.
   */
  id: string;
  /**
   * The slug of the certificate program.
   */
  slug: string;
  /**
   * The title of the certificate program.
   */
  title: string;
  /**
   * The id of the default Product used for the add-on purchase.
   */
  productId: number;
  /**
   * The partner name (e.g., "Microsoft").
   */
  partnerName?: string;
  /**
   * Attribution line shown under the title (e.g., "Curated by MasterClass" or "Built with Microsoft").
   */
  subheading?: string;
  /**
   * Short marketing description of the certificate program.
   */
  description?: string | null;
  images?: {
    mainImage?: Image;
    logo?: Image;
  };
  /**
   * Trailer media UUID for the modal video.
   */
  mediaUuid?: string | null;
  /**
   * True when the cert is in active pre-enroll (status comingSoon with pre-enroll enabled).
   */
  isPreenroll: boolean;
  /**
   * The launch date; null when pre-enroll only.
   */
  launchDate?: string | null;
  /**
   * The pre-enroll start date.
   */
  preEnrollDate?: string | null;
  pricing: PostPurchaseCertAddOnPricing;
};

export type PostPurchaseCertAddOnPricing = {
  /**
   * Currency code (e.g., "USD").
   */
  currency: string;
  /**
   * Price in minor currency units (cents), before discount.
   */
  price: number;
  /**
   * Price in minor currency units, after the 30% add-on discount.
   */
  discountedPrice: number;
  /**
   * Localized formatted price (e.g., "$999.00").
   */
  monetizedPrice: string;
  /**
   * Localized formatted price after discount (e.g., "$699.30").
   */
  discountedMonetizedPrice: string;
  /**
   * Discount percentage applied (always 30 for this flow).
   */
  discount: number;
  /**
   * Coupon code applied at checkout (e.g., "cert-addon-second-cert-30").
   */
  discountCode: string;
};

/**
 * Enterprise data-sharing consent state for this enrollment. Present on every
 * enrollment payload that represents an actual enrollment; absent from the
 * not-enrolled response. When `required` is false — a consumer enrollment, an
 * organization that does not require consent, or the feature disabled — only
 * `required` and `satisfied` are populated.
 *
 */
export type CertificateDataSharingConsent = {
  /**
   * Whether the organization that owns this entitlement requires data-sharing consent.
   */
  required?: boolean;
  /**
   * Whether content access is currently permitted. False when consent is required and not accepted.
   */
  satisfied?: boolean;
  /**
   * The learner current decision — one of `accepted`, `declined`, `revoked` — or null if they have never decided.
   */
  status?: string | null;
  /**
   * The purchasing organization that owns this entitlement.
   */
  organizationId?: number;
  /**
   * Display name of the purchasing organization, for the consent screen copy.
   */
  organizationName?: string;
  /**
   * The terms version the learner must accept. Echo this back when accepting.
   */
  termsVersion?: string;
  /**
   * When consent was accepted, if it has been.
   */
  consentedAt?: string | null;
};

export type CertificateProgramEnrollments = {
  enrollments?: Array<CertificateProgramEnrollment>;
  /**
   * Present only when expired=true. One row per program, the most recent expired term, omitted for programs where the learner holds an active or pending enrollment.
   */
  expiredEnrollments?: Array<CertificateProgramEnrollment>;
};

export type CertificateProgramEnrollmentSource =
  | "purchase"
  | "credit"
  | "trial"
  | "gift"
  | "subscription";

export const CertificateProgramEnrollmentSource = {
  PURCHASE: "purchase",
  CREDIT: "credit",
  TRIAL: "trial",
  GIFT: "gift",
  SUBSCRIPTION: "subscription",
} as const;

/**
 * The learning platform that delivers the program. `certificates` programs use the
 * Certificates curriculum; `educator` programs are taught on the Educator platform.
 *
 */
export type CertificateProgramTeachingPlatform = "certificates" | "educator";

export const CertificateProgramTeachingPlatform =
  /**
   * The learning platform that delivers the program. `certificates` programs use the
   * Certificates curriculum; `educator` programs are taught on the Educator platform.
   *
   */
  {
    CERTIFICATES: "certificates",
    EDUCATOR: "educator",
  } as const;

/**
 * The current status of the enrollment. `expired` is derived: it is reported for
 * enrollments that are inactive because their access expiration date has passed.
 * `inactive` covers all other deactivations (e.g. refund or revoke). Expired
 * enrollments do not grant content access.
 *
 */
export type CertificateProgramEnrollmentStatus =
  | "active"
  | "pending"
  | "inactive"
  | "expired";

export const CertificateProgramEnrollmentStatus =
  /**
   * The current status of the enrollment. `expired` is derived: it is reported for
   * enrollments that are inactive because their access expiration date has passed.
   * `inactive` covers all other deactivations (e.g. refund or revoke). Expired
   * enrollments do not grant content access.
   *
   */
  {
    ACTIVE: "active",
    PENDING: "pending",
    INACTIVE: "inactive",
    EXPIRED: "expired",
  } as const;

export type MyCertificateSubscription = {
  /**
   * True when the viewer has certificate catalog access: an active
   * entitlement carrying the certificate pass, from a certificate
   * subscription or from a membership that includes the pass. The
   * same value as `viewer.isSubscribed` on the offer endpoint.
   * `subscription` stays the certificate subscription billing record,
   * so it can be null while this is true. Prefer this over deriving
   * access from `subscription.status`.
   *
   */
  isSubscribed: boolean;
  subscription?: MyCertificateSubscriptionDetails | null;
};

/**
 * The viewer's certificate subscription, in any lifecycle state.
 */
export type MyCertificateSubscriptionDetails = {
  /**
   * Subscription id — the id used by the v2 cancel endpoint.
   */
  id?: number;
  displayName?: string;
  /**
   * One of trialing, active, lapsed, inactive, refunded, pending.
   */
  status?: string;
  memberSince?: string;
  expiresAt?: string | null;
  /**
   * When the subscription became inactive (access revoked). Set for
   * early-terminated subs, where `expiresAt` still holds the original
   * future term end; null while active/lapsed.
   *
   */
  terminatedAt?: string | null;
  cancelAtPeriodEnd?: boolean;
  /**
   * True while the term has at least one day left: the Pacific
   * calendar date of `expiresAt` is after today in Pacific time.
   * False from the Pacific day the term expires, even though `status`
   * can still read `active` that day. The same rule as
   * `remainingSubscriptionDays > 0`. It reads only `expiresAt`, not
   * `status` or `terminatedAt`, so an early-terminated subscription
   * can still report true: check `status` first. Null when
   * `expiresAt` is null.
   *
   */
  hasRemainingDays?: boolean | null;
  providerType?: string;
};

/**
 * The subscription offer plus comparison pricing for one page render.
 */
export type CertificateSubscriptionOffer = {
  subscriptionPlan?: CertificateSubscriptionPlan;
  singleCertificateComparison?: SingleCertificateComparison;
  viewer?: CertificateSubscriptionViewer;
  /**
   * Analytics data for tracking. Do not use for application logic.
   * Money values are in major units of `currency`, the visitor's local
   * currency: `price` and `revenue` are the discounted price,
   * `listPrice` is the price before any discount, and `discount` is
   * the amount taken off it (0 when no discount applies).
   *
   */
  analytics?: {
    [key: string]: unknown;
  };
};

/**
 * The purchasable Certificates Annual Pass subscription plan.
 */
export type CertificateSubscriptionPlan = {
  /**
   * Purchase plan slug identifying the subscription SKU at checkout.
   * Display and checkout handoff only — never use in business logic.
   *
   */
  slug?: string;
  /**
   * Display copy for the plan.
   */
  text?: {
    /**
     * Customer-facing plan name.
     */
    displayName?: string;
    /**
     * Supporting line shown under the plan name.
     */
    tagline?: string;
    /**
     * Optional promotional badge label shown above the plan.
     */
    badge?: string;
  };
  pricing?: CertificateSubscriptionPrice;
};

/**
 * A localized price. Currency is resolved server-side from the visitor's
 * geo; amounts are in the currency's smallest unit (cents, pence,
 * fillér for HUF — whole units for zero-decimal currencies like JPY).
 * Discount fields are present only when a discount applies: render
 * `formattedNetPrice` when present, `formattedPrice` otherwise.
 *
 */
export type CertificateSubscriptionPrice = {
  /**
   * ISO 4217 currency code resolved for the visitor.
   */
  currency?: string;
  /**
   * Price in the currency's smallest unit. Zero-decimal currencies
   * (JPY, KRW, VND, CLP) are in whole units. HUF is not zero-decimal
   * here: it has 100 subunits, so 31,900 Ft is 3190000.
   *
   */
  amountSubunits?: number;
  /**
   * Fully formatted display price, ready to render.
   */
  formattedPrice?: string;
  /**
   * List price rounded up to the whole currency unit, for pre-paywall display (FX-converted geos can carry cents on the list price). Checkout must keep rendering the exact `formattedPrice`.
   */
  formattedPriceRounded?: string;
  /**
   * See `CertificateSubscriptionBillingPeriod` for available values.
   */
  billingPeriod?: string;
  /**
   * Display suffix pairing the price with its cadence.
   */
  formattedBillingSuffix?: string;
  /**
   * The annual list price divided by 12 and rounded up to the whole
   * currency unit, for pre-paywall "per month" display. Rounding is
   * always up, so 12 months of it never undercut the pre-tax amount
   * charged at checkout. Present only on the subscription plan price.
   *
   */
  formattedMonthlyPriceRounded?: string;
  /**
   * The discounted annual price divided by 12 and rounded up to the
   * whole currency unit, for pre-paywall "per month" display. Rounding
   * is always up, as for `formattedMonthlyPriceRounded`. Present
   * only on the subscription plan price, and only when a discount
   * applies.
   *
   */
  formattedMonthlyNetPriceRounded?: string;
  /**
   * Price after discounts, in the currency's smallest unit. Absent
   * when no discount applies.
   *
   */
  netAmountSubunits?: number;
  /**
   * Fully formatted discounted price, ready to render.
   */
  formattedNetPrice?: string;
  /**
   * Discounted price rounded up to the whole currency unit, for
   * pre-paywall display (mirrors core's marketing-price convention).
   * Checkout must keep rendering the exact `formattedNetPrice`.
   * Absent when no discount applies.
   *
   */
  formattedNetPriceRounded?: string;
  /**
   * Fully formatted amount taken off the list price.
   */
  formattedDiscountAmount?: string;
  /**
   * Text to display indicating the applied discount.
   */
  discountSubheading?: string;
  /**
   * The discount code that was selected and applied to this price (the
   * highest-value eligible candidate). Absent when no discount applied.
   * Lets the frontend key promo copy off the winning candidate.
   *
   */
  winningDiscountSlug?: string;
  /**
   * Whether non-inclusive tax applies on top of the displayed price
   * (tax-exclusive currencies such as USD and CAD). Prices in
   * tax-inclusive currencies already contain tax.
   *
   */
  applyTax?: boolean;
};

/**
 * Billing period values for subscription pricing.
 */
export type CertificateSubscriptionBillingPeriod = "annual";

export const CertificateSubscriptionBillingPeriod =
  /**
   * Billing period values for subscription pricing.
   */
  {
    ANNUAL: "annual",
  } as const;

/**
 * The one-time-purchase price shown against the subscription. Catalog-wide
 * starting-at price by default; a specific program's price when
 * `certificateProgramSlug` is provided.
 *
 */
export type SingleCertificateComparison = {
  /**
   * Display copy for the comparison option.
   */
  text?: {
    /**
     * Name of the one-time purchase option.
     */
    label?: string;
    /**
     * Supporting line for the option.
     */
    description?: string;
  };
  pricing?: CertificateSubscriptionPrice;
  /**
   * True when the price is the catalog-wide minimum ("Starting at")
   * rather than a specific program's price.
   *
   */
  isStartingAt?: boolean;
  /**
   * Present only when `certificateProgramSlug` was provided.
   */
  certificateProgram?: {
    /**
     * The certificate program's slug.
     */
    slug?: string;
    text?: {
      /**
       * The certificate program's display title.
       */
      title?: string;
    };
  };
};

/**
 * The current visitor's relationship to the offer.
 */
export type CertificateSubscriptionViewer = {
  /**
   * True when the visitor has certificate catalog access, from a
   * certificate subscription or from a membership that includes the
   * certificate pass. Used to suppress purchase CTAs and show subscribed
   * states.
   *
   */
  isSubscribed?: boolean;
  /**
   * True when `certificateProgramSlug` was provided and the visitor
   * already owns that program via one-time purchase or enrollment.
   *
   */
  hasPurchasedProgram?: boolean;
};

/**
 * Error payload for certificate subscription offer requests.
 */
export type CertificateSubscriptionOfferErrorResponse = {
  /**
   * See `CertificateSubscriptionOfferErrorCode` for possible values.
   */
  errorCode?: string;
  /**
   * Human-readable error description.
   */
  errorMessage?: string;
};

/**
 * Error codes for certificate subscription offer requests.
 */
export type CertificateSubscriptionOfferErrorCode =
  | "certificate_program_not_found"
  | "offer_not_available";

export const CertificateSubscriptionOfferErrorCode =
  /**
   * Error codes for certificate subscription offer requests.
   */
  {
    CERTIFICATE_PROGRAM_NOT_FOUND: "certificate_program_not_found",
    OFFER_NOT_AVAILABLE: "offer_not_available",
  } as const;

export type AcceleratorUser = {
  /**
   * The UUID of the user
   */
  uuid?: string;
  /**
   * The employee ID of the user
   */
  employeeId?: string;
  /**
   * The location, this might be a store number or a geo
   */
  location?: string;
  /**
   * Slug to identify the organization that this user belongs to
   */
  orgSlug?: string;
  /**
   * Whether the user has consented to sharing their data with their organization
   */
  dataConsentGiven?: boolean;
};

export type GrowthCategory = {
  id: number;
  name: string;
  slug: string;
  /**
   * The parentId is the Category that a Subcategory belongs to. Categories don't have a parent_id
   */
  parentId?: number;
  uuid: string;
  rankings?: Array<{
    rankValue: number;
    rankType: string;
  }>;
  videos?: Array<{
    mediaUuid?: string;
    videoType?: string;
  }>;
};

export type GrowthContent = {
  uuid: string;
  /**
   * the id for the Course / Camp
   */
  contentId: number;
  /**
   * Unique slug for the content
   */
  slug: string;
  /**
   * See `GrowthContentType` for available types.
   */
  type: string;
  title: string;
  headline?: string;
  tagline?: string;
  skill?: string;
  instructors?: Array<{
    name: string;
  }>;
  instructorName?: string;
  /**
   * Instructor biography
   */
  instructorBio?: string;
  /**
   * Instructor image URL - uses image4x3 for courses or primary1x1 for camps
   */
  instructorImage?: string;
  leftAlignedNameplate?: string;
  nameplate?: string;
  marketingCmColumn?: string;
  /**
   * Media UUID for the course trailer
   */
  mediaUuid?: string;
  /**
   * Media UUID for the course sample (AKA "mobile_web_gem")
   */
  sampleMediaUuid?: string;
  primary16x9?: string;
  primary2x3?: string;
  primary1x1?: string;
  cinematic12x5?: string;
  tag?: string;
  releaseDescription?: string;
  durationInSeconds?: number;
  /**
   * Number of camp modules or number of series episodes or number of course chapters
   */
  durationAsCount?: number;
  vanityName?: string;
  primaryCategory: {
    id?: number;
  };
  /**
   * List of categories associated with the content
   */
  categories: Array<{
    id: number;
  }>;
  primarySubcategory: {
    id?: number;
  };
  /**
   * List of subcategories associated with the content
   */
  subcategories: Array<{
    id: number;
  }>;
  rankings?: Array<{
    rankValue: number;
    rankType: string;
  }>;
};

export type GrowthContentType = "course" | "camp" | "series";

export const GrowthContentType = {
  COURSE: "course",
  CAMP: "camp",
  SERIES: "series",
} as const;

export type GrowthSubcategoryWithLessons = {
  id: number;
  /**
   * The parentId is the Category that a Subcategory belongs to. Categories don't have a parent_id
   */
  parentId?: number;
  uuid: string;
  name: string;
  slug: string;
  /**
   * List of ranked lessons within the subcategory
   */
  lessons: Array<GrowthLesson>;
};

export type GrowthLesson = {
  uuid: string;
  /**
   * id for the lesson
   */
  contentId: number;
  /**
   * See `GrowthLessonType` for available types.
   */
  type: string;
  /**
   * Unique slug for the lesson
   */
  slug: string;
  /**
   * Title of the lesson
   */
  title: string;
  /**
   * Lesson abstract
   */
  abstract?: string;
  /**
   * Ranking of the lesson within the subcategory
   */
  rank: number;
  /**
   * The parent class for the lesson
   */
  class: {
    uuid?: string;
    /**
     * The total number of lessons (chapters or camp modules) in the class
     */
    lessonCount?: number;
  };
};

export type GrowthLessonType = "chapter" | "camptask" | "serieschapter";

export const GrowthLessonType = {
  CHAPTER: "chapter",
  CAMPTASK: "camptask",
  SERIESCHAPTER: "serieschapter",
} as const;

export type GrowthCategoryWithMedia = {
  id: number;
  /**
   * The parentId is the Category that a Subcategory belongs to. Categories don't have a parent_id
   */
  parentId?: number;
  uuid: string;
  name: string;
  slug: string;
  /**
   * List of media for the category / subcategory
   */
  media?: Array<GrowthCategoryMedia>;
};

export type GrowthCategoryMedia = {
  mediaType?: string;
  mediaUuid?: string;
  thumbnail16x9?: string;
  /**
   * The instructors in the media item
   */
  instructors?: Array<GrowthCategoryMediaInstructor>;
};

export type GrowthCategoryMediaInstructor = {
  id?: number;
  uuid?: string;
  /**
   * The instructor's position in the ordered list (0-based index)
   */
  order?: number;
  name?: string;
  /**
   * The instructor's primary 2x3 image
   */
  primary2x3?: string;
};

export type Outcome = {
  id: number;
  name: string;
  slug: string;
  uuid: string;
  /**
   * A one-liner describing the outcome
   */
  description?: string;
  /**
   * A short, action-oriented name phrased with an -ing verb form
   */
  gerund?: string;
};

export type ContentOutcome = {
  uuid: string;
  /**
   * the id for the Course / Camp
   */
  contentId: number;
  /**
   * Unique slug for the content
   */
  slug?: string;
  /**
   * See `GrowthContentType` for available types.
   */
  type: string;
  title?: string;
  /**
   * List of outcomes associated with the content ordered by relevance rank
   */
  outcomes?: Array<{
    id: number;
  }>;
};

export type EmailCaptureRequest = {
  /**
   * The email address to capture
   */
  email: string;
  /**
   * Custom event name for tracking
   */
  eventName?: string;
  /**
   * Whether user has consented to marketing emails
   */
  marketingConsent?: boolean;
  /**
   * Campaign identifier (e.g., cart, marketingEmails, accountCreation)
   */
  campaign?: string;
  /**
   * Product identifier (e.g., masterclass, certificates)
   */
  product?: string;
  /**
   * Unique event ID for deduplication across Iterable and Segment
   */
  eventId?: string;
};

export type EmailCaptureResponse = {
  /**
   * Whether the email capture was successful
   */
  success: boolean;
};

export type ErrorResponse = {
  /**
   * Error message
   */
  error: string;
};

export type SubscriptionPreferencesUser = {
  /**
   * The user's email address
   */
  email: string;
  /**
   * List of message type IDs the user has unsubscribed from
   */
  unsubscribedMessageTypeIds?: Array<number>;
  /**
   * List of message type IDs the user is subscribed to
   */
  subscribedMessageTypeIds?: Array<number>;
  /**
   * List of channel IDs the user has unsubscribed from
   */
  unsubscribedChannelIds?: Array<number>;
};

export type SubscriptionPreferencesMetadata = {
  channels: Array<IterableChannel>;
  messageTypes: Array<IterableMessageType>;
  /**
   * Admin-managed channels shown on the preference center page, in display order
   */
  preferenceChannels: Array<SubscriptionPreferenceChannel>;
};

export type SubscriptionPreferenceChannel = {
  iterableChannelId: number;
  title?: string | null;
  description?: string | null;
};

export type IterableChannel = {
  id: number;
  name: string;
  channelType: string;
  messageMedium: string;
};

export type IterableMessageType = {
  id: number;
  name: string;
  channelId: number;
  subscriptionPolicy: string;
};

export type SubscriptionPreferencesUpdateRequest = {
  /**
   * Email address to update subscription preferences for
   */
  email: string;
  /**
   * Email token hashed with HMAC-SHA256 and secret matching ITERABLE_HMACSHA1_SECRET to authenticate the request
   */
  subscriptionPreferencesToken: string;
  /**
   * Array of channel IDs to unsubscribe from
   */
  unsubscribedChannelIds?: Array<number>;
  /**
   * Array of message type IDs to unsubscribe from
   */
  unsubscribedMessageTypeIds?: Array<number>;
  /**
   * Array of message type IDs to subscribe to
   */
  subscribedMessageTypeIds?: Array<number>;
  /**
   * Iterable campaign ID from iterableEmailCampaignId cookie
   */
  campaignId?: number | null;
  /**
   * Iterable template ID from iterableTemplateId cookie
   */
  templateId?: number | null;
};

export type SubscriptionPreferencesUpdateResponse = {
  /**
   * Success message
   */
  message?: string;
};

export type LearningPath = {
  id: number;
  name: string;
  slug: string;
  description?: string;
  primaryAssetUrl?: string | null;
  content?: Array<GrowthContent>;
  categories?: Array<{
    id: number;
  }>;
  subcategories?: Array<{
    id: number;
  }>;
};

/**
 * The Decagon deployment a signature is minted for.
 */
export type DecagonProduct = "masterclass" | "executive";

export const DecagonProduct =
  /**
   * The Decagon deployment a signature is minted for.
   */
  {
    MASTERCLASS: "masterclass",
    EXECUTIVE: "executive",
  } as const;

export type DecagonUserToken = {
  /**
   * The Json Web Token (JWT)
   */
  userToken: string;
  expiresIn: number;
};

export type DecagonSignature = {
  /**
   * canonicalId - the value that was signed
   */
  userId: string;
  /**
   * HMAC-SHA256 hex digest
   */
  signature: string;
  /**
   * Unix seconds at which the signature expires
   */
  epoch: number;
  /**
   * Seconds until expiry
   */
  expiresIn: number;
};

export type CommerceProduct = {
  id: number;
  name: string;
  status: string;
  /**
   * The description of the product
   */
  description?: string;
  /**
   * List of purchase plans for the product
   */
  purchasePlans?: Array<CommercePurchasePlan>;
};

export type CommercePurchasePlan = {
  /**
   * the id for the Purchase Plan
   */
  id: number;
  /**
   * Unique slug for the purchase plan
   */
  slug: string;
  /**
   * Duration for the purchase plan
   */
  duration: number;
  durationUnits: string;
  /**
   * friendly name for the purchase plan
   */
  displayName: string;
  /**
   * List of pricing plans for the purchase plan
   */
  pricingPlans?: Array<CommercePricingPlan>;
};

export type CommercePricingPlan = {
  /**
   * the id for the Pricing Plan
   */
  id: number;
  /**
   * Unique name for the pricing plan
   */
  name: string;
  /**
   * Stripe price id for this pricing plan
   */
  paymentGatewaySkuId: string;
  currency: string;
  price: number;
  usdPrice?: number;
  active: boolean;
};

export type SubscriptionDetails = {
  /**
   * Days the subscription lasts
   */
  billingLengthDays: number;
  currency: string;
  price: number;
  /**
   * Name of pricing tier
   */
  displayName: string;
  /**
   * SKU of purchase plan
   */
  planSku: string;
};

export type CertificatePriceLimit = {
  /**
   * Price in minor currency units (cents)
   */
  price: number;
  /**
   * Currency code (USD, EUR, GBP, etc.)
   */
  currency: string;
  /**
   * Formatted price string
   */
  displayPrice: string;
};

export type BundlePricingComponent = {
  /**
   * Price in minor currency units (cents)
   */
  price: number;
  /**
   * Currency code
   */
  currency: string;
  /**
   * Formatted price string
   */
  displayPrice: string;
};

/**
 * All properties are optional — a component is omitted when its pricing data is unavailable.
 */
export type BundlePricingBreakdown = {
  premium?: BundlePricingComponent;
  certificate?: BundlePricingComponent;
  onCall?: BundlePricingComponent;
  bundle?: BundlePricingComponent;
  totalIndividual?: BundlePricingComponent;
  savings?: BundlePricingComponent;
};

/**
 * Certificate programs that a user can redeem with the bundle's certificate credit. Reuses the catalog `CertificateTile` shape so the bundle page can render the same component used elsewhere.
 */
export type BundleEligibleCertificates = {
  certificatePrograms: Array<CertificateTile>;
};

/**
 * A single row in the payment-history list.
 */
export type ReceiptListItem = {
  /**
   * The Payment id (as a string) used to build the download link.
   */
  paymentId: string;
  /**
   * When the payment was made (ISO 8601). The client formats it.
   */
  date: string;
  /**
   * Customer-facing summary; includes the term for renewals.
   */
  description: string;
  /**
   * Pre-formatted localized total charged for the payment.
   */
  total: string;
};

/**
 * A page of payment-history receipts plus the total count, so the typed
 * client can drive pagination without reading a response header. This is a
 * deliberate, localized body envelope for this FE-owned endpoint; other V3
 * collection endpoints return bare arrays with an X-Total-Count header.
 *
 */
export type ReceiptList = {
  /**
   * The receipts on the requested page, newest-first.
   */
  items: Array<ReceiptListItem>;
  pagination: ReceiptListPagination;
};

/**
 * Pagination metadata for the receipts list.
 */
export type ReceiptListPagination = {
  /**
   * Total number of receipts available for the user across all pages (mirrors the X-Total-Count header).
   */
  count: number;
};

/**
 * Request to change the payment method used for future installments.
 */
export type InstallmentChangePaymentMethodRequest = {
  /**
   * Stripe PaymentMethod token for the new card, collected on the client.
   */
  paymentMethodId: string;
};

/**
 * Shared error response for change-payment-method failures, used for both the `400`
 * (card declined / setup failed / Stripe error) and `422` (3D Secure required) responses.
 * Carries a human-readable `error.message`; no machine-readable code. On the `422`
 * response the `requiresAction` block is also present, carrying the redirect URL and the
 * `setupIntentId` to send to the confirm endpoint. The `400` response omits
 * `requiresAction`. Mirrors the `requiresAction` shape from `educator-payment-order`,
 * with a `setupIntentId` in place of a `paymentIntentId`.
 *
 */
export type InstallmentChangePaymentMethodErrorResponse = {
  error?: {
    /**
     * Human-readable error message.
     */
    message?: string;
  };
  /**
   * Present on the `422` response when the new card requires 3D Secure authentication.
   *
   */
  requiresAction?: {
    /**
     * URL for the 3D Secure authentication challenge.
     */
    redirectUrl?: string;
    /**
     * Stripe SetupIntent ID to send back on the confirm endpoint.
     */
    setupIntentId?: string;
  };
};

/**
 * Error body returned when the confirm step fails. Carries a human-readable message the frontend can display; the specific setup/Stripe failure code is logged in the backend rather than returned to the client.
 */
export type InstallmentChangePaymentMethodConfirmErrorResponse = {
  error?: {
    /**
     * Human-readable error message safe to surface to the learner.
     */
    message?: string;
  };
};

/**
 * Request to confirm a change-payment-method setup after 3DS authentication.
 */
export type InstallmentChangePaymentMethodConfirmRequest = {
  /**
   * Stripe SetupIntent id returned by the initiate endpoint's `422 requires_authentication`
   * response. The backend retrieves this SetupIntent and requires it to have succeeded
   * before swapping the stored card.
   *
   */
  setupIntentId: string;
};

/**
 * The product to put in the member's cart.
 */
export type CartAddProductRequest = {
  /**
   * The product to add. For an in-person event ticket this is the event detail's
   * `productId`. The backend resolves the cart product type itself, and a ticket is
   * always a quantity of one, so neither is sent.
   *
   */
  productId?: number;
};

/**
 * The cart line that was created, as the backend decorates it.
 */
export type CartAddProductResponse = {
  /**
   * Decorated product info. The in-person event flow does not read it.
   */
  product?: {
    [key: string]: unknown;
  };
};

/**
 * Request to buy what is in the member's cart. Send exactly one of `credit_card_id` or
 * `paymentMethodId`; neither or both returns `paymentMethodInvalid`.
 * Exception: when the cart's in-person ticket line carries the Booth incentive coupon and the
 * order total is $0, send neither. The backend re-checks eligibility and otherwise still
 * requires exactly one.
 *
 */
export type CommerceOrderRequest = {
  /**
   * A saved card to charge on-session: the `id` of a card from the credit-cards list
   * (the program card is one). Omit when sending `paymentMethodId`.
   *
   */
  creditCardId?: number;
  /**
   * A new card collected with Stripe Elements, saved to the member during the charge.
   * Omit when sending `creditCardId`.
   *
   */
  paymentMethodId?: string;
  /**
   * Where the purchase was made. Must be a known purchase source, otherwise `purchaseSourceInvalid`.
   */
  purchaseSource?: string;
  regionInfo?: CommerceOrderRegionInfo;
  /**
   * The caller's own page Stripe sends the member back to after a 3D Secure challenge.
   */
  returnUrl?: string;
  /**
   * Optional key-value attribution passed through to the Order Completed event (fbc, fbp, userAgent).
   */
  metadata?: {
    [key: string]: string;
  };
};

/**
 * Request to finish an order after the member completes a 3D Secure challenge.
 */
export type CommerceOrderConfirmRequest = {
  /**
   * Stripe PaymentIntent id from the `requiresAction` block of the order endpoint's `422` response.
   */
  paymentIntentId?: string;
  /**
   * Optional key-value attribution passed through to the Order Completed event (fbc, fbp, userAgent).
   */
  metadata?: {
    [key: string]: string;
  };
};

/**
 * The member's location, used to compute tax at charge time.
 */
export type CommerceOrderRegionInfo = {
  /**
   * State or province subdivision code.
   */
  regionCode?: string;
  /**
   * Postal or zip code.
   */
  postalCode?: string;
};

/**
 * A completed order. Returned by both the order and the confirm endpoints.
 */
export type CommerceOrderResponse = {
  /**
   * Result of the order.
   */
  status?: string;
  /**
   * The Commerce Order created for the cart.
   */
  orderId?: number;
  /**
   * The Payment on the order; the key for the receipt download.
   */
  paymentId?: number;
  charged?: CommerceOrderCharged;
  /**
   * Analytics data for tracking. Do not use for application logic. Carries the same keys as the
   * educator payment order endpoint: `orderId`, `paymentId`, `firstTimeOrder`,
   * `paymentProvider`, `cardBrand`, `cardLast4`, `productId`, `productSku`.
   *
   */
  analytics?: {
    [key: string]: string;
  };
};

/**
 * The amount taken from the card.
 */
export type CommerceOrderCharged = {
  /**
   * Exact amount taken from the card, in minor currency units, tax included.
   */
  totalCents?: number;
  /**
   * The tax inside `totalCents`, in minor currency units.
   */
  taxCents?: number;
  /**
   * ISO 4217 currency code.
   */
  currency?: string;
};

/**
 * Error codes for the Commerce order and confirm endpoints.
 * Three codes apply only to the order endpoint, only to a certificate cohort product, and are
 * returned before any charge: `cohortSoldOut` (422) when the accepting cohort has no seats
 * left, `cohortNotOnSale` (422) when it is paused, not active, or outside its enrollment
 * windows, and `programAlreadyEnrolled` (409) when the member already has an active or
 * pending enrollment in the certificate program, in any cohort or self-paced.
 *
 */
export type CommerceOrderErrorCode =
  | "cart_empty"
  | "purchase_source_invalid"
  | "product_not_purchasable"
  | "requires_authentication"
  | "payment_method_invalid"
  | "payment_failed"
  | "order_processing_failed"
  | "order_not_found"
  | "already_confirmed"
  | "cohort_sold_out"
  | "cohort_not_on_sale"
  | "program_already_enrolled";

export const CommerceOrderErrorCode =
  /**
   * Error codes for the Commerce order and confirm endpoints.
   * Three codes apply only to the order endpoint, only to a certificate cohort product, and are
   * returned before any charge: `cohortSoldOut` (422) when the accepting cohort has no seats
   * left, `cohortNotOnSale` (422) when it is paused, not active, or outside its enrollment
   * windows, and `programAlreadyEnrolled` (409) when the member already has an active or
   * pending enrollment in the certificate program, in any cohort or self-paced.
   *
   */
  {
    CART_EMPTY: "cart_empty",
    PURCHASE_SOURCE_INVALID: "purchase_source_invalid",
    PRODUCT_NOT_PURCHASABLE: "product_not_purchasable",
    REQUIRES_AUTHENTICATION: "requires_authentication",
    PAYMENT_METHOD_INVALID: "payment_method_invalid",
    PAYMENT_FAILED: "payment_failed",
    ORDER_PROCESSING_FAILED: "order_processing_failed",
    ORDER_NOT_FOUND: "order_not_found",
    ALREADY_CONFIRMED: "already_confirmed",
    COHORT_SOLD_OUT: "cohort_sold_out",
    COHORT_NOT_ON_SALE: "cohort_not_on_sale",
    PROGRAM_ALREADY_ENROLLED: "program_already_enrolled",
  } as const;

/**
 * Actions the client must perform to complete the order.
 */
export type CommerceOrderAction = "verify_payment";

export const CommerceOrderAction =
  /**
   * Actions the client must perform to complete the order.
   */
  {
    VERIFY_PAYMENT: "verify_payment",
  } as const;

/**
 * Error body for the Commerce order and confirm endpoints. The client maps `error.code` to a screen
 * and never parses `error.message`. `requiresAction` is present only when `error.code` is
 * `requiresAuthentication`.
 *
 */
export type CommerceOrderErrorResponse = {
  error?: CommerceOrderError;
  requiresAction?: CommerceOrderRequiresAction;
};

/**
 * The error code and a human-readable message.
 */
export type CommerceOrderError = {
  /**
   * See `CommerceOrderErrorCode` for values.
   */
  code?: string;
  /**
   * Human-readable error message, for logging only.
   */
  message?: string;
};

/**
 * The bank verification step the client must complete before calling the confirm endpoint.
 */
export type CommerceOrderRequiresAction = {
  /**
   * The Order kept without a Payment while the member clears the challenge. The client
   * needs it to build the confirm URL, which is why it travels on the error body.
   *
   */
  orderId?: number;
  /**
   * See `CommerceOrderAction` for values.
   */
  action?: string;
  /**
   * URL of the 3D Secure challenge.
   */
  redirectUrl?: string;
  /**
   * Stripe PaymentIntent id to send to the confirm endpoint.
   */
  paymentIntentId?: string;
};

/**
 * The member's saved cards. `items` is empty when the member has none to show.
 */
export type CommerceCreditCardList = {
  /**
   * Saved cards, in the same order as the v1 endpoint returns them.
   */
  items?: Array<CommerceCreditCard>;
};

/**
 * A saved card. Carries no Stripe or other internal ids.
 */
export type CommerceCreditCard = {
  /**
   * The saved card's id. Send it to `POST /api/v3/commerce/orders` as `credit_card_id`.
   * Not for display.
   *
   */
  id?: number;
  /**
   * Card brand. The client handles display casing. Omitted for a Link payment method.
   */
  brand?: string;
  /**
   * Last four digits of the card, zero-padded to 4 characters. Omitted for a Link payment method.
   *
   */
  lastFour?: string;
  /**
   * Whether this is the member's default card.
   */
  isDefault?: boolean;
};

/**
 * Result of cancelling a subscription at period end.
 */
export type SubscriptionCancellation = {
  id: number;
  cancelAtPeriodEnd: boolean;
  /**
   * When access ends. The subscription will not renew after this.
   */
  expiresAt: string;
};

/**
 * Error body for subscription cancellation, in the v3 `ErrorSerializer` shape.
 */
export type SubscriptionCancellationErrorResponse = {
  errors: Array<SubscriptionCancellationError>;
};

export type SubscriptionCancellationError = {
  /**
   * HTTP status code, as a string.
   */
  status: string;
  /**
   * See `SubscriptionCancellationErrorCode` for possible values.
   */
  code: string;
  /**
   * Human-readable summary. Do not branch on it.
   */
  title: string;
};

/**
 * Machine-readable error codes returned by the subscription cancellation endpoint.
 */
export type SubscriptionCancellationErrorCode =
  | "unauthorized"
  | "subscription_not_found"
  | "already_cancelled"
  | "not_a_web_subscription"
  | "invalid_status"
  | "provider_error";

export const SubscriptionCancellationErrorCode =
  /**
   * Machine-readable error codes returned by the subscription cancellation endpoint.
   */
  {
    UNAUTHORIZED: "unauthorized",
    SUBSCRIPTION_NOT_FOUND: "subscription_not_found",
    ALREADY_CANCELLED: "already_cancelled",
    NOT_A_WEB_SUBSCRIPTION: "not_a_web_subscription",
    INVALID_STATUS: "invalid_status",
    PROVIDER_ERROR: "provider_error",
  } as const;

export type SupportedCapabilities =
  | "media_download"
  | "concurrent_devices"
  | "multiple_profiles"
  | "notes"
  | "bookmarks"
  | "recipes"
  | "class_resources"
  | "class_ta";

export const SupportedCapabilities = {
  MEDIA_DOWNLOAD: "media_download",
  CONCURRENT_DEVICES: "concurrent_devices",
  MULTIPLE_PROFILES: "multiple_profiles",
  NOTES: "notes",
  BOOKMARKS: "bookmarks",
  RECIPES: "recipes",
  CLASS_RESOURCES: "class_resources",
  CLASS_TA: "class_ta",
} as const;

export type Capabilities = {
  /**
   * List of capabilities available to the user. Each capability key appears at most once.
   */
  userCapabilities?: Array<Capability>;
};

export type Capability = {
  /**
   * See `SupportedCapabilities` for a list of currently supported keys.
   */
  key: string;
  /**
   * The value associated with the capability (e.g., "true", "false", or other capability-specific values)
   */
  value: string;
};

export type TermsPage = {
  id: number;
  name: string;
  urlSlug: string;
  /**
   * Markdown-formatted terms content.
   */
  content: string;
  startsAt: string;
  endsAt: string;
};

/**
 * Status of the enrollment application, derived from internal state by the server.
 */
export type EducatorApplicationStatus =
  | "draft"
  | "submitted"
  | "video_interview"
  | "in_review"
  | "pending_payment"
  | "rejected"
  | "completed";

export const EducatorApplicationStatus =
  /**
   * Status of the enrollment application, derived from internal state by the server.
   */
  {
    DRAFT: "draft",
    SUBMITTED: "submitted",
    VIDEO_INTERVIEW: "video_interview",
    IN_REVIEW: "in_review",
    PENDING_PAYMENT: "pending_payment",
    REJECTED: "rejected",
    COMPLETED: "completed",
  } as const;

/**
 * Status values that can be set by the client when creating or updating an application.
 */
export type EducatorApplicationWriteStatus = "draft" | "published";

export const EducatorApplicationWriteStatus =
  /**
   * Status values that can be set by the client when creating or updating an application.
   */
  {
    DRAFT: "draft",
    PUBLISHED: "published",
  } as const;

/**
 * The employment status of the applicant
 */
export type EducatorEmploymentStatus =
  | "employed_full_time"
  | "employed_part_time"
  | "self_employed"
  | "not_currently_working"
  | "student";

export const EducatorEmploymentStatus =
  /**
   * The employment status of the applicant
   */
  {
    EMPLOYED_FULL_TIME: "employed_full_time",
    EMPLOYED_PART_TIME: "employed_part_time",
    SELF_EMPLOYED: "self_employed",
    NOT_CURRENTLY_WORKING: "not_currently_working",
    STUDENT: "student",
  } as const;

/**
 * Years of professional experience
 */
export type EducatorYearsOfExperience = "0" | "1-3" | "4-7" | "8-15" | "16+";

export const EducatorYearsOfExperience =
  /**
   * Years of professional experience
   */
  {
    _0: "0",
    _1_3: "1-3",
    _4_7: "4-7",
    _8_15: "8-15",
    _16_: "16+",
  } as const;

/**
 * How long ago the applicant's most recent role ended
 */
export type EducatorRoleEndedRange =
  | "under_6_months"
  | "6_to_12_months"
  | "1_to_2_years"
  | "over_2_years";

export const EducatorRoleEndedRange =
  /**
   * How long ago the applicant's most recent role ended
   */
  {
    UNDER_6_MONTHS: "under_6_months",
    _6_TO_12_MONTHS: "6_to_12_months",
    _1_TO_2_YEARS: "1_to_2_years",
    OVER_2_YEARS: "over_2_years",
  } as const;

/**
 * The primary reason the applicant is choosing to apply now
 */
export type EducatorApplyReason =
  | "keep_up_with_ai"
  | "leading_ai_change"
  | "moving_into_bigger_role"
  | "changing_or_starting_something"
  | "other";

export const EducatorApplyReason =
  /**
   * The primary reason the applicant is choosing to apply now
   */
  {
    KEEP_UP_WITH_AI: "keep_up_with_ai",
    LEADING_AI_CHANGE: "leading_ai_change",
    MOVING_INTO_BIGGER_ROLE: "moving_into_bigger_role",
    CHANGING_OR_STARTING_SOMETHING: "changing_or_starting_something",
    OTHER: "other",
  } as const;

/**
 * Represents an enrollment cohort
 */
export type EducatorEnrollmentCohort = {
  /**
   * Cohort unique identifier
   */
  id?: string;
  /**
   * Text content for the cohort
   */
  text?: {
    /**
     * Cohort display name
     */
    name?: string;
  };
  /**
   * The deadline for enrollment
   */
  enrollmentDeadlineDate?: string;
  /**
   * The start date of the program
   */
  programStartDate?: string;
  /**
   * Analytics data for tracking. Do not use for application logic.
   */
  analytics?: {
    [key: string]: string;
  };
};

/**
 * Represents an enrollment application
 */
export type EducatorEnrollmentApplication = {
  /**
   * The unique identifier for the application
   */
  uuid?: string;
  /**
   * See `EducatorApplicationStatus` for available values
   */
  status?: string;
  questionnaire?: EducatorEnrollmentApplicationQuestionnaire;
  cohort?: EducatorEnrollmentCohort;
  referral?: EducatorEnrollmentReferral;
  /**
   * Analytics data for tracking. Do not use for application logic.
   * An open set of properties: clients echo whatever it holds onto their tracking events rather than reading keys individually, so properties can be added here without a contract change. Today it carries the two in the example — `value`, the lead value: what this applicant is worth to Meta value-based optimization campaigns, derived server-side from their years of experience and employment status; and `currency`, the ISO 4217 code that value is denominated in.
   * The lead value is keyed `value`, not `leadValue`, on purpose. Segment's browser Facebook Pixel destination forwards event properties to Meta under their own names, and Meta only reads a property named `value` as the conversion value, so any other name is silently ignored for bidding.
   * Both are absent until the applicant has answered both questions the value derives from, which is most of the life of a draft. Every number the matrix produces is a real bid signal, so there is no default to fall back to.
   */
  analytics?: {
    [key: string]: unknown;
  };
};

/**
 * Fast Track Referral state for the signed-in applicant, always present.
 *
 * A referred applicant is one an admin nominated ahead of time. They see a shorter
 * form: the essay step is skipped and the LinkedIn URL we already hold is used.
 * The shortening must not be surfaced in copy — do not render "step skipped" or
 * similar messaging off the back of these flags.
 *
 */
export type EducatorEnrollmentReferral = {
  /**
   * Whether the applicant was nominated as a Fast Track Referral.
   */
  isReferred?: boolean;
  /**
   * Whether to omit the written essay step. Distinct from `isReferred` so the
   * two can diverge later without a contract change; today it tracks it.
   *
   */
  skipEssay?: boolean;
  /**
   * The LinkedIn URL captured with the nomination, when one was supplied.
   * Also merged into `questionnaire.linkedinUrl` when the applicant has not
   * entered one themselves, so an existing answer is never overwritten.
   *
   */
  prefillLinkedinUrl?: string;
};

/**
 * Enrollment application questionnaire. All properties are optional to support draft state.
 */
export type EducatorEnrollmentApplicationQuestionnaire = {
  /**
   * Applicant's full name
   */
  fullName?: string;
  /**
   * LinkedIn profile URL
   */
  linkedinUrl?: string;
  /**
   * See `EducatorEmploymentStatus` for available values
   */
  employmentStatus?: string;
  /**
   * Current job title
   */
  currentTitle?: string;
  /**
   * Current company name
   */
  currentCompany?: string;
  /**
   * Degree being pursued, asked only when employmentStatus is student
   */
  degree?: string;
  /**
   * Major or field of study, asked only when employmentStatus is student
   */
  major?: string;
  /**
   * College or university attended, asked only when employmentStatus is student
   */
  collegeOrUniversity?: string;
  /**
   * Most recent job title, asked only when employmentStatus is notCurrentlyWorking
   */
  pastTitle?: string;
  /**
   * Most recent company, asked only when employmentStatus is notCurrentlyWorking
   */
  pastCompany?: string;
  /**
   * See `EducatorRoleEndedRange` for available values
   */
  pastRoleEnded?: string;
  /**
   * Optional. See `EducatorApplyReason` for available values
   */
  applyReason?: string;
  /**
   * Free-text reason, asked only when applyReason is other
   */
  applyReasonOther?: string;
  /**
   * See `EducatorYearsOfExperience` for available values
   */
  yearsOfExperience?: string;
  /**
   * Timezone in GMT format
   */
  timezone?: string;
  /**
   * Optional US phone number provided for SMS marketing consent
   */
  phoneNumber?: string;
};

/**
 * Request to create a new enrollment application
 */
export type CreateEducatorEnrollmentApplicationRequest = {
  /**
   * Initial status. See `EducatorApplicationWriteStatus` for available values.
   */
  status?: string;
  questionnaire?: EducatorEnrollmentApplicationQuestionnaire;
  /**
   * The ID of the intended cohort
   */
  cohortId?: string;
  /**
   * Free-form metadata associated with the application
   */
  metadata?: {
    [key: string]: unknown;
  };
};

/**
 * Request to update an enrollment application
 */
export type UpdateEducatorEnrollmentApplicationRequest = {
  /**
   * Updated status. See `EducatorApplicationWriteStatus` for available values.
   */
  status?: string;
  questionnaire?: EducatorEnrollmentApplicationQuestionnaire;
  /**
   * The ID of the intended cohort
   */
  cohortId?: string;
  /**
   * Applicant's written submission for the enrollment application. Limited to 400 words. Only persisted when the written submission feature flag is enabled for the user; otherwise ignored by the server.
   *
   */
  writtenSubmission?: string;
  /**
   * The prompt text the applicant was shown when writing their written submission, stored verbatim. Limited to 1000 characters. Only persisted alongside `writtenSubmission`.
   *
   */
  writtenSubmissionPrompt?: string;
  /**
   * Free-form metadata associated with the application
   */
  metadata?: {
    [key: string]: unknown;
  };
};

export type EducatorErrorResponse = {
  error?: {
    /**
     * The error code specific to the API endpoint
     */
    code?: string;
    /**
     * Human-readable error message
     */
    message?: string;
  };
};

export type EducatorSessionTokenResponse = {
  /**
   * The Educator access token (a JWT).
   */
  accessToken: string;
  /**
   * When the access token expires.
   */
  expiresAt: string;
};

export type EducatorUserRegistrationRequest = {
  /**
   * The user's email address.
   */
  email: string;
  /**
   * OAuth response type. Must be "code".
   */
  responseType: string;
  /**
   * The educator OAuth application's client ID.
   */
  clientId: string;
  /**
   * The redirect URI registered for the educator OAuth application.
   */
  redirectUri: string;
  /**
   * Optional GDPR marketing consent. When provided, updates the user's GDPR setting.
   */
  gdprOptIn?: boolean;
};

export type EducatorUserRegistrationResponse = {
  /**
   * OAuth authorization code to exchange for tokens via POST /oauth/token
   */
  authorizationCode?: string;
  /**
   * Authorization code expiry time in seconds
   */
  expiresIn?: number;
};

/**
 * Authentication method used for registration
 */
export type EducatorAuthMethod = "email" | "google" | "apple" | "facebook";

export const EducatorAuthMethod =
  /**
   * Authentication method used for registration
   */
  {
    EMAIL: "email",
    GOOGLE: "google",
    APPLE: "apple",
    FACEBOOK: "facebook",
  } as const;

export type EducatorRegistrationCompletedRequest = {
  /**
   * The visit session identifier from the frontend tracking system (validated as required by endpoint)
   */
  visitSessionId?: string;
  /**
   * Client's indication of whether this is a newly created user (validated as required by endpoint).
   * Server validates against account creation time - only true if created within 5 minutes.
   *
   */
  isNewUser?: boolean;
  /**
   * Optional key-value metadata to include in the Segment event properties
   */
  metadata?: {
    [key: string]: string;
  };
};

/**
 * Confirmation that registration event was successfully tracked
 */
export type EducatorRegistrationCompletedResponse = {
  /**
   * Whether the event was successfully tracked
   */
  success?: boolean;
  /**
   * Human-readable status message
   */
  message?: string;
  /**
   * Processed event data showing what the server inferred and validated
   */
  data?: {
    /**
     * Authentication method inferred by server from user's authentication records. See `EducatorAuthMethod` for possible values.
     */
    authMethod?: string;
    /**
     * Validated new user status after server-side check (true only if account created within last 5 minutes)
     */
    isNewUser?: boolean;
  };
};

/**
 * Error codes specific to the payment details endpoint
 */
export type EducatorPaymentDetailsErrorCode =
  | "enrollment_application_not_found"
  | "enrollment_application_not_eligible"
  | "cohort_not_found"
  | "product_not_configured"
  | "pricing_not_found"
  | "invalid_plan_type";

export const EducatorPaymentDetailsErrorCode =
  /**
   * Error codes specific to the payment details endpoint
   */
  {
    ENROLLMENT_APPLICATION_NOT_FOUND: "enrollment_application_not_found",
    ENROLLMENT_APPLICATION_NOT_ELIGIBLE: "enrollment_application_not_eligible",
    COHORT_NOT_FOUND: "cohort_not_found",
    PRODUCT_NOT_CONFIGURED: "product_not_configured",
    PRICING_NOT_FOUND: "pricing_not_found",
    INVALID_PLAN_TYPE: "invalid_plan_type",
  } as const;

/**
 * Payment breakdown for the selected plan. All text values are pre-formatted for display.
 */
export type EducatorPaymentDetailsResponse = {
  /**
   * See `EducatorPaymentPlanType` for available values
   */
  planType?: string;
  amountChargedNow?: EducatorAmountChargedNow;
  /**
   * Future installments after the initial charge. Empty for full payment.
   */
  pendingInstallments?: Array<EducatorPendingInstallment>;
  programPrice?: EducatorProgramPrice;
  boothOffer?: EducatorPaymentPlansBoothOffer;
  /**
   * Analytics data for tracking. Do not use for application logic.
   */
  analytics?: {
    [key: string]: string;
  };
};

/**
 * The full program price for the selected plan, across all installments. Omitted on the
 * retry response for a missed installment.
 *
 */
export type EducatorProgramPrice = {
  /**
   * Pre-formatted display text
   */
  text?: {
    /**
     * Formatted currency amount
     */
    amount?: string;
  };
};

/**
 * The amount to be charged immediately upon order placement
 */
export type EducatorAmountChargedNow = {
  /**
   * Pre-formatted display text
   */
  text?: {
    /**
     * Display label for the charge
     */
    label?: string;
    /**
     * Formatted currency amount
     */
    amount?: string;
    /**
     * Tax disclaimer text
     */
    taxNote?: string;
  };
};

/**
 * A future installment payment that will be charged after enrollment
 */
export type EducatorPendingInstallment = {
  /**
   * Pre-formatted display text
   */
  text?: {
    /**
     * Installment display label
     */
    label?: string;
    /**
     * Formatted due date
     */
    dueDate?: string;
    /**
     * Formatted currency amount
     */
    amount?: string;
  };
};

/**
 * The free Booth ticket offer for this cohort. Omitted when the cohort has no in-person
 * event with a free ticket coupon. When `eligibleForDiscount` is true, the member's
 * ticket is free, and the client sends `productId` back with the payment.
 *
 */
export type EducatorPaymentPlansBoothOffer = {
  /**
   * True when the event's free ticket coupon is redeemable for this member
   */
  eligibleForDiscount?: boolean;
  /**
   * The Booth ticket product
   */
  productId?: number;
  /**
   * The ticket price in US dollars, formatted for display. Omitted when the ticket has
   * no US price.
   *
   */
  text?: {
    /**
     * The ticket's price before the discount
     */
    listPrice?: string;
    /**
     * What the member pays for the ticket, in the same currency
     */
    offerPrice?: string;
  };
};

/**
 * A payment plan option available for the learner's enrollment application
 */
export type EducatorPaymentPlan = {
  /**
   * See `EducatorPaymentPlanType` for available values
   */
  planType?: string;
  /**
   * Total price across all installments in minor currency units (cents)
   */
  price?: number;
  /**
   * ISO 4217 currency code for all price values in this plan
   */
  currency?: string;
  text?: {
    /**
     * Display title for this plan shown on the payment selection page
     */
    title?: string;
    /**
     * Pre-formatted summary of the payment schedule. The client renders this as-is — no formatting logic required.
     */
    details?: string;
    /**
     * Pre-formatted total price across all installments (the same amount as `price`,
     * localized for display). The client renders this as-is — no formatting logic required.
     *
     */
    total?: string;
  };
  /**
   * Plan-specific analytics data for tracking. Merge with root-level analytics before sending to Segment.
   */
  analytics?: {
    [key: string]: string;
  };
};

/**
 * Response containing all available payment plans for the enrollment application
 */
export type EducatorPaymentPlansResponse = {
  /**
   * Pre-formatted display text
   */
  text?: {
    /**
     * Name of the cohort this applicant is actually paying into — resolved from
     * the same cohort as the pricing on this response, so display copy can never
     * disagree with what is charged.
     *
     * The name already contains the word "Cohort" (e.g. `Fall '26 Cohort`), so
     * clients render it as-is and must not append the noun.
     *
     */
    cohortName?: string;
  };
  /**
   * The plan type the client should pre-select on load. Controlled by the backend
   * so the default can change without a client release. See `EducatorPaymentPlanType`
   * for available values.
   *
   */
  selectedPlanType?: string;
  /**
   * Available payment plan options, ordered by number of installments descending,
   * with the pay-in-full option last.
   *
   */
  items?: Array<EducatorPaymentPlan>;
  /**
   * Info banner about payment deadline. Omitted when no deadline applies —
   * present only when the current date is within 7 days of the application approval date
   * (days 1–7 inclusive). Omitted on day 8 and beyond, or when approvedAt is not set.
   *
   */
  spotNoticeBanner?: {
    text?: {
      /**
       * Pre-formatted banner message
       */
      message?: string;
    };
  };
  /**
   * Markdown message strings for the payment screen, taken from the enrollment
   * window active today on the accepting cohort, in render order. Empty when no
   * window is active. The {dayOrDate} placeholder is already substituted
   * server-side; the client renders each string as-is (markdown).
   *
   */
  paymentScreenMessages?: Array<string>;
  /**
   * The enrollment window active today on the accepting cohort, resolved from the
   * same window as `paymentScreenMessages`. Drives the payment-screen banner style
   * (yellow for active windows, pink for `closed`). See `EducatorEnrollmentWindowType`
   * for the possible values. Omitted when no window is active.
   *
   */
  windowType?: string;
  boothOffer?: EducatorPaymentPlansBoothOffer;
  /**
   * Common analytics data shared across all plans. The client should merge this with each plan's analytics before sending to Segment.
   */
  analytics?: {
    [key: string]: string;
  };
};

/**
 * Identifies which screen layout the client should render. The server determines this from the enrollment application status and installment payment states.
 *
 */
export type EducatorEnrollmentScreenVariant =
  | "application_tracker"
  | "rejected"
  | "accepted"
  | "missed_kira_deadline"
  | "missed_payment_deadline"
  | "payment_complete"
  | "enrollment_confirmed"
  | "payment_failed"
  | "access_suspended"
  | "withdrawn"
  | "removed";

export const EducatorEnrollmentScreenVariant =
  /**
   * Identifies which screen layout the client should render. The server determines this from the enrollment application status and installment payment states.
   *
   */
  {
    APPLICATION_TRACKER: "application_tracker",
    REJECTED: "rejected",
    ACCEPTED: "accepted",
    MISSED_KIRA_DEADLINE: "missed_kira_deadline",
    MISSED_PAYMENT_DEADLINE: "missed_payment_deadline",
    PAYMENT_COMPLETE: "payment_complete",
    ENROLLMENT_CONFIRMED: "enrollment_confirmed",
    PAYMENT_FAILED: "payment_failed",
    ACCESS_SUSPENDED: "access_suspended",
    WITHDRAWN: "withdrawn",
    REMOVED: "removed",
  } as const;

/**
 * Severity level for banners and notices
 */
export type EducatorEnrollmentStatusAlertSeverity =
  | "info"
  | "success"
  | "warning"
  | "error";

export const EducatorEnrollmentStatusAlertSeverity =
  /**
   * Severity level for banners and notices
   */
  {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
  } as const;

/**
 * A webinar shown on the enrollment status page.
 */
export type EducatorWebinar = {
  id?: string;
  /**
   * Free-text webinar type/format.
   */
  type?: string;
  /**
   * Webinar start time (UTC; authored in PT).
   */
  startsAt?: string;
  /**
   * Start time for display in US Pacific, e.g. "Thursday, March 24, 4:30 PM PT".
   */
  startsAtLabel?: string;
  /**
   * "This Week" / "Next Week" for the current or following calendar week (US Pacific); null when further out.
   */
  weekLabel?: string | null;
  title?: string;
  instructor?: string | null;
  host?: string | null;
  /**
   * External URL the CTA opens (a registration page or a recording).
   */
  registrationUrl?: string;
  /**
   * Whether registrationUrl is a recording/video link rather than a registration page.
   */
  isRecording?: boolean;
  desktopImage?: EducatorImageResource;
  mobileImage?: EducatorImageResource;
};

/**
 * Enrollment status page data. The response shape varies by state —
 * the client renders whatever fields are present and hides what is null.
 *
 */
export type EducatorEnrollmentStatusResponse = {
  /**
   * See `EducatorEnrollmentScreenVariant` for values
   */
  screenVariant?: string;
  /**
   * Page title and description text
   */
  text?: {
    /**
     * Page title
     */
    title?: string;
    /**
     * Page description text
     */
    description?: string;
  };
  /**
   * Hero artwork for the screen (present on confirmed and accepted screens when the cohort has an image)
   */
  images?: {
    hero?: EducatorImageResource;
  };
  banner?: EducatorEnrollmentStatusBanner;
  notice?: EducatorEnrollmentStatusNotice;
  /**
   * Pending installments. Empty array when none.
   */
  installments?: Array<EducatorEnrollmentStatusInstallment>;
  /**
   * The user's paid MasterClass Executive receipts, newest-first, for the Invoices card (each row has a per-row download via its payment_id). Distinct from `installments`, which is the upcoming payment schedule. Empty array when none.
   */
  receipts?: Array<EducatorReceiptListItem>;
  /**
   * Published, upcoming webinars the applicant/member is eligible for — visible-to-all plus their cohort's webinars matched to admission status — soonest-first. Capped at three: up to two registrations plus the soonest recording; three registrations when no recording is eligible; a single recording when no registration is. Empty array when none.
   */
  webinars?: Array<EducatorWebinar>;
  savedCard?: EducatorSavedCard;
  /**
   * Call-to-action buttons. Null when no actions available.
   */
  ctas?: {
    primary?: EducatorEnrollmentStatusCta;
    secondary?: EducatorEnrollmentStatusCta;
  };
  /**
   * Application progress steps for the step tracker UI. Each step has a computed status (completed/current/pending). Empty array when the step tracker is not applicable (post-payment, rejected, etc.).
   *
   */
  applicationSteps?: Array<EducatorApplicationStep>;
  /**
   * Markdown message strings for the landing-page banner, taken from the enrollment
   * window active today on the accepting cohort (the `lpBanner` spot), in render
   * order. Empty when no window is active. The {dayOrDate} placeholder is already
   * substituted server-side; the client renders each string as-is (markdown).
   *
   */
  bannerMessages?: Array<string>;
  /**
   * Pre-formatted "Month Day" date (e.g. "August 14") by which the applicant can expect
   * an enrollment decision — 10 days after the close of the enrollment window they fell
   * into at submission. Derived live from that window, so it reflects admin edits to the
   * window's close date. Present only while the application is under review; omitted
   * otherwise.
   *
   */
  expectedDecisionDate?: string;
  celebration?: EducatorEnrollmentCelebration;
  /**
   * Analytics data for tracking. Do not use for application logic.
   */
  analytics?: {
    [key: string]: string;
  };
};

/**
 * Copy for the acceptance celebration shown once to an admitted applicant on the checkout screen. Present only on the `accepted` screen variant; omitted otherwise.
 *
 */
export type EducatorEnrollmentCelebration = {
  /**
   * Total number of applications submitted to MasterClass Executive to date.
   */
  applicantCount: number;
  /**
   * One line grounded in the applicant's own essay, generated at essay submission and editable by admins. Falls back to a generic line when no personalized one is available (no essay, thin essay, or sensitivity-flagged).
   *
   */
  highlight: string;
};

/**
 * Full-width top-of-page banner for critical alerts (e.g., access suspension).
 * Null when not needed.
 *
 */
export type EducatorEnrollmentStatusBanner = {
  /**
   * See `EducatorEnrollmentStatusAlertSeverity` for values
   */
  severity?: string;
  text?: {
    /**
     * Banner message text
     */
    message?: string;
  };
};

/**
 * Inline card/notice in the content area for info, success, and warning messages.
 * Null when not needed.
 *
 */
export type EducatorEnrollmentStatusNotice = {
  /**
   * See `EducatorEnrollmentStatusAlertSeverity` for values
   */
  severity?: string;
  text?: {
    /**
     * Bold title text
     */
    title?: string;
    /**
     * Description text
     */
    message?: string;
  };
};

/**
 * A pending installment payment
 */
export type EducatorEnrollmentStatusInstallment = {
  text?: {
    /**
     * Installment label
     */
    label?: string;
    /**
     * Formatted currency amount
     */
    amount?: string;
    /**
     * Auto-charge date description
     */
    description?: string;
  };
};

/**
 * Call-to-action button
 */
export type EducatorEnrollmentStatusCta = {
  /**
   * Button display text
   */
  label?: string;
  /**
   * Destination URL (relative path with query params)
   */
  url?: string;
  analytics?: {
    [key: string]: string;
  };
};

/**
 * Visual state of an application step in the progress tracker
 */
export type EducatorApplicationStepStatus = "completed" | "current" | "pending";

export const EducatorApplicationStepStatus =
  /**
   * Visual state of an application step in the progress tracker
   */
  {
    COMPLETED: "completed",
    CURRENT: "current",
    PENDING: "pending",
  } as const;

/**
 * A single step in the application progress tracker
 */
export type EducatorApplicationStep = {
  /**
   * Display order of this step (1-indexed)
   */
  sequence?: number;
  /**
   * See `EducatorApplicationStepStatus` for values
   */
  status?: string;
  /**
   * Display text for this step
   */
  text?: {
    /**
     * Step title
     */
    title?: string;
    /**
     * Step description (only present for the current step)
     */
    description?: string;
  };
  /**
   * Step images (only present for the current step)
   */
  images?: {
    hero?: EducatorImageResource;
  };
  /**
   * Kira check-in URL for the video application step (JAR-962). Only present when the application is in pendingChallengeCompletion status and the Kira applicant.created webhook has been received. Null in all other cases.
   *
   */
  kiraCheckInUrl?: string | null;
  /**
   * Call-to-action buttons for this step. Only present when the step is current and a CTA applies (e.g., written-submission flow).
   */
  ctas?: {
    primary?: EducatorEnrollmentStatusCta;
  };
  /**
   * True when the applicant has already supplied a LinkedIn URL on their enrollment application questionnaire. Drives the written-submission modal's decision to skip its LinkedIn input.
   * Contract: present on the written-submission step only, and always a boolean (`true` or `false`) when present — never null, never absent on that step. Omitted entirely from all other steps; consumers should not look for it elsewhere.
   *
   */
  hasLinkedinUrl?: boolean;
};

/**
 * Image with accessibility metadata
 */
export type EducatorImageResource = {
  /**
   * Image URL
   */
  url?: string;
  /**
   * Image width in pixels
   */
  width?: number;
  /**
   * Image height in pixels
   */
  height?: number;
  /**
   * Alt text for accessibility. Empty string for decorative images.
   */
  altText?: string;
};

/**
 * A single row in the MasterClass Executive receipts list.
 */
export type EducatorReceiptListItem = {
  /**
   * The Payment id (as a string) used to build the download link.
   */
  paymentId: string;
  /**
   * The calendar day the payment was made, as an ISO 8601 date (no time or offset). Date-only so it can't shift a day across time zones and always matches the day printed on the invoice PDF. The client formats it.
   */
  date: string;
  /**
   * Customer-facing summary. A payment that settled several installments in one charge (lump-sum grace retry) is labeled with the range (e.g. "Installments 2–3 of 3").
   */
  description: string;
  /**
   * Pre-formatted localized total charged for the payment.
   */
  total: string;
  /**
   * 1-based index of this installment in the payment plan. For a lump-sum retry that settled several installments, this is the first installment in the range (the range is spelled out in `description`). Null when the plan can't be resolved from the Payment.
   */
  installmentIndex?: number | null;
  /**
   * Total number of installments in the payment plan. Null when the plan can't be resolved from the Payment.
   */
  installmentCount?: number | null;
  /**
   * Name of the cohort the enrollment belongs to. Null when the cohort can't be resolved from the Payment.
   */
  cohortName?: string | null;
};

/**
 * Card on file for the installment schedule. Null when no schedule, no resolvable CreditCard, or a Link method.
 */
export type EducatorSavedCard = {
  /**
   * Card brand. Client handles display casing.
   */
  brand?: string;
  /**
   * Zero-padded 4-digit string (preserves leading zeros).
   */
  lastFour?: string;
} | null;

/**
 * Error codes for the payment order endpoint
 */
export type EducatorPaymentOrderErrorCode =
  | "enrollment_application_not_found"
  | "enrollment_application_not_eligible"
  | "cohort_not_found"
  | "product_not_configured"
  | "pricing_not_found"
  | "invalid_plan_type"
  | "payment_failed"
  | "payment_method_invalid"
  | "stripe_error"
  | "tax_calculation_failed"
  | "order_processing_failed"
  | "payment_plan_failed"
  | "requires_authentication";

export const EducatorPaymentOrderErrorCode =
  /**
   * Error codes for the payment order endpoint
   */
  {
    ENROLLMENT_APPLICATION_NOT_FOUND: "enrollment_application_not_found",
    ENROLLMENT_APPLICATION_NOT_ELIGIBLE: "enrollment_application_not_eligible",
    COHORT_NOT_FOUND: "cohort_not_found",
    PRODUCT_NOT_CONFIGURED: "product_not_configured",
    PRICING_NOT_FOUND: "pricing_not_found",
    INVALID_PLAN_TYPE: "invalid_plan_type",
    PAYMENT_FAILED: "payment_failed",
    PAYMENT_METHOD_INVALID: "payment_method_invalid",
    STRIPE_ERROR: "stripe_error",
    TAX_CALCULATION_FAILED: "tax_calculation_failed",
    ORDER_PROCESSING_FAILED: "order_processing_failed",
    PAYMENT_PLAN_FAILED: "payment_plan_failed",
    REQUIRES_AUTHENTICATION: "requires_authentication",
  } as const;

/**
 * Actions the client must perform to complete the payment
 */
export type EducatorPaymentOrderAction = "verify_payment";

export const EducatorPaymentOrderAction =
  /**
   * Actions the client must perform to complete the payment
   */
  {
    VERIFY_PAYMENT: "verify_payment",
  } as const;

/**
 * Error response for payment order failures. When `error.code` is `requiresAuthentication`, the `requiresAction` block is present.
 */
export type EducatorPaymentOrderErrorResponse = {
  error?: {
    /**
     * See `EducatorPaymentOrderErrorCode` for values
     */
    code?: string;
    /**
     * Human-readable error message
     */
    message?: string;
  };
  /**
   * Present when the payment requires additional client action
   */
  requiresAction?: {
    /**
     * See `EducatorPaymentOrderAction` for values
     */
    action?: string;
    /**
     * URL for the payment verification challenge
     */
    redirectUrl?: string;
    /**
     * Stripe PaymentIntent ID to send back on the confirm endpoint
     */
    paymentIntentId?: string;
  };
};

/**
 * Request to process an educator enrollment payment
 */
export type EducatorPaymentOrderRequest = {
  /**
   * See `EducatorPaymentPlanType` for available values
   */
  planType?: string;
  /**
   * Stripe payment method token from the frontend
   */
  paymentMethodId?: string;
  /**
   * Geo region info from the CloudFlare worker, used for tax calculation
   */
  regionInfo?: {
    /**
     * State or province subdivision code (e.g. CA, ON, RI)
     */
    regionCode?: string;
    /**
     * Postal/zip code for US tax calculation. Fallback when Stripe PM billing details are unavailable.
     */
    postalCode?: string;
  };
  /**
   * Optional key-value metadata for analytics tracking (fbc, fbp, etc.)
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Product id from the payment plans `boothOffer`. When present, the member's free
   * Booth ticket is placed after the payment succeeds, on the direct and the 3D Secure path.
   *
   */
  boothProductId?: number;
};

/**
 * Response after successfully processing a payment order
 */
export type EducatorPaymentOrderResponse = {
  /**
   * Result of the payment order
   */
  status?: string;
  /**
   * Analytics data for tracking. Do not use for application logic.
   */
  analytics?: {
    [key: string]: string;
  };
};

/**
 * Total price for the educator product. All text values are pre-formatted for display.
 * Examples: "$2,500" for US, "C$5,342" for Canada.
 *
 */
export type EducatorProductPriceResponse = {
  /**
   * Pre-formatted display text
   */
  text?: {
    /**
     * Formatted total price including currency symbol and locale-appropriate formatting
     */
    totalPrice?: string;
    /**
     * ISO 4217 currency code
     */
    currencyCode?: string;
  };
  /**
   * Analytics data for tracking. Do not use for application logic.
   */
  analytics?: {
    [key: string]: string;
  };
};

/**
 * Request to confirm a payment after 3DS authentication
 */
export type EducatorPaymentConfirmRequest = {
  /**
   * Stripe PaymentIntent ID received from the payment-order endpoint
   */
  paymentIntentId?: string;
  /**
   * Optional key-value metadata for analytics tracking (fbc, fbp, etc.)
   */
  metadata?: {
    [key: string]: string;
  };
};

/**
 * Response after successfully confirming a payment
 */
export type EducatorPaymentConfirmResponse = {
  /**
   * Result of the payment confirmation
   */
  status?: string;
  /**
   * Analytics data for tracking. Do not use for application logic.
   */
  analytics?: {
    [key: string]: string;
  };
};

/**
 * Available seat count for the active cohort.
 */
export type EducatorAvailableSeatsResponse = {
  /**
   * Pre-formatted display text
   */
  text?: {
    /**
     * Number of remaining seats, as a string .
     */
    availableSeats?: string;
    /**
     * Name of the active cohort.
     */
    cohortName?: string;
  };
  /**
   * Analytics data for tracking. Do not use for application logic.
   */
  analytics?: {
    [key: string]: string;
  };
};

/**
 * High-level enrollment state for the landing page. Lets clients drive UI changes.
 */
export type EducatorCohortDetailsState = "bau" | "closed";

export const EducatorCohortDetailsState =
  /**
   * High-level enrollment state for the landing page. Lets clients drive UI changes.
   */
  {
    BAU: "bau",
    CLOSED: "closed",
  } as const;

/**
 * Granular enrollment funnel phase. Maps directly to the active step in the enrollment process.
 */
export type EducatorCohortEnrollmentPhase =
  | "applications"
  | "challenge_submissions"
  | "payments"
  | "closed";

export const EducatorCohortEnrollmentPhase =
  /**
   * Granular enrollment funnel phase. Maps directly to the active step in the enrollment process.
   */
  {
    APPLICATIONS: "applications",
    CHALLENGE_SUBMISSIONS: "challenge_submissions",
    PAYMENTS: "payments",
    CLOSED: "closed",
  } as const;

/**
 * Landing page cohort data. All text values are pre-formatted for display.
 * Fields are nullable depending on the current enrollment state.
 *
 */
export type EducatorCohortDetailsResponse = {
  /**
   * See `EducatorCohortDetailsState` for values.
   */
  state: string;
  /**
   * Whether the signed-in viewer may still apply after the cohort has closed —
   * true only for a Fast Track Referral nominee. Always false for anonymous
   * callers, since it is resolved from the bearer token.
   *
   * Read this alongside `state`: a closed cohort with this set must not be
   * routed to the waitlist. `state` itself is unchanged for these viewers, so
   * CTAs keep describing the cohort as closed.
   *
   */
  viewerBypassesClose?: boolean;
  /**
   * See `EducatorCohortEnrollmentPhase` for values.
   */
  enrollmentPhase?: string;
  /**
   * Available seats data. Null when enrollment is closed.
   */
  seats?: {
    text?: {
      /**
       * Number of remaining seats formatted as a string.
       */
      availableSeats?: string;
      /**
       * Name of the active cohort.
       */
      cohortName?: string;
    };
  } | null;
  /**
   * Cohort price data. Null when enrollment is closed.
   */
  price?: {
    text?: {
      /**
       * Formatted total price including currency symbol.
       */
      totalPrice?: string;
      /**
       * ISO 4217 currency code.
       */
      currencyCode?: string;
    };
  } | null;
  /**
   * Tracking data. Do not use for application logic.
   */
  analytics?: {
    [key: string]: string;
  };
  /**
   * Active cohort's enrollment deadline, formatted as month and
   * zero-padded day with no year. Null when no active cohort exists.
   *
   */
  applicationDeadline?: string | null;
  /**
   * Active cohort's program start date with month, unpadded day and year.
   * Null when no active cohort exists.
   *
   */
  programStartDate?: string | null;
  /**
   * Name of the cohort driving the landing page: the accepting cohort while
   * enrollment is open, or the cohort that just closed in the `closed`
   * state. Unlike `seats.text.cohortName`, this stays populated
   * after enrollment closes, and a trailing "Cohort" is stripped so the client
   * can append its own noun. Null when no cohort is resolved.
   *
   */
  currentCohortName?: string | null;
  /**
   * Name of the next upcoming cohort: the nearest active cohort whose program
   * starts after `currentCohortName`'s, with a trailing "Cohort" stripped.
   * Null when none is scheduled yet.
   *
   */
  nextCohortName?: string | null;
  /**
   * Cohort imagery for the landing page. Present only when the accepting
   * cohort has artwork set; omitted otherwise.
   *
   */
  images?: {
    hero?: EducatorImageResource;
  };
  /**
   * Every enrollment window configured on the active cohort, in chronological order,
   * with its schedule (dates only). Empty when the cohort has no windows.
   *
   */
  enrollmentWindows?: Array<EducatorEnrollmentWindow>;
  currentWindow?: EducatorEnrollmentWindowMessages;
};

/**
 * A single enrollment window on the active cohort, with its schedule. Dates only —
 * messaging for the window active today is carried separately by `currentWindow`
 * (see `EducatorEnrollmentWindowMessages`).
 *
 */
export type EducatorEnrollmentWindow = {
  /**
   * The predefined enrollment window. See `EducatorEnrollmentWindowType` for values.
   *
   */
  windowType?: string;
  /**
   * Human-readable window name.
   */
  name?: string;
  /**
   * When the window opens.
   */
  startsAt?: string;
  /**
   * When the window closes (inclusive, end-of-day).
   */
  endsAt?: string;
  /**
   * `endsAt` formatted for display in Pacific Time as inclusive end-of-day,
   * e.g. "September 24, 2026 at 11:59 PM Pacific Time.". Null when `ends_at` is blank.
   *
   */
  endsAtDisplay?: string | null;
};

/**
 * Messaging for the enrollment window active today, resolved server-side from the
 * admin-configured windows on the active cohort. Null when no window is active.
 * Display strings are grouped under `text`; each spot holds an ordered array of
 * message strings the client renders stacked.
 *
 */
export type EducatorEnrollmentWindowMessages = {
  /**
   * The predefined enrollment window currently active. See
   * `EducatorEnrollmentWindowType` for the possible values.
   *
   */
  windowType?: string;
  /**
   * When the window opens.
   */
  startsAt?: string;
  /**
   * When the window closes (inclusive, end-of-day).
   */
  endsAt?: string;
  /**
   * Pre-formatted display strings for the active window.
   */
  text?: {
    /**
     * Human-readable window name.
     */
    name?: string;
    /**
     * Markdown message strings grouped by display spot, in render order. Each
     * spot is an ordered array of strings the client renders stacked; the
     * {dayOrDate} placeholder is already substituted server-side.
     *
     */
    messages?: {
      lpBanner?: Array<string>;
      paymentScreen?: Array<string>;
    };
  };
};

/**
 * Ordered, visible section slugs per layout. Each array is already sorted by display order
 * and contains only the sections an admin has marked visible.
 *
 */
export type EducatorSectionLayoutResponse = {
  /**
   * Visible landing-page section slugs, in display order.
   */
  landingPage: Array<string>;
  /**
   * Visible content section slugs, in display order. Reserved for a future content-ordering
   * surface — currently always empty.
   *
   */
  content: Array<string>;
};

/**
 * OAuth provider identifier.
 */
export type EducatorOauthProvider = "google" | "facebook" | "apple";

export const EducatorOauthProvider =
  /**
   * OAuth provider identifier.
   */
  {
    GOOGLE: "google",
    FACEBOOK: "facebook",
    APPLE: "apple",
  } as const;

/**
 * Drives which payment status layout the client renders.
 */
export type EducatorAccountPaymentStatusVariant =
  | "pending_installments"
  | "payment_complete"
  | "payment_failed";

export const EducatorAccountPaymentStatusVariant =
  /**
   * Drives which payment status layout the client renders.
   */
  {
    PENDING_INSTALLMENTS: "pending_installments",
    PAYMENT_COMPLETE: "payment_complete",
    PAYMENT_FAILED: "payment_failed",
  } as const;

/**
 * Severity level for payment status notices.
 */
export type EducatorAccountNoticeSeverity = "success" | "warning";

export const EducatorAccountNoticeSeverity =
  /**
   * Severity level for payment status notices.
   */
  {
    SUCCESS: "success",
    WARNING: "warning",
  } as const;

/**
 * Account tab data. The client renders whatever sections are present
 * and hides what is null.
 *
 */
export type EducatorAccountResponse = {
  /**
   * User's full display name. Pre-formatted for rendering.
   */
  name: string;
  /**
   * User's email address. Read-only in the UI.
   */
  email: string;
  /**
   * True if the user has a password identity (email + password login).
   */
  passwordSet: boolean;
  /**
   * The educator program the user is enrolled in, used to address the certificate endpoints under `/api/v3/educator/programs/{programUuid}/certificate`. Null when the user has no enrollment. Carries no certificate data itself — the certificate state is read from the certificate endpoint.
   */
  programUuid?: string | null;
  connectedAccount?: EducatorConnectedAccount;
  paymentStatus?: EducatorAccountPaymentStatus;
  savedCard?: EducatorSavedCard;
  /**
   * Analytics data for tracking.
   */
  analytics?: {
    [key: string]: string;
  };
  /**
   * The user's MasterClass Executive receipts, newest-first, for the Invoices card (each row has a per-row download via its payment_id). Empty array when none.
   */
  receipts?: Array<EducatorReceiptListItem>;
};

/**
 * The OAuth provider linked to the user's account. Null when the user
 * has no connected OAuth provider. At most one provider at a time.
 *
 */
export type EducatorConnectedAccount = {
  /**
   * OAuth provider identifier. Used by the client to render the provider icon. See `EducatorOauthProvider` for values.
   */
  provider: string;
  text: {
    /**
     * Status label rendered next to the provider icon.
     */
    connectedLabel: string;
    /**
     * Instructional message rendered below the connected account row.
     * The client renders `supportEmail` as a mailto link inline within this message.
     *
     */
    supportMessage: string;
    /**
     * Support email rendered as a clickable mailto link at the end of `supportMessage`.
     */
    supportEmail: string;
  };
} | null;

/**
 * Installment payment status section. Null when the user has no enrollment
 * application — the section is not rendered.
 *
 * Status variants:
 * - `pendingInstallments`: Enrollment confirmed. Upcoming installments listed.
 * No notice. CTA to proactively change the payment method present.
 * - `paymentComplete`: All payments received. Success notice shown.
 * No installments list. No CTA.
 * - `paymentFailed`: A scheduled charge failed. Warning notice shown.
 * Outstanding installments listed. CTA to update payment method present.
 *
 */
export type EducatorAccountPaymentStatus = {
  /**
   * Drives which payment status layout the client renders. See `EducatorAccountPaymentStatusVariant` for values.
   */
  status?: string;
  /**
   * Identifier of the installment schedule this status describes. Present only in the `pendingInstallments` variant; omitted otherwise. Lets the change-payment-method flow pin its request to this schedule.
   */
  installmentScheduleId?: string;
  /**
   * Section text strings.
   */
  text?: {
    /**
     * Payment status section title.
     */
    title?: string;
  };
  /**
   * Inline notice card. Null for `pendingInstallments`.
   * Present for `paymentComplete` (success) and `paymentFailed` (warning).
   *
   */
  notice?: {
    /**
     * See `EducatorAccountNoticeSeverity` for values.
     */
    severity?: string;
    text?: {
      /**
       * Notice message. Pre-formatted for rendering.
       * - `paymentComplete`: "Payment complete. Your enrollment is confirmed."
       * - `paymentFailed`: "Error. We couldn't charge your card. Please update your payment method."
       *
       */
      message?: string;
    };
  } | null;
  /**
   * Installments section. Present for `pendingInstallments` and `paymentFailed`.
   * Null for `paymentComplete`.
   *
   */
  installments?: {
    text?: {
      /**
       * Label rendered above the installments list.
       */
      label?: string;
    };
    /**
     * Upcoming or overdue installments.
     */
    items?: Array<EducatorAccountInstallment>;
  } | null;
  /**
   * Call-to-action buttons. Null for `paymentComplete`.
   * - `pendingInstallments`: `changePaymentMethod` present (proactively update the payment method).
   * - `paymentFailed`: `payWithDifferentMethod` present (retry the failed charge with a new method).
   *
   */
  ctas?: {
    changePaymentMethod?: EducatorAccountCta;
    payWithDifferentMethod?: EducatorAccountCta;
  } | null;
} | null;

/**
 * A single installment entry in the payment status section.
 */
export type EducatorAccountInstallment = {
  text?: {
    /**
     * Installment identifier label.
     */
    label?: string;
    /**
     * Formatted currency amount.
     */
    amount?: string;
    /**
     * Scheduled charge date description. Pre-formatted for rendering.
     */
    description?: string;
  };
};

/**
 * A call-to-action button for the account tab.
 */
export type EducatorAccountCta = {
  text: {
    /**
     * CTA button label.
     */
    label: string;
  };
  /**
   * Destination URL (relative path).
   */
  url: string;
};

export type CreateEducatorWaitlistRequest = {
  /**
   * The visitor's email address
   */
  email: string;
  /**
   * The visitor's full name
   */
  fullName: string;
  /**
   * Whether the visitor consented to receive marketing communications (GDPR)
   */
  gdprOptIn: boolean;
  /**
   * Optional frontend visit session identifier
   */
  visitSessionId?: string;
};

export type CreateEducatorWaitlistResponse = {
  /**
   * Whether the signup was recorded successfully
   */
  success?: boolean;
};

export type AlexandriaContentList = {
  content: Array<AlexandriaContent>;
};

export type AlexandriaContent = {
  /**
   * Either `course` or `certificateProgram`.
   */
  contentType: string;
  contentId: number;
  /**
   * The course vanity name, or the certificate program course code (its slug when it has no course code).
   */
  vanityName: string;
  title: string;
  instructorNames: Array<string>;
  categories: Array<string>;
  videos: Array<AlexandriaContentVideo>;
};

export type AlexandriaContentVideo = {
  /**
   * The chapter id for a course, or the video id for a certificate program.
   */
  id: number;
  title: string;
  mediaUuid: string;
};

/**
 * include dependencies
 */
export type Parameterdeep = boolean;

export type Parameterplatform = "web";

export const Parameterplatform = {
  WEB: "web",
} as const;

/**
 * include additional dependencies
 */
export type Parameterinclude = string;

/**
 * include additional dependencies
 */
export type Parameterfilter = string;

/**
 * gift query param, determines whether we are sending a gift or not
 */
export type Parametergift = boolean;

/**
 * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
 */
export type ParameterdiscountSlug = string;

/**
 * UUID of the current Profile, used to filter response data to that Profile
 */
export type ParameterMCProfileId = string;

/**
 * Short lived token used for the playback urls by chromecast
 */
export type ParameterXPLAYBACKTOKEN = string;

export type GetBookmarksData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filter by given bookmarked entity id
   */
  filterBookmarkeeIds?: number;
  /**
   * Filter by given bookmarked entity type
   */
  filterBookmarkeeType?: string;
};

export type GetBookmarksResponse = Bookmarks;

export type CreateBookmarkData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Bookmark attributes
   */
  requestBody: CreateBookmarkAttributes;
};

export type CreateBookmarkResponse = Bookmark;

export type DeleteBookmarkData = {
  id: number;
};

export type DeleteBookmarkResponse = void;

export type GetSessionsData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * slug to be remove from response
   */
  excludedSlug?: string;
  /**
   * include hub dependencies
   */
  hub?: string;
};

export type GetSessionsResponse = SessionsResult;

export type GetSessionBySlugData = {
  /**
   * include dependencies
   */
  deep: boolean;
  /**
   * slug id
   */
  slug: string;
};

export type GetSessionBySlugResponse = SingleSessionResult;

export type GetSessionInteractionsData = {
  sessionUuid: string;
};

export type GetSessionInteractionsResponse = SessionsInteractions;

export type GetCategoriesResponse = CategoriesResult;

export type GetChaptersData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  filter?: {
    /**
     * specify a comma-separated list of ids to filter
     */
    id?: string;
  };
};

export type GetChaptersResponse = ChapterResult;

export type GetCoursesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  filter?: {
    tag?: string;
    /**
     * specify a comma-separated list of ids to filter
     */
    id?: string;
  };
};

export type GetCoursesResponse = CoursesResult;

export type GetCourseBySlugData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters courses by tag
   */
  filter?: {
    tag?: string;
  };
  /**
   * Course slug
   */
  slug: string;
};

export type GetCourseBySlugResponse = Course | CourseDeep;

export type GetCoursesContentGemsData = {
  /**
   * Course id
   */
  id: number;
};

export type GetCoursesContentGemsResponse = MobileContentGems;

export type GetContentRowsData = {
  pageSlug?: string;
  platform?: "web";
};

export type GetContentRowsResponse = ContentRows;

export type GetContentRowByIdData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Content row ID
   */
  id: number;
};

export type GetContentRowByIdResponse = ContentRow;

export type GetConversationsData = {
  /**
   * filters by course
   */
  filterCourseId?: number;
  /**
   * filters by client session
   */
  filterVisitSessionId?: string;
  /**
   * Sort by attribute
   */
  sort?: string;
};

export type GetConversationsResponse = Conversations;

export type CreateConversationData = {
  /**
   * Conversation attributes
   */
  requestBody: ConversationAttributes;
};

export type CreateConversationResponse = Conversation;

export type GetConversationIntroductionData = {
  /**
   * Current chapter
   */
  chapterId?: number;
  /**
   * Current course
   */
  courseId?: number;
};

export type GetConversationIntroductionResponse = ConversationIntroduction;

export type GetConversationData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  id: number;
};

export type GetConversationResponse = Conversation;

export type GetConversationMessagesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  id: number;
  /**
   * Page size
   */
  pageLimit?: number;
  /**
   * Page offset (multiple of page[limit])
   */
  pageOffset?: number;
  /**
   * Sort by id or -id
   */
  sort?: string;
};

export type GetConversationMessagesResponse = ConversationMessages;

export type CreateConversationMessageData = {
  id: number;
  /**
   * Message attributes
   */
  requestBody: ConversationMessageAttributes;
};

export type CreateConversationMessageResponse = ConversationMessage;

export type UpsertConversationMessageData = {
  id: number;
  /**
   * Message attributes
   */
  requestBody: ConversationMessageAttributes;
};

export type UpsertConversationMessageResponse = ConversationMessage;

export type GetConversationMessageData = {
  conversationId: number;
  /**
   * include dependencies
   */
  deep?: boolean;
  id: number;
};

export type GetConversationMessageResponse = ConversationMessage;

export type UpdateConversationMessageData = {
  conversationId: number;
  id: number;
  /**
   * Message update attributes
   */
  requestBody: ConversationMessageUpdateAttributes;
};

export type UpdateConversationMessageResponse = ConversationMessage;

export type CreateEmailConfirmationData = {
  /**
   * Context for the Email Confirmation
   */
  requestBody: EmailConfirmationAttributes;
};

export type CreateEmailConfirmationResponse = EmailConfirmation;

export type GetEmailConfirmationData = {
  /**
   * Token that references a specific Email Confirmation
   */
  token: string;
};

export type GetEmailConfirmationResponse = EmailConfirmation;

export type GetLegacyEmailConfirmationResponse = {
  confirmationStatus?: EmailConfirmationStatus;
  email?: string;
};

export type CreateLegacyEmailConfirmationData = {
  /**
   * Email confirmation attributes
   */
  requestBody: {
    emailConfirmation: EmailConfirmationLegacyAttributes;
  };
};

export type CreateLegacyEmailConfirmationResponse = {
  confirmationStatus?: string;
};

export type DownloadExampleCsvResponse = unknown;

export type GetEnterpriseSubscriptionsResponse = EnterpriseSubscriptions;

export type GetNotificationsResponse = EnterpriseNotifications;

export type ClearNotificationsData = {
  /**
   * Ids to clear
   */
  requestBody: {
    ids: Array<string>;
  };
};

export type ClearNotificationsResponse = void;

export type GetScheduledInvitationData = {
  /**
   * Bulk import id
   */
  id: number;
};

export type GetScheduledInvitationResponse = TeamScheduledInvitation;

export type UpdateScheduledInviteData = {
  id: number;
  /**
   * Scheduled invite attributes
   */
  requestBody: {
    sendInviteAt: string;
  };
};

export type UpdateScheduledInviteResponse = unknown;

export type CancelScheduledInviteData = {
  id: number;
};

export type CancelScheduledInviteResponse = void;

export type GetScheduledInvitationCsvData = {
  /**
   * Bulk invite ID
   */
  id: number;
  /**
   * team ID
   */
  teamId?: number;
};

export type GetScheduledInvitationCsvResponse = string;

export type CreateTeamData = {
  /**
   * Attributes for the new Profile
   */
  requestBody: TeamCreateAttributes;
};

export type CreateTeamResponse = Team;

export type GetTeamData = {
  filter?: string;
  /**
   * Team ID
   */
  id: number;
  include?: string;
  pageOffset?: number;
};

export type GetTeamResponse = Team;

export type DeleteTeamData = {
  /**
   * Team ID
   */
  id: number;
};

export type DeleteTeamResponse = unknown;

export type UpdateTeamData = {
  /**
   * Team ID
   */
  id: number;
  /**
   * Team's new name
   */
  requestBody: {
    name?: string;
  };
};

export type UpdateTeamResponse = unknown;

export type AddAdminByEmailData = {
  /**
   * Email and role
   */
  requestBody: {
    /**
     * New admin's email
     */
    email?: string;
    /**
     * New admin's role
     */
    role?: string;
  };
  /**
   * Team ID
   */
  teamId: number;
};

export type AddAdminByEmailResponse = unknown;

export type RemindUserData = {
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type RemindUserResponse = unknown;

export type BulkRemoveUsersData = {
  /**
   * User IDs to remove. If omitted, all members are removed from the team.
   */
  requestBody?: {
    userIds?: Array<number>;
  };
  /**
   * Team ID
   */
  teamId: number;
};

export type BulkRemoveUsersResponse = void;

export type UpdateTeamUserData = {
  /**
   * User's new name
   */
  requestBody: {
    user?: {
      firstName?: string;
      lastName?: string;
    };
  };
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type UpdateTeamUserResponse = unknown;

export type AddUserData = {
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type AddUserResponse = unknown;

export type DeleteUserData = {
  /**
   * Admin Role
   */
  role?: string;
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type DeleteUserResponse = unknown;

export type AddAdminData = {
  /**
   * admin role
   */
  role: string;
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type AddAdminResponse = unknown;

export type SetAdminRoleData = {
  /**
   * admin role
   */
  adminRole: string;
  /**
   * Team ID
   */
  teamId: number;
  /**
   * User ID
   */
  userId: number;
};

export type SetAdminRoleResponse = unknown;

export type GetScheduledInvitationsData = {
  /**
   * Team ID
   */
  teamId: number;
};

export type GetScheduledInvitationsResponse = TeamScheduledInvitations;

export type GetOrganizationData = {
  deep?: boolean;
  /**
   * Organization ID
   */
  id: number;
};

export type GetOrganizationResponse = Organization;

export type RemoveLogoData = {
  /**
   * Organization ID
   */
  id: number;
};

export type RemoveLogoResponse = void;

export type SaveOrganizationMessageData = {
  /**
   * Attributes for the custom message
   */
  requestBody: TeamNotification;
};

export type SaveOrganizationMessageResponse = TeamNotification;

export type GetOrganizationMessageData = {
  /**
   * Team notification ID
   */
  id: number;
};

export type GetOrganizationMessageResponse = TeamNotification;

export type DeleteOrganizationMessageData = {
  /**
   * Team notification ID
   */
  id: number;
};

export type DeleteOrganizationMessageResponse = void;

export type DismissOrganizationMessageData = {
  /**
   * Team notification ID
   */
  id: number;
};

export type DismissOrganizationMessageResponse = unknown;

export type GetUnreadOrganizationMessageResponse = Array<MemberNotification>;

export type GetEpisodesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters for Episodes
   */
  filter?: {
    pilot?: boolean;
  };
};

export type GetEpisodesResponse = Episodes;

export type GetEpisodeBySlugData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Episode slug
   */
  slug: string;
};

export type GetEpisodeBySlugResponse = Episode;

export type GetExperimentsResponse = Experiments;

export type GetFeatureInteractionsData = {
  /**
   * Filters for current user's Feature Interactions
   */
  filter?: {
    id?: number;
  };
};

export type GetFeatureInteractionsResponse = FeatureInteractionsResult;

export type UpdateFeatureInteractionData = {
  /**
   * Updated feature interaction info
   */
  requestBody: FeatureInteractionAttributes;
};

export type UpdateFeatureInteractionResponse = FeatureInteraction;

export type GetGuestPassesData = {
  /**
   * Referral token
   */
  referralToken: string;
};

export type GetGuestPassesResponse = FreeTrial;

export type SendGuestPassViaEmailData = {
  /**
   * Emails where the guest pass will be shared
   */
  requestBody: GuestPassShareAttributes;
};

export type SendGuestPassViaEmailResponse = unknown;

export type GetImmersiveHerosData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * specify a one of slug, courseSlug, or chapterSlug to filter
   */
  filter?: {
    /**
     * specify a gem slug to filter
     */
    slug?: string;
    /**
     * specify a course slug to filter
     */
    courseSlug?: string;
    /**
     * specify a chapter slug to filter
     */
    chapterSlug?: string;
  };
};

export type GetImmersiveHerosResponse = ImmersiveHeros;

export type GetInstructorsData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  filter?: {
    /**
     * specify a playlist
     */
    playlist?: string;
    /**
     * specify a comma-separated list of ids to filter
     */
    id?: string;
  };
};

export type GetInstructorsResponse = Array<Instructor>;

export type GetMarketingSectionsData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * include additional dependencies
   */
  include?: string;
};

export type GetMarketingSectionsResponse = MarketingSectionsResult;

export type GetNotesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters for Notes
   */
  filter?: {
    courseSlug?: string;
  };
};

export type GetNotesResponse = Notes;

export type CreateNoteData = {
  /**
   * Note attributes
   */
  requestBody: CreateNoteAttributes;
};

export type CreateNoteResponse = Note;

export type DeleteNoteData = {
  id: number;
};

export type DeleteNoteResponse = void;

export type UpdateNoteData = {
  id: number;
  /**
   * Note attributes
   */
  requestBody: {
    content: string;
  };
};

export type UpdateNoteResponse = Note;

export type GetPlaylistData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  slug: string;
  track?: string;
};

export type GetPlaylistResponse = Playlist;

export type GetPlaylistsData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  filter?: {
    /**
     * specify a comma-separated list of ids to filter
     */
    id?: string;
  };
};

export type GetPlaylistsResponse = Playlists;

export type GetProductsData = {
  /**
   * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
   */
  discountSlug?: string;
  /**
   * include additional dependencies
   */
  filterPurchasePlanSlugs?: string;
  /**
   * gift query param, determines whether we are sending a gift or not
   */
  gift?: boolean;
};

export type GetProductsResponse = Products;

export type GetProfilesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
};

export type GetProfilesResponse = Profiles;

export type CreateProfileData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Attributes for the new Profile
   */
  requestBody: ProfileCreateAttributes;
};

export type CreateProfileResponse = Profile;

export type GetProfileData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Profile ID
   */
  id: number;
};

export type GetProfileResponse = Profile;

export type UpdateProfileData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  id: number;
  /**
   * Profile attributes to be changed
   */
  requestBody: ProfileUpdateAttributes;
};

export type UpdateProfileResponse = Profile;

export type DeleteProfileData = {
  id: number;
};

export type DeleteProfileResponse = void;

export type GetOnboardingContentRecommendationResponse =
  OnboardingContentRecommendation;

export type GetPurchasePlanData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Either id number or specific plan slug
   */
  id: string | number;
};

export type GetPurchasePlanResponse = PurchasePlan;

export type GetReferralAudioProgramsResponse = ReferralAudioProgramsResult;

export type CreateShareableGuestPassLinksData = {
  /**
   * Attributes to create an invitation link. These attributes will be used to create utm params and handle link redirection
   */
  requestBody: ReferralTokenAttributes;
};

export type CreateShareableGuestPassLinksResponse = ShareLinks;

export type GetShowcasesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
};

export type GetShowcasesResponse = ShowcasesResult;

export type GetSkillsResponse = SkillsResult;

export type GetLastUserSubscriptionData = {
  /**
   * include dependencies
   */
  deep?: boolean;
};

export type GetLastUserSubscriptionResponse = Subscription;

export type GetThemesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters for ids
   */
  filter?: {
    /**
     * CSV of ids to filter
     */
    id?: string;
  };
  /**
   * include additional dependencies
   */
  include?: string;
};

export type GetThemesResponse = ThemesResults;

export type GetCurrentTierCollectionData = {
  /**
   * param to support the prcng-897V1 experiment (accelerator bundle) and return the correct tier collection
   */
  acceleratorBundleBucket?: string;
  /**
   * temporal param to support the prcng-107V1 experiment and return the correct tier collection
   */
  collapsedBucket?: string;
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
   */
  discountSlug?: string;
  /**
   * gift query param, determines whether we are sending a gift or not
   */
  gift?: boolean;
  /**
   * param to support the prcng-1194V1 experiment (MasterClass Pro tier) and return the correct tier collection
   */
  mcProBucket?: string;
  /**
   * param to support the prcng-861V1 experiment (standard price decrease) and return the correct tier collection
   */
  standardPriceDecreaseBucket?: string;
};

export type GetCurrentTierCollectionResponse = TierCollection;

export type GetPersonaBundleTierCollectionData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
   */
  discountSlug?: string;
  /**
   * gift query param, determines whether we are sending a gift or not
   */
  gift?: boolean;
};

export type GetPersonaBundleTierCollectionResponse = TierCollection;

export type GetUserCartDataData = {
  /**
   * include dependencies
   */
  deep?: boolean;
};

export type GetUserCartDataResponse = CartData;

export type GetUserGuestPassesResponse = GuestPass;

export type GetLastUserProductResponse = Product;

export type ValidateStreamConcurrencyData = {
  /**
   * Information about a new streaming session
   */
  requestBody: StreamAttributes;
};

export type ValidateStreamConcurrencyResponse = StreamsResult;

export type ReleaseConcurrentSeatData = {
  /**
   * Streaming session id
   */
  requestBody: StreamAttributes;
};

export type ReleaseConcurrentSeatResponse = StreamsResult;

export type GetUserSessionsResponse = UserSessionsResult;

export type GetUserCoursesData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * include additional dependencies
   */
  include?: string;
};

export type GetUserCoursesResponse = UserCoursesResult;

export type CreateUserCourseData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Course to associate to User
   */
  requestBody: CreateUserCourseAttributes;
};

export type CreateUserCourseResponse = UserCourse;

export type GetUserCourseBySlugData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters courses by tag
   */
  filter?: {
    tag?: string;
  };
  /**
   * Course slug
   */
  slug: string;
};

export type GetUserCourseBySlugResponse = UserCourse;

export type GetUserProgressData = {
  /**
   * Filters for current user's watch list items
   */
  filter?: {
    contentType?: string;
  };
};

export type GetUserProgressResponse = UserProgressResults;

export type GetUserPlaylistsData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * Filters for completed playlists
   */
  filter?: {
    completed?: boolean;
  };
  /**
   * include additional dependencies
   */
  include?: string;
};

export type GetUserPlaylistsResponse = UserPlaylistResults;

export type GetUserData = {
  /**
   * include dependencies
   */
  deep?: boolean;
  /**
   * User id
   */
  id: string | number;
};

export type GetUserResponse = User;

export type UpdateUserData = {
  /**
   * User id
   */
  id: string | number;
  /**
   * Updated user info
   */
  requestBody: UserAttributesForUpdate;
};

export type UpdateUserResponse = User;

export type GetVideoProgressEntriesData = {
  /**
   * Filters for current user's Video Progress Entries
   */
  filter?: {
    byVideoType?: string;
  };
};

export type GetVideoProgressEntriesResponse = VideoProgressEntriesResult;

export type CreateVideoProgressEntryData = {
  /**
   * New video progress entry info
   */
  requestBody: VideoProgressEntryAttributesForCreate;
};

export type CreateVideoProgressEntryResponse = VideoProgressEntry;

export type UpdateVideoProgressEntryData = {
  /**
   * Video Progress Entry id
   */
  id: number;
  /**
   * Updated video progress entry info
   */
  requestBody: VideoProgressEntryAttributesForUpdate;
};

export type UpdateVideoProgressEntryResponse = VideoProgressEntry;

export type GetWatchListItemsData = {
  /**
   * include dependencies
   */
  deep?: boolean;
};

export type GetWatchListItemsResponse = WatchListResults;

export type CreateWatchListItemData = {
  /**
   * Information about the watch list item
   */
  requestBody: WatchListItemAttributes;
};

export type CreateWatchListItemResponse = WatchListItem;

export type DeleteWatchListItemData = {
  /**
   * Id of the current item
   */
  id: number;
};

export type DeleteWatchListItemResponse = unknown;

export type GetLandingPricesData = {
  /**
   * user geo to calculate price
   */
  mcGeo: string;
};

export type GetLandingPricesResponse = LandingPrices;

export type GetPersonaBundleResponse = PersonaBundle;

export type GetSearchConfigData = {
  mode?: "library" | "search" | "customplaylists";
  platform?: "web";
  userExperience?: "consumer" | "enterprise";
};

export type GetSearchConfigResponse = SearchConfig;

export type GetRegisteredEmailData = {
  /**
   * email to verify
   */
  email: string;
};

export type GetRegisteredEmailResponse = EmailAccount;

export type CompleteUserRegistrationData = {
  /**
   * User attributes
   */
  requestBody: UserRegistration;
};

export type CompleteUserRegistrationResponse = unknown;

export type AddCreditCardData = {
  /**
   * Credit card params
   */
  requestBody: CreateCreditCardAttributes;
};

export type AddCreditCardResponse = CreditCard;

export type GetCreditCardsResponse = CreditCards;

export type RemoveCreditCardData = {
  id: number;
};

export type RemoveCreditCardResponse = void;

export type GetCreditCardsWithCurrencyData = {
  /**
   * Skip the Stripe customer currency filter. One-time charges are not bound by the customer's currency lock, only subscriptions are, so flows that charge a saved card once (certificate add-ons) can use any saved card.
   */
  forOneTimePurchase?: boolean;
  /**
   * Include Link payment methods (which have no card details). Required for post-purchase add-on flows that support Link purchases.
   */
  includeLink?: boolean;
  /**
   * Filter credit card by payment method cards or token cards
   */
  tokenOnly?: boolean;
};

export type GetCreditCardsWithCurrencyResponse = CreditCards;

export type GetDefaultCreditCardResponse = CreditCard;

export type CheckSetupIntentStatusData = {
  setupIntentId: string;
};

export type CheckSetupIntentStatusResponse = SetupIntentStatus | CreditCard;

export type VerifyCouponData = {
  /**
   * Slug of the coupon to be verified
   */
  code: string;
  /**
   * ID of the product the coupon is being applied to
   */
  productId: number;
};

export type VerifyCouponResponse = DiscountCoupon;

export type CreateOrderData = {
  /**
   * Order params
   */
  requestBody: CreateOrderAttributes;
  /**
   * COM-839
   */
  xTsBucket: string;
};

export type CreateOrderResponse = Order;

export type ConfirmData = {
  id: number;
};

export type ConfirmResponse = OrderConfirmation;

export type AddDiscountToCartProductsData = {
  /**
   * Send the productId and discount we would like to add
   */
  requestBody: UpdateProductAttributes;
};

export type AddDiscountToCartProductsResponse = unknown;

export type AddProductToCartData = {
  /**
   * Cart attributes
   */
  requestBody: AddProductAttributes;
};

export type AddProductToCartResponse = {
  product: CartProduct;
};

export type ClearCartResponse = {
  /**
   * Status of the cart clear operation
   */
  status: boolean;
  /**
   * Message indicating the success of the operation
   */
  message: string;
};

export type RemoveProductFromCartData = {
  /**
   * Product attributes
   */
  requestBody: RemoveProductAttributes;
};

export type RemoveProductFromCartResponse = {
  product: CartProduct;
};

export type GetCartProductsData = {
  /**
   * if user is gifting, we send gift = true
   */
  gift?: boolean;
};

export type GetCartProductsResponse = CartProducts;

export type RedeemData = {
  /**
   * gift token
   */
  bogoGiftToken: string;
  /**
   * Gift attributes
   */
  requestBody: {
    gift: RedeemBogoGift;
  };
};

export type RedeemResponse = {
  gifteeName?: string;
};

export type GetGiftAddOnResponse = GiftAddOn;

export type GetAddOnsResponse = {
  persona?: PersonaAddOn;
  learningToolkit?: LearningToolkitAddOn;
  gift?: GiftAddOn;
  certificatePrograms?: Array<CertificateProgramAddOn>;
  certificateCredit?: CertificateCreditAddOn;
};

export type GetAnnualPassAddOnResponse = AnnualPassAddOn;

export type GetLearningToolkitAddOnResponse = LearningToolkitAddOn;

export type GetPersonaAddOnResponse = PersonaAddOn;

export type GetCertificateCreditAddOnResponse = CertificateCreditAddOn;

export type GetPostPurchaseCertificateAddOnsResponse =
  Array<CertificateProgramAddOn>;

export type PreviewProrationData = {
  /**
   * ID of the product to preview proration for
   */
  id: number;
};

export type PreviewProrationResponse = ProrationPreview;

export type CancelData = {
  id: number;
};

export type CancelResponse = unknown;

export type ReactivateData = {
  id: number;
};

export type ReactivateResponse = unknown;

export type PreviewData = {
  /**
   * The product id of the plan to preview
   */
  changeProductId: number;
  id: number;
};

export type PreviewResponse = {
  /**
   * The prorated amount for the plan change
   */
  proratedAmount?: string;
  /**
   * The currency code
   */
  currency?: string;
  /**
   * The type of change (upgrade or downgrade)
   */
  changeType?: "upgrade" | "downgrade";
};

export type UpdateData = {
  /**
   * Subscription ID
   */
  id: number;
  /**
   * Subscription attributes
   */
  requestBody: {
    /**
     * The type of change
     */
    changeType: string;
    /**
     * The product id of the plan to update
     */
    changeProductId: number;
  };
};

export type UpdateResponse = {
  /**
   * A message indicating the subscription was updated
   */
  message?: string;
};

export type PricingUpgradeResponse = unknown;

export type GetWatchBundleData = {
  watchBundleUuid: string;
};

export type GetWatchBundleResponse = WatchBundle;

export type GetWatchBundleDetailsData = {
  bundleUuid?: string;
  /**
   * The database ID or slug of the bundleable content.
   * Must be provided together with contentType.
   *
   */
  contentId?: string;
  /**
   * The type of the bundleable content.
   * Must be provided together with contentId.
   *
   */
  contentType?: "Course" | "Playlist";
};

export type GetWatchBundleDetailsResponse = WatchBundleDetails;

export type GetWatchBundleExtrasData = {
  watchBundleUuid: string;
};

export type GetWatchBundleExtrasResponse = WatchBundleExtras;

export type GetWatchBundleInteractionsData = {
  watchBundleUuid: string;
};

export type GetWatchBundleInteractionsResponse = WatchBundleInteractions;

export type AddBookmarkData = {
  /**
   * The unique identifier of a resource to bookmark.
   */
  uuid: string;
};

export type AddBookmarkResponse = V3Bookmark;

export type RemoveBookmarkData = {
  /**
   * The unique identifier of a resource to bookmark.
   */
  uuid: string;
};

export type RemoveBookmarkResponse = void;

export type PatchNoteData = {
  contentUuid: string;
  requestBody: {
    entry: string;
  };
};

export type PatchNoteResponse = V3Note;

export type DestroyNoteData = {
  contentUuid: string;
};

export type DestroyNoteResponse = void;

export type GetWatchBundleContentInteractionsData = {
  /**
   * Content uuid
   */
  contentUuid: string;
};

export type GetWatchBundleContentInteractionsResponse =
  WatchBundleContentInteractions;

export type PatchPlaybackData = {
  contentUuid: string;
  requestBody: {
    cursor: number;
  };
};

export type PatchPlaybackResponse = Playhead;

export type GetPlaybackTokenResponse = PlaybackTokenResponse;

export type UpdateSurveyResponseData = {
  contentUuid: string;
  requestBody: UpdateSurvey;
};

export type UpdateSurveyResponseResponse = void;

export type ShowSharingData = {
  uuid: string;
};

export type ShowSharingResponse = Sharing;

export type GetSessionActivityInteractionsData = {
  /**
   * Activity uuid
   */
  uuid: string;
};

export type GetSessionActivityInteractionsResponse =
  SessionActivityInteractions;

export type GetAssigneesResponse = Assignees;

export type GetContentProgressData = {
  filters?: {
    [key: string]: unknown;
  };
  /**
   * Filters progress based on who shared
   */
  sharedBy?: "all" | "me";
  /**
   * The team identifier in which the progress content was assigned.
   */
  teamId: string;
  /**
   * The unique identifier of an assignable content.
   */
  uuid: string;
};

export type GetContentProgressResponse = ContentProgress;

export type GetAssignmentsResponse = AssignedContents;

export type CreateAssignmentsData = {
  requestBody: CreateAssignments;
  xRequestId?: string;
};

export type CreateAssignmentsResponse = unknown;

export type DestroyAssignmentData = {
  contentUuid: string;
  requestBody: UserIdentifier;
};

export type DestroyAssignmentResponse = void;

export type BulkDestroyAssignmentData = {
  contentUuid: string;
};

export type BulkDestroyAssignmentResponse = unknown;

export type GetAssignableContentResponse = AssignableContentResult;

export type GetNavigationResponse = NavigationContents;

export type GetOrganizationInfoData = {
  id: string;
};

export type GetOrganizationInfoResponse = V3Organization;

export type GetTemplateBulkImportResponse = string;

export type GetEnterpriseSkillsResponse = Array<EnterprisePlaylistSkill>;

export type V3GetPlaylistsData = {
  /**
   * The unique identifier of an organization.
   */
  organizationId: number;
};

export type V3GetPlaylistsResponse = V3Playlists;

export type CreatePlaylistData = {
  requestBody: CreatePlaylist;
};

export type CreatePlaylistResponse = CreatedPlaylist;

export type V3GetPlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type V3GetPlaylistResponse = V3Playlist;

export type UpdatePlaylistData = {
  formData: UpdatePlaylist;
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type UpdatePlaylistResponse = void;

export type DeletePlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type DeletePlaylistResponse = void;

export type PublishPlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type PublishPlaylistResponse = void;

export type UnpublishPlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type UnpublishPlaylistResponse = void;

export type DuplicatePlaylistData = {
  requestBody: CreatePlaylist;
  /**
   * The unique identifier of a playlist.
   */
  uuid: string;
};

export type DuplicatePlaylistResponse = CreatedPlaylist;

export type GetLessonsFromPlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  playlistUuid: string;
};

export type GetLessonsFromPlaylistResponse = Array<EnterprisePlaylistLesson>;

export type AddLessonsToPlaylistData = {
  playlistUuid: string;
  requestBody: EnterprisePlaylistAddLessons;
};

export type AddLessonsToPlaylistResponse = unknown;

export type ReorderLessonsInPlaylistData = {
  /**
   * The unique identifier of a playlist.
   */
  playlistUuid: string;
  requestBody: ReorderLessons;
};

export type ReorderLessonsInPlaylistResponse = void;

export type UpdateLessonInPlaylistData = {
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
  /**
   * The unique identifier of a playlist.
   */
  playlistUuid: string;
  requestBody: UpdateLesson;
};

export type UpdateLessonInPlaylistResponse = void;

export type RemoveLessonFromPlaylistData = {
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
  /**
   * The unique identifier of a playlist.
   */
  playlistUuid: string;
};

export type RemoveLessonFromPlaylistResponse = void;

export type GetProgramData = {
  /**
   * The unique identifier of a program.
   */
  programSlug: string;
};

export type GetProgramResponse = Program;

export type EnrollProgramsData = {
  /**
   * The unique identifier of a program.
   */
  programSlug: string;
};

export type EnrollProgramsResponse = unknown;

export type GetProgramDownloadResourcesData = {
  /**
   * The unique identifier of a program.
   */
  programSlug: string;
  /**
   * Files to be compressed that belong to the same section.
   */
  stage?: "before" | "along" | "after";
};

export type GetProgramDownloadResourcesResponse = Blob | File;

export type GetModuleDownloadResourcesData = {
  /**
   * The unique identifier of a module.
   */
  moduleSlug: string;
  /**
   * The unique identifier of a program.
   */
  programSlug: string;
};

export type GetModuleDownloadResourcesResponse = Blob | File;

export type GetQuoteData = {
  requestBody: EnterpriseQuoteRequest;
};

export type GetQuoteResponse = EnterpriseQuote;

export type GetAddonQuoteData = {
  requestBody: EnterpriseAddonQuoteRequest;
};

export type GetAddonQuoteResponse = EnterpriseQuote;

export type CreateCertificateInterestData = {
  requestBody: CreateCertificateInterest;
};

export type CreateCertificateInterestResponse = CertificateInterestResult;

export type ProcessAddonOrderData = {
  requestBody: EnterpriseProcessAddonOrderRequest;
};

export type ProcessAddonOrderResponse = EnterpriseAddonOrder;

export type ProcessOrderData = {
  requestBody: EnterpriseProcessOrderRequest;
};

export type ProcessOrderResponse = EnterpriseOrder;

export type GetInvoiceData = {
  /**
   * The unique identifier of the invoice.
   */
  invoiceId: string;
};

export type GetInvoiceResponse = EnterpriseInvoice;

export type GetLicensesResponse = EnterpriseLicenses;

export type RevokeConsentResponse = void;

export type CreateTeamCsvImportData = {
  formData: CreateTeamCsvImport;
  /**
   * License (EnterpriseSubscription) id.
   */
  licenseId: number;
};

export type CreateTeamCsvImportResponse = TeamCsvImportTask;

export type GetTeamCsvImportData = {
  /**
   * TeamCsvImportTask id.
   */
  id: number;
  /**
   * License (EnterpriseSubscription) id.
   */
  licenseId: number;
};

export type GetTeamCsvImportResponse = TeamCsvImportTask;

export type ResendInviteNotificationsData = {
  /**
   * Team ID
   */
  teamId: number;
};

export type ResendInviteNotificationsResponse = unknown | void;

export type GetMetricData = {
  filters?: {
    [key: string]: unknown;
  };
  slug: string;
  teamId: string;
};

export type GetMetricResponse = EnterpriseAnalyticsMetric;

export type CreateGenerateCsvReportJobData = {
  /**
   * generate-csv-report-job request body
   */
  requestBody: EnterpriseAnalyticsGenerateCsvReportJobRequest;
};

export type CreateGenerateCsvReportJobResponse =
  EnterpriseAnalyticsGenerateCsvReportJobResponse;

export type GetGenerateCsvReportJobData = {
  uuid: string;
};

export type GetGenerateCsvReportJobResponse =
  EnterpriseAnalyticsGenerateCsvReportJobResponse;

export type GetContentRowsV3Data = {
  /**
   * Used to filter out tiles with a different entityType
   */
  entityType?: Array<V3ContentRowEntityType>;
  filter: {
    bundle: string;
    /**
     * comma-separated list of ids to filter
     */
    id?: string;
    platform:
      | "iphone"
      | "ipad"
      | "android_phone"
      | "android_tv"
      | "fire_tv"
      | "apple tv"
      | "roku"
      | "web";
    /**
     * Used to override row reference
     */
    referenceUuid?: string;
  };
  includeItems?: boolean;
  resourceUuid?: string;
};

export type GetContentRowsV3Response = V3ContentRows;

export type GetResourceUniqueIdentifierData = {
  /**
   * Type of the resource in plural.
   */
  resourceTypePlural:
    | "stories"
    | "collections"
    | "collection-parts"
    | "collection-part-cards"
    | "courses"
    | "chapters"
    | "certificate_programs"
    | "curriculum_lessons";
  /**
   * Slug of the resource.
   */
  slug: string;
};

export type GetResourceUniqueIdentifierResponse = UniqueIdentifiersResponse;

export type GetMyListResponse = Array<MyListItem>;

export type AddToMyListData = {
  contentUuid: string;
};

export type AddToMyListResponse = unknown;

export type RemoveFromMyListData = {
  contentUuid: string;
};

export type RemoveFromMyListResponse = void;

export type GetHomepageLayoutResponse = HomepageLayout;

export type GetSemanticSearchData = {
  /**
   * The question asked by the user
   */
  q: string;
};

export type GetSemanticSearchResponse = SemanticSearchResponse;

export type GetAppDataResponse = AppData;

export type UpdateLearningPreferencesData = {
  requestBody: LearningPreferences;
};

export type UpdateLearningPreferencesResponse = void;

export type GetCareerGoalResponse = CareerGoalPage;

export type V3GetSkillsData = {
  /**
   * The career goal selected
   */
  careerGoal: string;
};

export type V3GetSkillsResponse = SkillsPage;

export type GetSubskillsData = {
  /**
   * The skills selected
   */
  skills: string;
};

export type GetSubskillsResponse = SubskillsPage;

export type GetTabContentData = {
  navigation?: string;
  tab?: string;
  xPlatform?: string;
};

export type GetTabContentResponse = TabContent;

export type GetCollectionRowsResponse = CollectionRows;

export type GetCollectionData = {
  collectionUuid: string;
};

export type GetCollectionResponse = Collection;

export type UpdateCardProgressData = {
  cardUuid: string;
};

export type UpdateCardProgressResponse = void;

export type GetCollectionInteractionsData = {
  collectionUuid: string;
};

export type GetCollectionInteractionsResponse = CollectionInteractions;

export type CreateOnboardingResponse = Onboarding;

export type UpdateOnboardingData = {
  /**
   * Onboarding Id
   */
  id: number;
};

export type UpdateOnboardingResponse = void;

export type UpdateSessionPreferencesData = {
  requestBody: UpdateSessionPreferences;
  /**
   * Session uuid
   */
  uuid: string;
};

export type UpdateSessionPreferencesResponse = void;

export type GetIterableTokenResponse = IterableToken;

export type GetEligibleInfoData = {
  /**
   * The unique identifier of a resource to redeem.
   */
  uuid: string;
};

export type GetEligibleInfoResponse = RevolutEligibleGift;

export type ActivateRevolutGiftData = {
  /**
   * The unique identifier of a resource to redeem.
   */
  uuid: string;
};

export type ActivateRevolutGiftResponse = unknown;

export type GetCertificateProgramProductBundleData = {
  /**
   * The slug of the product bundle.
   */
  slug: string;
};

export type GetCertificateProgramProductBundleResponse = ProductBundle;

export type GetCertificateProgramCatalogResponse = CertificateProgramCatalog;

export type GetCertificateHubTilesResponse = CertificateHubTiles;

export type GetCertificateProgramInteractionsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateProgramInteractionsResponse =
  CertificateProgramInteractions;

export type GetCertificateProgramData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateProgramResponse = CertificateProgram;

export type GetCurriculumData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCurriculumResponse = Curriculum;

export type GetCurriculumInteractionsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCurriculumInteractionsResponse = CurriculumInteractions;

export type PostCurriculumInteractionsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type PostCurriculumInteractionsResponse = CurriculumInteractions;

export type DismissCurriculumMigrationNotificationData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type DismissCurriculumMigrationNotificationResponse = void;

export type GetCurriculumLessonData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
};

export type GetCurriculumLessonResponse = CurriculumLesson;

export type GetCurriculumLessonInteractionsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
};

export type GetCurriculumLessonInteractionsResponse =
  CurriculumLessonInteractions;

export type PostCurriculumLessonInteractionsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
};

export type PostCurriculumLessonInteractionsResponse =
  CurriculumLessonInteractions;

export type GetCurriculumLessonDownloadResourcesData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The unique identifier of a lesson.
   */
  lessonUuid: string;
};

export type GetCurriculumLessonDownloadResourcesResponse = Blob | File;

export type DownloadCurriculumCapstoneSummaryData = {
  /**
   * The unique identifier of the capstone summary activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type DownloadCurriculumCapstoneSummaryResponse = Blob | File;

export type SubmitCurriculumQuizActivityData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  requestBody: CurriculumQuizActivityInteractions;
};

export type SubmitCurriculumQuizActivityResponse =
  CurriculumActivityInteractions;

export type SubmitCurriculumDiscussionActivityData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  requestBody: CurriculumDiscussionActivityInteractions;
};

export type SubmitCurriculumDiscussionActivityResponse =
  CurriculumActivityInteractions;

export type SubmitCurriculumQuestionnaireActivityData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  requestBody: CurriculumQuestionnaireActivityInteractions;
};

export type SubmitCurriculumQuestionnaireActivityResponse =
  CurriculumActivityInteractions;

export type SubmitCurriculumAiProjectActivityData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  requestBody: CurriculumAIProjectSubmitRequest;
};

export type SubmitCurriculumAiProjectActivityResponse =
  CurriculumActivityInteractions;

export type PostCurriculumActivityReadData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The unique identifier of the activity.
   */
  uuid: string;
};

export type PostCurriculumActivityReadResponse = unknown;

export type PostCurriculumActivityConversationData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type PostCurriculumActivityConversationResponse =
  AppliedLearningUserConversation;

export type RestartCurriculumActivityConversationData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type RestartCurriculumActivityConversationResponse =
  AppliedLearningUserConversation;

export type PostCurriculumActivityConversationUnlockData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type PostCurriculumActivityConversationUnlockResponse =
  CurriculumActivityInteractions;

export type PatchCurriculumActivityConversationSyncData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type PatchCurriculumActivityConversationSyncResponse =
  CurriculumActivityInteractions;

export type CreateCurriculumRoleplayConversationData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  requestBody?: CreateRoleplayConversationRequest;
};

export type CreateCurriculumRoleplayConversationResponse =
  RoleplayUserConversation;

export type RestartCurriculumRoleplayConversationData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  requestBody?: CreateRoleplayConversationRequest;
};

export type RestartCurriculumRoleplayConversationResponse =
  RoleplayUserConversation;

export type SubmitCurriculumRoleplayConversationData = {
  /**
   * The unique identifier of the activity.
   */
  activityUuid: string;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type SubmitCurriculumRoleplayConversationResponse =
  CurriculumActivityInteractions;

export type GetCertificateProgramProductData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * Optional list of candidate discount codes, e.g. `discountSlugs[]=a&discountSlugs[]=b`. The backend selects the highest-value eligible coupon among all candidates and reports it via `winningDiscountSlug`
   */
  discountSlugs?: Array<string>;
};

export type GetCertificateProgramProductResponse = CertificateProgramProduct;

export type GetProductAssetProductData = {
  /**
   * The unique identifier of a certificate program or product bundle
   */
  assetUuid: string;
  /**
   * Optional list of candidate discount codes, e.g. `discountSlugs[]=a&discountSlugs[]=b`. The backend selects the highest-value eligible coupon among all candidates and reports it via `winningDiscountSlug`.
   */
  discountSlugs?: Array<string>;
};

export type GetProductAssetProductResponse = CertificateProgramProduct;

export type ListCertificateProgramProductsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  discountSlugs?: {
    [key: string]: string;
  };
};

export type ListCertificateProgramProductsResponse = CertificateProgramProducts;

export type GetCertificateProgramProductByUuidData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * Optional list of candidate discount codes, e.g. `discountSlugs[]=a&discountSlugs[]=b`. The backend selects the highest-value eligible coupon among all candidates and reports it via `winningDiscountSlug`.
   */
  discountSlugs?: Array<string>;
  /**
   * The unique identifier of a product
   */
  productUuid: string;
};

export type GetCertificateProgramProductByUuidResponse =
  CertificateProgramProduct;

export type GetCertificateProgramRewardData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateProgramRewardResponse = UserCertificateProgramReward;

export type PostCertificateProgramRewardData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type PostCertificateProgramRewardResponse = UserCertificateProgramReward;

export type PostCertificateProgramAddOnData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type PostCertificateProgramAddOnResponse = unknown;

export type GetCertificateProgramPostPurchaseCertsData = {
  /**
   * Comma-separated list of certificate program UUIDs the user has previously dismissed. Excluded from the returned slots so a declined cert is never re-offered.
   *
   */
  dismissedIds?: string;
};

export type GetCertificateProgramPostPurchaseCertsResponse =
  PostPurchaseCertAddOns;

export type GetCertificateProgramCouponData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The code of the coupon
   */
  couponCode: string;
  /**
   * The unique identifier of the product
   */
  productUuid: string;
};

export type GetCertificateProgramCouponResponse = CertificateProgramCoupon;

export type DownloadCertificateProgramBundleData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type DownloadCertificateProgramBundleResponse = Blob | File;

export type DownloadCertificateProgramToolkitData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type DownloadCertificateProgramToolkitResponse = Blob | File;

export type GetCertificateProgramToolkitData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateProgramToolkitResponse = Toolkit;

export type GetCertificateProgramToolData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The unique identifier of the tool.
   */
  uuid: string;
};

export type GetCertificateProgramToolResponse = UserTool;

export type GetCertificateProgramProjectsData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateProgramProjectsResponse = Projects;

export type GetCertificateProgramRecentActivityData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateProgramRecentActivityResponse = RecentActivity;

export type GetCertificateProgramEnrollmentsData = {
  /**
   * Filter by active enrollments. If multiple status parameters are provided,
   * the results will be concatenated together.
   *
   */
  active?: boolean;
  /**
   * Filter by expired enrollments (inactive enrollments whose access expiration
   * date has passed). If multiple status parameters are provided, the results
   * will be concatenated together.
   *
   */
  expired?: boolean;
  /**
   * Filter by inactive enrollments. If multiple status parameters are provided,
   * the results will be concatenated together.
   *
   */
  inactive?: boolean;
  /**
   * Filter by pending enrollments. If multiple status parameters are provided,
   * the results will be concatenated together.
   *
   */
  pending?: boolean;
};

export type GetCertificateProgramEnrollmentsResponse =
  CertificateProgramEnrollments;

export type CreateCertificateChallengeData = {
  /**
   * Whether the challenge was automatically enrolled rather than user opt-in.
   */
  autoEnrolled?: boolean;
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  /**
   * The discount percentage for the challenge.
   */
  discountPercent: number;
  /**
   * The number of days for the challenge period. One of 15, 30, or 45.
   */
  durationDays: number;
};

export type CreateCertificateChallengeResponse = CertificateChallenge;

export type GetCertificateChallengeData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateChallengeResponse = CertificateChallenge;

export type VerifyCertificateChallengeCouponData = {
  /**
   * The coupon code to verify.
   */
  code: string;
};

export type VerifyCertificateChallengeCouponResponse = CertificateProgramCoupon;

export type VerifyCertificateProgramCouponData = {
  /**
   * The coupon code to verify.
   */
  code: string;
};

export type VerifyCertificateProgramCouponResponse = CertificateProgramCoupon;

export type RequestEnrollmentExtensionData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type RequestEnrollmentExtensionResponse = CertificateProgramEnrollment;

export type AcceptCertificateDataSharingConsentData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  requestBody: {
    /**
     * The terms version presented to the learner. Must match the current version.
     */
    termsVersion: string;
  };
};

export type AcceptCertificateDataSharingConsentResponse =
  CertificateProgramEnrollment;

export type GetCertificateProgramEnrollmentData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type GetCertificateProgramEnrollmentResponse =
  CertificateProgramEnrollment;

export type EnrollInCertificateProgramData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
  requestBody: {
    /**
     * Only available for non production environments. If true, the user will be enrolled in all the courses of the certificate program.
     * This is only available for non-production environments.
     *
     */
    autoCheckout?: boolean;
  };
};

export type EnrollInCertificateProgramResponse = {
  /**
   * The date and time when the certificate program was provisioned.
   */
  enrolledAt?: string;
};

export type WithdrawFromCertificateProgramData = {
  /**
   * The unique identifier of a certificate program
   */
  certificateProgramUuid: string;
};

export type WithdrawFromCertificateProgramResponse = void;

export type GetCertificateSubscriptionOfferData = {
  /**
   * When the offer is rendered on a certificate course page, the slug of
   * that certificate program. The comparison block then carries that
   * program's own one-time price instead of the catalog-wide
   * starting-at price.
   *
   */
  certificateProgramSlug?: string;
  /**
   * Optional list of candidate discount codes, e.g.
   * `discountSlugs[]=a&discountSlugs[]=b`. The backend selects the
   * highest-value eligible coupon per price among all candidates and
   * reports it via that price's `winning_discount_slug`.
   *
   */
  discountSlugs?: Array<string>;
  /**
   * Optional price-test variant purchase plan slug. When it names an
   * active price-test plan available in the visitor's geo, the offer
   * carries that plan's pricing; otherwise (unknown slug, no active
   * test, or the variant has no price for the geo) the response
   * silently falls back to the canonical plan. The plan actually
   * served is always reported in `subscriptionPlan.slug` and
   * `analytics.planSlug`.
   *
   */
  planSlug?: string;
};

export type GetCertificateSubscriptionOfferResponse =
  CertificateSubscriptionOffer;

export type GetMyCertificateSubscriptionResponse = MyCertificateSubscription;

export type V3GetUserData = {
  requestBody?: AcceleratorUser;
};

export type V3GetUserResponse = AcceleratorUser;

export type GetGrowthCategoriesResponse = Array<GrowthCategory>;

export type GetGrowthContentData = {
  /**
   * Comma-separated list of subcategory IDs to filter content by
   */
  filterSubcategoryIds?: string;
};

export type GetGrowthContentResponse = Array<GrowthContent>;

export type GetQuizRecommendedLessonsResponse =
  Array<GrowthSubcategoryWithLessons>;

export type GetQuizCategoryMediaResponse = Array<GrowthCategoryWithMedia>;

export type GetOutcomesResponse = Array<Outcome>;

export type GetContentOutcomesResponse = Array<ContentOutcome>;

export type CreateEmailCaptureData = {
  requestBody: EmailCaptureRequest;
};

export type CreateEmailCaptureResponse = EmailCaptureResponse;

export type GetSubscriptionPreferencesUserData = {
  /**
   * Email address to get subscription preferences for
   */
  email: string;
  /**
   * Email token hashed with HMAC-SHA256 and secret matching ITERABLE_HMACSHA1_SECRET to authenticate the request
   */
  subscriptionPreferencesToken: string;
};

export type GetSubscriptionPreferencesUserResponse =
  SubscriptionPreferencesUser;

export type UpdateUserSubscriptionPreferencesData = {
  requestBody: SubscriptionPreferencesUpdateRequest;
};

export type UpdateUserSubscriptionPreferencesResponse =
  SubscriptionPreferencesUpdateResponse;

export type GetSubscriptionPreferencesMetadataResponse =
  SubscriptionPreferencesMetadata;

export type GetLearningPathsResultsData = {
  /**
   * Comma-separated list of category IDs
   */
  categoryIds?: string;
  /**
   * Comma-separated list of subcategory IDs
   */
  subcategoryIds?: string;
};

export type GetLearningPathsResultsResponse = Array<LearningPath>;

export type GetUserTokenResponse = DecagonUserToken;

export type GetDecagonSignatureData = {
  /**
   * The Decagon deployment the calling surface belongs to. Each
   * deployment verifies signatures with its own secret, so the
   * signature is minted with the key for this product.
   * See `DecagonProduct` for available values.
   *
   */
  product?: string;
};

export type GetDecagonSignatureResponse = DecagonSignature;

export type RequestSupportOtpData = {
  requestBody: {
    /**
     * The MasterClass account email. Mutually exclusive with `orderNumber`.
     */
    email?: string;
    /**
     * A MasterClass order number from a purchase receipt, with or without a
     * leading `#`. Mutually exclusive with `email`.
     *
     */
    orderNumber?: string;
    requestType: "request" | "resend" | "cancel";
    /**
     * Decagon conversation id; binds the attempt to a conversation.
     */
    conversationId?: string;
  };
};

export type RequestSupportOtpResponse = {
  status?: string;
  message?: string;
  expiresAt?: string;
};

export type ValidateSupportOtpData = {
  requestBody: {
    /**
     * Mutually exclusive with `orderNumber`.
     */
    email?: string;
    /**
     * Mutually exclusive with `email`.
     */
    orderNumber?: string;
    /**
     * The numeric code, kept as a string to preserve leading zeros.
     */
    otp: string;
    conversationId?: string;
  };
};

export type ValidateSupportOtpResponse = {
  status?: string;
  verificationState?: string;
  isValid?: boolean;
  /**
   * Decagon user JWT
   */
  token?: string;
  expiresAt?: string;
};

export type CheckSupportOtpStatusData = {
  requestBody: {
    /**
     * Mutually exclusive with `orderNumber`.
     */
    email?: string;
    /**
     * Mutually exclusive with `email`.
     */
    orderNumber?: string;
    conversationId: string;
  };
};

export type CheckSupportOtpStatusResponse = {
  status?: string;
  verificationState?:
    | "verified"
    | "pending"
    | "expired"
    | "not_found"
    | "unavailable";
  isValid?: boolean;
  /**
   * Echoes the request's conversation_id (absent only when the flag is off).
   */
  conversationId?: string;
  token?: string;
  expiresAt?: string;
};

export type VerifySupportMagicLinkData = {
  requestBody: {
    /**
     * The opaque single-use magic-link token from the email.
     */
    token: string;
  };
};

export type VerifySupportMagicLinkResponse = {
  status:
    | "verified"
    | "already_verified"
    | "expired"
    | "invalid"
    | "unavailable";
};

export type GetCommerceProductData = {
  /**
   * The name of the product to retrieve
   */
  productName: string;
};

export type GetCommerceProductResponse = CommerceProduct;

export type GetCommercePurchasePlansData = {
  /**
   * The name of the purchase-plan to retrieve
   */
  slug: string;
};

export type GetCommercePurchasePlansResponse = CommercePurchasePlan;

export type GetCertificatePriceLimitData = {
  /**
   * Override geo for pricing (defaults to request geo)
   */
  mcGeo?: string;
};

export type GetCertificatePriceLimitResponse = CertificatePriceLimit;

export type GetBundlePricingResponse = BundlePricingBreakdown;

export type GetBundleEligibleCertificatesResponse = BundleEligibleCertificates;

export type RedeemGiftcardData = {
  /**
   * Giftcode for redemption
   */
  requestBody: {
    /**
     * Giftcard code number
     */
    giftcode: string;
  };
};

export type RedeemGiftcardResponse = SubscriptionDetails;

export type DownloadReceiptData = {
  /**
   * The id of the Payment to download the receipt for.
   */
  paymentId: number;
};

export type DownloadReceiptResponse = Blob | File;

export type ListReceiptsData = {
  /**
   * Maximum number of receipts to return. Defaults to 5 when omitted; values above 100 are capped to 100.
   */
  pageLimit?: number;
  /**
   * Number of receipts to skip from the start of the set.
   */
  pageOffset?: number;
};

export type ListReceiptsResponse = ReceiptList;

export type ConfirmInstallmentChangePaymentMethodData = {
  /**
   * The id of the installment schedule whose stored payment method is being changed.
   */
  installmentScheduleId: number;
  requestBody: InstallmentChangePaymentMethodConfirmRequest;
};

export type ConfirmInstallmentChangePaymentMethodResponse = unknown;

export type AddProductToCartV3Data = {
  requestBody: CartAddProductRequest;
};

export type AddProductToCartV3Response = CartAddProductResponse;

export type CreateCommerceOrderData = {
  requestBody: CommerceOrderRequest;
};

export type CreateCommerceOrderResponse = CommerceOrderResponse;

export type ConfirmCommerceOrderData = {
  /**
   * The id of the Commerce Order returned when the order endpoint asked for bank verification.
   */
  orderId: number;
  requestBody: CommerceOrderConfirmRequest;
};

export type ConfirmCommerceOrderResponse = CommerceOrderResponse;

export type GetCommerceCreditCardsData = {
  /**
   * When `true`, returns cards regardless of their Stripe customer's currency.
   */
  forOneTimePurchase?: boolean;
  /**
   * When `true`, also returns Link payment methods, which have no brand or last four.
   */
  includeLink?: boolean;
  /**
   * When `true`, leaves out cards saved as Stripe PaymentMethods (`pm` ids).
   */
  tokenOnly?: boolean;
};

export type GetCommerceCreditCardsResponse = CommerceCreditCardList;

export type CancelCommerceSubscriptionData = {
  /**
   * ID of one of the authenticated user's own subscriptions.
   */
  subscriptionId: number;
};

export type CancelCommerceSubscriptionResponse = SubscriptionCancellation;

export type InitiateInstallmentChangePaymentMethodData = {
  /**
   * ID of the installment schedule whose future payment method is being changed.
   */
  installmentScheduleId: number;
  requestBody: InstallmentChangePaymentMethodRequest;
};

export type InitiateInstallmentChangePaymentMethodResponse = unknown;

export type GetCapabilitiesResponse = Capabilities;

export type GetTermsPageData = {
  /**
   * URL slug for the terms page.
   */
  slug: string;
};

export type GetTermsPageResponse = TermsPage;

export type CreateEducatorEnrollmentApplicationData = {
  requestBody: CreateEducatorEnrollmentApplicationRequest;
};

export type CreateEducatorEnrollmentApplicationResponse =
  EducatorEnrollmentApplication;

export type GetEducatorEnrollmentApplicationResponse =
  EducatorEnrollmentApplication;

export type UpdateEducatorEnrollmentApplicationData = {
  requestBody: UpdateEducatorEnrollmentApplicationRequest;
};

export type UpdateEducatorEnrollmentApplicationResponse =
  EducatorEnrollmentApplication;

export type AutoCheckoutEducatorEnrollmentResponse = void;

export type EducatorUserRegistrationData = {
  requestBody: EducatorUserRegistrationRequest;
};

export type EducatorUserRegistrationResponse2 =
  EducatorUserRegistrationResponse;

export type EducatorRegistrationCompletedData = {
  requestBody: EducatorRegistrationCompletedRequest;
};

export type EducatorRegistrationCompletedResponse2 =
  EducatorRegistrationCompletedResponse;

export type EducatorSessionTokenResponse2 = EducatorSessionTokenResponse;

export type GetEducatorPaymentDetailsData = {
  /**
   * The payment plan type selected on the previous screen.
   * See `EducatorPaymentPlanType` for available values.
   * Defaults to '1-payment' if omitted.
   *
   */
  planType?: string;
};

export type GetEducatorPaymentDetailsResponse = EducatorPaymentDetailsResponse;

export type GetEducatorPaymentPlansResponse = EducatorPaymentPlansResponse;

export type GetEducatorEnrollmentStatusResponse =
  EducatorEnrollmentStatusResponse;

export type ProcessEducatorPaymentOrderData = {
  requestBody: EducatorPaymentOrderRequest;
};

export type ProcessEducatorPaymentOrderResponse = EducatorPaymentOrderResponse;

export type GetEducatorProductPriceResponse = EducatorProductPriceResponse;

export type RemoveFromContinueWatchingData = {
  entityUuid: string;
};

export type RemoveFromContinueWatchingResponse = void;

export type ConfirmEducatorPaymentData = {
  requestBody: EducatorPaymentConfirmRequest;
};

export type ConfirmEducatorPaymentResponse = EducatorPaymentConfirmResponse;

export type GetEducatorAvailableSeatsResponse = EducatorAvailableSeatsResponse;

export type GetEducatorCohortDetailsResponse = EducatorCohortDetailsResponse;

export type GetEducatorSectionLayoutResponse = EducatorSectionLayoutResponse;

export type GetEducatorAccountResponse = EducatorAccountResponse;

export type CreateEducatorWaitlistSignupData = {
  requestBody: CreateEducatorWaitlistRequest;
};

export type CreateEducatorWaitlistSignupResponse =
  CreateEducatorWaitlistResponse;

export type DownloadEducatorReceiptData = {
  /**
   * The id of the Payment to download the receipt for.
   */
  paymentId: number;
};

export type DownloadEducatorReceiptResponse = Blob | File;

export type DownloadEducatorReceiptsArchiveResponse = Blob | File;

export type GetAlexandriaContentData = {
  /**
   * Shared secret issued to the martech Alexandria loader.
   */
  xMartechApiKey: string;
};

export type GetAlexandriaContentResponse = AlexandriaContentList;

export type $OpenApiTs = {
  "/jsonapi/v1/bookmarks": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filter by given bookmarked entity id
         */
        filterBookmarkeeIds?: number;
        /**
         * Filter by given bookmarked entity type
         */
        filterBookmarkeeType?: string;
      };
      res: {
        /**
         * List of bookmarks
         */
        200: Bookmarks;
      };
    };
    post: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Bookmark attributes
         */
        requestBody: CreateBookmarkAttributes;
      };
      res: {
        /**
         * Created bookmark
         */
        200: Bookmark;
      };
    };
  };
  "/jsonapi/v1/bookmarks/{id}": {
    delete: {
      req: {
        id: number;
      };
      res: {
        /**
         * Bookmark is deleted
         */
        204: void;
      };
    };
  };
  "/jsonapi/v1/camps": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * slug to be remove from response
         */
        excludedSlug?: string;
        /**
         * include hub dependencies
         */
        hub?: string;
      };
      res: {
        /**
         * Sessions response
         */
        200: SessionsResult;
      };
    };
  };
  "/jsonapi/v1/camps/{slug}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep: boolean;
        /**
         * slug id
         */
        slug: string;
      };
      res: {
        /**
         * Session response
         */
        200: SingleSessionResult;
      };
    };
  };
  "/api/v3/sessions/{session_uuid}/interactions": {
    get: {
      req: {
        sessionUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: SessionsInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/categories": {
    get: {
      res: {
        /**
         * List of categories
         */
        200: CategoriesResult;
      };
    };
  };
  "/jsonapi/v1/chapters": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        filter?: {
          /**
           * specify a comma-separated list of ids to filter
           */
          id?: string;
        };
      };
      res: {
        /**
         * Chapter response
         */
        200: ChapterResult;
      };
    };
  };
  "/jsonapi/v1/courses": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        filter?: {
          tag?: string;
          /**
           * specify a comma-separated list of ids to filter
           */
          id?: string;
        };
      };
      res: {
        /**
         * Courses response
         */
        200: CoursesResult;
      };
    };
  };
  "/jsonapi/v1/courses/{slug}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters courses by tag
         */
        filter?: {
          tag?: string;
        };
        /**
         * Course slug
         */
        slug: string;
      };
      res: {
        /**
         * Courses response
         */
        200: Course | CourseDeep;
      };
    };
  };
  "/jsonapi/v1/courses/{id}/content-gems": {
    get: {
      req: {
        /**
         * Course id
         */
        id: number;
      };
      res: {
        /**
         * Mobile content gems response
         */
        200: MobileContentGems;
      };
    };
  };
  "/jsonapi/v2/content-rows": {
    get: {
      req: {
        pageSlug?: string;
        platform?: "web";
      };
      res: {
        /**
         * List of content rows
         */
        200: ContentRows;
      };
    };
  };
  "/jsonapi/v2/content-rows/{id}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Content row ID
         */
        id: number;
      };
      res: {
        /**
         * Content row response
         */
        200: ContentRow;
      };
    };
  };
  "/jsonapi/v1/conversations": {
    get: {
      req: {
        /**
         * filters by course
         */
        filterCourseId?: number;
        /**
         * filters by client session
         */
        filterVisitSessionId?: string;
        /**
         * Sort by attribute
         */
        sort?: string;
      };
      res: {
        /**
         * Conversation response
         */
        200: Conversations;
      };
    };
    post: {
      req: {
        /**
         * Conversation attributes
         */
        requestBody: ConversationAttributes;
      };
      res: {
        /**
         * Created note
         */
        200: Conversation;
      };
    };
  };
  "/jsonapi/v1/conversations/introduction": {
    get: {
      req: {
        /**
         * Current chapter
         */
        chapterId?: number;
        /**
         * Current course
         */
        courseId?: number;
      };
      res: {
        /**
         * Conversation response
         */
        200: ConversationIntroduction;
      };
    };
  };
  "/jsonapi/v1/conversations/{id}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        id: number;
      };
      res: {
        /**
         * Conversation response
         */
        200: Conversation;
      };
    };
  };
  "/jsonapi/v1/conversations/{id}/messages": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        id: number;
        /**
         * Page size
         */
        pageLimit?: number;
        /**
         * Page offset (multiple of page[limit])
         */
        pageOffset?: number;
        /**
         * Sort by id or -id
         */
        sort?: string;
      };
      res: {
        /**
         * Conversation messagesresponse
         */
        200: ConversationMessages;
      };
    };
    post: {
      req: {
        id: number;
        /**
         * Message attributes
         */
        requestBody: ConversationMessageAttributes;
      };
      res: {
        /**
         * Created message
         */
        200: ConversationMessage;
      };
    };
    put: {
      req: {
        id: number;
        /**
         * Message attributes
         */
        requestBody: ConversationMessageAttributes;
      };
      res: {
        /**
         * Created or updated message
         */
        200: ConversationMessage;
      };
    };
  };
  "/jsonapi/v1/conversations/{conversation_id}/messages/{id}": {
    get: {
      req: {
        conversationId: number;
        /**
         * include dependencies
         */
        deep?: boolean;
        id: number;
      };
      res: {
        /**
         * Conversation response
         */
        200: ConversationMessage;
      };
    };
    patch: {
      req: {
        conversationId: number;
        id: number;
        /**
         * Message update attributes
         */
        requestBody: ConversationMessageUpdateAttributes;
      };
      res: {
        /**
         * Conversation message response
         */
        200: ConversationMessage;
      };
    };
  };
  "/jsonapi/v1/email-confirmations": {
    post: {
      req: {
        /**
         * Context for the Email Confirmation
         */
        requestBody: EmailConfirmationAttributes;
      };
      res: {
        /**
         * Email Confirmation sent to the email on file.
         */
        200: EmailConfirmation;
      };
    };
  };
  "/jsonapi/v1/email-confirmations/{token}": {
    get: {
      req: {
        /**
         * Token that references a specific Email Confirmation
         */
        token: string;
      };
      res: {
        /**
         * Email Confirmation
         */
        200: EmailConfirmation;
      };
    };
  };
  "/email_confirmations": {
    get: {
      res: {
        /**
         * Email confirmation response
         */
        200: {
          confirmationStatus?: EmailConfirmationStatus;
          email?: string;
        };
      };
    };
    post: {
      req: {
        /**
         * Email confirmation attributes
         */
        requestBody: {
          emailConfirmation: EmailConfirmationLegacyAttributes;
        };
      };
      res: {
        /**
         * Email confirmation already exists
         */
        200: {
          confirmationStatus?: string;
        };
        /**
         * Bad request
         */
        400: {
          error?: string;
        };
      };
    };
  };
  "/jsonapi/v1/enterprise/enterprise_subscriptions/template": {
    get: {
      res: {
        /**
         * CSV downloaded
         */
        200: unknown;
        /**
         * Not authorized to download csv
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/enterprise_subscriptions": {
    get: {
      res: {
        /**
         * Enterprise Subscriptions list
         */
        200: EnterpriseSubscriptions;
        /**
         * Not authorized to get enterprise subscriptions
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/enterprise_notifications": {
    get: {
      res: {
        /**
         * Notification list
         */
        200: EnterpriseNotifications;
        /**
         * Not authorized to get notifications
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/enterprise_notifications/clear": {
    patch: {
      req: {
        /**
         * Ids to clear
         */
        requestBody: {
          ids: Array<string>;
        };
      };
      res: {
        /**
         * Notifications deleted
         */
        204: void;
      };
    };
  };
  "/jsonapi/v1/enterprise/bulk_send_invites/{id}": {
    get: {
      req: {
        /**
         * Bulk import id
         */
        id: number;
      };
      res: {
        /**
         * Scheduled invitation retrieved
         */
        200: TeamScheduledInvitation;
        /**
         * Not authorized to get scheduled invitation
         */
        401: unknown;
      };
    };
    patch: {
      req: {
        id: number;
        /**
         * Scheduled invite attributes
         */
        requestBody: {
          sendInviteAt: string;
        };
      };
      res: {
        /**
         * Scheduled invite has been successfully updated
         */
        200: unknown;
      };
    };
    delete: {
      req: {
        id: number;
      };
      res: {
        /**
         * Scheduled invite has been successfully cancelled.
         */
        204: void;
      };
    };
  };
  "/jsonapi/v1/enterprise/bulk_send_invites/{id}/user_bulk_send_invites": {
    get: {
      req: {
        /**
         * Bulk invite ID
         */
        id: number;
        /**
         * team ID
         */
        teamId?: number;
      };
      res: {
        /**
         * Team's Scheduled invitations CSV retrieved
         */
        200: string;
        /**
         * Not authorized to get Team's Scheduled invitations CSV
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams": {
    post: {
      req: {
        /**
         * Attributes for the new Profile
         */
        requestBody: TeamCreateAttributes;
      };
      res: {
        /**
         * Team created successfully
         */
        201: Team;
        /**
         * Not authorized to create team
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{id}": {
    get: {
      req: {
        filter?: string;
        /**
         * Team ID
         */
        id: number;
        include?: string;
        pageOffset?: number;
      };
      res: {
        /**
         * Team data
         */
        200: Team;
      };
    };
    delete: {
      req: {
        /**
         * Team ID
         */
        id: number;
      };
      res: {
        /**
         * Team deleted
         */
        200: unknown;
        /**
         * Not authorized to delete team
         */
        401: unknown;
        /**
         * Team not found
         */
        404: unknown;
      };
    };
    patch: {
      req: {
        /**
         * Team ID
         */
        id: number;
        /**
         * Team's new name
         */
        requestBody: {
          name?: string;
        };
      };
      res: {
        /**
         * Team name updated
         */
        200: unknown;
        /**
         * Not authorized to update user
         */
        401: unknown;
        /**
         * Team not found
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/email": {
    post: {
      req: {
        /**
         * Email and role
         */
        requestBody: {
          /**
           * New admin's email
           */
          email?: string;
          /**
           * New admin's role
           */
          role?: string;
        };
        /**
         * Team ID
         */
        teamId: number;
      };
      res: {
        /**
         * New admin added
         */
        200: unknown;
        /**
         * Unauthorized admin or requires a logged in user
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/remind/{user_id}": {
    post: {
      req: {
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * Reminder sent
         */
        200: unknown;
        /**
         * Not authorized to remind user
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/users/bulk_destroy": {
    delete: {
      req: {
        /**
         * User IDs to remove. If omitted, all members are removed from the team.
         */
        requestBody?: {
          userIds?: Array<number>;
        };
        /**
         * Team ID
         */
        teamId: number;
      };
      res: {
        /**
         * Users removed from team
         */
        204: void;
        /**
         * Not authorized to remove users from team
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/users/{user_id}": {
    patch: {
      req: {
        /**
         * User's new name
         */
        requestBody: {
          user?: {
            firstName?: string;
            lastName?: string;
          };
        };
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * User updated
         */
        200: unknown;
        /**
         * Not authorized to update user
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
    post: {
      req: {
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * User added to team
         */
        200: unknown;
        /**
         * Not authorized to add user to team
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        /**
         * Admin Role
         */
        role?: string;
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * User removed from team
         */
        200: unknown;
        /**
         * Not authorized to remove user from team
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/users/{user_id}/role/{role}": {
    post: {
      req: {
        /**
         * admin role
         */
        role: string;
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * User added to team
         */
        200: unknown;
        /**
         * Not authorized to add user to team
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/users/{user_id}/admin_role/{admin_role}": {
    post: {
      req: {
        /**
         * admin role
         */
        adminRole: string;
        /**
         * Team ID
         */
        teamId: number;
        /**
         * User ID
         */
        userId: number;
      };
      res: {
        /**
         * User updated
         */
        200: unknown;
        /**
         * Not authorized to update user
         */
        401: unknown;
        /**
         * User not found
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/teams/{team_id}/scheduled_invitations": {
    get: {
      req: {
        /**
         * Team ID
         */
        teamId: number;
      };
      res: {
        /**
         * Scheduled invitations retrieved
         */
        200: TeamScheduledInvitations;
        /**
         * Not authorized to get scheduled invitations
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/organizations/{id}": {
    get: {
      req: {
        deep?: boolean;
        /**
         * Organization ID
         */
        id: number;
      };
      res: {
        /**
         * Organization data
         */
        200: Organization;
      };
    };
  };
  "/jsonapi/v1/enterprise/organizations/{id}/logo": {
    delete: {
      req: {
        /**
         * Organization ID
         */
        id: number;
      };
      res: {
        /**
         * Logo has been removed
         */
        204: void;
      };
    };
  };
  "/jsonapi/v1/enterprise/team_notifications": {
    post: {
      req: {
        /**
         * Attributes for the custom message
         */
        requestBody: TeamNotification;
      };
      res: {
        /**
         * Custom message saved successfully
         */
        201: TeamNotification;
        /**
         * Not authorized to add custom message
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/team_notifications/{id}": {
    get: {
      req: {
        /**
         * Team notification ID
         */
        id: number;
      };
      res: {
        /**
         * Custom message retrieved
         */
        200: TeamNotification;
        /**
         * Not authorized to get organization custom message
         */
        401: unknown;
      };
    };
    delete: {
      req: {
        /**
         * Team notification ID
         */
        id: number;
      };
      res: {
        /**
         * Organization Custom Message has been deleted
         */
        204: void;
        /**
         * Not authorized to delete organization custom message
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/team_notifications/{id}/dismiss": {
    post: {
      req: {
        /**
         * Team notification ID
         */
        id: number;
      };
      res: {
        /**
         * Organization Custom Message has been dismissed for the current user
         */
        200: unknown;
        /**
         * Not authorized to dismiss the organization custom message
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/enterprise/my_notifications/unread": {
    get: {
      res: {
        /**
         * Custom message retrieved
         */
        200: Array<MemberNotification>;
        /**
         * Not authorized to get organization member custom message
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/episodes": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters for Episodes
         */
        filter?: {
          pilot?: boolean;
        };
      };
      res: {
        /**
         * List of all Episodes filtered by options
         */
        200: Episodes;
      };
    };
  };
  "/jsonapi/v1/episodes/{slug}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Episode slug
         */
        slug: string;
      };
      res: {
        /**
         * Episode response
         */
        200: Episode;
      };
    };
  };
  "/jsonapi/v1/experiments/sessionless": {
    get: {
      res: {
        /**
         * Array of experiments
         */
        200: Experiments;
      };
    };
  };
  "/jsonapi/v1/feature-interactions": {
    get: {
      req: {
        /**
         * Filters for current user's Feature Interactions
         */
        filter?: {
          id?: number;
        };
      };
      res: {
        /**
         * List of feature interactions
         */
        200: FeatureInteractionsResult;
      };
    };
    post: {
      req: {
        /**
         * Updated feature interaction info
         */
        requestBody: FeatureInteractionAttributes;
      };
      res: {
        /**
         * Successful create/update of Feature Interaction
         */
        200: FeatureInteraction;
      };
    };
  };
  "/jsonapi/v1/guest-passes/{referralToken}": {
    get: {
      req: {
        /**
         * Referral token
         */
        referralToken: string;
      };
      res: {
        /**
         * free trial data
         */
        200: FreeTrial;
      };
    };
  };
  "/jsonapi/v1/guest-pass-email-share": {
    post: {
      req: {
        /**
         * Emails where the guest pass will be shared
         */
        requestBody: GuestPassShareAttributes;
      };
      res: {
        /**
         * Fire events for emails
         */
        200: unknown;
      };
    };
  };
  "/jsonapi/v1/immersive-heros": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * specify a one of slug, courseSlug, or chapterSlug to filter
         */
        filter?: {
          /**
           * specify a gem slug to filter
           */
          slug?: string;
          /**
           * specify a course slug to filter
           */
          courseSlug?: string;
          /**
           * specify a chapter slug to filter
           */
          chapterSlug?: string;
        };
      };
      res: {
        /**
         * Immersive Heroes response
         */
        200: ImmersiveHeros;
      };
    };
  };
  "/jsonapi/v1/instructors": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        filter?: {
          /**
           * specify a playlist
           */
          playlist?: string;
          /**
           * specify a comma-separated list of ids to filter
           */
          id?: string;
        };
      };
      res: {
        /**
         * List of instructors
         */
        200: Array<Instructor>;
        /**
         * User is not signed in
         */
        401: unknown;
      };
    };
  };
  "/jsonapi/v1/marketing-sections": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * include additional dependencies
         */
        include?: string;
      };
      res: {
        /**
         * Marketing sections response
         */
        200: MarketingSectionsResult;
      };
    };
  };
  "/jsonapi/v1/notes": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters for Notes
         */
        filter?: {
          courseSlug?: string;
        };
      };
      res: {
        /**
         * List of notes
         */
        200: Notes;
      };
    };
    post: {
      req: {
        /**
         * Note attributes
         */
        requestBody: CreateNoteAttributes;
      };
      res: {
        /**
         * Created note
         */
        200: Note;
      };
    };
  };
  "/jsonapi/v1/notes/{id}": {
    delete: {
      req: {
        id: number;
      };
      res: {
        /**
         * Note is deleted
         */
        204: void;
      };
    };
    patch: {
      req: {
        id: number;
        /**
         * Note attributes
         */
        requestBody: {
          content: string;
        };
      };
      res: {
        /**
         * Updated note
         */
        200: Note;
      };
    };
  };
  "/jsonapi/v1/playlists/{slug}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        slug: string;
        track?: string;
      };
      res: {
        /**
         * Playlist response
         */
        200: Playlist;
      };
    };
  };
  "/jsonapi/v1/playlists": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        filter?: {
          /**
           * specify a comma-separated list of ids to filter
           */
          id?: string;
        };
      };
      res: {
        /**
         * Playlists response
         */
        200: Playlists;
      };
    };
  };
  "/jsonapi/v1/products": {
    get: {
      req: {
        /**
         * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
         */
        discountSlug?: string;
        /**
         * include additional dependencies
         */
        filterPurchasePlanSlugs?: string;
        /**
         * gift query param, determines whether we are sending a gift or not
         */
        gift?: boolean;
      };
      res: {
        /**
         * Products response
         */
        200: Products;
      };
    };
  };
  "/jsonapi/v1/profiles": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
      };
      res: {
        /**
         * List of all Profiles associated to the current User
         */
        200: Profiles;
      };
    };
    post: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Attributes for the new Profile
         */
        requestBody: ProfileCreateAttributes;
      };
      res: {
        /**
         * Newly created Profile
         */
        200: Profile;
      };
    };
  };
  "/jsonapi/v1/profiles/{id}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Profile ID
         */
        id: number;
      };
      res: {
        /**
         * The profile uniquely identified by the given id
         */
        200: Profile;
      };
    };
    patch: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        id: number;
        /**
         * Profile attributes to be changed
         */
        requestBody: ProfileUpdateAttributes;
      };
      res: {
        /**
         * The updated Profile
         */
        200: Profile;
      };
    };
    delete: {
      req: {
        id: number;
      };
      res: {
        /**
         * Profile is deleted
         */
        204: void;
      };
    };
  };
  "/jsonapi/v1/onboarding-content-recommendation": {
    get: {
      res: {
        /**
         * Onboarding content recommendation response
         */
        200: OnboardingContentRecommendation;
      };
    };
  };
  "/jsonapi/v1/purchase_plans/{id}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Either id number or specific plan slug
         */
        id: string | number;
      };
      res: {
        /**
         * Purchase plan data
         */
        200: PurchasePlan;
      };
    };
  };
  "/jsonapi/v1/referral-audio-programs": {
    get: {
      res: {
        /**
         * List of showcase items
         */
        200: ReferralAudioProgramsResult;
      };
    };
  };
  "/jsonapi/v1/referral-tokens": {
    post: {
      req: {
        /**
         * Attributes to create an invitation link. These attributes will be used to create utm params and handle link redirection
         */
        requestBody: ReferralTokenAttributes;
      };
      res: {
        /**
         * Created invitation links
         */
        200: ShareLinks;
      };
    };
  };
  "/jsonapi/v1/showcases": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
      };
      res: {
        /**
         * List of showcase items
         */
        200: ShowcasesResult;
      };
    };
  };
  "/jsonapi/v1/skills": {
    get: {
      res: {
        /**
         * List of skills
         */
        200: SkillsResult;
      };
    };
  };
  "/jsonapi/v1/subscriptions/last": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
      };
      res: {
        /**
         * The subscription item
         */
        200: Subscription;
      };
    };
  };
  "/jsonapi/v1/themes": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters for ids
         */
        filter?: {
          /**
           * CSV of ids to filter
           */
          id?: string;
        };
        /**
         * include additional dependencies
         */
        include?: string;
      };
      res: {
        /**
         * Themes response
         */
        200: ThemesResults;
      };
    };
  };
  "/jsonapi/v1/tier_collections/current": {
    get: {
      req: {
        /**
         * param to support the prcng-897V1 experiment (accelerator bundle) and return the correct tier collection
         */
        acceleratorBundleBucket?: string;
        /**
         * temporal param to support the prcng-107V1 experiment and return the correct tier collection
         */
        collapsedBucket?: string;
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
         */
        discountSlug?: string;
        /**
         * gift query param, determines whether we are sending a gift or not
         */
        gift?: boolean;
        /**
         * param to support the prcng-1194V1 experiment (MasterClass Pro tier) and return the correct tier collection
         */
        mcProBucket?: string;
        /**
         * param to support the prcng-861V1 experiment (standard price decrease) and return the correct tier collection
         */
        standardPriceDecreaseBucket?: string;
      };
      res: {
        /**
         * Tiers response
         */
        200: TierCollection;
      };
    };
  };
  "/jsonapi/v1/tier_collections/persona-bundle": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * discount slug query param, if sent the endpoint will respond the product with discounted prices applied
         */
        discountSlug?: string;
        /**
         * gift query param, determines whether we are sending a gift or not
         */
        gift?: boolean;
      };
      res: {
        /**
         * Tiers response
         */
        200: TierCollection;
      };
    };
  };
  "/jsonapi/v1/user/cart-data": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
      };
      res: {
        /**
         * User cart data
         */
        200: CartData;
      };
    };
  };
  "/jsonapi/v1/user/guest-passes": {
    get: {
      res: {
        /**
         * User guest passes data
         */
        200: GuestPass;
      };
    };
  };
  "/jsonapi/v1/user/products/last": {
    get: {
      res: {
        /**
         * Product response
         */
        200: Product;
        /**
         * User is not signed in
         */
        401: unknown;
        /**
         * User has no subscription with a product
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v1/user/streams": {
    post: {
      req: {
        /**
         * Information about a new streaming session
         */
        requestBody: StreamAttributes;
      };
      res: {
        /**
         * Streaming session information is received
         */
        200: StreamsResult;
      };
    };
    delete: {
      req: {
        /**
         * Streaming session id
         */
        requestBody: StreamAttributes;
      };
      res: {
        /**
         * Streaming session is destroyed
         */
        200: StreamsResult;
      };
    };
  };
  "/jsonapi/v1/user-camps": {
    get: {
      res: {
        /**
         * User sessions response
         */
        200: UserSessionsResult;
      };
    };
  };
  "/jsonapi/v1/user-courses": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * include additional dependencies
         */
        include?: string;
      };
      res: {
        /**
         * User courses response
         */
        200: UserCoursesResult;
      };
    };
    post: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Course to associate to User
         */
        requestBody: CreateUserCourseAttributes;
      };
      res: {
        /**
         * Created User Course
         */
        200: UserCourse;
      };
    };
  };
  "/jsonapi/v1/user-courses/{slug}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters courses by tag
         */
        filter?: {
          tag?: string;
        };
        /**
         * Course slug
         */
        slug: string;
      };
      res: {
        /**
         * User course response
         */
        200: UserCourse;
      };
    };
  };
  "/jsonapi/v1/user-progress": {
    get: {
      req: {
        /**
         * Filters for current user's watch list items
         */
        filter?: {
          contentType?: string;
        };
      };
      res: {
        /**
         * User progress response
         */
        200: UserProgressResults;
      };
    };
  };
  "/jsonapi/v1/user-playlists": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * Filters for completed playlists
         */
        filter?: {
          completed?: boolean;
        };
        /**
         * include additional dependencies
         */
        include?: string;
      };
      res: {
        /**
         * User playlists response
         */
        200: UserPlaylistResults;
      };
    };
  };
  "/jsonapi/v1/users/{id}": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
        /**
         * User id
         */
        id: string | number;
      };
      res: {
        /**
         * User data
         */
        200: User;
      };
    };
    patch: {
      req: {
        /**
         * User id
         */
        id: string | number;
        /**
         * Updated user info
         */
        requestBody: UserAttributesForUpdate;
      };
      res: {
        /**
         * Successful update of user
         */
        200: User;
      };
    };
  };
  "/jsonapi/v1/video-progress-entries": {
    get: {
      req: {
        /**
         * Filters for current user's Video Progress Entries
         */
        filter?: {
          byVideoType?: string;
        };
      };
      res: {
        /**
         * Video Progress Entries for current user
         */
        200: VideoProgressEntriesResult;
      };
    };
    post: {
      req: {
        /**
         * New video progress entry info
         */
        requestBody: VideoProgressEntryAttributesForCreate;
      };
      res: {
        /**
         * Successful create of Video Progress Entry
         */
        200: VideoProgressEntry;
      };
    };
  };
  "/jsonapi/v1/video-progress-entries/{id}": {
    patch: {
      req: {
        /**
         * Video Progress Entry id
         */
        id: number;
        /**
         * Updated video progress entry info
         */
        requestBody: VideoProgressEntryAttributesForUpdate;
      };
      res: {
        /**
         * Successful update of Video Progress Entry
         */
        200: VideoProgressEntry;
      };
    };
  };
  "/jsonapi/v1/watch-list-items": {
    get: {
      req: {
        /**
         * include dependencies
         */
        deep?: boolean;
      };
      res: {
        /**
         * Watch list items response
         */
        200: WatchListResults;
      };
    };
    post: {
      req: {
        /**
         * Information about the watch list item
         */
        requestBody: WatchListItemAttributes;
      };
      res: {
        /**
         * Successful create of Watch List Item
         */
        200: WatchListItem;
      };
    };
  };
  "/jsonapi/v1/watch-list-items/{id}": {
    delete: {
      req: {
        /**
         * Id of the current item
         */
        id: number;
      };
      res: {
        /**
         * The item is removed
         */
        200: unknown;
      };
    };
  };
  "/jsonapi/v1/products/landing-prices": {
    get: {
      req: {
        /**
         * user geo to calculate price
         */
        mcGeo: string;
      };
      res: {
        /**
         * Prices response
         */
        200: LandingPrices;
      };
    };
  };
  "/jsonapi/v1/products/persona-bundle": {
    get: {
      res: {
        /**
         * Persona bundle pricing information response
         */
        200: PersonaBundle;
      };
    };
  };
  "/jsonapi/v2/search-config": {
    get: {
      req: {
        mode?: "library" | "search" | "customplaylists";
        platform?: "web";
        userExperience?: "consumer" | "enterprise";
      };
      res: {
        /**
         * Algolia search configuration
         */
        200: SearchConfig;
      };
    };
  };
  "/api/v1/accounts/check_email": {
    get: {
      req: {
        /**
         * email to verify
         */
        email: string;
      };
      res: {
        /**
         * Email is registered (User already exists)
         */
        200: EmailAccount;
        /**
         * Email is not registered (User does not exists)
         */
        404: UnregisteredEmail;
      };
    };
  };
  "/api/v1/accounts/complete_registration": {
    put: {
      req: {
        /**
         * User attributes
         */
        requestBody: UserRegistration;
      };
      res: {
        /**
         * User name and password are set correctly
         */
        200: unknown;
      };
    };
  };
  "/api/v1/credit_cards": {
    post: {
      req: {
        /**
         * Credit card params
         */
        requestBody: CreateCreditCardAttributes;
      };
      res: {
        /**
         * Credit card created
         */
        200: CreditCard;
      };
    };
    get: {
      res: {
        /**
         * Credit cards index
         */
        200: CreditCards;
      };
    };
  };
  "/api/v1/credit_cards/{id}": {
    delete: {
      req: {
        id: number;
      };
      res: {
        /**
         * Credit card is deleted
         */
        204: void;
      };
    };
  };
  "/api/v1/credit_cards/credit_cards_with_currency": {
    get: {
      req: {
        /**
         * Skip the Stripe customer currency filter. One-time charges are not bound by the customer's currency lock, only subscriptions are, so flows that charge a saved card once (certificate add-ons) can use any saved card.
         */
        forOneTimePurchase?: boolean;
        /**
         * Include Link payment methods (which have no card details). Required for post-purchase add-on flows that support Link purchases.
         */
        includeLink?: boolean;
        /**
         * Filter credit card by payment method cards or token cards
         */
        tokenOnly?: boolean;
      };
      res: {
        /**
         * Credit cards with user ip currency index
         */
        200: CreditCards;
      };
    };
  };
  "/api/v1/credit_cards/default_credit_card": {
    get: {
      res: {
        /**
         * Default credit card
         */
        200: CreditCard;
      };
    };
  };
  "/api/v1/credit_cards/confirm": {
    get: {
      req: {
        setupIntentId: string;
      };
      res: {
        /**
         * Returns either a status object or credit card details. A status object is returned while the setup intent is pending confirmation. Once confirmed, the complete credit card details are returned.
         */
        200: SetupIntentStatus | CreditCard;
      };
    };
  };
  "/api/v1/coupons/verify": {
    get: {
      req: {
        /**
         * Slug of the coupon to be verified
         */
        code: string;
        /**
         * ID of the product the coupon is being applied to
         */
        productId: number;
      };
      res: {
        /**
         * Coupon details
         */
        200: DiscountCoupon;
      };
    };
  };
  "/api/v2/orders": {
    post: {
      req: {
        /**
         * Order params
         */
        requestBody: CreateOrderAttributes;
        /**
         * COM-839
         */
        xTsBucket: string;
      };
      res: {
        /**
         * Purchase completed
         */
        200: Order;
      };
    };
  };
  "/api/v2/orders/{id}/confirm": {
    get: {
      req: {
        id: number;
      };
      res: {
        /**
         * Order status retrieved
         */
        200: OrderConfirmation;
      };
    };
  };
  "/api/v2/cart": {
    put: {
      req: {
        /**
         * Send the productId and discount we would like to add
         */
        requestBody: UpdateProductAttributes;
      };
      res: {
        /**
         * Cart product updated successfully
         */
        200: unknown;
      };
    };
  };
  "/api/v2/cart/add_product": {
    post: {
      req: {
        /**
         * Cart attributes
         */
        requestBody: AddProductAttributes;
      };
      res: {
        /**
         * Product added successfully
         */
        200: {
          product: CartProduct;
        };
      };
    };
  };
  "/api/v2/cart/clear_cart": {
    post: {
      res: {
        /**
         * Cart cleared successfully
         */
        200: {
          /**
           * Status of the cart clear operation
           */
          status: boolean;
          /**
           * Message indicating the success of the operation
           */
          message: string;
        };
      };
    };
  };
  "/api/v2/cart/remove_product": {
    post: {
      req: {
        /**
         * Product attributes
         */
        requestBody: RemoveProductAttributes;
      };
      res: {
        /**
         * Product removed successfully
         */
        200: {
          product: CartProduct;
        };
      };
    };
  };
  "/api/v2/cart/show_products": {
    get: {
      req: {
        /**
         * if user is gifting, we send gift = true
         */
        gift?: boolean;
      };
      res: {
        /**
         * List of all products added
         */
        200: CartProducts;
      };
    };
  };
  "/bogo_gifts/{bogo_gift_token}/redeem": {
    post: {
      req: {
        /**
         * gift token
         */
        bogoGiftToken: string;
        /**
         * Gift attributes
         */
        requestBody: {
          gift: RedeemBogoGift;
        };
      };
      res: {
        /**
         * Gift sent correctly
         */
        200: {
          gifteeName?: string;
        };
      };
    };
  };
  "/api/v2/users/gift_add_on": {
    get: {
      res: {
        /**
         * Discount details for purchase a gift add on subscription
         */
        200: GiftAddOn;
        /**
         * No user logged in to the system
         */
        401: unknown;
      };
    };
  };
  "/api/v2/add_ons": {
    get: {
      res: {
        /**
         * Details required for the add ons storefront page
         */
        200: {
          persona?: PersonaAddOn;
          learningToolkit?: LearningToolkitAddOn;
          gift?: GiftAddOn;
          certificatePrograms?: Array<CertificateProgramAddOn>;
          certificateCredit?: CertificateCreditAddOn;
        };
      };
    };
  };
  "/api/v2/add_ons/annual_pass": {
    get: {
      res: {
        /**
         * Details needed for purchase of an annual pass subscription add-on
         */
        200: AnnualPassAddOn;
      };
    };
  };
  "/api/v2/add_ons/learning_toolkit": {
    get: {
      res: {
        /**
         * Details needed for purchase of a learning toolkit subscription
         */
        200: LearningToolkitAddOn;
      };
    };
  };
  "/api/v2/add_ons/persona": {
    get: {
      res: {
        /**
         * Details needed for purchase of a persona add-on subscription
         */
        200: PersonaAddOn;
      };
    };
  };
  "/api/v2/add_ons/certificate_credit": {
    get: {
      res: {
        /**
         * Details needed for purchase of a certificate credit add-on subscription
         */
        200: CertificateCreditAddOn;
      };
    };
  };
  "/api/v2/add_ons/post_purchase_certificates": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<CertificateProgramAddOn>;
      };
    };
  };
  "/api/v2/add_ons/{id}/preview_proration": {
    get: {
      req: {
        /**
         * ID of the product to preview proration for
         */
        id: number;
      };
      res: {
        /**
         * Proration preview information for the specified product
         */
        200: ProrationPreview;
        /**
         * Product not found
         */
        404: {
          error?: string;
        };
      };
    };
  };
  "/api/v2/add_on_subscriptions/{id}/cancel": {
    put: {
      req: {
        id: number;
      };
      res: {
        /**
         * Add on Subscription will not be renewed
         */
        200: unknown;
      };
    };
  };
  "/api/v2/subscriptions/{id}/reactivate": {
    put: {
      req: {
        id: number;
      };
      res: {
        /**
         * Subscription reactivated
         */
        200: unknown;
      };
    };
  };
  "/api/v2/subscriptions/{id}/preview": {
    get: {
      req: {
        /**
         * The product id of the plan to preview
         */
        changeProductId: number;
        id: number;
      };
      res: {
        /**
         * Preview response
         */
        200: {
          /**
           * The prorated amount for the plan change
           */
          proratedAmount?: string;
          /**
           * The currency code
           */
          currency?: string;
          /**
           * The type of change (upgrade or downgrade)
           */
          changeType?: "upgrade" | "downgrade";
        };
      };
    };
  };
  "/api/v2/subscriptions/{id}": {
    put: {
      req: {
        /**
         * Subscription ID
         */
        id: number;
        /**
         * Subscription attributes
         */
        requestBody: {
          /**
           * The type of change
           */
          changeType: string;
          /**
           * The product id of the plan to update
           */
          changeProductId: number;
        };
      };
      res: {
        /**
         * Subscription updated
         */
        200: {
          /**
           * A message indicating the subscription was updated
           */
          message?: string;
        };
      };
    };
  };
  "/api/v2/subscriptions/pricing-upgrade": {
    put: {
      res: {
        /**
         * Subscription upgraded
         */
        200: unknown;
      };
    };
  };
  "/api/v3/watch-bundles/{watch_bundle_uuid}": {
    get: {
      req: {
        watchBundleUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: WatchBundle;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/watch-bundle-details": {
    get: {
      req: {
        bundleUuid?: string;
        /**
         * The database ID or slug of the bundleable content.
         * Must be provided together with contentType.
         *
         */
        contentId?: string;
        /**
         * The type of the bundleable content.
         * Must be provided together with contentId.
         *
         */
        contentType?: "Course" | "Playlist";
      };
      res: {
        /**
         * OK
         */
        200: WatchBundleDetails;
        /**
         * Bad request. Required query parameters are missing or invalid.
         *
         */
        400: unknown;
        /**
         * The resource could not be found.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/watch-bundles/{watch_bundle_uuid}/extras": {
    get: {
      req: {
        watchBundleUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: WatchBundleExtras;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/watch-bundles/{watch_bundle_uuid}/interactions": {
    get: {
      req: {
        watchBundleUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: WatchBundleInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/bookmarks/{uuid}": {
    patch: {
      req: {
        /**
         * The unique identifier of a resource to bookmark.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: V3Bookmark;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        /**
         * The unique identifier of a resource to bookmark.
         */
        uuid: string;
      };
      res: {
        /**
         * No Content. The bookmark was removed from the resource.
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/notes/{content_uuid}": {
    patch: {
      req: {
        contentUuid: string;
        requestBody: {
          entry: string;
        };
      };
      res: {
        /**
         * OK
         */
        200: V3Note;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        contentUuid: string;
      };
      res: {
        /**
         * No Content. The note was destroyed.
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/watch-bundles-contents/{content_uuid}/interactions": {
    get: {
      req: {
        /**
         * Content uuid
         */
        contentUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: WatchBundleContentInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/playback/{content_uuid}": {
    patch: {
      req: {
        contentUuid: string;
        requestBody: {
          cursor: number;
        };
      };
      res: {
        /**
         * OK
         */
        200: Playhead;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/playback/token": {
    get: {
      res: {
        /**
         * OK
         */
        200: PlaybackTokenResponse;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/surveys/{content_uuid}": {
    patch: {
      req: {
        contentUuid: string;
        requestBody: UpdateSurvey;
      };
      res: {
        /**
         * Survey feedback was accepted. The watch bundle interactions will be updated to indicate
         * the survey should not be taken again.
         *
         */
        204: void;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/sharing/{uuid}": {
    get: {
      req: {
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Sharing;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/session-activities/{uuid}/interactions": {
    get: {
      req: {
        /**
         * Activity uuid
         */
        uuid: string;
      };
      res: {
        /**
         * Session activity response
         */
        200: SessionActivityInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/assignees": {
    get: {
      res: {
        /**
         * OK
         */
        200: Assignees;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/progress/{uuid}": {
    get: {
      req: {
        filters?: {
          [key: string]: unknown;
        };
        /**
         * Filters progress based on who shared
         */
        sharedBy?: "all" | "me";
        /**
         * The team identifier in which the progress content was assigned.
         */
        teamId: string;
        /**
         * The unique identifier of an assignable content.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: ContentProgress;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/assignments": {
    get: {
      res: {
        /**
         * OK
         */
        200: AssignedContents;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
    post: {
      req: {
        requestBody: CreateAssignments;
        xRequestId?: string;
      };
      res: {
        /**
         * OK
         */
        201: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/assignments/{content_uuid}": {
    delete: {
      req: {
        contentUuid: string;
        requestBody: UserIdentifier;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/assignments/{content_uuid}/bulk": {
    delete: {
      req: {
        contentUuid: string;
      };
      res: {
        /**
         * Accepted
         */
        202: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * Not Found
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/assignable-content": {
    get: {
      res: {
        /**
         * OK
         */
        200: AssignableContentResult;
      };
    };
  };
  "/api/v3/enterprise/admin/navigation": {
    get: {
      res: {
        /**
         * OK
         */
        200: NavigationContents;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/admin/organizations/{id}": {
    get: {
      req: {
        id: string;
      };
      res: {
        /**
         * OK
         */
        200: V3Organization;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/admin/template-bulk-import": {
    get: {
      res: {
        /**
         * OK
         */
        200: string;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/skills": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<EnterprisePlaylistSkill>;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists": {
    get: {
      req: {
        /**
         * The unique identifier of an organization.
         */
        organizationId: number;
      };
      res: {
        /**
         * OK
         */
        200: V3Playlists;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
    post: {
      req: {
        requestBody: CreatePlaylist;
      };
      res: {
        /**
         * Created
         */
        201: CreatedPlaylist;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * This playlist title already exists. Try a different one.
         *
         */
        409: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: V3Playlist;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
    patch: {
      req: {
        formData: UpdatePlaylist;
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{uuid}/publish": {
    patch: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{uuid}/unpublish": {
    patch: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{uuid}/duplicate": {
    post: {
      req: {
        requestBody: CreatePlaylist;
        /**
         * The unique identifier of a playlist.
         */
        uuid: string;
      };
      res: {
        /**
         * Created
         */
        201: CreatedPlaylist;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{playlist_uuid}/lessons": {
    get: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        playlistUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Array<EnterprisePlaylistLesson>;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
    post: {
      req: {
        playlistUuid: string;
        requestBody: EnterprisePlaylistAddLessons;
      };
      res: {
        /**
         * Created
         */
        201: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{playlist_uuid}/lessons/reorder": {
    patch: {
      req: {
        /**
         * The unique identifier of a playlist.
         */
        playlistUuid: string;
        requestBody: ReorderLessons;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/playlists/{playlist_uuid}/lessons/{lesson_uuid}": {
    patch: {
      req: {
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
        /**
         * The unique identifier of a playlist.
         */
        playlistUuid: string;
        requestBody: UpdateLesson;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
        /**
         * The unique identifier of a playlist.
         */
        playlistUuid: string;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/programs/{program_slug}": {
    get: {
      req: {
        /**
         * The unique identifier of a program.
         */
        programSlug: string;
      };
      res: {
        /**
         * OK
         */
        200: Program;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/programs/{program_slug}/enroll": {
    put: {
      req: {
        /**
         * The unique identifier of a program.
         */
        programSlug: string;
      };
      res: {
        /**
         * Enrolled
         */
        201: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/programs/{program_slug}/download-resources": {
    get: {
      req: {
        /**
         * The unique identifier of a program.
         */
        programSlug: string;
        /**
         * Files to be compressed that belong to the same section.
         */
        stage?: "before" | "along" | "after";
      };
      res: {
        /**
         * A ZIP file
         */
        200: Blob | File;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/programs/{program_slug}/modules/{module_slug}/download-resources": {
    get: {
      req: {
        /**
         * The unique identifier of a module.
         */
        moduleSlug: string;
        /**
         * The unique identifier of a program.
         */
        programSlug: string;
      };
      res: {
        /**
         * A ZIP file
         */
        200: Blob | File;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/quote": {
    post: {
      req: {
        requestBody: EnterpriseQuoteRequest;
      };
      res: {
        /**
         * Generated
         */
        201: EnterpriseQuote;
        /**
         * The input to the quote service is invalid
         *
         */
        400: unknown;
      };
    };
  };
  "/api/v3/enterprise/addon-quote": {
    post: {
      req: {
        requestBody: EnterpriseAddonQuoteRequest;
      };
      res: {
        /**
         * Generated
         */
        201: EnterpriseQuote;
        /**
         * The input to the quote service is invalid
         *
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/certificate-interest": {
    post: {
      req: {
        requestBody: CreateCertificateInterest;
      };
      res: {
        /**
         * Interest captured
         */
        201: CertificateInterestResult;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The certificate painted-door feature is not enabled, or the organization was not found.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/process-addon-order": {
    post: {
      req: {
        requestBody: EnterpriseProcessAddonOrderRequest;
      };
      res: {
        /**
         * Processed
         */
        201: EnterpriseAddonOrder;
        /**
         * The input to the order service is invalid
         *
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/process-order": {
    post: {
      req: {
        requestBody: EnterpriseProcessOrderRequest;
      };
      res: {
        /**
         * Order Processed
         */
        201: EnterpriseOrder;
        /**
         * The input to the order service is invalid
         *
         */
        400: unknown;
      };
    };
  };
  "/api/v3/enterprise/invoice/{invoice_id}": {
    get: {
      req: {
        /**
         * The unique identifier of the invoice.
         */
        invoiceId: string;
      };
      res: {
        /**
         * Invoice ready
         */
        200: EnterpriseInvoice;
        /**
         * The invoice does not exist
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/licenses": {
    get: {
      res: {
        /**
         * OK
         */
        200: EnterpriseLicenses;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/licenses/revoke-consent": {
    post: {
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/licenses/{license_id}/team-csv-imports": {
    post: {
      req: {
        formData: CreateTeamCsvImport;
        /**
         * License (EnterpriseSubscription) id.
         */
        licenseId: number;
      };
      res: {
        /**
         * Task enqueued.
         */
        202: TeamCsvImportTask;
        /**
         * The request body was invalid (missing or empty file).
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
        /**
         * File exceeds the maximum allowed size (10 MB).
         */
        413: unknown;
      };
    };
  };
  "/api/v3/enterprise/licenses/{license_id}/team-csv-imports/{id}": {
    get: {
      req: {
        /**
         * TeamCsvImportTask id.
         */
        id: number;
        /**
         * License (EnterpriseSubscription) id.
         */
        licenseId: number;
      };
      res: {
        /**
         * OK
         */
        200: TeamCsvImportTask;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/teams/{team_id}/remind-all": {
    post: {
      req: {
        /**
         * Team ID
         */
        teamId: number;
      };
      res: {
        /**
         * Reminders queued successfully
         */
        202: unknown;
        /**
         * No pending members to remind
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * Team not found or user is not authorized for this team.
         */
        404: unknown;
        /**
         * Reminder already sent within the past 24 hours
         */
        429: {
          error?: string;
        };
      };
    };
  };
  "/api/v3/enterprise/analytics/metrics/{slug}": {
    get: {
      req: {
        filters?: {
          [key: string]: unknown;
        };
        slug: string;
        teamId: string;
      };
      res: {
        /**
         * OK
         */
        200: EnterpriseAnalyticsMetric;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/enterprise/analytics/generate-csv-report-jobs": {
    post: {
      req: {
        /**
         * generate-csv-report-job request body
         */
        requestBody: EnterpriseAnalyticsGenerateCsvReportJobRequest;
      };
      res: {
        /**
         * OK
         */
        202: EnterpriseAnalyticsGenerateCsvReportJobResponse;
        /**
         * The request format is not valid.
         *
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The request is not authorized
         *
         */
        403: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/enterprise/analytics/generate-csv-report-jobs/{uuid}": {
    get: {
      req: {
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: EnterpriseAnalyticsGenerateCsvReportJobResponse;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The request is not authorized
         *
         */
        403: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/jsonapi/v3/content-rows": {
    get: {
      req: {
        /**
         * Used to filter out tiles with a different entityType
         */
        entityType?: Array<V3ContentRowEntityType>;
        filter: {
          bundle: string;
          /**
           * comma-separated list of ids to filter
           */
          id?: string;
          platform:
            | "iphone"
            | "ipad"
            | "android_phone"
            | "android_tv"
            | "fire_tv"
            | "apple tv"
            | "roku"
            | "web";
          /**
           * Used to override row reference
           */
          referenceUuid?: string;
        };
        includeItems?: boolean;
        resourceUuid?: string;
      };
      res: {
        /**
         * List of content rows
         */
        200: V3ContentRows;
      };
    };
  };
  "/api/v3/unique-identifiers/{resource_type_plural}/{slug}": {
    get: {
      req: {
        /**
         * Type of the resource in plural.
         */
        resourceTypePlural:
          | "stories"
          | "collections"
          | "collection-parts"
          | "collection-part-cards"
          | "courses"
          | "chapters"
          | "certificate_programs"
          | "curriculum_lessons";
        /**
         * Slug of the resource.
         */
        slug: string;
      };
      res: {
        /**
         * OK
         */
        200: UniqueIdentifiersResponse;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/my-list": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<MyListItem>;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/my-list/{content_uuid}": {
    post: {
      req: {
        contentUuid: string;
      };
      res: {
        /**
         * OK
         */
        201: unknown;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    delete: {
      req: {
        contentUuid: string;
      };
      res: {
        /**
         * No Content. The content was removed from My List.
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/homepage-layout": {
    get: {
      res: {
        /**
         * Get list of navigation tabs
         */
        200: HomepageLayout;
      };
    };
  };
  "/api/v3/semantic-search": {
    get: {
      req: {
        /**
         * The question asked by the user
         */
        q: string;
      };
      res: {
        /**
         * OK
         */
        200: SemanticSearchResponse;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/app-data": {
    get: {
      res: {
        /**
         * OK
         */
        200: AppData;
      };
    };
  };
  "/api/v3/learning-preferences": {
    patch: {
      req: {
        requestBody: LearningPreferences;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/learning-preferences/career-goal": {
    get: {
      res: {
        /**
         * OK
         */
        200: CareerGoalPage;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/learning-preferences/skills": {
    get: {
      req: {
        /**
         * The career goal selected
         */
        careerGoal: string;
      };
      res: {
        /**
         * OK
         */
        200: SkillsPage;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/learning-preferences/subskills": {
    get: {
      req: {
        /**
         * The skills selected
         */
        skills: string;
      };
      res: {
        /**
         * OK
         */
        200: SubskillsPage;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/tab-content": {
    get: {
      req: {
        navigation?: string;
        tab?: string;
        xPlatform?: string;
      };
      res: {
        /**
         * Get content that will be presented on UI tab
         */
        200: TabContent;
      };
    };
  };
  "/api/v3/collection-rows": {
    get: {
      res: {
        /**
         * OK
         */
        200: CollectionRows;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/collections/{collection_uuid}": {
    get: {
      req: {
        collectionUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Collection;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/card-progress/{card_uuid}": {
    patch: {
      req: {
        cardUuid: string;
      };
      res: {
        /**
         * Card was marked as viewed successfully
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/collections/{collection_uuid}/interactions": {
    get: {
      req: {
        collectionUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CollectionInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/onboarding": {
    post: {
      res: {
        /**
         * New onboarding
         */
        200: Onboarding;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/onboarding/{id}/complete": {
    post: {
      req: {
        /**
         * Onboarding Id
         */
        id: number;
      };
      res: {
        /**
         * OK
         */
        204: void;
        /**
         * The request body was invalid.
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/session-preferences/{uuid}": {
    patch: {
      req: {
        requestBody: UpdateSessionPreferences;
        /**
         * Session uuid
         */
        uuid: string;
      };
      res: {
        /**
         * No Content
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/iterable-token": {
    get: {
      res: {
        /**
         * Get a valid JWT
         */
        200: IterableToken;
      };
    };
  };
  "/api/v3/partnerships/revolut/eligible/{uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a resource to redeem.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: RevolutEligibleGift;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource is not found
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/partnerships/revolut/activate/{uuid}": {
    put: {
      req: {
        /**
         * The unique identifier of a resource to redeem.
         */
        uuid: string;
      };
      res: {
        /**
         * Activation successfully
         *
         */
        200: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The activation fails due to un-eligible status.
         *
         */
        409: unknown;
      };
    };
  };
  "/api/v3/product-bundles/{slug}": {
    get: {
      req: {
        /**
         * The slug of the product bundle.
         */
        slug: string;
      };
      res: {
        /**
         * OK
         */
        200: ProductBundle;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/catalog": {
    get: {
      res: {
        /**
         * OK
         */
        200: CertificateProgramCatalog;
        /**
         * The resource could not be found.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/hub/tiles": {
    get: {
      res: {
        /**
         * OK
         */
        200: CertificateHubTiles;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/interactions": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgram;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/curriculum": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Curriculum;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/curriculum/interactions": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/curriculum/interactions/migration-notification": {
    patch: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * No Content
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/lessons/{lesson_uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumLesson;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The user does not have permission to access the resource.
         *
         */
        403: CurriculumLessonAccessErrorResponse;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/lessons/{lesson_uuid}/interactions": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumLessonInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The user does not have permission to access the resource.
         *
         */
        403: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumLessonInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The user does not have permission to access the resource.
         *
         */
        403: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/lessons/{lesson_uuid}/download": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The unique identifier of a lesson.
         */
        lessonUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Blob | File;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/capstone-summary/download": {
    get: {
      req: {
        /**
         * The unique identifier of the capstone summary activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Blob | File;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/quiz/submit": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        requestBody: CurriculumQuizActivityInteractions;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumActivityInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
        /**
         * Unprocessable Entity
         *
         */
        422: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/discussion/submit": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        requestBody: CurriculumDiscussionActivityInteractions;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumActivityInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
        /**
         * There was a conflict. This can occur if an evaluation of the submission is in progress.
         *
         */
        409: unknown;
        /**
         * Unprocessable Entity
         *
         */
        422: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/questionnaire/submit": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        requestBody: CurriculumQuestionnaireActivityInteractions;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumActivityInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
        /**
         * Unprocessable Entity
         *
         */
        422: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/ai-project/submit": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        requestBody: CurriculumAIProjectSubmitRequest;
      };
      res: {
        /**
         * OK
         */
        200: CurriculumActivityInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
        /**
         * Unprocessable Entity
         *
         */
        422: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{uuid}/read": {
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The unique identifier of the activity.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/conversation": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: AppliedLearningUserConversation;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/conversation/restart": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: AppliedLearningUserConversation;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/conversation/unlock": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * Result unlocked. Returns the updated conversation progress including the result.
         */
        200: CurriculumActivityInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/conversation/sync": {
    patch: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * Progress synced. Returns the updated activity interactions.
         */
        200: CurriculumActivityInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/roleplay-conversations": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        requestBody?: CreateRoleplayConversationRequest;
      };
      res: {
        /**
         * OK
         */
        200: RoleplayUserConversation;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/roleplay-conversations/restart": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        requestBody?: CreateRoleplayConversationRequest;
      };
      res: {
        /**
         * OK
         */
        200: RoleplayUserConversation;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/activities/{activity_uuid}/roleplay-conversations/submit": {
    post: {
      req: {
        /**
         * The unique identifier of the activity.
         */
        activityUuid: string;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * Conversation submitted for evaluation. Returns the updated roleplay activity interactions with evaluation status.
         */
        200: CurriculumActivityInteractions;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
        /**
         * There was a conflict. This can occur if an evaluation of the conversation is already in progress.
         *
         */
        409: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/product": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * Optional list of candidate discount codes, e.g. `discountSlugs[]=a&discountSlugs[]=b`. The backend selects the highest-value eligible coupon among all candidates and reports it via `winningDiscountSlug`
         */
        discountSlugs?: Array<string>;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramProduct;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/product-assets/{asset_uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program or product bundle
         */
        assetUuid: string;
        /**
         * Optional list of candidate discount codes, e.g. `discountSlugs[]=a&discountSlugs[]=b`. The backend selects the highest-value eligible coupon among all candidates and reports it via `winningDiscountSlug`.
         */
        discountSlugs?: Array<string>;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramProduct;
        /**
         * Bad Request
         */
        400: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/products": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        discountSlugs?: {
          [key: string]: string;
        };
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramProducts;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/products/{product_uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * Optional list of candidate discount codes, e.g. `discountSlugs[]=a&discountSlugs[]=b`. The backend selects the highest-value eligible coupon among all candidates and reports it via `winningDiscountSlug`.
         */
        discountSlugs?: Array<string>;
        /**
         * The unique identifier of a product
         */
        productUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramProduct;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/reward": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: UserCertificateProgramReward;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * Accepted
         */
        202: UserCertificateProgramReward;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/add-ons": {
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: unknown;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/add-ons/post-purchase-certs": {
    get: {
      req: {
        /**
         * Comma-separated list of certificate program UUIDs the user has previously dismissed. Excluded from the returned slots so a declined cert is never re-offered.
         *
         */
        dismissedIds?: string;
      };
      res: {
        /**
         * OK
         */
        200: PostPurchaseCertAddOns;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/coupons/{coupon_code}": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The code of the coupon
         */
        couponCode: string;
        /**
         * The unique identifier of the product
         */
        productUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramCoupon;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/bundle/download": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Blob | File;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The user does not have permission to access the resource — e.g. the certificate has not yet been claimed.
         *
         */
        403: unknown;
        /**
         * The resource could not be found.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/toolkit/download": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Blob | File;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found — e.g. the program does not exist
         * or the user has no available tools yet.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/toolkit": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Toolkit;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The user does not have permission to access the resource.
         *
         */
        403: unknown;
        /**
         * The resource could not be found.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/tools/{uuid}": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The unique identifier of the tool.
         */
        uuid: string;
      };
      res: {
        /**
         * OK
         */
        200: UserTool;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The user does not have permission to access the resource.
         *
         */
        403: unknown;
        /**
         * The resource could not be found.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/projects": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: Projects;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The user does not have permission to access the resource.
         *
         */
        403: unknown;
        /**
         * The resource could not be found.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/recent-activity": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: RecentActivity;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The user does not have permission to access the resource.
         *
         */
        403: unknown;
        /**
         * The resource could not be found.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/enrollments": {
    get: {
      req: {
        /**
         * Filter by active enrollments. If multiple status parameters are provided,
         * the results will be concatenated together.
         *
         */
        active?: boolean;
        /**
         * Filter by expired enrollments (inactive enrollments whose access expiration
         * date has passed). If multiple status parameters are provided, the results
         * will be concatenated together.
         *
         */
        expired?: boolean;
        /**
         * Filter by inactive enrollments. If multiple status parameters are provided,
         * the results will be concatenated together.
         *
         */
        inactive?: boolean;
        /**
         * Filter by pending enrollments. If multiple status parameters are provided,
         * the results will be concatenated together.
         *
         */
        pending?: boolean;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramEnrollments;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/challenge": {
    post: {
      req: {
        /**
         * Whether the challenge was automatically enrolled rather than user opt-in.
         */
        autoEnrolled?: boolean;
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        /**
         * The discount percentage for the challenge.
         */
        discountPercent: number;
        /**
         * The number of days for the challenge period. One of 15, 30, or 45.
         */
        durationDays: number;
      };
      res: {
        /**
         * Created
         */
        201: CertificateChallenge;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the certificate program does not exist,
         * or the user does not have an active enrollment.
         *
         */
        404: unknown;
        /**
         * Unprocessable Entity. Returned when durationDays is invalid.
         *
         */
        422: unknown;
      };
    };
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateChallenge;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the certificate program does not exist,
         * the user does not have an active enrollment, or no challenge exists.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-challenges/verify-coupon": {
    get: {
      req: {
        /**
         * The coupon code to verify.
         */
        code: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramCoupon;
        /**
         * The coupon code resolves to a coupon that is not a certificate-challenge
         * coupon. Body is empty; the FE should treat this as "no modal".
         *
         */
        422: unknown;
      };
    };
  };
  "/api/v3/certificates/coupons/verify": {
    get: {
      req: {
        /**
         * The coupon code to verify.
         */
        code: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramCoupon;
        /**
         * The coupon does not exist or is not associated with a Certificate Program product.
         * Body is empty; the FE should treat this as "no modal".
         *
         */
        422: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/enrollment/extension": {
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK. The updated enrollment, now active with the new expiration date.
         */
        200: CertificateProgramEnrollment;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the certificate program does not exist
         * or the user has no expired enrollment for it.
         *
         */
        404: unknown;
        /**
         * Unprocessable Entity. The enrollment is not eligible: the extension limit was
         * reached, the enrollment was revoked or refunded, or the user already has
         * another active enrollment for the program.
         *
         */
        422: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/enrollment/data-sharing-consent/accept": {
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        requestBody: {
          /**
           * The terms version presented to the learner. Must match the current version.
           */
          termsVersion: string;
        };
      };
      res: {
        /**
         * OK. The enrollment, with consent now satisfied.
         */
        200: CertificateProgramEnrollment;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * No active enrollment for this certificate program, or the enrollment is not
         * owned by an organization that requires data-sharing consent.
         *
         */
        404: unknown;
        /**
         * The submitted termsVersion is not the current one. The client must reload
         * and present the current terms before accepting.
         *
         */
        422: unknown;
      };
    };
  };
  "/api/v3/certificate-programs/{certificate_program_uuid}/enrollment": {
    get: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateProgramEnrollment;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
    post: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
        requestBody: {
          /**
           * Only available for non production environments. If true, the user will be enrolled in all the courses of the certificate program.
           * This is only available for non-production environments.
           *
           */
          autoCheckout?: boolean;
        };
      };
      res: {
        /**
         * OK
         */
        200: {
          /**
           * The date and time when the certificate program was provisioned.
           */
          enrolledAt?: string;
        };
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
        /**
         * Unprocessable Entity
         *
         */
        422: unknown;
      };
    };
    delete: {
      req: {
        /**
         * The unique identifier of a certificate program
         */
        certificateProgramUuid: string;
      };
      res: {
        /**
         * No Content
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/certificate-subscriptions/offer": {
    get: {
      req: {
        /**
         * When the offer is rendered on a certificate course page, the slug of
         * that certificate program. The comparison block then carries that
         * program's own one-time price instead of the catalog-wide
         * starting-at price.
         *
         */
        certificateProgramSlug?: string;
        /**
         * Optional list of candidate discount codes, e.g.
         * `discountSlugs[]=a&discountSlugs[]=b`. The backend selects the
         * highest-value eligible coupon per price among all candidates and
         * reports it via that price's `winning_discount_slug`.
         *
         */
        discountSlugs?: Array<string>;
        /**
         * Optional price-test variant purchase plan slug. When it names an
         * active price-test plan available in the visitor's geo, the offer
         * carries that plan's pricing; otherwise (unknown slug, no active
         * test, or the variant has no price for the geo) the response
         * silently falls back to the canonical plan. The plan actually
         * served is always reported in `subscriptionPlan.slug` and
         * `analytics.planSlug`.
         *
         */
        planSlug?: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificateSubscriptionOffer;
        /**
         * The certificate program referenced by `certificateProgramSlug`
         * could not be found, or no subscription offer is available.
         *
         */
        404: CertificateSubscriptionOfferErrorResponse;
      };
    };
  };
  "/api/v3/certificate-subscriptions/mine": {
    get: {
      res: {
        /**
         * OK
         */
        200: MyCertificateSubscription;
        /**
         * Not signed in.
         */
        401: unknown;
      };
    };
  };
  "/api/v3/accelerator/user": {
    post: {
      req: {
        requestBody?: AcceleratorUser;
      };
      res: {
        /**
         * OK
         */
        200: AcceleratorUser;
        /**
         * The request body was invalid.
         */
        400: unknown;
      };
    };
  };
  "/api/v3/growth/categories": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<GrowthCategory>;
      };
    };
  };
  "/api/v3/growth/content": {
    get: {
      req: {
        /**
         * Comma-separated list of subcategory IDs to filter content by
         */
        filterSubcategoryIds?: string;
      };
      res: {
        /**
         * OK
         */
        200: Array<GrowthContent>;
      };
    };
  };
  "/api/v3/growth/quiz-results/recommended-lessons": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<GrowthSubcategoryWithLessons>;
      };
    };
  };
  "/api/v3/growth/quiz/category-media": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<GrowthCategoryWithMedia>;
      };
    };
  };
  "/api/v3/growth/outcomes": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<Outcome>;
      };
    };
  };
  "/api/v3/growth/content-outcomes": {
    get: {
      res: {
        /**
         * OK
         */
        200: Array<ContentOutcome>;
      };
    };
  };
  "/api/v3/growth/email-capture": {
    post: {
      req: {
        requestBody: EmailCaptureRequest;
      };
      res: {
        /**
         * Email captured successfully
         */
        200: EmailCaptureResponse;
        /**
         * Bad request - email is required
         */
        400: ErrorResponse;
      };
    };
  };
  "/api/v3/growth/subscription-preferences-user": {
    get: {
      req: {
        /**
         * Email address to get subscription preferences for
         */
        email: string;
        /**
         * Email token hashed with HMAC-SHA256 and secret matching ITERABLE_HMACSHA1_SECRET to authenticate the request
         */
        subscriptionPreferencesToken: string;
      };
      res: {
        /**
         * OK
         */
        200: SubscriptionPreferencesUser;
        /**
         * Unauthorized
         */
        401: ErrorResponse;
        /**
         * User not found
         */
        404: ErrorResponse;
      };
    };
    post: {
      req: {
        requestBody: SubscriptionPreferencesUpdateRequest;
      };
      res: {
        /**
         * Subscription preferences updated successfully
         */
        200: SubscriptionPreferencesUpdateResponse;
        /**
         * Bad Request - Missing required parameters
         */
        400: ErrorResponse;
        /**
         * Unauthorized
         */
        401: ErrorResponse;
        /**
         * User not found
         */
        404: ErrorResponse;
      };
    };
  };
  "/api/v3/growth/subscription-preferences-metadata": {
    get: {
      res: {
        /**
         * OK
         */
        200: SubscriptionPreferencesMetadata;
      };
    };
  };
  "/api/v3/growth/learning-paths/results": {
    get: {
      req: {
        /**
         * Comma-separated list of category IDs
         */
        categoryIds?: string;
        /**
         * Comma-separated list of subcategory IDs
         */
        subcategoryIds?: string;
      };
      res: {
        /**
         * OK
         */
        200: Array<LearningPath>;
      };
    };
  };
  "/api/v3/decagon/user-token": {
    get: {
      res: {
        /**
         * Get a valid JWT
         */
        200: DecagonUserToken;
      };
    };
  };
  "/api/v3/decagon/signature": {
    get: {
      req: {
        /**
         * The Decagon deployment the calling surface belongs to. Each
         * deployment verifies signatures with its own secret, so the
         * signature is minted with the key for this product.
         * See `DecagonProduct` for available values.
         *
         */
        product?: string;
      };
      res: {
        /**
         * Signed canonicalId
         */
        200: DecagonSignature;
      };
    };
  };
  "/api/v3/decagon/otp/request": {
    post: {
      req: {
        requestBody: {
          /**
           * The MasterClass account email. Mutually exclusive with `orderNumber`.
           */
          email?: string;
          /**
           * A MasterClass order number from a purchase receipt, with or without a
           * leading `#`. Mutually exclusive with `email`.
           *
           */
          orderNumber?: string;
          requestType: "request" | "resend" | "cancel";
          /**
           * Decagon conversation id; binds the attempt to a conversation.
           */
          conversationId?: string;
        };
      };
      res: {
        /**
         * OTP sent, resent, or cancelled
         */
        200: {
          status?: string;
          message?: string;
          expiresAt?: string;
        };
        /**
         * Invalid email, order number, or request type; both or neither of `email` and
         * `orderNumber` given; enterprise user; or rate limited
         *
         */
        400: unknown;
        /**
         * Missing/invalid service credentials or feature disabled
         */
        401: unknown;
        /**
         * User or order not found
         */
        404: unknown;
        /**
         * Too many requests (throttled by IP)
         */
        429: unknown;
      };
    };
  };
  "/api/v3/decagon/otp/validate": {
    post: {
      req: {
        requestBody: {
          /**
           * Mutually exclusive with `orderNumber`.
           */
          email?: string;
          /**
           * Mutually exclusive with `email`.
           */
          orderNumber?: string;
          /**
           * The numeric code, kept as a string to preserve leading zeros.
           */
          otp: string;
          conversationId?: string;
        };
      };
      res: {
        /**
         * Code valid — verified, with a minted token
         */
        200: {
          status?: string;
          verificationState?: string;
          isValid?: boolean;
          /**
           * Decagon user JWT
           */
          token?: string;
          expiresAt?: string;
        };
        /**
         * Invalid or expired code, or both `email` and `orderNumber` given
         */
        400: unknown;
        /**
         * Missing/invalid service credentials or feature disabled
         */
        401: unknown;
        /**
         * No OTP for this email or order number
         */
        404: unknown;
        /**
         * Too many requests (throttled by IP)
         */
        429: unknown;
      };
    };
  };
  "/api/v3/decagon/otp/status": {
    post: {
      req: {
        requestBody: {
          /**
           * Mutually exclusive with `orderNumber`.
           */
          email?: string;
          /**
           * Mutually exclusive with `email`.
           */
          orderNumber?: string;
          conversationId: string;
        };
      };
      res: {
        /**
         * Current verification state. verified:
         * `{status: success, verificationState: verified, isValid: true, token, expiresAt}`;
         * pending: `{verificationState: pending, isValid: false}`;
         * expired: `{verificationState: expired, isValid: false}`;
         * notFound: `{verificationState: notFound, isValid: false}`;
         * unavailable (flag off): `{verificationState: unavailable, isValid: false}`.
         *
         */
        200: {
          status?: string;
          verificationState?:
            | "verified"
            | "pending"
            | "expired"
            | "not_found"
            | "unavailable";
          isValid?: boolean;
          /**
           * Echoes the request's conversation_id (absent only when the flag is off).
           */
          conversationId?: string;
          token?: string;
          expiresAt?: string;
        };
        /**
         * conversationId missing, or both `email` and `orderNumber` given
         */
        400: unknown;
        /**
         * Missing/invalid service credentials or feature disabled
         */
        401: unknown;
        /**
         * No user for this email or order number
         */
        404: unknown;
      };
    };
  };
  "/api/v3/support-verifications": {
    post: {
      req: {
        requestBody: {
          /**
           * The opaque single-use magic-link token from the email.
           */
          token: string;
        };
      };
      res: {
        /**
         * Verification outcome (HTTP 200 for every case): `verified`,
         * `alreadyVerified`, `expired`, `invalid`, or `unavailable` (flag off).
         *
         */
        200: {
          status:
            | "verified"
            | "already_verified"
            | "expired"
            | "invalid"
            | "unavailable";
        };
        /**
         * Too many requests (throttled by IP)
         */
        429: unknown;
      };
    };
  };
  "/api/v3/commerce/products/{product_name}": {
    get: {
      req: {
        /**
         * The name of the product to retrieve
         */
        productName: string;
      };
      res: {
        /**
         * OK
         */
        200: CommerceProduct;
      };
    };
  };
  "/api/v3/commerce/purchase-plans/{slug}": {
    get: {
      req: {
        /**
         * The name of the purchase-plan to retrieve
         */
        slug: string;
      };
      res: {
        /**
         * OK
         */
        200: CommercePurchasePlan;
      };
    };
  };
  "/api/v3/user-credits/certificate-limit": {
    get: {
      req: {
        /**
         * Override geo for pricing (defaults to request geo)
         */
        mcGeo?: string;
      };
      res: {
        /**
         * OK
         */
        200: CertificatePriceLimit;
        /**
         * Certificate not found or not accessible
         */
        404: unknown;
      };
    };
  };
  "/api/v3/products/bundle-pricing": {
    get: {
      res: {
        /**
         * OK
         */
        200: BundlePricingBreakdown;
      };
    };
  };
  "/api/v3/products/bundle-eligible-certificates": {
    get: {
      res: {
        /**
         * OK
         */
        200: BundleEligibleCertificates;
      };
    };
  };
  "/api/v3/commerce/bhn/redeem-giftcode": {
    post: {
      req: {
        /**
         * Giftcode for redemption
         */
        requestBody: {
          /**
           * Giftcard code number
           */
          giftcode: string;
        };
      };
      res: {
        /**
         * OK
         */
        200: SubscriptionDetails;
        /**
         * Giftcode Invalid
         */
        400: unknown;
        /**
         * Subscription invalid
         */
        409: unknown;
        /**
         * Service Unavailable
         */
        503: unknown;
      };
    };
  };
  "/api/v3/receipts/{payment_id}/download": {
    get: {
      req: {
        /**
         * The id of the Payment to download the receipt for.
         */
        paymentId: number;
      };
      res: {
        /**
         * OK
         */
        200: Blob | File;
        /**
         * Authentication credentials missing or invalid.
         */
        401: unknown;
        /**
         * Payment not found, not owned by the authenticated user, or not eligible
         * for a self-serve receipt (platform store, partnership, gift card, or
         * enterprise billing). Returned for all unauthorized cases to avoid
         * leaking resource existence.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/receipts": {
    get: {
      req: {
        /**
         * Maximum number of receipts to return. Defaults to 5 when omitted; values above 100 are capped to 100.
         */
        pageLimit?: number;
        /**
         * Number of receipts to skip from the start of the set.
         */
        pageOffset?: number;
      };
      res: {
        /**
         * OK
         */
        200: ReceiptList;
        /**
         * Authentication credentials missing or invalid.
         */
        401: unknown;
      };
    };
  };
  "/api/v3/commerce/installment/{installment_schedule_id}/change-payment-method/confirm": {
    post: {
      req: {
        /**
         * The id of the installment schedule whose stored payment method is being changed.
         */
        installmentScheduleId: number;
        requestBody: InstallmentChangePaymentMethodConfirmRequest;
      };
      res: {
        /**
         * Card swapped successfully (terminal success). The stored payment method on the
         * installment schedule now points at the newly authenticated card. No response body.
         *
         */
        201: unknown;
        /**
         * The SetupIntent did not succeed or Stripe returned an error, so the card was not
         * swapped. The response carries a human-readable `error.message` the frontend can
         * surface to the learner; the specific setup/Stripe failure code stays backend-only
         * for logging.
         *
         */
        400: InstallmentChangePaymentMethodConfirmErrorResponse;
        /**
         * The schedule is not eligible for a payment-method change. Returned when the schedule
         * has no pending installments, does not exist, or is not owned by the authenticated user.
         * A single 404 is used for all three so resource existence is not leaked to non-owners.
         * No response body — the specific reason is logged in the backend rather than returned
         * to the client.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/cart/add-product": {
    post: {
      req: {
        requestBody: CartAddProductRequest;
      };
      res: {
        /**
         * The product is in the cart.
         */
        200: CartAddProductResponse;
        /**
         * The product cannot be bought by this member.
         */
        400: unknown;
        /**
         * Authentication credentials missing or invalid.
         */
        401: unknown;
        /**
         * No product with that id.
         */
        404: unknown;
      };
    };
  };
  "/api/v3/commerce/orders": {
    post: {
      req: {
        requestBody: CommerceOrderRequest;
      };
      res: {
        /**
         * The order was charged and completed.
         */
        201: CommerceOrderResponse;
        /**
         * Authentication credentials missing or invalid.
         */
        401: unknown;
        /**
         * `programAlreadyEnrolled`: the cart holds a certificate cohort product and the member already
         * has an active or pending enrollment in that certificate program. Returned before any charge.
         *
         */
        409: CommerceOrderErrorResponse;
        /**
         * The order could not be completed. See `CommerceOrderErrorCode` for the values of `error.code`;
         * this endpoint returns `cartEmpty`, `purchaseSourceInvalid`, `productNotPurchasable`,
         * `requiresAuthentication`, `paymentMethodInvalid`, `paymentFailed`, `orderProcessingFailed`,
         * and for a certificate cohort product `cohortSoldOut` and `cohortNotOnSale`, both before
         * any charge. The `requiresAction` block is present only when `error.code` is
         * `requiresAuthentication`.
         *
         */
        422: CommerceOrderErrorResponse;
      };
    };
  };
  "/api/v3/commerce/orders/{order_id}/confirm": {
    post: {
      req: {
        /**
         * The id of the Commerce Order returned when the order endpoint asked for bank verification.
         */
        orderId: number;
        requestBody: CommerceOrderConfirmRequest;
      };
      res: {
        /**
         * The order was confirmed and completed.
         */
        201: CommerceOrderResponse;
        /**
         * Authentication credentials missing or invalid.
         */
        401: unknown;
        /**
         * `orderNotFound`: the order is not the member's, or the PaymentIntent does not belong to it.
         * Returned for both so resource existence is not leaked.
         *
         */
        404: CommerceOrderErrorResponse;
        /**
         * `alreadyConfirmed`: the order already has a Payment.
         */
        409: CommerceOrderErrorResponse;
        /**
         * `paymentFailed` when the verified PaymentIntent did not succeed (abandoned or declined),
         * `orderProcessingFailed` for any other failure.
         *
         */
        422: CommerceOrderErrorResponse;
      };
    };
  };
  "/api/v3/commerce/credit-cards": {
    get: {
      req: {
        /**
         * When `true`, returns cards regardless of their Stripe customer's currency.
         */
        forOneTimePurchase?: boolean;
        /**
         * When `true`, also returns Link payment methods, which have no brand or last four.
         */
        includeLink?: boolean;
        /**
         * When `true`, leaves out cards saved as Stripe PaymentMethods (`pm` ids).
         */
        tokenOnly?: boolean;
      };
      res: {
        /**
         * OK
         */
        200: CommerceCreditCardList;
        /**
         * Authentication credentials missing or invalid.
         */
        401: unknown;
      };
    };
  };
  "/api/v3/commerce/subscriptions/{subscription_id}/cancel": {
    post: {
      req: {
        /**
         * ID of one of the authenticated user's own subscriptions.
         */
        subscriptionId: number;
      };
      res: {
        /**
         * Auto-renew is off. The body carries the real end date.
         */
        200: SubscriptionCancellation;
        /**
         * No user-scoped token. Machine-to-machine tokens are rejected. Code `unauthorized`.
         */
        401: SubscriptionCancellationErrorResponse;
        /**
         * Code `subscriptionNotFound`. The subscription does not exist or belongs to another
         * user; both return 404 so existence is not leaked.
         *
         */
        404: SubscriptionCancellationErrorResponse;
        /**
         * Code `alreadyCancelled` when auto-renew is already off (safe to treat as success),
         * or `notAWebSubscription` when an app store or partner bills the subscription.
         *
         */
        409: SubscriptionCancellationErrorResponse;
        /**
         * Code `invalidStatus`. The subscription is neither active nor trialing.
         */
        422: SubscriptionCancellationErrorResponse;
        /**
         * Code `providerError`. Stripe or Braintree rejected the cancellation. The
         * subscription record is left unchanged.
         *
         */
        502: SubscriptionCancellationErrorResponse;
      };
    };
  };
  "/api/v3/commerce/installment/{installment_schedule_id}/change-payment-method": {
    post: {
      req: {
        /**
         * ID of the installment schedule whose future payment method is being changed.
         */
        installmentScheduleId: number;
        requestBody: InstallmentChangePaymentMethodRequest;
      };
      res: {
        /**
         * Card swapped successfully (terminal success). No response body.
         */
        201: unknown;
        /**
         * The card was declined, the SetupIntent failed, or Stripe returned an error.
         *
         */
        400: InstallmentChangePaymentMethodErrorResponse;
        /**
         * The installment schedule is not eligible (has no pending installments), was not
         * found, or is not owned by the authenticated user. No response body.
         *
         */
        404: unknown;
        /**
         * 3D Secure authentication is required before the card can be swapped. The
         * `requiresAction` block carries the redirect URL and the `setupIntentId`
         * to send to the confirm endpoint.
         *
         */
        422: InstallmentChangePaymentMethodErrorResponse;
      };
    };
  };
  "/api/v3/capabilities": {
    get: {
      res: {
        /**
         * OK
         */
        200: Capabilities;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
      };
    };
  };
  "/api/v3/terms-pages/{slug}": {
    get: {
      req: {
        /**
         * URL slug for the terms page.
         */
        slug: string;
      };
      res: {
        /**
         * OK
         */
        200: TermsPage;
        /**
         * No active terms page exists for the provided slug.
         */
        404: unknown;
      };
    };
  };
  "/api/v3/educator/enrollment/application": {
    post: {
      req: {
        requestBody: CreateEducatorEnrollmentApplicationRequest;
      };
      res: {
        /**
         * Application created successfully
         */
        201: EducatorEnrollmentApplication;
        /**
         * Bad Request - Invalid input data
         */
        400: EducatorErrorResponse;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Unprocessable Entity - Validation errors
         */
        422: EducatorErrorResponse;
      };
    };
    get: {
      res: {
        /**
         * OK
         */
        200: EducatorEnrollmentApplication;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Not Found - User does not have an application yet
         */
        404: EducatorErrorResponse;
      };
    };
    patch: {
      req: {
        requestBody: UpdateEducatorEnrollmentApplicationRequest;
      };
      res: {
        /**
         * Application updated successfully
         */
        200: EducatorEnrollmentApplication;
        /**
         * Bad Request - Invalid input data or application cannot be modified
         */
        400: EducatorErrorResponse;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Not Found - User does not have an application yet
         */
        404: EducatorErrorResponse;
        /**
         * Unprocessable Entity - Validation errors
         */
        422: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/enrollment/auto-checkout": {
    post: {
      res: {
        /**
         * User is enrolled and onboarded
         */
        204: void;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Not Found - Endpoint is unavailable in production
         */
        404: EducatorErrorResponse;
        /**
         * Unprocessable Entity - The user cannot be enrolled
         */
        422: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/auth/register": {
    post: {
      req: {
        requestBody: EducatorUserRegistrationRequest;
      };
      res: {
        /**
         * User created and authorization code issued
         */
        201: EducatorUserRegistrationResponse;
        /**
         * Bad Request - Invalid input, missing OAuth params, or registration failed
         */
        400: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/auth/registration-completed": {
    post: {
      req: {
        requestBody: EducatorRegistrationCompletedRequest;
      };
      res: {
        /**
         * Registration event tracked successfully
         */
        200: EducatorRegistrationCompletedResponse;
        /**
         * Bad Request - Invalid input data
         */
        400: EducatorErrorResponse;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Conflict - Registration event already tracked for this user
         */
        409: EducatorErrorResponse;
        /**
         * Unprocessable Entity - Validation errors
         */
        422: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/auth/session-token": {
    post: {
      res: {
        /**
         * Token issued
         */
        200: EducatorSessionTokenResponse;
        /**
         * There is no website session.
         *
         */
        401: unknown;
        /**
         * The user holds no Educator-platform enrollment.
         *
         */
        403: unknown;
      };
    };
  };
  "/api/v3/educator/enrollment/payment-details": {
    get: {
      req: {
        /**
         * The payment plan type selected on the previous screen.
         * See `EducatorPaymentPlanType` for available values.
         * Defaults to '1-payment' if omitted.
         *
         */
        planType?: string;
      };
      res: {
        /**
         * Payment details retrieved successfully
         */
        200: EducatorPaymentDetailsResponse;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Not Found - Enrollment application or cohort not found
         */
        404: EducatorErrorResponse;
        /**
         * Unprocessable Entity - Configuration or plan type error
         */
        422: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/enrollment/payment-plans": {
    get: {
      res: {
        /**
         * Available payment plans for the enrollment application
         */
        200: EducatorPaymentPlansResponse;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Enrollment application not found
         */
        404: EducatorErrorResponse;
        /**
         * Application has no intended cohort, or the cohort has no pricing configured
         */
        422: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/enrollment/status": {
    get: {
      res: {
        /**
         * Enrollment status retrieved successfully
         */
        200: EducatorEnrollmentStatusResponse;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Not Found - No enrollment application exists
         */
        404: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/enrollment/payment-order": {
    post: {
      req: {
        requestBody: EducatorPaymentOrderRequest;
      };
      res: {
        /**
         * Payment order processed successfully
         */
        201: EducatorPaymentOrderResponse;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Unprocessable Entity - Validation, configuration, or payment error.
         * When `error.code` is `requiresAuthentication`, the response includes
         * 3DS authentication fields for the frontend to complete the challenge.
         *
         */
        422: EducatorPaymentOrderErrorResponse;
      };
    };
  };
  "/api/v3/educator/enrollment/product-price": {
    get: {
      res: {
        /**
         * Product price retrieved successfully
         */
        200: EducatorProductPriceResponse;
        /**
         * No cohort is accepting enrollment, or the accepting cohort's product has no
         * pricing for the region or the US.
         *
         */
        404: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/continue-watching/{entity_uuid}": {
    delete: {
      req: {
        entityUuid: string;
      };
      res: {
        /**
         * No Content. The content was hidden from Continue Watching.
         */
        204: void;
        /**
         * The authentication credentials required to access this resource are missing or invalid.
         *
         */
        401: unknown;
        /**
         * The resource could not be found. Either the resource does not exist or the user does not have authorization to access the resource.
         *
         */
        404: unknown;
      };
    };
  };
  "/api/v3/educator/enrollment/payment-confirm": {
    post: {
      req: {
        requestBody: EducatorPaymentConfirmRequest;
      };
      res: {
        /**
         * Payment confirmed and enrollment created successfully
         */
        201: EducatorPaymentConfirmResponse;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Unprocessable Entity - Payment verification failed or token invalid
         */
        422: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/enrollment/available-seats": {
    get: {
      res: {
        /**
         * Available seats retrieved successfully
         */
        200: EducatorAvailableSeatsResponse;
        /**
         * No cohort is currently accepting enrollment
         */
        404: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/enrollment/cohort-details": {
    get: {
      res: {
        /**
         * Cohort details retrieved successfully
         */
        200: EducatorCohortDetailsResponse;
      };
    };
  };
  "/api/v3/educator/enrollment/section-layout": {
    get: {
      res: {
        /**
         * Section layout retrieved successfully
         */
        200: EducatorSectionLayoutResponse;
      };
    };
  };
  "/api/v3/educator/account": {
    get: {
      res: {
        /**
         * Account data retrieved successfully
         */
        200: EducatorAccountResponse;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/enrollment/waitlist": {
    post: {
      req: {
        requestBody: CreateEducatorWaitlistRequest;
      };
      res: {
        /**
         * Waitlist signup created
         */
        201: CreateEducatorWaitlistResponse;
        /**
         * Bad Request - Missing or invalid fields
         */
        400: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/receipts/{payment_id}/download": {
    get: {
      req: {
        /**
         * The id of the Payment to download the receipt for.
         */
        paymentId: number;
      };
      res: {
        /**
         * PDF invoice for the payment
         */
        200: Blob | File;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Not Found - Payment does not exist, is not owned by the authenticated
         * user, or is not eligible for an MCX receipt. Returned for all
         * unauthorized cases to avoid leaking resource existence.
         *
         */
        404: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/educator/receipts/download": {
    get: {
      res: {
        /**
         * Zip archive of the learner's MCX invoices
         */
        200: Blob | File;
        /**
         * Unauthorized - User is not authenticated
         */
        401: EducatorErrorResponse;
        /**
         * Not Found - The authenticated user has no invoices eligible for an
         * MCX receipt. Returned for all unauthorized cases to avoid leaking
         * resource existence.
         *
         */
        404: EducatorErrorResponse;
      };
    };
  };
  "/api/v3/martech/alexandria-content": {
    get: {
      req: {
        /**
         * Shared secret issued to the martech Alexandria loader.
         */
        xMartechApiKey: string;
      };
      res: {
        /**
         * OK
         */
        200: AlexandriaContentList;
        /**
         * Missing or invalid `X-Martech-Api-Key`, or the key is not configured
         */
        401: unknown;
      };
    };
  };
};
